/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f28a8c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f28a8c2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"3e6beb1f-4627-40cc-8346-563eb6da75f2","title":"Informācija par printeri","link":"finding-information-about-printer-topic.html","desc":"Informācijas atrašana par printeri Resursi","descFull":"Informācijas atrašana par printeri Resursi un vietas, kur tos meklēt Kādu informāciju jūs meklējat? Skatiet šeit Sākotnējās iestatīšanas norādījumi Skatiet kopā ar printeri piegādāto uzstādīšanas dokumentāciju. Printera programmatūra Printera vai faksa draiveris Printera programmaparatūra Utilīta Skatiet vietni  www.lexmark.com/downloads , meklējiet savu printera modeli un pēc tam veida izvēlnē atlasiet vajadzīgo draiveri, programmaparatūru vai utilītu. Papīra un speciālā apdrukājamā materiāla izvēle un glabāšana Papīra ievietošana Printera iestatījumu konfigurēšana Dokumentu un fotoattēlu skatīšana un drukāšana Printera konfigurēšana tīklā Printera apkope un uzturēšana Problēmu novēršana un risināšana Informācijas centrs — dodieties uz vietni  http://infoserve.lexmark.com . Pamācību video — dodieties uz vietni  https://infoserve.lexmark.com/idv/ . Skārienekrāna rokasgrāmata  — skatiet vietni  http://support.lexmark.com . Printera pieejamības funkciju iestatīšana un konfigurēšana Lexmark pieejamības rokasgrāmata  — dodieties uz vietni  http://support.lexmark.com . Palīdzības informācija par printera programmatūras lietošanu. Palīdzība par Microsoft Windows vai Macintosh operētājsistēmām — atveriet printera programmatūru vai lietojumprogrammu un pēc tam noklikšķiniet uz  Palīdzība . Noklikšķiniet uz  , lai skatītu no konteksta atkarīgu informāciju. Palīdzības informācija tiek instalēta automātiski, instalējot printera programmatūru. Atkarībā no operētājsistēmas printera programmatūra atrodas printera programmu mapē vai uz darbvirsmas. Dokumentācija Atbalsts, izmantojot tiešsaistes tērzēšanu Atbalsts, izmantojot e-pastu Atbalsts, izmantojot balsi Apmeklējiet vietni  http://support.lexmark.com . Izvēlieties savu valsti vai reģionu un pēc tam produktu, lai skatītu attiecīgo atbalsta vietni. Atbalsta dienesta kontaktinformāciju jūsu valstī vai reģionā var atrast tīmekļa vietnē vai drukātajā garantijā, kas bija iekļauta printera komplektācijā. Sazinoties ar klientu atbalsta dienestu, sagatavojiet šādu informāciju: Iegādes vieta un datums Iekārtas veids un sērijas numurs Lai iegūtu papildinformāciju, skatiet:  . Drošības informācija Reglamentējoša informācija Informācija par garantiju Vides informācija Informācija par garantiju atšķiras atkarībā no valsts vai reģiona: ASV  — skatiet printera komplektācijā iekļauto paziņojumu par ierobežoto garantiju vai skatiet vietni  http://support.lexmark.com . Citās valstīs vai reģionos  — skatiet printera komplektācijā iekļauto drukāto garantiju. Produkta informācijas ceļvedis  — skatiet kopā ar printeri piegādāto dokumentāciju vai dodieties uz tīmekļa vietni  http://support.lexmark.com . Informācija par Lexmark digitālo pasi Atveriet  https://csr.lexmark.com/digital-passport.php . informācija par printeri atrašana printera informācijas atrašana"},{"UUID":"8902298d-0ee4-4d99-ac67-0fe0e30481e6","title":"Informācija par printeri","link":"finding-printer-serial-number-topic.html","desc":"Printera sērijas numura atrašana Atveriet","descFull":"Printera sērijas numura atrašana Atveriet priekšējās durvis. Sērijas numurs ir norādīts printera kreisajā pusē. printera sērijas numura atrašana sērijas numurs, printeris atrašana"},{"UUID":"958ac7b8-96d3-4b06-8698-2e66b4109e59","title":"Informācija par printeri","link":"printer-configurations-topic.html","desc":"Printera konfigurācijas Printera konfigurēšana noteikti","descFull":"Printera konfigurācijas Printera konfigurēšana noteikti jāveic uz līdzenas, izturīgas un stabilas virsmas. Pamata modelis Printera pamata modeļa detaļas 1 Automātiskais dokumentu padevējs (Automatic document feeder — ADF) 2 ADF paplāte 3 ADF nodalījums 4 Standarta nodalījums 5 Standarta 520 lokšņu paplāte 6 Daudzfunkciju padevējs 7 Vadības panelis Konfigurēts modelis Uzstādot printerim vai daudzfunkciju printerim vienu vai vairākus aprīkojumus, iespējams, ir jāizmanto ritenīši, mēbele vai cita ietaise, lai novērstu nestabilu novietojumu, kas varētu radīt traumas. Papildinformāciju par atbalstītām konfigurācijām skatiet vietnē  www.lexmark.com/multifunctionprinters . Uzstādot printerim vai daudzfunkciju printerim vienu vai vairākus aprīkojumus, iespējams, ir jāizmanto ritenīši, mēbele vai cita ietaise, lai novērstu nestabilu novietojumu, kas varētu radīt traumas. Papildinformāciju par atbalstītām konfigurācijām jautājiet printera iegādes vietā. Lai novērstu nestabilu iekārtas novietojumu, ievietojiet papīru katrā paplātē atsevišķi. Turiet pārējās paplātes aizvērtas, kamēr tās netiek lietotas. Konfigurēta printera modeļa detaļas 1 Apdarinātājs ar skavotāju Nav atbalstīts, ja ir uzstādīts cits apdarinātājs. 2 Standarta 520 lokšņu paplāte 3 Izvēles 3 x 520 lokšņu paplāte 4 Apdarinātājs ar skavotāju, caurumotāju Atbalstīts tikai, ja ir uzstādītas izvēles paplātes. 5 Izvēles 2520 lokšņu tandēma paplāte 6 Izvēles 2000 lokšņu paplāte Dažas ierīces var nebūt pieejamas. Papildinformāciju jautājiet printera iegādes vietā. printera konfigurācijas printera pamata konfigurācija pilnībā konfigurēts printeris"},{"UUID":"582fdd90-a397-481b-ba0e-85f5e1b14f68","title":"Informācija par printeri","link":"using-control-panel-topic.html","desc":"Ja lietojat vadības paneli Vadības","descFull":"Ja lietojat vadības paneli Vadības paneļa detaļas un to funkcijas Vadības panelis Funkcija 1 Barošanas poga Ieslēdziet vai izslēdziet printeri. Lai izslēgtu printeri, nospiediet un piecas sekundes turiet ieslēgšanas/izslēgšanas pogu. Iestatiet printerī miega vai hibernēšanas režīmu. Pamodiniet printeri no miega vai hibernēšanas režīma. 2 Rādīt Skatiet printera ziņojumus un izejmateriālu statusu. Iestatiet un darbiniet printeri. 3 Indikatora gaisma Pārbaudiet printera statusu. vadības panelis lietošana vadības paneļa lietošana"},{"UUID":"9e5c8216-ab6b-46b4-ad13-253d97a0d294","title":"Informācija par printeri","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Par indikatora gaismas statusu Indikatora","descFull":"Par indikatora gaismas statusu Indikatora gaismas krāsa un tai atbilstošais printera statuss Indikatora gaisma Printera statuss Izslēgts Printeris ir izslēgts. Deg, zils Printeris ir gatavs darbībai. Mirgojoša, zila Printeris drukā vai apstrādā datus. Mirgojoša, sarkana Printerim ir nepieciešama lietotāja iejaukšanās. Vienmērīga, dzeltena Printeris ir miega režīmā. Mirgojoša, dzeltena Printeris ir dziļā miega vai hibernēšanas režīmā. indikatora gaisma par statusu printera statuss"},{"UUID":"390e158e-ee0f-40a1-9deb-f7bd1f86b971","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Norādījumi par papīru Izmantojiet atbilstošu","descFull":"Norādījumi par papīru Izmantojiet atbilstošu papīru, lai novērstu sastrēgumus un garantētu drukāšanu bez problēmām. Vienmēr izmantojiet jaunu papīru, kas nav bojāts. Pirms papīra ievietošanas noskaidrojiet, kura ir ieteicamā apdrukājamā papīra puse. Šī informācija parasti ir norādīta uz papīra iepakojuma. Neizmantojiet papīru, kas ir apgriezts manuāli. Neizmantojiet vienā paplātē dažādu izmēru, veidu vai svara papīru; šāds sajaukums var radīt sastrēgumu. Neizmantojiet krītpapīru, ja vien tas nav speciāli paredzēts elektrografiskajam printerim. Papildinformāciju skatiet dokumentā  Papīra un speciālā apdrukājamā materiāla rokasgrāmata . papīrs atlase papīra vadotnes"},{"UUID":"bca3f013-b9ee-4479-bb6f-ac8aafbcfe66","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Papīra īpašības Tālāk norādītās papīra","descFull":"Papīra īpašības Tālāk norādītās papīra īpašības ietekmē drukas kvalitāti un uzticamību. Pirms drukāšanas apsveriet tālāk norādītās papīra īpašības. Svars No paplātēm var padod dažāda svara papīru. Papīrs, kas sver mazāk nekā 60 g/m 2  (16 mārciņas), iespējams, nav pietiekami stingrs, lai to pareizi padotu, un var iestrēgt. Lai iegūtu papildinformāciju, skatiet tēmu “Atbalstītie papīra svari”. Sarullēšanās Papīra malas bieži sarullējas. Pārmērīga sarullēšanās var radīt papīra padeves problēmas. Sarullēšanās var notikt pēc papīra apstrādes printerī, kur tas tiek pakļauts augstai temperatūrai. Glabājot papīru bez iesaiņojuma karstā, mitrā, aukstā vai sausā vidē, var tikt veicināta papīra sarullēšanās pirms drukāšanas, tādējādi radot padeves problēmas. Gludums Papīra gludums tieši ietekmē drukas kvalitāti. Ja papīrs ir pārāk raupjš, toneris uz tā netiek uzklāts pareizi. Ja papīrs ir pārāk gluds, var rasties papīra padeves vai drukas kvalitātes problēmas. Ieteicams izmantot papīru, kura gludums ir 50 pēc Šefīlda. Mitruma saturs Papīra mitruma saturs ietekmē gan drukas kvalitāti, gan printera spēju papīru pareizi padot. Pirms izmantošanas glabājiet papīru oriģinālajā iepakojumā. Ja papīrs ir pakļauts mitruma līmeņa izmaiņām, var pasliktināties tā kvalitāte. Pirms drukāšanas noturiet papīru tā oriģinālajā iepakojumā 24–48 stundas. Papīrs jātur tajā pašā vidē, kurā atrodas printeris. Ja papīra glabāšanas vai transportēšanas vide ir ļoti atšķiras no vides, kādā atrodas printeris, pagariniet šo laiku līdz vairākām dienām. Biezam papīram var būt nepieciešams garāks papīra aklimatizācijas laiks. Šķiedras virziens Šķiedras virziens attiecas uz šķiedru izlīdzinājumu papīra loksnē. Šķiedras virziens var būt  garenšķiedru , kad virziens atbilst papīra garumam, un  šķērsšķiedru , kad virziens atbilst papīra platumam. Informāciju par ieteicamo šķiedru virzienu skatiet tēmā “Atbalstītie papīra svari”. Šķiedru sastāvs Visbiežāk augstas kvalitātes printera papīrs ir veidots no 100% ķīmiski apstrādātas celulozes. Šis sastāvs papīram nodrošina augsta līmeņa stabilitāti, tāpēc retāk rodas papīra padeves problēmas un drukas kvalitāte ir labāka. Ja papīrs satur, piemēram, kokvilnas šķiedras, tas var negatīvi ietekmēt papīra apstrādi. papīra īpašības"},{"UUID":"08946547-90ef-4e43-b7de-f2744d63f0be","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Nepieņemams papīrs Printerī nav ieteicams","descFull":"Nepieņemams papīrs Printerī nav ieteicams izmantot šāda veida papīru: Ķīmiski apstrādāts papīrs, ko izmanto kopiju ieguvei bez koppapīra. To sauc arī par paškoppējošo papīru, paškoppējošo koppapīru (CCP) vai bezkarbona papīru (NCR). Iepriekš apdrukāts papīrs, kas satur ķimikālijas, kuras var notraipīt printeri. Iepriekš apdrukāts papīrs, kuru var ietekmēt printera termofiksatora temperatūra. Iepriekš apdrukāts papīrs, kam ir nepieciešama reģistrācija (precīza drukāšana lapā), kas pārsniedz ±2,3 mm (±0,09 collas). Piemēram, optiskās rakstzīmju atpazīšanas (optical character recognition — OCR) veidlapas. Dažreiz reģistrāciju var koriģēt, izmantojot programmatūru, lai sekmīgi drukātu šīs veidlapas. Krītpapīrs (dzēšams, augstas kvalitātes), sintētisks papīrs vai termālais papīrs. Papīrs ar nelīdzenām malām vai izteiktu faktūru, raupjš vai sarullēts. Papīri, kas neatbilst EN12281:2002 (Eiropa). Papīrs, kas sver mazāk nekā 60 g/m 2  (16 mārciņas) Veidlapas vai dokumenti, kas sastāv no vairākām daļām. nepieņemams papīrs"},{"UUID":"ece83f36-a07b-44db-9c04-ab3ef8e17857","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Papīra glabāšana Ievērojiet tālāk sniegtos","descFull":"Papīra glabāšana Ievērojiet tālāk sniegtos papīra glabāšanas norādījumus, lai izvairītos no iestrēguša papīra un novērstu drukas kvalitātes problēmas. Pirms drukāšanas 24–48 stundas glabājiet papīru oriģinālajā iepakojumā tādā pašā vidē, kādā atrodas printeris. Ja papīra glabāšanas vai transportēšanas vide ir ļoti atšķiras no vides, kādā atrodas printeris, pagariniet šo laiku līdz vairākām dienām. Biezam papīram var būt nepieciešams garāks papīra aklimatizācijas laiks. Lai iegūtu labākus rezultātus, glabājiet papīru vietā, kur temperatūra ir 21 °C (70 °F) un relatīvais mitrums ir 40%. Vairākums ražotāju iesaka drukāt 18–24 °C (65–75 °F) ar relatīvo mitrumu 40–60%. Glabājiet papīru kastē, uz paletes vai plaukta, nevis uz grīdas. Glabājiet atsevišķas pakas uz līdzenas virsmas. Neturiet neko uz atsevišķām papīra pakām. Izņemiet papīru no kastes vai iesaiņojuma tikai tad, kad esat gatavs to ievietot printerī. Kaste un iesaiņojums palīdz nodrošināt, ka papīrs ir tīrs, sauss un līdzens. papīra glabāšana"},{"UUID":"9f099e24-6aff-45ea-a0ef-cf05f737feec","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Iepriekš apdrukātu veidlapu un veidlapu","descFull":"Iepriekš apdrukātu veidlapu un veidlapu izvēle Izmantojiet garenšķiedras papīru. Izmantojiet tikai tādas iepriekš apdrukātas veidlapas un veidlapas, kas ir drukātas, izmantojot ofseta iespiedumu vai gravēšanu. Neizmantojiet papīru ar raupju vai piesātinātu tekstūru. Izmantojiet tintes, kuras neietekmē tonera sveķi. Parasti šīm prasībām atbilst tintes, kas oksidējas vai kurām ir eļļas bāze; lateksa tintes var neatbilst šīm prasībām. Vispirms izdrukājiet paraugus uz tām iepriekš apdrukātajām veidlapām un veidlapām, ko domājat izmantot. Tikai pēc tam iegādājieties tās lielā apjomā. Veicot šo darbību, varat pārbaudīt, vai iepriekš apdrukātās veidlapas vai veidlapas tinte ietekmē drukas kvalitāti. Ja rodas šaubas, sazinieties ar papīra piegādātāju. Ja drukājat uz veidlapas, ievietojiet papīru tā, lai tā orientācija atbilstu printerim. Papildinformāciju skatiet dokumentā  Papīra un speciālā apdrukājamā materiāla rokasgrāmata . papīrs iepriekš apdrukātas veidlapas iepriekš apdrukātas veidlapas atlase papīrs veidlapa veidlapa atlase"},{"UUID":"f7d442f1-1fd7-41f9-93a3-e664fe35922f","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Atbalstītie papīra izmēri Papīra izmēri,","descFull":"Atbalstītie papīra izmēri Papīra izmēri, ko atbalsta standarta paplāte, MPF, aplokšņu paplāte un divpusējā drukāšana Papīra izmēri Standarta 520 lokšņu paplāte Daudzfunkciju padevējs Aplokšņu paplāte Divpusēja drukāšana 1  Ievieto tikai īsās malas orientācijā. 2  Ievieto tikai garās malas orientācijā. 3  Atbalsta papīra izmērus no 139,7 x 181,86 mm (5,5 x 7,16 collas) līdz 296,93 x 431,8 mm (11,69 x 17 collas). 4  Atbalsta papīra izmērus no 88,9 x 98,38 mm (3,5 x 3,87 collas) līdz 296,93 x 482,6 mm (11,69 x 19 collas). 5  Atbalsta papīra izmērus no 128 x 139,7 mm (5 x 5,5 collas) līdz 296,93 x 482,6 mm (11,69 x 19 collas). A3 1 297 x 420 mm (11,69 x 16,54 collas) X A4 210 x 297 mm (8,27 x 11,7 collas) 2 X A5 148 x 210 mm (5,83 x 8,27 collas) 1 2 X A6 105 x 148 mm (4,13 x 5,83 collas) X 1 X X Executive 184,2 x 266,7 mm (7,25 x 10,5 collas) 2 X Folio 1 215,9 x 330,2 mm (8,5 x 13 collas) X Hagaki 100 x 148 mm (3,94 x 5,83 collas) X 1 X X JIS B4 1 257 x 364 mm (10,12 x 14,33 collas) X JIS B5 182 x 257 mm (7,17 x 10,1 collas) 2 X Ledger 1 279,4 x 4431,8 mm (11 x 17 collas) X Legal 1 215,9 x 355,6 mm (8,5 x 14 collas) X Letter 215,9 x 279,4 mm (8,5 x 11 collas) 2 X Oficio (Meksika) 1 215,9 x 340,4 mm (8,5 x 13,4 collas) X Statement 139,7 x 215,9 mm (5,5 x 8,5 collas) 1 2 X Universāls 3 4 X 5 Aploksne 7 3/4 98,4 x 190,5 mm (3,875 x 7,5 collas) X 2 X Aploksne 9 98,4 x 225,4 mm (3,875 x 8,9 collas) X 2 X Aploksne 10 104,8 x 241,3 mm (4,12 x 9,5 collas) X 2 X Aploksne B5 176 x 250 mm (6,93 x 9,84 collas) X 1 X Aploksne C5 162 x 229 mm (6,38 x 9,01 collas) X 2 X Aploksne DL 110 x 220 mm (4,33 x 8,66 collas) X 2 X ADF atbalsta papīra izmērus no 125 x 85 mm (4,92 x 3,35 collas) līdz 297 x 431,8 mm (11,69 x 17 collas). Plakanvirsmas skeneris atbalsta maksimālo papīra izmēru 297 x 431,8 mm (11,69 x 17 collas). Izvēles paplāšu atbalstītie papīra izmēri Papīra izmēri Izvēles 520 lokšņu paplāte, izvēles 520 lokšņu paplāte ar atvilktni un izvēles 3 x 520 lokšņu paplāte Izvēles 2520 lokšņu tandēma paplāte Izvēles 2000 lokšņu paplāte 1  Ievieto tikai īsās malas orientācijā. 2  Ievieto tikai garās malas orientācijā. 3  Atbalsta papīra izmērus no 139,7 x 181,86 mm (5,5 x 7,16 collas) līdz 296,93 x 431,8 mm (11,69 x 17 collas). A3 1 297 x 420 mm (11,69 x 16,54 collas) X A4 210 x 297 mm (8,27 x 11,7 collas) 2 A5 1 148 x 210 mm (5,83 x 8,27 collas) X A6 105 x 148 mm (4,13 x 5,83 collas) X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 collas) 2 Folio 1 215,9 x 330,2 mm (8,5 x 13 collas) X Hagaki 100 x 148 mm (3,94 x 5,83 collas) X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 collas) X JIS B5 182 x 257 mm (7,17 x 10,1 collas) 2 Ledger 1 279,4 x 4431,8 mm (11 x 17 collas) X Legal 1 215,9 x 355,6 mm (8,5 x 14 collas) X Letter 215,9 x 279,4 mm (8,5 x 11 collas) 2 Oficio (Meksika) 1 215,9 x 340,4 mm (8,5 x 13,4 collas) X Statement 1 139,7 x 215,9 mm (5,5 x 8,5 collas) X Universāls 3 3 3 Aploksne 7 3/4 98,4 x 190,5 mm (3,875 x 7,5 collas) X X X Aploksne 9 98,4 x 225,4 mm (3,875 x 8,9 collas) X X X Aploksne 10 104,8 x 241,3 mm (4,12 x 9,5 collas) X X X Aploksne B5 176 x 250 mm (6,93 x 9,84 collas) X X X Aploksne C5 162 x 229 mm (6,38 x 9,01 collas) X X X Aploksne DL 110 x 220 mm (4,33 x 8,66 collas) X X X Papīra izmēri, ko atbalsta izvades nodalījumi Papīra izmēri Standarta nodalījums Augšējais nodalījums Kaudze Ofsets Kaudze 1  Ievieto tikai īsās malas orientācijā. 2  Ievieto tikai garās malas orientācijā. 3  Atbalsta papīra izmērus no 88,9 x 98,38 mm (3,5 x 3,87 collas) līdz 296,93 x 482,6 mm (11,69 x 19 collas). 4  Atbalsta papīra izmērus no 88,9 x 98,38 mm (3,5 x 3,87 collas) līdz 296,93 x 431,8 mm (11,69 x 17 collas). A3 1 297 x 420 mm (11,69 x 16,54 collas) A4 210 x 297 mm (8,27 x 11,7 collas) A5 148 x 210 mm (5,83 x 8,27 collas) A6 1 105 x 148 mm (4,13 x 5,83 collas) Executive 184,2 x 266,7 mm (7,25 x 10,5 collas) Folio 1 215,9 x 330,2 mm (8,5 x 13 collas) Hagaki 1 100 x 148 mm (3,94 x 5,83 collas) JIS B4 1 257 x 364 mm (10,12 x 14,33 collas) JIS B5 182 x 257 mm (7,17 x 10,1 collas) Ledger 1 279,4 x 4431,8 mm (11 x 17 collas) Legal 1 215,9 x 355,6 mm (8,5 x 14 collas) Letter 215,9 x 279,4 mm (8,5 x 11 collas) Oficio (Meksika) 1 215,9 x 340,4 mm (8,5 x 13,4 collas) Statement 139,7 x 215,9 mm (5,5 x 8,5 collas) Universāls 3 4 X Aploksne 7 3/4 2 98,4 x 190,5 mm (3,875 x 7,5 collas) Aploksne 9 2 98,4 x 225,4 mm (3,875 x 8,9 collas) Aploksne 10 2 104,8 x 241,3 mm (4,12 x 9,5 collas) Aploksne B5 2 176 x 250 mm (6,93 x 9,84 collas) Aploksne C5 2 162 x 229 mm (6,38 x 9,01 collas) Aploksne DL 2 110 x 220 mm (4,33 x 8,66 collas) Apdarinātāju atbalstītie papīra izmēri Papīra izmēri Apdarinātājs ar skavotāju Apdarinātājs ar skavotāju, caurumotāju Kaudze Ofsets Skavošana Kaudze Ofsets Skavošana Caurumotājs 1  Ievieto tikai īsās malas orientācijā. 2  Ievieto tikai garās malas orientācijā. 3  Atbalsta papīra izmērus no 88,9 x 98,38 mm (3,5 x 3,87 collas) līdz 296,93 x 431,8 mm (11,69 x 17 collas). 4  Atbalsta papīra izmērus no 190 x 139,7 mm (7,48 x 5,5 collas) līdz 296,93 x 431,8 mm (11,69 x 17 collas). 5  Atbalsta papīra izmērus no 202,9 x 182,03 mm (7,99 x 7,17 collas) līdz 296,93 x 431,8 mm (11,69 x 17 collas). 6  Atbalsta caurumošanu tikai līdz 2 atverēm. 7  Atbalsta caurumošanu tikai līdz 2 atverēm, ja ievietots īsās malas orientācijā. 8  Atbalsta papīra izmērus no 88,9 x 98,38 mm (3,5 x 3,87 collas) līdz 320,04 x 1320,8 mm (12,6 x 52 collas). 9  Atbalsta papīra izmērus no 209,97 x 148 mm (8,27 x 5,83 collas) līdz 296,93 x 431,8 mm (11,69 x 17 collas). A3 1 297 x 420 mm (11,69 x 16,54 collas) A4 210 x 297 mm (8,27 x 11,7 collas) A5 148 x 210 mm (5,83 x 8,27 collas) 2 X 2 2 6 A6 105 x 148 mm (4,13 x 5,83 collas) X X X X X Reklāmkarogs Maksimālais platums: 215,9 mm (8,5 collas) Maksimālais garums: 1320,8 mm (52 collas) 1 X X 1 X X X Executive 184,2 x 266,7 mm (7,25 x 10,5 collas) 2 2 2 2 2 2 Folio 1 215,9 x 330,2 mm (8,5 x 13 collas) Hagaki 100 x 148 mm (3,94 x 5,83 collas) X X X X X JIS B4 1 257 x 364 mm (10,12 x 14,33 collas) JIS B5 182 x 257 mm (7,17 x 10,1 collas) 2 2 2 2 7 Ledger 1 279,4 x 4431,8 mm (11 x 17 collas) Legal 1 215,9 x 355,6 mm (8,5 x 14 collas) Letter 215,9 x 279,4 mm (8,5 x 11 collas) Oficio (Meksika) 1 215,9 x 340,4 mm (8,5 x 13,4 collas) Statement 139,7 x 215,9 mm (5,5 x 8,5 collas) 2 X X X X X Universāls 3 4 5 8 9 9 X Aploksne 7 3/4 98,4 x 190,5 mm (3,875 x 7,5 collas) X X X X X X Aploksne 9 98,4 x 225,4 mm (3,875 x 8,9 collas) X X X X X X Aploksne 10 104,8 x 241,3 mm (4,12 x 9,5 collas) X X X X X X Aploksne B5 176 x 250 mm (6,93 x 9,84 collas) 2 X X X X X X Aploksne C5 162 x 229 mm (6,38 x 9,01 collas) 1 X X X X X X Aploksne DL 110 x 220 mm (4,33 x 8,66 collas) X X X X X X atbalstītie papīra izmēri papīra izmēri, atbalstīti"},{"UUID":"8a0611c1-1346-4c4b-8d09-bc2d0eb7813c","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Atbalstītie papīra veidi Atbalstītie papīra","descFull":"Atbalstītie papīra veidi Atbalstītie papīra veidi Papīra veidi, ko atbalsta standarta paplāte, MPF, aplokšņu paplāte un divpusējā drukāšana Papīra veids Standarta 520 lokšņu paplāte Daudzfunkciju padevējs Aplokšņu paplāte Divpusēja drukāšana Augstas kvalitātes X Kartons  X Krāsains X Pielāgots veids X Aploksne X X Spīdīgs X Smags spīdīgs papīrs X Smags X Etiķetes X X Veidlapa X Viegls X Vienkāršs X Iepriekš apdrukāts X Pārstrādāts X Raupja aploksne X X Raupja kokvilna X Vinila etiķetes X X X X Izvēles paplāšu atbalstītie papīra veidi Papīra veids Izvēles 520 lokšņu paplāte, izvēles 520 lokšņu paplāte ar atvilktni un izvēles 3 x 520 lokšņu paplāte Izvēles 2520 lokšņu tandēma paplāte Izvēles 2000 lokšņu paplāte Augstas kvalitātes Kartons  Krāsains Pielāgots veids Aploksne X X X Spīdīgs Smags spīdīgs papīrs Smags Etiķetes Veidlapa Viegls Vienkāršs Iepriekš apdrukāts Pārstrādāts Raupja aploksne X X X Raupja kokvilna Vinila etiķetes X X X Papīra veidi, ko atbalsta izvades nodalījumi Papīra veids Standarta nodalījums Augšējais nodalījums Kaudze Ofsets Kaudze Augstas kvalitātes Kartons  Krāsains Pielāgots veids Aploksne Spīdīgs Smags spīdīgs papīrs Smags Etiķetes Veidlapa Viegls Vienkāršs Iepriekš apdrukāts Pārstrādāts Raupja aploksne Raupja kokvilna Vinila etiķetes X X X Apdarinātāju atbalstītie papīra veidi Papīra veids Apdarinātājs ar skavotāju Apdarinātājs ar skavotāju, caurumotāju Kaudze Ofsets Skavošana Kaudze Ofsets Skavošana Caurumotājs Augstas kvalitātes Kartons  X X Krāsains Pielāgots veids Aploksne X X X X X X Spīdīgs Smags spīdīgs papīrs X X Smags X X Etiķetes X X X X X Veidlapa Viegls Vienkāršs Iepriekš apdrukāts Pārstrādāts Raupja aploksne X X X X X X Raupja kokvilna X X Vinila etiķetes X X X X X X X atbalstītie papīra veidi papīra veidi atbalstīts"},{"UUID":"408d47ba-c945-4523-bb96-d9bfc317059f","title":"Papīra izvēle","link":"paper-guidelines-topic.html","desc":"Atbalstītie papīra svari Printera atbalstītais","descFull":"Atbalstītie papīra svari Printera atbalstītais papīra svars 520 lokšņu paplāte, 520 lokšņu paplāte ar atvilktni, 3 x 520 lokšņu paplāte, 2520 lokšņu tandēma paplāte Daudzfunkciju padevējs Aplokšņu paplāte Izvēles 2000 lokšņu paplāte 60-256 g/m 2 (12–68 mārciņas) 60–216 g/m 2 (12-57 mārciņas) 75-90 g/m 2 (20-24 mārciņas) 60–216 g/m 2 (12-57 mārciņas) Ja izmantojat papīru, kas sver 60–176 g/m 2  (16–47 mārciņas, augsta kvalitāte), ieteicams, lai tas ir garenšķiedras papīrs. Ja papīrs ir vieglāks par 75 g/m 2  (20 mārciņas, augsta kvalitāte), iestatījumam  Papīra veids  ir jābūt  Viegls papīrs . Ja tas netiek ievērots, papīrs var pārmērīgi sarullēties, šādi izraisot padeves kļūdas (īpaši mitrākās vidēs). Divpusējai drukāšanai var izmantot 60–162 g/m 2  (16–43 mārciņas, augsta kvalitāte) papīru. 100% kokvilnas satura maksimālais svars ir 90 g/m 2  (24 mārciņas, augsta kvalitāte). atbalstītie papīra svari papīra svars atbalstīts"},{"UUID":"739d57c0-38c8-4cbf-9977-ad0b192a4784","title":"Uzstādīšana, instalēšana un konfigurēšana","link":"selecting-location-printer-topic.html","desc":"Printera atrašanās vietas izvēle Atstājiet","descFull":"Printera atrašanās vietas izvēle Atstājiet pietiekami daudz vietas, lai varētu atvērt paplātes, vākus, durvis un uzstādīt aparatūras ierīces. Novietojiet printeri blakus elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Lai izvairītos no elektrošoka riska, nenovietojiet šo produktu un nelietojiet to blakus ūdenim vai mitrās vietās. Nodrošiniet, lai gaisa plūsma telpā atbilst jaunākajai ASHRAE 62 standarta vai CEN/TC 156 standarta versijai. Nodrošiniet līdzenu, stingru un stabilu virsmu. Nodrošiniet, lai printeris: ir tīrs, sauss un bez putekļiem; nesaskaras ar noklīdušām skavām un papīra saspraudēm; neatrodas tiešā gaisa kondicionētāju, sildītāju vai ventilatoru gaisa plūsmas ietekmē; nav pakļauts tiešai saules gaismai vai lielam mitrumam. Ņemiet vērā ieteicamās temperatūras un izvairieties no krasām temperatūras svārstībām. Ieteicamās temperatūras Vides temperatūra Noliktavas temperatūra Lai nodrošinātu pareizu ventilāciju, ievērojiet šos norādījumus par nepieciešamo platību ap printeri. Ieteicamā platība ap printeri 1 Augšpuse 2 Aizmugure 3 Labā puse 4 Priekšpuse 5 Kreisā puse printeris atrašanās vietas izvēle atrašanās vietas izvēle printerim printeris minimāla brīvā vieta printera pārvietošana"},{"UUID":"e9edb45e-ecfd-406b-a506-61eafbe621f2","title":"Uzstādīšana, instalēšana un konfigurēšana","link":"attaching-cables-topic.html","desc":"Kabeļu pievienošana Lai izvairītos no","descFull":"Kabeļu pievienošana Lai izvairītos no elektrošoka riska, negaisa laikā neveiciet šī produkta uzstādīšanu un neveidojiet nekādus elektriskus vai kabeļu savienojumus, izmantojot, piemēram, strāvas vadu, faksa funkciju vai tālruņa līniju. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Lai izvairītos no aizdegšanās vai elektrošoka riska, izmantojiet tikai to strāvas vadu, kas iekļauts šī produkta komplektācijā, vai ražotāja apstiprinātu rezerves daļu. Lai samazinātu aizdegšanās risku, kad šo produktu pievienojat publiskajam tālruņa tīklam, izmantojiet tikai 26 AWG vai lielāku telekomunikāciju (RJ-11) vadu. Lietotājiem Austrālijā jāizmanto Austrālijas Komunikāciju un mediju iestādes apstiprināts vads. Lai izvairītos no datu zaudēšanas vai nepareizas printera darbības, drukāšanas laikā nepieskarieties USB kabelim, bezvadu tīkla adapterim vai printerim šeit attēlotajā apgabalā. Printera porti un kontaktligzda; to funkcijas Printera ports Funkcija 1 USB ports Pievienojiet tastatūru vai citu saderīgu ierīci. 2 USB printera ports Pievienojiet printeri datoram. 3 Ethernet ports Pievienojiet printeri tīklam. 4 LINE ports Pieejams tikai, ja ir uzstādīta faksa karte. Pievienojiet printeri aktīvai tālruņa līnijai, izmantojot standarta kontaktligzdu (RJ-11), DSL filtru vai VoIP adapteri vai citu adapteri, kas ļauj piekļūt tālruņa līnijai, lai nosūtītu un saņemtu faksus. 5 Strāvas vada kontaktligzda Pievienojiet printeri pareizi iezemētam elektrotīklam. kabeļu pievienošana printera porti USB kabelis Ethernet kabelis USB ports Ethernet ports strāvas vada kontaktligzda"},{"UUID":"1e786f0a-86a3-42ae-85c1-35493aebe737","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Sākuma ekrāna izmantošana Sākuma ekrāns","descFull":"Sākuma ekrāna izmantošana Sākuma ekrāns var atšķirties atkarībā no sākuma ekrāna pielāgošanas iestatījumiem, administratīvajām izvēlēm un aktīvajiem iegultajiem risinājumiem. Sākuma ekrāna ikonas un to funkcijas # Ikona Funkcija 1 Apturēšanas vai atcelšanas poga Apturiet pašreizējo darbu. 2 Kopēšana Veiciet kopēšanu. 3 Valodas maiņa Mainiet printera displeja valodu. 4 E-pasts Sūtiet e-pasta ziņojumus. 5 Iestatījumi Piekļūstiet printera izvēlnēm. 6 Fakss Sūtiet faksu. 7 Adrešu grāmata Piekļūstiet kontaktpersonām, izveidojiet un kārtojiet tās. 8 Statuss/izejmateriāli Skatiet printera brīdinājuma vai kļūdas ziņojumus gadījumos, kad printerim ir nepieciešama lietotāja iejaukšanās, lai varētu turpināt darbu. Skatiet papildinformāciju par printera brīdinājumu vai ziņojumu, kā arī uzziniet, kā to notīrīt. Varat arī piekļūt šim iestatījumam, pieskaroties sākuma ekrāna augšpuses sadaļai. 9 Aizturēti darbi Skatiet visus aktuālos aizturētos drukas darbus. 10 Darbu rinda Skatiet visus aktuālos drukas darbus. Varat arī piekļūt šim iestatījumam, pieskaroties sākuma ekrāna augšpuses sadaļai. 11 USB disks Skatiet, atlasiet vai drukājiet fotoattēlus un dokumentus no zibatmiņas diska. 12 Skenēšanas profili Skenējiet un saglabājiet dokumentus tieši datorā. 13 FTP Skenējiet un saglabājiet dokumentus tieši FTP serverī. 14 Grāmatzīmes Kārtojiet visas grāmatzīmes. 15 Cietais disks Skatiet, atlasiet un pārvaldiet dokumentus cietajā diskā vai viedajā krātuves diskā. 16 Tīkla mape Skenējiet tīkla mapē vai tīkla atrašanās vietā. 17 Poga Sākums Sāciet darbu atkarībā no atlasītā režīma. 18 Ekrāna tastatūra Ievades laukā ievadiet ciparus vai simbolus. sākuma ekrāna izmantošana sākuma ekrāns lietošana"},{"UUID":"f63d2348-9d88-45bc-ad88-f1b5051cb6ee","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Sākuma ekrāna pielāgošana Atveriet tīmekļa","descFull":"Sākuma ekrāna pielāgošana Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi Ierīce Sākuma ekrāna pielāgošana . Izpildiet vienu vai vairākas tālāk norādītās darbības. Lai sākuma ekrānam pievienotu ikonu, noklikšķiniet uz  , atlasiet lietojumprogrammas nosaukumu un pēc tam noklikšķiniet uz  Pievienot . Lai no sākuma ekrāna noņemtu ikonu, atlasiet lietojumprogrammas nosaukumu un pēc tam noklikšķiniet uz  Noņemt . Lai pielāgotu lietojumprogrammas nosaukumu, atlasiet lietojumprogrammas nosaukumu, noklikšķiniet uz  Rediģēt  un pēc tam piešķiriet nosaukumu. Lai atjaunotu lietojumprogrammas nosaukumu, atlasiet lietojumprogrammas nosaukumu, noklikšķiniet uz  Rediģēt  un pēc tam atlasiet  Atjaunot lietojumprogrammas etiķeti . Lai starp lietojumprogrammām pievienotu atstarpi, noklikšķiniet uz  , atlasiet  BLANK SPACE  un pēc tam noklikšķiniet uz  Pievienot . Lai kārtotu lietojumprogrammas, velciet lietojumprogrammu nosaukumus vajadzīgajā secībā. Lai atjaunotu noklusējuma sākuma ekrānu, noklikšķiniet uz  Atjaunot sākuma ekrānu . Piemērojiet izmaiņas. sākuma ekrāna ikonas parādīšana ikonas sākuma ekrānā rādīšana sākuma ekrāns pielāgošana lietojumprogrammu rādīšana sākuma ekrānā lietojumprogrammu pievienošana sākuma ekrānam"},{"UUID":"4694494d-16ba-48d9-8de6-e9a1dfea4006","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Atbalstītās lietojumprogrammas Lietojumprogrammas un printera","descFull":"Atbalstītās lietojumprogrammas Lietojumprogrammas un printera modeļi, kas tās atbalsta Lietojumprogramma Printera modeļi skenēšanas centrs CX930, CX931, XC9325, XC9335 īsceļu centrs CX930, CX931, XC9325, XC9335 Card Copy CX930, CX931, XC9325, XC9335 displeja pielāgošana CX930, CX931, XC9325, XC9335 Klientu atbalsts XC9325, XC9335 Ierīces kvotas XC9325, XC9335 atbalstītās lietojumprogrammas"},{"UUID":"19baf8ce-ae9f-4a41-a4e8-f5f339077bfc","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Skenēšanas centra iestatīšana Sākuma ekrānā","descFull":"Skenēšanas centra iestatīšana Sākuma ekrānā pieskarieties pie  Skenēšanas centrs . Atlasiet un izveidojiet galamērķi, pēc tam konfigurējiet iestatījumus. Veidojot tīkla galamērķi, noteikti validējiet un koriģējiet iestatījumus, līdz nerodas kļūdas. Tiek saglabāti tikai tie galamērķi, kas tika izveidoti serverī Embedded Web Server. Papildinformāciju skatiet kopā ar risinājumu piegādātajā dokumentācijā. Piemērojiet izmaiņas. Skenēšanas centrs iestatīšana"},{"UUID":"fb04fc3f-cab8-49f9-9be1-6d746de2822b","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Īsceļa izveide Sākuma ekrānā pieskarieties","descFull":"Īsceļa izveide Sākuma ekrānā pieskarieties pie  Īsceļu centrs . Iespējams, ir mainīta ikona un nosaukums. Papildinformāciju jautājiet savam administratoram. Atlasiet printera funkciju un pēc tam pieskarieties pie  Izveidot īsceļu . Drošā e-pasta funkcija netiek atbalstīta. Konfigurējiet iestatījumus un pēc tam pieskarieties pie  Saglabāt . Ierakstiet unikālu īsceļa nosaukumu. Lai sākuma ekrānā nebūtu apgrieztu nosaukumu, ierakstiet tikai līdz 25 rakstzīmēm. Pieskarieties pie  Labi . Lietojumprogramma automātiski ģenerē unikālu īsceļa numuru. Lai palaistu īsceļu, pieskarieties pie  , pieskarieties pie  #  un pēc tam ievadiet īsceļa numuru. īsceļu izveide īsceļi izveide īsceļš Kopēšana īsceļš E-pasts īsceļš Fakss īsceļš FTP"},{"UUID":"24b1387f-0156-43f1-bef3-5c4b3254a63c","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Card Copy iestatīšana Atveriet tīmekļa","descFull":"Card Copy iestatīšana Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Lietojumprogrammas Card Copy Konfigurēt . Pārbaudiet, vai ir iespējota  ikona Displejs . Pārbaudiet, vai ir konfigurēti  E-pasta iestatījumi  un  Tīkla koplietošanas iestatījumi . Skenējot karti pārliecinieties, vai norādītā skenēšanas izšķirtspēja nepārsniedz 200 dpi krāsainiem dokumentiem un 400 dpi melnbaltiem dokumentiem. Skenējot vairākas kartes pārliecinieties, vai norādītā skenēšanas izšķirtspēja nepārsniedz 150 dpi krāsainiem dokumentiem un 300 dpi melnbaltiem dokumentiem. Piemērojiet izmaiņas. Lai skenētu vairākas kartes, ir nepieciešams printera cietais disks vai viedais krātuves disks. Card Copy iestatīšana"},{"UUID":"5bed2b6a-2abb-4dd9-b1f8-776abeb8c95d","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Displeja pielāgošanas lietošana Pirms lietojumprogrammas","descFull":"Displeja pielāgošanas lietošana Pirms lietojumprogrammas izmantošanas veiciet tālāk norādītās darbības. Serverī Embedded Web Server noklikšķiniet uz  Lietotnes Displeja pielāgošana Konfigurēt . Iespējojiet un konfigurējiet ekrānsaudzētāja, slaidrādes un fona tapetes iestatījumus. Ekrānsaudzētāja un slaidrādes attēlu pārvaldība Sadaļā Ekrānsaudzētāja un slaidrādes attēli pievienojiet, rediģējiet vai izdzēsiet attēlu. Varat pievienot līdz 10 attēliem. Ja opcija ir iespējota, ekrānsaudzētājā tiek parādītas statusa ikonas tikai tad, kad ir kļūdas, brīdinājumi vai mākoņa paziņojumi. Piemērojiet izmaiņas. Fona tapetes attēla maiņa Sākuma ekrānā pieskarieties pie  Mainīt fona tapeti . Atlasiet izmantojamo attēlu. Piemērojiet izmaiņas. Slaidrādes rādīšana no zibatmiņas diska Ievietojiet zibatmiņas disku USB portā. Sākuma ekrānā pieskarieties pie  Slaidrāde . Attēli tiek rādīti alfabētiskā secībā. Kad slaidrāde ir sākta, varat noņemt zibatmiņas disku, taču attēli netiks glabāti printerī. Ja slaidrāde tiek apturēta, vēlreiz ievietojiet zibatmiņas disku, lai skatītu attēlus. displeja pielāgošana lietošana displeja pielāgošanas lietošana displeja pielāgošana fona tapetes maiņa slaidrādes rādīšana ekrānsaudzētāja pārvaldība"},{"UUID":"e6843078-3329-4fa5-8da6-b82bd27359ee","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Klientu atbalsta lietošana Tikai daži","descFull":"Klientu atbalsta lietošana Tikai daži printera modeļi atbalsta šo lietojumprogrammu. Lai iegūtu papildinformāciju, skatiet:  . Tikai daži printera modeļi atbalsta šo lietojumprogrammu. Informāciju par lietojumprogrammas iestatījumu konfigurēšanu skatiet dokumentā  Klientu atbalsta administratora rokasgrāmata. Sākuma ekrānā pieskarieties pie  Klientu atbalsts . Izdrukājiet informāciju vai nosūtiet pa e-pastu. Klientu atbalsts lietošana klientu atbalsta  lietošana"},{"UUID":"1a89abd2-c49c-4515-a69b-931202b68925","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Ierīces kvotu iestatīšana Tikai daži","descFull":"Ierīces kvotu iestatīšana Tikai daži printera modeļi atbalsta šo lietojumprogrammu. Lai iegūtu papildinformāciju, skatiet:  . Tikai daži printera modeļi atbalsta šo lietojumprogrammu. Informāciju par lietojumprogrammas iestatījumu konfigurēšanu skatiet dokumentā  Ierīces kvotu administratora rokasgrāmata . Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Lietotnes Ierīces kvotas Konfigurēt . Sadaļā  Lietotāju konti  pievienojiet vai rediģējiet lietotāju un pēc tam iestatiet lietotāja kvotu. Piemērojiet izmaiņas. ierīces kvotu  iestatīšana Ierīces kvotas iestatīšana"},{"UUID":"5f5bfea1-3067-4666-8a33-b6c3261c8c4b","title":"Grāmatzīmju pārvaldība","link":"using-home-screen-topic.html","desc":"Grāmatzīmju izveide Izmantojiet grāmatzīmes, lai","descFull":"Grāmatzīmju izveide Izmantojiet grāmatzīmes, lai drukātu bieži izmantotus dokumentus, kas ir saglabāti serveros vai tīmeklī. Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Grāmatzīmes Pievienot grāmatzīmi  un pēc tam ierakstiet grāmatzīmes nosaukumu. Atlasiet  Adreses  protokola veidu un pēc tam veiciet kādu no tālāk norādītajām darbībām: Ja izmantojat HTTP un HTTPS, ierakstiet URL, ko lietot kā grāmatzīmi. Izmantojot HTTPS, noteikti izmantojiet resursdatora nosaukumu, nevis IP adresi. Piemēram, ierakstiet  manatīmekļavietne.com/paraugs.pdf , nevis  123.123.123.123/paraugs.pdf . Pārbaudiet, vai resursdatora nosaukums atbilst arī servera sertifikātā norādītajam kopējam nosaukumam (Common Name — CN). Papildinformāciju par CN vērtības iegūšanu servera sertifikātā skatiet tīmekļa pārlūkprogrammas palīdzības saturā. Ja izmantojat FTP, ierakstiet FTP adresi. Piemēram,  mansserveris/mansdirektorijs . Ievadiet FTP porta numuru. 21. ports ir noklusējuma ports, kurā tiek sūtītas komandas. Ja izmantojat SMB, ierakstiet tīkla mapes adresi. Piemēram,  mansserveris/manakoplietošana/mansfails.pdf . Ierakstiet tīkla domēna nosaukumu. Ja nepieciešams, atlasiet FTP un SMB  autentifikācijas  veidu. Lai ierobežotu piekļuvi grāmatzīmei, ievadiet PIN. Lietojumprogramma atbalsta šādus failu veidus: PDF, JPEG un TIFF. Daži printeru modeļi atbalsta citus failu veidus, piemēram, DOCX un XLSX. Noklikšķiniet uz  Saglabāt . grāmatzīmes izveide grāmatzīmju izveide"},{"UUID":"097aac50-fa81-4b3f-988f-6d82fef314e1","title":"Grāmatzīmju pārvaldība","link":"using-home-screen-topic.html","desc":"Mapju izveide Atveriet tīmekļa pārlūkprogrammu","descFull":"Mapju izveide Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Grāmatzīmes Pievienot mapi  un pēc tam ierakstiet mapes nosaukumu. Lai ierobežotu piekļuvi mapei, ievadiet PIN. Noklikšķiniet uz  Saglabāt . Mapē varat izveidot mapes vai grāmatzīmes. Lai izveidotu grāmatzīmi, skatiet  . grāmatzīmes mapju izveide mapju izveide grāmatzīmēm"},{"UUID":"7b40fbbf-8687-429c-8fe8-c7bd90f7697a","title":"Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana","link":"using-home-screen-topic.html","desc":"Adrešu grāmata Kontaktpersonu pārvaldība Sākuma","descFull":"Adrešu grāmata Kontaktpersonu pārvaldība Sākuma ekrānā pieskarieties pie  Adrešu grāmata . Izpildiet vienu vai vairākas tālāk norādītās darbības. Lai pievienotu kontaktpersonu, ekrāna augšdaļā pieskarieties pie   un pēc tam pieskarieties pie  Izveidot kontaktpersonu . Ja nepieciešams, norādiet pieteikšanās veidu, lai atļautu piekļuvi lietojumprogrammām. Lai izdzēstu kontaktpersonu, ekrāna augšdaļā pieskarieties pie  , pieskarieties pie  Dzēst kontaktpersonas  un pēc tam atlasiet kontaktpersonu. Lai rediģētu kontaktpersonas informāciju, pieskarieties pie kontaktpersonas vārda. Lai izveidotu grupu, ekrāna augšdaļā pieskarieties pie   un pēc tam pieskarieties pie  Izveidot grupu . Ja nepieciešams, norādiet pieteikšanās veidu, lai atļautu piekļuvi lietojumprogrammām. Lai izdzēstu grupu, ekrāna augšdaļā pieskarieties pie  , pieskarieties pie  Dzēst grupas  un pēc tam atlasiet grupu. Lai rediģētu kontaktpersonu grupu, pieskarieties pie  GROUPS atlasiet grupas nosaukumu  atlasiet vajadzīgo darbību. Piemērojiet izmaiņas. kontaktpersonu pievienošana kontaktpersonu dzēšana kontaktpersonu grupu pievienošana kontaktpersonu grupu dzēšana kontaktpersonu rediģēšana Adrešu grāmata lietošana"},{"UUID":"10a9aec3-eb0f-483e-b777-4aaf5444489f","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Balss norāžu aktivizēšana Sākuma ekrānā","descFull":"Balss norāžu aktivizēšana Sākuma ekrānā Ar vienu pirkstu un vienu kustību displejā lēnām pārvelciet pa kreisi un pēc tam uz augšu, līdz dzirdat balss ziņojumu. Ar diviem pirkstiem pieskarieties pie  Labi . Ja žesti nestrādā, pieskarieties stingrāk. Lietojot tastatūru Nospiediet un turiet taustiņu  5 , līdz dzirdat balss ziņojumu. Nospiediet taustiņu  Tab , lai pārvietotu kursoru uz pogas Labi, pēc tam nospiediet taustiņu  Enter . Kad ir aktivizētas balss norādes, vienmēr izmantojiet divus pirkstus, lai atlasītu jebkuru vienumu displejā. Balss norādes tiek atbalstītas dažās valodās. balss norādes aktivizēšana Balss norāžu aktivizēšana"},{"UUID":"3450e280-92ee-4422-a220-70d0e4dc8cc4","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Balss norāžu deaktivizēšana Ar vienu","descFull":"Balss norāžu deaktivizēšana Ar vienu pirkstu un vienu kustību displejā lēnām pārvelciet pa kreisi un pēc tam uz augšu, līdz dzirdat balss ziņojumu. Ar diviem pirkstiem veiciet kādu no šīm darbībām: Pieskarieties pie  Balss norādes , pēc tam pieskarieties pie  Labi . Pieskarieties pie  Atcelt . Ja žesti nestrādā, pieskarieties stingrāk. Balss norādes varat arī deaktivizēt, veicot kādu no šīm darbībām: Ar diviem pirkstiem divreiz pieskarieties sākuma ekrānam. Nospiediet ieslēgšanas/izslēgšanas pogu, lai printerī aktivizētu miega vai hibernēšanas režīmu. balss norādes deaktivizēšana balss norāžu deaktivizēšana"},{"UUID":"a95539ce-dbb1-432b-bc74-06f6ba8d1232","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Pārvietošanās ekrānā, izmantojot žestus Vairākumu","descFull":"Pārvietošanās ekrānā, izmantojot žestus Vairākumu žestu var izmantot tikai tad, ja ir aktivizētas balss norādes. Iespējojiet palielinājumu, lai lietotu tālummaiņas un panoramēšanas žestus. Izmantojiet fizisko tastatūru, lai ievadītu rakstzīmes un koriģētu noteiktus iestatījumus. Žesti un to funkcijas Žests Funkcija Ar vienu pirkstu pārvelciet pa kreisi un pēc tam uz augšu Atveriet pieejamības režīmu. Izmantojiet šo pašu žestu, lai izietu no pieejamības režīma. Šo žestu var lietot arī tad, kad printeris ir normālā darbības režīmā. Ar vienu pirkstu divas reizes pieskarieties Ekrānā atlasiet opciju vai vienumu. Ar diviem pirkstiem divas reizes pieskarieties sākuma ekrāna ikonai Deaktivizējiet pieejamības režīmu. Ar vienu pirkstu trīs reizes pieskarieties Tuviniet vai tāliniet tekstu un attēlus. Ar vienu pirkstu pārvelciet pa labi vai uz leju Pārejiet pie nākamā vienuma ekrānā. Ar vienu pirkstu pārvelciet pa kreisi vai uz augšu Pārejiet pie iepriekšējā vienuma ekrānā. Ar vienu pirkstu pārvelciet uz augšu un pēc tam uz leju Pārejiet pie pirmā vienuma ekrānā. Bīdīšana Piekļūstiet tālummainīta attēla detaļām, kas atrodas ārpus ekrāna. Ar diviem pirkstiem velciet tālummainīto attēlu. Ar vienu pirkstu pārvelciet uz augšu un pēc tam pa labi Palieliniet skaļumu. Šo žestu var lietot arī tad, kad printeris ir normālā darbības režīmā. Ar vienu pirkstu pārvelciet uz leju un pēc tam pa labi Samaziniet skaļumu. Šo žestu var lietot arī tad, kad printeris ir normālā darbības režīmā. Ar vienu pirkstu pārvelciet uz augšu un pēc tam pa kreisi Izejiet no lietojumprogrammas un atgriezieties sākuma ekrānā. Ar vienu pirkstu pārvelciet uz leju un pēc tam pa kreisi Atgriezieties pie iepriekšējā iestatījuma. pārvietošanās ekrānā lietojot žestus pārvietošanās ekrānā, izmantojot žestus"},{"UUID":"01f26209-4bb7-4e76-b6f5-f61f9bf276d6","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Ekrāna tastatūras lietošana Kad ir","descFull":"Ekrāna tastatūras lietošana Kad ir redzama ekrāna tastatūra, veiciet vienu vai vairākas no šīm darbībām: Pieskarieties taustiņam, lai rakstzīmi izrunātu un ierakstītu laukā. Ar pirkstu velciet pa dažādām rakstzīmēm, lai rakstzīmi izrunātu un ierakstītu laukā. Ar diviem pirkstiem pieskarieties tekstlodziņam, lai izrunātu laukā esošās rakstzīmes. Pieskarieties pie  Atpakaļatkāpe , lai dzēstu rakstzīmes. ekrāna tastatūra lietošana"},{"UUID":"eb320851-7309-4ee1-9a58-1827212c80fe","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Palielinājuma režīma iespējošana Ar vienu","descFull":"Palielinājuma režīma iespējošana Ar vienu pirkstu un vienu kustību displejā lēnām pārvelciet pa kreisi un pēc tam uz augšu, līdz dzirdat balss ziņojumu. Printera modeļos bez iebūvētiem skaļruņiem izmantojiet austiņas, lai dzirdētu ziņojumu. Ar diviem pirkstiem veiciet šādas darbības: Pieskarieties pie  Palielinājuma režīms . Pieskarieties pie  Labi . Ja žesti nestrādā, pieskarieties stingrāk. Lai iegūtu papildinformāciju par pārvietošanos palielinātā ekrānā, skatiet:  . palielinājuma režīms iespējošana palielinājuma režīma iespējošana"},{"UUID":"0171651c-7bab-430e-8f6f-2d751dbf4469","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Balss norāžu runas ātruma pielāgošana","descFull":"Balss norāžu runas ātruma pielāgošana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Pieejamība Runas ātrums . Atlasiet runas ātrumu. balss norādes runas ātrums balss norāžu runas ātrums koriģēšana runas ātruma koriģēšana balss norādes"},{"UUID":"c70e35d3-5719-4518-9253-affedb22d2df","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Austiņu noklusējuma skaļuma koriģēšana Sākuma","descFull":"Austiņu noklusējuma skaļuma koriģēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Pieejamība . Koriģējiet austiņu skaļumu. Skaļums tiek atiestatīts uz noklusējuma vērtību, kad lietotājs iziet no pieejamības režīma vai printeris atsāk darbību pēc miega vai hibernēšanas režīma. austiņu noklusējuma skaļums koriģēšana noklusējuma skaļuma regulēšana austiņas"},{"UUID":"4761fc10-2caf-4429-b80c-72bd9c35cc80","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Iekšējā skaļruņa noklusējuma skaļuma koriģēšana","descFull":"Iekšējā skaļruņa noklusējuma skaļuma koriģēšana Sākuma ekrānā pieskarieties pie  . Koriģējiet skaļumu. Ja ir iespējots klusais režīms, skaņas signāli tiek izslēgti. Šis iestatījums samazina arī printera darbības ātrumu. Skaļums tiek atiestatīts uz noklusējuma vērtību, kad lietotājs iziet no pieejamības režīma vai printeris atsāk darbību pēc miega vai hibernēšanas režīma. skaļruņa noklusējuma skaļums koriģēšana noklusējuma skaļuma regulēšana skaļrunis"},{"UUID":"4bddf53c-b30d-4de3-8047-692a3caec077","title":"Pieejamības funkciju iestatīšana un lietošana","link":"activating-voice-guidance-topic.html","desc":"Izrunātu paroļu vai personas identifikācijas","descFull":"Izrunātu paroļu vai personas identifikācijas numuru iespējošana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Pieejamība Izrunāt paroles/PIN . Iespējojiet iestatījumu. izrunātas paroles iespējošana personas identifikācijas numuri iespējošana izrunātu paroļu iespējošana personas identifikācijas numuru iespējošana"},{"UUID":"23efdfd6-360d-49de-be2c-70f859e779a4","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Atbalstītie faksi Printera modeļi un","descFull":"Atbalstītie faksi Printera modeļi un to atbalstītie faksi Printera modelis Analogais fakss 1 etherFAX 2 Faksa serveris Fax over IP (FoIP) 3 1  Nepieciešama uzstādīta faksa karte. Papildinformāciju jautājiet printera iegādes vietā. 2  Nepieciešams abonements. Lai iegūtu papildinformāciju, skatiet vietni  https://www.etherfax.net/lexmark  vai jautājiet printera iegādes vietā. 3  Jāinstalē licenču kopa. Papildinformāciju jautājiet printera iegādes vietā. CX930 CX931 XC9325 XC9335 atbalstītie faksi"},{"UUID":"4135a297-ca0f-49d2-b0af-f6ba2fd2d730","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Faksa funkcijas iestatīšana, izmantojot analogo","descFull":"Faksa funkcijas iestatīšana, izmantojot analogo faksu Ir jāuzstāda faksa karte, lai printeris varētu lietot analogo faksu. Dažas savienojuma metodes ir izmantojamas tikai dažās valstīs vai reģionos. Ja faksa funkcija ir iespējota un nav pilnībā iestatīta, iespējams, mirgo sarkana indikatora gaisma. Ja jums nav TCP/IP vides, faksu iestatiet vadības panelī. Lai izvairītos no datu zaudēšanas vai nepareizas printera darbības, faksa saņemšanas vai sūtīšanas laikā nepieskarieties kabeļiem vai printerim šeit attēlotajos apgabalos. Izvēlnes  Iestatījumi  lietošana printerī Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Vispārīgi faksa iestatījumi . Konfigurējiet iestatījumus. Ja lietojat serveri Embedded Web Server Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi Fakss Faksa iestatīšana Vispārīgi faksa iestatījumi . Konfigurējiet iestatījumus. Piemērojiet izmaiņas. analogais fakss iestatīšana iestatīšana analogais fakss"},{"UUID":"910f29a0-e8b8-410c-b514-eb4c17963e27","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Faksa funkcijas iestatīšana, izmantojot etherFAX","descFull":"Faksa funkcijas iestatīšana, izmantojot etherFAX Printera programmaparatūrai jābūt atjauninātai uz jaunāko versiju. Lai iegūtu papildinformāciju, skatiet:  . Printerī ir jābūt instalētai atbilstošai licenču kopai. Lai iegūtu papildinformāciju, sazinieties ar etherFAX. Pārliecinieties, vai jūsu printeris ir reģistrēts etherFAX portālā. Lai iegūtu papildinformāciju, skatiet vietni  https://www.etherfax.net/lexmark . Reģistrējoties ir nepieciešams printera sērijas numurs. Lai atrastu sērijas numuru, skatiet  . Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi Fakss Faksa iestatīšana Vispārīgi faksa iestatījumi . Iestatījums  Faksa iestatīšana  ir redzams tikai tad, ja  Faksa režīms  iestatījums ir  Fakss . Laukā  Faksa nosaukums  ierakstiet unikālu nosaukumu. Laukā  Faksa numurs  ierakstiet faksa numuru, ko izsniedza etherFAX. Izvēlnē  Faksa pārraide  atlasiet  etherFAX . Šī izvēlne ir redzama tikai tad, ja ir pieejama vairāk nekā viena faksa pārraide. Ja printerim ir uzstādīta tikai etherFAX, tā tiek automātiski konfigurēta. Piemērojiet izmaiņas. etherFAX faksa funkcijas iestatīšana faksa funkcijas iestatīšana etherFAX lietošana"},{"UUID":"77919fb1-cdc9-41f9-a4ab-ea07a4b0c053","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Faksa funkcijas iestatīšana, izmantojot faksa","descFull":"Faksa funkcijas iestatīšana, izmantojot faksa serveri Šī funkcija ļauj sūtīt faksa ziņojumus faksa pakalpojumu sniedzējam, kas atbalsta e-pasta ziņojumu saņemšanu. Šī funkcija atbalsta tikai izejošos faksa ziņojumus. Lai nodrošinātu faksa saņemšanu, nodrošiniet, lai jūsu printerī būtu konfigurēta faksa ierīce, piemēram, analogais fakss, etherFAX vai Fax over IP (FoIP). Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi Fakss . Izvēlnē  Faksa režīms  atlasiet  Faksa serveris  un pēc tam noklikšķiniet uz  Saglabāt . Noklikšķiniet uz  Faksa servera iestatīšana . Laukā  Adresāta formāts  ierakstiet  [#]@myfax.com , kur  [#]  ir faksa numurs un  myfax.com  ir faksa pakalpojumu sniedzēja domēns. Ja nepieciešams, konfigurējiet lauku  Atbildes adrese ,  Tēma  vai  Ziņojums . Lai nodrošinātu, ka printerī tiek saņemti faksa ziņojumi, iespējojiet faksa saņemšanas iestatījumu ierīcē. Nodrošiniet, lai būtu konfigurēta faksa ierīce. Noklikšķiniet uz  Saglabāt . Noklikšķiniet uz  Faksa servera e-pasta iestatījumi  un pēc tam veiciet kādu no tālāk norādītajām darbībām. Iespējojiet  Lietot SMTP serveri e-pasta funkcijai . Ja SMTP iestatījumi e-pasta funkcijai nav konfigurēti, skatiet sadaļu  . Konfigurējiet SMTP iestatījumus. Papildinformāciju jautājiet savam e-pasta pakalpojumu sniedzējam. Piemērojiet izmaiņas. faksa serveris, lietošana faksa funkcijas iestatīšana faksa funkcijas iestatīšana, izmantojot faksa serveri"},{"UUID":"357ccde9-f4b6-422f-b661-1ced53512162","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Faksa iestatīšana, izmantojot standarta tālruņa","descFull":"Faksa iestatīšana, izmantojot standarta tālruņa līniju Šie norādījumi attiecas tikai uz tiem printeriem, kas atbalsta analogo faksu. Lai iegūtu papildinformāciju, skatiet:  . Šie norādījumi attiecas tikai uz tiem printeriem, kas atbalsta analogo faksu. Lai izvairītos no elektrošoka riska, negaisa laikā neveiciet šī produkta uzstādīšanu un neveidojiet nekādus elektriskus vai kabeļu savienojumus, izmantojot, piemēram, strāvas vadu, faksa funkciju vai tālruņa līniju. Lai izvairītos no elektrošoka riska, nelietojiet faksa funkciju negaisa laikā. Lai samazinātu aizdegšanās risku, kad šo produktu pievienojat publiskajam tālruņa tīklam, izmantojiet tikai 26 AWG vai lielāku telekomunikāciju (RJ-11) vadu. Lietotājiem Austrālijā jāizmanto Austrālijas Komunikāciju un mediju iestādes apstiprināts vads. 1. iestatīšanas veids. Printeris ir pievienots atvēlētajai faksa līnijai Vienu tālruņa kabeļa galu pievienojiet printera līnijas portam. Otru kabeļa galu pievienojiet aktīvai analogajai kontaktligzdai. Varat iestatīt printeri saņemt faksus automātiski (opcijas  Automātiska atbilde  iestatījums  Ieslēgts ) vai manuāli (opcijas  Automātiska atbilde  iestatījums  Izslēgts ). Ja vēlaties saņemt faksus automātiski, iestatiet printeri atbildēt, kad tiek saņemts konkrēts zvanu skaits. 2. iestatīšanas veids. Printerim ir kopīga līnija ar automātisko atbildētāju Ja abonējat atšķirīgas zvanīšanas pakalpojumu, pārliecinieties, ka printerī iestatāt pareizo zvana signālu. Pretējā gadījumā printeris nevar saņemt faksus pat tad, ja ir iestatīta automātiska faksu saņemšana. Ierīces ir pievienotas dažādām kontaktligzdām Vienu tālruņa kabeļa galu pievienojiet printera līnijas portam. Otru kabeļa galu pievienojiet aktīvai analogajai kontaktligzdai. Ja līnija tiek izmantota tikai vienam tālruņa numuram, iestatiet printeri saņemt faksus automātiski. Iestatiet printeri atbildēt uz zvaniem, nogaidot divus zvana signālus pēc automātiskā atbildētāja. Piemēram, ja automātiskais atbildētājs atbild uz zvaniem pēc četriem zvana signāliem, kā printera iestatījuma  Zvana signāli pirms atbildes  vērtību norādiet  6 . faksa iestatīšana standarta tālruņa līnijas savienojums faksa iestatīšana standarta tālruņa līnijas savienojums automātiskais atbildētājs iestatīšana"},{"UUID":"73c8d439-162d-4414-a2b9-69c433218230","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Faksa iestatīšana valstīs vai reģionos","descFull":"Faksa iestatīšana valstīs vai reģionos ar atšķirīgām tālruņa kontaktligzdām un spraudņiem Šie norādījumi attiecas tikai uz tiem printeriem, kas atbalsta analogo faksu. Lai iegūtu papildinformāciju, skatiet:  . Šie norādījumi attiecas tikai uz tiem printeriem, kas atbalsta analogo faksu. Lai izvairītos no elektrošoka riska, negaisa laikā neveiciet šī produkta uzstādīšanu un neveidojiet nekādus elektriskus vai kabeļu savienojumus, izmantojot, piemēram, strāvas vadu, faksa funkciju vai tālruņa līniju. Lai izvairītos no elektrošoka riska, nelietojiet faksa funkciju negaisa laikā. Lai samazinātu aizdegšanās risku, kad šo produktu pievienojat publiskajam tālruņa tīklam, izmantojiet tikai 26 AWG vai lielāku telekomunikāciju (RJ-11) vadu. Lietotājiem Austrālijā jāizmanto Austrālijas Komunikāciju un mediju iestādes apstiprināts vads. Standarta sienas kontaktligzda, kas tiek lietota lielākajā daļā valstu vai reģionu, ir RJ-11. Ja jūsu telpās esošā kontaktligzda vai aprīkojums nav piemērots šāda veida savienojumam, izmantojiet tālruņa adapteri. Jūsu valstij vai reģionam paredzēts adapteris, iespējams, nav iekļauts printera komplektācijā, un to ir jāiegādājas atsevišķi. Printera tālruņa portā, iespējams, ir uzstādīts adaptera spraudnis. Nenoņemiet adaptera spraudni no printera tālruņa porta, ja veidojat savienojumu ar seriālu vai kaskādes veida tālruņa sistēmu. Adaptera spraudņa daļas numurs Daļas nosaukums Daļas numurs Lexmark adaptera spraudnis 40X8519 Printera pievienošana citai, nevis RJ-11 sienas kontaktligzdai Vienu tālruņa kabeļa galu pievienojiet printera līnijas portam. Otru kabeļa galu pievienojiet RJ-11 adapterim un pēc tam pievienojiet adapteri sienas kontaktligzdai. Ja vēlaties tai pašai sienas kontaktligzdai pievienot papildu ierīci ar citu, nevis RJ-11 savienotāju, pievienojiet to tieši tālruņa adapterim. faksa iestatīšana atkarīgs no valsts vai reģiona faksa iestatīšana atkarīgs no valsts vai reģiona RJ‑11 adapteris adaptera spraudnis"},{"UUID":"66e7aca4-6c1e-497c-ad6b-79c1c17c8ac1","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Pievienošana atšķirīgās zvanīšanas pakalpojumam Atšķirīgās","descFull":"Pievienošana atšķirīgās zvanīšanas pakalpojumam Atšķirīgās zvanīšanas pakalpojums ļauj izmantot vairākus tālruņa numurus vienā tālruņa līnijā. Katrs tālruņa numurs tiek piesaistīts atšķirīgam zvana signālam. Šie norādījumi attiecas tikai uz tiem printeriem, kas atbalsta analogo faksu. Lai iegūtu papildinformāciju, skatiet:  . Šie norādījumi attiecas tikai uz tiem printeriem, kas atbalsta analogo faksu. Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Faksa saņemšanas iestatījumi Administratora vadīklas Atbildēt uz . Atlasiet zvana signālu. atšķirīgas zvanīšanas pakalpojums, fakss iespējošana printera pievienošana atšķirīgās zvanīšanas pakalpojumam zvana signāla piešķiršana printerim"},{"UUID":"18d0d46d-7692-4e72-9228-105912b503ce","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Faksa datuma un laika iestatīšana","descFull":"Faksa datuma un laika iestatīšana Pārbaudiet, vai fakss ir konfigurēts. Lai iegūtu papildinformāciju, skatiet:  . Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Preferences Datums un laiks Konfigurēt . Konfigurējiet iestatījumus. faksa sūtīšana datuma un laika iestatīšana datums un laiks faksa iestatījumi"},{"UUID":"704c8170-0015-4e0f-9083-464c87853de6","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Ziemas/vasaras laika perioda konfigurēšana Pārbaudiet,","descFull":"Ziemas/vasaras laika perioda konfigurēšana Pārbaudiet, vai fakss ir konfigurēts. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Preferences Datums un laiks Konfigurēt . Izvēlnē  Laika josla  pieskarieties pie  (UTC+lietotājs) pielāgots . Pieskarieties pie  UTC (GMT) laika nobīde  un pēc tam konfigurējiet iestatījumus. ziemas/vasaras laika perioda konfigurēšana ziemas/vasaras laiks konfigurēšana"},{"UUID":"1a00ea19-0d88-4b7c-baf5-d8d1d4d58ec6","title":"Faksa funkcijas iestatīšana printerī","link":"setting-up-printer-to-fax-group.html","desc":"Faksa skaļruņa iestatījumu konfigurēšana Pārbaudiet,","descFull":"Faksa skaļruņa iestatījumu konfigurēšana Pārbaudiet, vai fakss ir konfigurēts. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Skaļruņa iestatījumi . Rīkojieties šādi: Izvēlieties opcijas  Skaļruņa režīms  iestatījumu  Vienmēr ieslēgts . Izvēlieties opcijas  Skaļruņa skaļums  iestatījumu  Augsts . Iespējojiet  Zvanītāja skaļums . faksa skaļruņa iestatījumu konfigurēšana faksa skaļruņa iestatījumi konfigurēšana"},{"UUID":"e4943715-f519-4a42-9d2a-60dd725afd71","title":"Uzstādīšana, instalēšana un konfigurēšana","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"E-pasta SMTP iestatījumu konfigurēšana Konfigurējiet","descFull":"E-pasta SMTP iestatījumu konfigurēšana Konfigurējiet vienkāršā pasta pārsūtīšanas protokola (Simple Mail Transfer Protocol — SMTP) iestatījumus, lai e-pastā sūtītu skenētu dokumentu. Katram e-pasta pakalpojumu sniedzējam iestatījumi var atšķirties. Pirms darba sākšanas pārbaudiet, vai printeris ir pievienots tīklam un tīkls ir savienots ar internetu. Embedded Web Server lietošana Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi E-pasts Sadaļā  E-pasta iestatīšana  konfigurējiet iestatījumus. Papildinformāciju skatiet sarakstā ar  e-pasta pakalpojumu sniedzējiem . Ja e-pasta pakalpojumu sniedzējs nav sarakstā, sazinieties ar savu pakalpojumu sniedzēju, lai noskaidrotu iestatījumus. Noklikšķiniet uz  Saglabāt . Izvēlnes  Iestatījumi  lietošana printerī Sākuma ekrānā pieskarieties pie  Iestatījumi E-pasts E-pasta iestatīšana Konfigurējiet iestatījumus. Papildinformāciju skatiet sarakstā ar  e-pasta pakalpojumu sniedzējiem . Ja e-pasta pakalpojumu sniedzējs nav sarakstā, sazinieties ar savu pakalpojumu sniedzēju, lai noskaidrotu iestatījumus. E‑pasta pakalpojumu sniedzēji AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live vai Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Ja, izmantojot nodrošinātos iestatījumus, rodas kļūdas, sazinieties ar savu e-pasta pakalpojumu sniedzēju. Ja e-pasta pakalpojumu sniedzējs nav sarakstā, sazinieties ar savu sniedzēju. AOL Mail AOL Mail iestatījums Iestatījums Vērtība Primārā SMTP vārteja smtp.aol.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Lietotnes parole  Lai izveidotu lietotnes paroli, atveriet lapu  AOL Account Security , piesakieties savā kontā un pēc tam noklikšķiniet uz  Generate app password . Comcast Mail Comcast Mail iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.comcast.net Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Konta parole Nodrošiniet, lai jūsu kontā ir iespējots trešās puses piekļuves drošības iestatījums. Papildinformāciju skatiet  Comcast Xfinity Connect palīdzības lapā . Gmail Pārbaudiet, vai jūsu Google kontā ir iespējota divpakāpju verifikācija. Lai iespējotu divpakāpju verifikāciju, atveriet lapu  Google Account Security , piesakieties savā kontā un pēc tam sadaļā  Signing in to Google  noklikšķiniet uz  2‑Step Verification . Gmail SMTP iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.gmail.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Lietotnes parole Lai izveidotu lietotnes paroli, atveriet lapu  Google Account Security , piesakieties savā kontā un pēc tam sadaļā  Signing in to Google  noklikšķiniet uz  App passwords . Opcija  App passwords  ir redzama tikai tad, ja ir iespējota divpakāpju verifikācija. iCloud Mail Pārbaudiet, vai jūsu kontā ir iespējota divpakāpju verifikācija. iCloud Mail iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.mail.me.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Lietotnes parole Lai izveidotu lietotnes paroli, atveriet lapu  iCloud Account Management , piesakieties savā kontā un pēc tam sadaļā  Security  noklikšķiniet uz  Generate Password . Mail.com Mail.com iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.mail.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Konta parole NetEase Mail (mail.126.com) Pārbaudiet, vai jūsu kontā ir iespējots SMTP pakalpojums. Lai iespējotu pakalpojumu, NetEase Mail sākumlapā noklikšķiniet uz  Settings POP3/SMTP/IMAP  un tad iespējojiet vai nu  IMAP/SMTP service  vai  POP3/SMTP service NetEase Mail (mail.126.com) iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.126.com Primārās SMTP vārtejas ports 465 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Autorizēšanas parole Autorizēšanas parole tiek nodrošināta tad, ja ir iespējots iestatījums  IMAP/SMTP service  vai  POP3/SMTP service . NetEase Mail (mail.163.com) Pārbaudiet, vai jūsu kontā ir iespējots SMTP pakalpojums. Lai iespējotu pakalpojumu, NetEase Mail sākumlapā noklikšķiniet uz  Settings POP3/SMTP/IMAP  un tad iespējojiet vai nu  IMAP/SMTP service  vai  POP3/SMTP service NetEase Mail (mail.163.com) iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.163.com Primārās SMTP vārtejas ports 465 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Autorizēšanas parole Autorizēšanas parole tiek nodrošināta tad, ja ir iespējots iestatījums  IMAP/SMTP service  vai  POP3/SMTP service . NetEase Mail (mail.yeah.net) Pārbaudiet, vai jūsu kontā ir iespējots SMTP pakalpojums. Lai iespējotu pakalpojumu, NetEase Mail sākumlapā noklikšķiniet uz  Settings POP3/SMTP/IMAP  un tad iespējojiet vai nu  IMAP/SMTP service  vai  POP3/SMTP service NetEase Mail (mail.yeah.net) iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.yeah.net Primārās SMTP vārtejas ports 465 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Autorizēšanas parole Autorizēšanas parole tiek nodrošināta tad, ja ir iespējots iestatījums  IMAP/SMTP service  vai  POP3/SMTP service . Outlook Live vai Microsoft 365 Šie iestatījumi attiecas uz outlook.com, hotmail.com e-pasta domēniem un Microsoft 365 kontiem. Outlook Live vai Microsoft 365 iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.office365.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Konta parole vai lietotnes parole Kontos, kuros ir atspējota divpakāpju verifikācija, izmantojiet konta paroli. Outlook.com vai hotmail.com kontos, kuros ir iespējota divpakāpju verifikācija, izmantojiet lietotnes paroli. Lai izveidotu lietotnes paroli, atveriet lapu  Outlook Live Account Management  un pēc tam piesakieties savā kontā. Papildu iestatīšanas opcijas uzņēmumiem, kuros izmanto Microsoft 365, skatiet  Microsoft 365 palīdzības lapā . QQ Mail Pārbaudiet, vai jūsu kontā ir iespējots SMTP pakalpojums. Lai iespējotu pakalpojumu, QQ Mail sākumlapā noklikšķiniet uz  Settings Account . Sadaļā  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  iespējojiet  POP3/SMTP service  vai  IMAP/SMTP service . QQ Mail iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.qq.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Autorizēšanas kods Lai ģenerētu autorizēšanas kodu, QQ Mail sākumlapā noklikšķiniet uz  Settings Account  un tad sadaļā  POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV Service  noklikšķiniet uz  Generate authorization code . Sina Mail Pārbaudiet, vai jūsu kontā ir iespējots POP3/SMTP pakalpojums. Lai iespējotu pakalpojumu, Sina Mail sākumlapā noklikšķiniet uz  Settings More settings User‑end POP/IMAP/SMTP  un tad iespējojiet  POP3/SMTP service . Sina Mail iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.sina.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Autorizēšanas kods Lai ģenerētu autorizēšanas kodu, e-pasta sākumlapā noklikšķiniet uz  Settings More settings User‑end POP/IMAP/SMTP , un tad iespējojiet  Authorization code status . Sohu Mail Pārbaudiet, vai jūsu kontā ir iespējots SMTP pakalpojums. Lai iespējotu pakalpojumu, Sohu Mail sākumlapā noklikšķiniet uz  Options Settings POP3/SMTP/IMAP  un tad iespējojiet vai nu  IMAP/SMTP service  vai  POP3/SMTP service Sohu Mail iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.sohu.com Primārās SMTP vārtejas ports 465 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Neatkarīga parole Neatkarīga parole tiek nodrošina tad, ja ir iespējots iestatījums  IMAP/SMTP service  vai  POP3/SMTP service . Yahoo! Mail Yahoo! mail iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.mail.yahoo.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Lietotnes parole  Lai izveidotu lietotnes paroli, atveriet lapu  Yahoo Account Security , piesakieties savā kontā un pēc tam noklikšķiniet uz  Generate app password . Zoho Mail Zoho Mail iestatījumi Iestatījums Vērtība Primārā SMTP vārteja smtp.zoho.com Primārās SMTP vārtejas ports 587 Izmantot SSL/TLS Nepieciešams Pieprasīt uzticamu sertifikātu Atspējots Atbildes adrese Jūsu e-pasta adrese SMTP servera autentifikācija Pieteikšanās/parasta Ierīces iniciēts e-pasts Lietot ierīces SMTP akreditācijas datus Ierīces lietotāja ID Jūsu e-pasta adrese Ierīces parole Konta parole vai lietotnes parole Kontos, kuros ir atspējota divpakāpju verifikācija, izmantojiet konta paroli. Kontos, kuros ir iespējota divpakāpju verifikācija, izmantojiet lietotnes paroli. Lai izveidotu lietotnes paroli, atveriet lapu  Zoho Mail Account Security , piesakieties savā kontā un pēc tam sadaļā  Application‑Specific Passwords  noklikšķiniet uz  Generate New Password . e‑pasta pakalpojumu sniedzēji e-pasta servera iestatījumu konfigurēšana SMTP iestatījumi konfigurēšana e‑pasta funkcija iestatīšana E-pasta serveris konfigurēšana"},{"UUID":"0c684f4e-2cbb-4b6e-a332-8b5d1c75c810","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Speciālā apdrukājamā materiāla izmēru un","descFull":"Speciālā apdrukājamā materiāla izmēru un veida iestatīšana Paplātes automātiski nosaka vienkārša papīra izmērus. Ja izmantojat speciālo apdrukājamo materiālu, piemēram, etiķetes, kartonu vai aploksnes, veiciet tālāk norādītās darbības. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids  atlasiet papīra avotu. Iestatiet speciālā apdrukājamā materiāla izmērus un veidu. papīra izmēru iestatīšana papīra veida iestatīšana papīra izmēri iestatīšana papīra veids iestatīšana"},{"UUID":"723a80fd-55b7-4651-9e44-68a4a2344e11","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Universālo papīra izmēru iestatījumu konfigurēšana","descFull":"Universālo papīra izmēru iestatījumu konfigurēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Apdrukājamā materiāla konfigurēšana Universālā iestatīšana . Konfigurējiet iestatījumus. papīrs universālu izmēru iestatījums universālo papīra izmēru iestatīšana universāli papīra izmēri iestatīšana"},{"UUID":"7e5ad3c7-471a-4253-9431-0c3f9794dc46","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Iestatījuma  Vairāki universāli izmēri","descFull":"Iestatījuma  Vairāki universāli izmēri  iespējošana Sākuma ekrānā pieskarieties  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Paplātes konfigurēšana . Iespējojiet iestatījumu  Vairāki universāli izmēri . Vairāki universāli izmēri iespējošana papīra izmēru iestatīšana Vairāki universāli izmēri"},{"UUID":"79349c33-c5fa-49b6-a073-fc2882682a1b","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Papīra ievietošana 520 lokšņu paplātē Lai","descFull":"Papīra ievietošana 520 lokšņu paplātē Lai novērstu nestabilu iekārtas novietojumu, ievietojiet papīru katrā paplātē atsevišķi. Turiet pārējās paplātes aizvērtas, kamēr tās netiek lietotas. Izvelciet paplāti. Lai novērstu papīra iestrēgšanu, neizvelciet paplātes printera darbības laikā. Pielāgojiet vadotnes atbilstoši ievietojamā papīra izmēriem. Lai novietotu vadotnes, izmantojiet indikatorus paplātes apakšdaļā. Pirms papīra ievietošanas izlieciet, pāršķirstiet to un nolīdziniet papīra malas. Ievietojiet papīra kaudzi ar apdrukājamo pusi uz leju. Ja ievietojat veidlapas vai caurumotu papīru, veiciet kādu no tālāk norādītajām darbībām. Vienpusēja drukāšana garās malas orientācijā Veidlapas ievietojiet ar apdrukāto pusi uz augšu tā, lai galvene būtu vērsta uz paplātes aizmuguri. Caurumoto papīru novietojiet ar apdrukāto pusi uz augšu un ar caurumiem pret paplātes kreiso pusi. Vienpusēja drukāšana īsās malas orientācijā Veidlapas ievietojiet ar apdrukāto pusi uz augšu tā, lai galvene būtu vērsta uz paplātes kreiso pusi. Caurumoto papīru novietojiet ar apdrukāto pusi uz augšu un ar caurumiem pret paplātes priekšpusi. Divpusēja drukāšana garās malas orientācijā Veidlapas ievietojiet ar apdrukāto pusi uz leju tā, lai galvene būtu vērsta uz paplātes aizmuguri. Caurumoto papīru novietojiet ar apdrukāto pusi uz leju un ar caurumiem pret paplātes labo pusi. Divpusēja drukāšana īsās malas orientācijā Veidlapas ievietojiet ar apdrukāto pusi uz leju tā, lai galvene būtu vērsta uz paplātes kreiso pusi. Caurumoto papīru novietojiet ar apdrukāto pusi uz leju un ar caurumiem pret paplātes aizmuguri. Neslidiniet papīru paplātē. Pārliecinieties, vai sānu vadotnes cieši pieguļ papīram. Nodrošiniet, lai ievietotā papīra daudzums nepārsniedz maksimālā papīra daudzuma indikatoru. Pārpildīšana var radīt papīra sastrēgumu. Ievietojiet paplāti. Ja nepieciešams, iestatiet papīra izmērus un veidu atbilstoši paplātēs ievietotajam papīram. Ja ir uzstādīts apdarinātājs, drukātie attēli tiek apgriezti par 180°. 520 lokšņu paplāte ievietošana ievietošana 520 lokšņu paplātē paplāšu ievietošana"},{"UUID":"5bb7af7b-fad8-40e6-90df-c6512e283569","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Papīra ievietošana 2520 lokšņu tandēma paplātē","descFull":"Papīra ievietošana 2520 lokšņu tandēma paplātē Lai novērstu nestabilu iekārtas novietojumu, ievietojiet papīru katrā paplātē atsevišķi. Turiet pārējās paplātes aizvērtas, kamēr tās netiek lietotas. Izvelciet paplāti. Lai novērstu papīra iestrēgšanu, neizvelciet paplātes printera darbības laikā. Pielāgojiet vadotnes atbilstoši ievietojamā papīra izmēriem. Pirms papīra ievietošanas izlieciet, pāršķirstiet to un nolīdziniet papīra malas. Ievietojiet papīru. Vienpusēja drukāšana: ievietojiet papīru ar apdrukājamo pusi uz augšu. Divpusēja drukāšana: ievietojiet papīru ar apdrukājamo pusi uz leju. Ja ievietojat veidlapas vai caurumotu papīru, veiciet kādu no tālāk norādītajām darbībām. Vienpusēja drukāšana Veidlapas ievietojiet ar apdrukāto pusi uz augšu tā, lai galvene būtu vērsta uz paplātes aizmuguri. Caurumoto papīru novietojiet ar apdrukāto pusi uz augšu un ar caurumiem pret paplātes kreiso pusi. Divpusēja drukāšana Veidlapas ievietojiet ar apdrukāto pusi uz leju tā, lai galvene būtu vērsta uz paplātes aizmuguri. Caurumoto papīru novietojiet ar apdrukāto pusi uz leju un ar caurumiem pret paplātes labo pusi. Neslidiniet papīru paplātē. Nodrošiniet, lai ievietotā papīra daudzums nepārsniedz maksimālā papīra daudzuma indikatoru. Pārpildīšana var radīt papīra sastrēgumu. Ievietojiet paplāti. Ja nepieciešams, iestatiet papīra izmērus un veidu atbilstoši paplātēs ievietotajam papīram. Ja ir uzstādīts apdarinātājs, drukātie attēli tiek apgriezti par 180°. 2520 lokšņu tandēma paplāte ievietošana papīra ievietošana 2520 lokšņu tandēma paplātē paplāšu ievietošana"},{"UUID":"a63ef073-e9fb-44e9-87c3-b44d336d50d9","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Papīra ievietošana 2000 lokšņu paplātē Lai","descFull":"Papīra ievietošana 2000 lokšņu paplātē Lai novērstu nestabilu iekārtas novietojumu, ievietojiet papīru katrā paplātē atsevišķi. Turiet pārējās paplātes aizvērtas, kamēr tās netiek lietotas. Izvelciet paplāti, pēc tam atveriet paplātes sānu durvis. Lai novērstu papīra iestrēgšanu, neizvelciet paplātes printera darbības laikā. Noregulējiet vadotni paplātes aizmugurē. Atkārtojiet to pašu darbību paplātes priekšpusē. Noregulējiet sviru pie paplātes sānu durvīm. Pirms papīra ievietošanas izlieciet, pāršķirstiet to un nolīdziniet papīra malas. Ievietojiet papīra kaudzi ar apdrukājamo pusi uz leju. Ja ievietojat veidlapas vai caurumotu papīru, veiciet kādu no tālāk norādītajām darbībām. Vienpusēja drukāšana Veidlapas ievietojiet ar apdrukāto pusi uz leju tā, lai galvene būtu vērsta uz paplātes aizmuguri. Caurumoto papīru novietojiet ar apdrukāto pusi uz leju un ar caurumiem pret paplātes kreiso pusi. Divpusēja drukāšana Veidlapas ievietojiet ar apdrukāto pusi uz augšu tā, lai galvene būtu vērsta uz paplātes aizmuguri. Caurumoto papīru novietojiet ar apdrukāto pusi uz augšu un ar caurumiem pret paplātes kreiso pusi. Nodrošiniet, lai ievietotā papīra daudzums nepārsniedz maksimālā papīra daudzuma indikatoru. Pārpildīšana var radīt papīra sastrēgumu. Aizveriet paplātes sānu un pēc tam ievietojiet paplāti. Ja nepieciešams, iestatiet papīra izmērus un veidu atbilstoši paplātēs ievietotajam papīram. Ja ir uzstādīts apdarinātājs, drukātie attēli tiek apgriezti par 180°. 2520 lokšņu tandēma paplāte ievietošana papīra ievietošana 2520 lokšņu tandēma paplātē"},{"UUID":"1b6cb309-1309-44e3-8df2-271ba3e43e77","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Ievietošana aplokšņu paplātē Lai novērstu","descFull":"Ievietošana aplokšņu paplātē Lai novērstu nestabilu iekārtas novietojumu, ievietojiet papīru katrā paplātē atsevišķi. Turiet pārējās paplātes aizvērtas, kamēr tās netiek lietotas. Izvelciet aplokšņu paplāti. Lai novērstu papīra iestrēgšanu, neizvelciet paplātes printera darbības laikā. Pirms papīra ievietošanas izlieciet, pāršķirstiet to un nolīdziniet aplokšņu malas. Pielāgojiet vadotnes atbilstoši ievietojamās aploksnes izmēriem. Lai novietotu vadotnes, izmantojiet indikatorus paplātes apakšdaļā. Ievietojiet aploksnes ar atloka pusi uz leju, novietojot tās paplātes kreisajā pusē. Pārliecinieties, vai sānu vadotnes cieši pieguļ aploksnēm. Nodrošiniet, lai ievietotā papīra daudzums nepārsniedz maksimālā daudzuma indikatoru. Pārpildīšana var radīt sastrēgumu. Ievietojiet paplāti. Ja nepieciešams, iestatiet papīra izmērus un veidu atbilstoši paplātēs ievietotajai aploksnei. aplokšņu paplāte ievietošana ievietošana aplokšņu paplātē"},{"UUID":"8a9229c3-1ffe-44d6-8048-fafe44bc1607","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Papīra ievietošana daudzfunkciju padevējā Atveriet","descFull":"Papīra ievietošana daudzfunkciju padevējā Atveriet daudzfunkciju padevēju. Pielāgojiet sānu vadotnes atbilstoši ievietojamā papīra izmēriem. Pirms papīra ievietošanas izlieciet, pāršķirstiet to un nolīdziniet papīra malas. Ievietojiet papīru. Pārliecinieties, vai sānu vadotnes cieši pieguļ papīram. Padeve ar garo malu Drukājot uz vienas puses, veidlapas ievietojiet ar apdrukāto pusi uz leju tā, lai galvene ir vērsta uz printera aizmuguri. Iepriekš caurumoto papīru novietojiet ar apdrukājamo pusi uz leju un ar caurumiem labajā pusē. Drukājot uz abām pusēm, veidlapas ievietojiet ar apdrukāto pusi uz augšu tā, lai galvene ir vērsta uz printera aizmuguri. Iepriekš caurumoto papīru novietojiet ar apdrukājamo pusi uz augšu un ar caurumiem kreisajā pusē. Padeve ar īso malu Drukājot uz vienas puses, veidlapas ievietojiet ar apdrukāto pusi uz leju tā, lai galvene būtu papīra kreisajā pusē. Iepriekš caurumoto papīru novietojiet ar apdrukājamo pusi uz leju un ar caurumiem pret printera priekšpusi. Drukājot uz abām pusēm, veidlapas ievietojiet ar apdrukāto pusi uz augšu tā, lai galvene būtu papīra kreisajā pusē. Iepriekš caurumoto papīru novietojiet ar apdrukājamo pusi uz augšu un ar caurumiem pret printera aizmuguri. Kad apdarinātājs ir uzstādīts, printeris apgriež attēlus par 180°. daudzfunkciju padevējs ievietošana ievietošana, daudzfunkciju padevējs veidlapas ievietošana caurumota papīra ievietošana"},{"UUID":"254e6c22-5ddb-443d-b2b2-a7a65937c520","title":"Papīra un speciālā apdrukājamā materiāla ievietošana","link":"loading-trays-group.html","desc":"Paplāšu pievienošana Sākuma ekrānā pieskarieties","descFull":"Paplāšu pievienošana Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana atlasiet papīra avotu. Iestatiet vienādus papīra izmērus un veidu paplātēs, kuras tiek savienotas. Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Paplāšu konfigurēšana Paplāšu pievienošana . Pieskarieties pie  Automātiski . Lai atvienotu paplātes, nodrošiniet, ka paplātēm nav vienādu papīra izmēru vai veida iestatījumu. Termofiksatora temperatūra mainās atkarībā no norādītā papīra veida. Lai novērstu drukāšanas problēmas, pieskaņojiet printera papīra veida iestatījumu atbilstoši paplātē ievietotajam papīram. paplāšu atvienošana paplāšu pievienošana paplātes pievienošana paplātes atvienošana"},{"UUID":"8a91bfee-0a82-4ec4-bd30-9659a80441f7","title":"Programmatūras, draiveru un programmaparatūras uzstādīšana un atjaunināšana","link":"installing-printer-software-topic.html","desc":"Printera programmatūras instalēšana Printera draiveris","descFull":"Printera programmatūras instalēšana Printera draiveris ir iekļauts programmatūras instalētāja pakotnē. Macintosh datoros, kuros ir macOS 10.7 vai jaunāka versija, nav jāinstalē draiveris, lai drukātu AirPrint sertificētā printerī. Ja vēlaties pielāgot drukāšanas funkcijas, lejupielādējiet printera draiveri. Iegūstiet programmatūras instalētāja pakotnes kopiju. Izmantojiet programmatūras kompaktdisku, kas bija printera komplektācijā. Skatiet vietni  www.lexmark.com/downloads . Apmeklējiet vietni  www.dell.com/support/printers . Skatiet mūsu tīmekļa vietni vai jautājiet printera iegādes vietā. Palaidiet instalētāju un pēc tam izpildiet datora ekrānā redzamos norādījumus. printera programmatūras instalēšana printera programmatūra uzstādīšana printera draivera uzstādīšana printera draiveris uzstādīšana"},{"UUID":"ac4f5f43-334e-44e4-9f0f-c9691e464456","title":"Programmatūras, draiveru un programmaparatūras uzstādīšana un atjaunināšana","link":"installing-printer-software-topic.html","desc":"Faksa draivera instalēšana Atveriet vietni","descFull":"Faksa draivera instalēšana Atveriet vietni  www.lexmark.com/downloads , meklējiet savu printera modeli un pēc tam lejupielādējiet attiecīgo instalētāja pakotni. Atveriet mūsu tīmekļa vietni vai vietu, kur iegādājāties printeri, un pēc tam iegūstiet instalētāja pakotni. Atveriet vietni  www.dell.com/support  un pēc tam lejupielādējiet attiecīgo instalētāja pakotni. Savā datorā noklikšķiniet uz  Printera rekvizīti  un pēc tam dodieties uz cilni  Konfigurēšana . Palaidiet instalētāju un pēc tam izpildiet datora ekrānā redzamos norādījumus. Atlasiet  Fakss  un pēc tam noklikšķiniet uz  Lietot . faksa draiveris uzstādīšana faksa draivera instalēšana"},{"UUID":"638c16cd-4665-4eec-84c2-894ff34bb3f7","title":"Programmatūras, draiveru un programmaparatūras uzstādīšana un atjaunināšana","link":"installing-printer-software-topic.html","desc":"Printeru pievienošana datoram Pirms darba","descFull":"Printeru pievienošana datoram Pirms darba sākšanas veiciet vienu no šīm darbībām: Pievienojiet printeri un datoru vienam tīklam. Papildinformāciju par printera pievienošanu tīklam skatiet  . Pievienojiet datoru printerim. Lai iegūtu papildinformāciju, skatiet:  . Pievienojiet printeri datoram, izmantojot USB kabeli. Lai iegūtu papildinformāciju, skatiet:  . USB kabelis ir jāiegādājas atsevišķi. Windows lietotājiem Datorā instalējiet printera draiveri. Lai iegūtu papildinformāciju, skatiet:  . Atveriet  Printeri un skeneri  un pēc tam noklikšķiniet uz  Pievienot printeri vai skeneri . Atkarībā no printera savienojuma veiciet vienu no šīm darbībām: Sarakstā atlasiet printeri un pēc tam noklikšķiniet uz  Pievienot ierīci . Noklikšķiniet uz  Rādīt Wi‑Fi Direct printerus , atlasiet printeri un pēc tam noklikšķiniet uz  Pievienot ierīci . Noklikšķiniet uz  Vajadzīgā printera nav sarakstā  un pēc tam logā  Pievienot printeri  veiciet šādas darbības: Atlasiet  Pievienot printeri, izmantojot TCP/IP adresi vai resursdatora nosaukumu  un pēc tam noklikšķiniet uz  Tālāk . Laukā  Resursdatora nosaukums vai IP adrese  ierakstiet printera IP adresi un pēc tam noklikšķiniet uz  Tālāk . Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Atlasiet printera draiveri un pēc tam noklikšķiniet uz  Tālāk . Atlasiet  Izmantot pašlaik instalēto printera draiveri (ieteicams)  un pēc tam noklikšķiniet uz  Tālāk . Ierakstiet printera nosaukumu un pēc tam noklikšķiniet uz  Tālāk . Atlasiet printera koplietošanas opciju un pēc tam noklikšķiniet uz  Tālāk . Noklikšķiniet uz  Pabeigt . Macintosh lietotājiem Datorā atveriet  Printeri un skeneri . Noklikšķiniet uz   un pēc tam atlasiet printeri. Izvēlnē  Lietošana  atlasiet printera draiveri. Lai lietotu Macintosh printera draiveri, atlasiet  AirPrint  vai  Secure AirPrint . Ja vēlaties pielāgot drukāšanas funkcijas, atlasiet Lexmark printera draiveri. Lai instalētu draiveri, skatiet  . Ja vēlaties pielāgot drukāšanas funkcijas, atlasiet ražotāja printera draiveri. Lai instalētu draiveri, skatiet  . Pievienojiet printeri. printeru pievienošana datoram"},{"UUID":"ac213a96-72c8-487d-bef4-1d210b5fe649","title":"Programmatūras, draiveru un programmaparatūras uzstādīšana un atjaunināšana","link":"installing-printer-software-topic.html","desc":"Programmaparatūras atjaunināšana Lai uzlabotu printera","descFull":"Programmaparatūras atjaunināšana Lai uzlabotu printera veiktspēju un novērstu problēmas, regulāri atjauniniet printera programmaparatūru. Papildinformāciju par programmaparatūras atjaunināšanu vaicājiet savam Lexmark pārstāvim. Papildinformāciju par programmaparatūras atjaunināšanu vaicājiet savam Dell pārstāvim. Papildinformāciju par programmaparatūras atjaunināšanu vaicājiet savam tirdzniecības pārstāvim. Lai iegūtu jaunāko programmaparatūru, atveriet vietni  www.lexmark.com/downloads  un meklējiet savu printera modeli. Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi Ierīce Atjaunināt programmaparatūru . Veiciet kādu no tālāk norādītajām darbībām. Noklikšķiniet uz  Pārbaudīt atjauninājumus Es piekrītu sākt atjauninājumu . Augšupielādējiet zibatmiņas diska failu. Pārlūkojiet, lai atrastu zibatmiņas diska failu. Pārbaudiet, vai esat izvilcis programmaparatūras tilpsaspiestu failu. Noklikšķiniet uz  Augšupielādēt Sākt . programmaparatūras atjaunināšana programmaparatūra, atjaunināšana"},{"UUID":"8a0bafdf-baf4-44e8-a356-c52c61b5b4a8","title":"Programmatūras, draiveru un programmaparatūras uzstādīšana un atjaunināšana","link":"installing-printer-software-topic.html","desc":"Konfigurācijas faila eksportēšana vai importēšana","descFull":"Konfigurācijas faila eksportēšana vai importēšana Printera konfigurācijas iestatījumus varat eksportēt teksta failā, pēc tam failu varat importēt, lai iestatījumus lietotu citos printeros. Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Lietojumprogrammā Embedded Web Server noklikšķiniet uz  Eksportēt konfigurāciju  vai  Importēt konfigurāciju . Izpildiet ekrānā redzamos norādījumus. Ja printeris atbalsta lietojumprogrammas, veiciet tālāk norādītās darbības. Noklikšķiniet uz  Lietotnes atlasiet lietojumprogrammu Konfigurēšana . Noklikšķiniet uz  Eksportēt  vai  Importēt . konfigurācijas faila eksportēšana Embedded Web Server lietošana konfigurācijas faila importēšana Embedded Web Server lietošana"},{"UUID":"a2101be7-ca7e-412d-bb8a-b0b1144d0612","title":"Programmatūras, draiveru un programmaparatūras uzstādīšana un atjaunināšana","link":"installing-printer-software-topic.html","desc":"Pieejamo ierīču pievienošana printera draiverim","descFull":"Pieejamo ierīču pievienošana printera draiverim Windows lietotājiem Atveriet printeru mapi. Atlasiet printeri, kuru vēlaties atjaunināt, un veiciet kādu no tālāk norādītajām darbībām. Operētājsistēmā Windows 7 vai jaunākā versijā atlasiet  Printera rekvizīti . Vecākās versijās atlasiet  Rekvizīti . Pārejiet uz cilni Konfigurācija un pēc tam atlasiet  Atjaunināt tagad — jautāt printeri . Piemērojiet izmaiņas. Macintosh lietotājiem Izvēlnes Apple sadaļā Sistēmas preferences pārejiet uz printeri, pēc tam atlasiet  Ierīces un izejmateriāli . Pārejiet uz sarakstu ar aparatūras ierīcēm un pēc tam pievienojiet uzstādītās ierīces. Piemērojiet izmaiņas. aparatūras ierīču pievienošana printera draiveris printera draiveris aparatūras ierīces, pievienošana iekšējo ierīču pievienošana printera draiveris aparatūras ierīces, pievienošana printera draiveris iekšējās ierīces, pievienošana printera draiveris"},{"UUID":"4ec3bd63-9093-4388-a2ff-a6a8d293e00b","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Aplokšņu paplātes uzstādīšana Izņemiet standarta","descFull":"Aplokšņu paplātes uzstādīšana Izņemiet standarta paplāti. Neizmetiet standarta paplāti. Izpakojiet aplokšņu paplāti un noņemiet visu iepakojumu. Ievietojiet aplokšņu paplāti. Lai nodrošinātu aplokšņu paplātes pieejamību drukāšanas darbiem, sākuma ekrānā pieskarieties  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Paplātes konfigurēšana Aplokšņu paplātes iestatījumi Ieslēgts . aplokšņu paplātes uzstādīšana aplokšņu paplāte uzstādīšana aparatūras ierīce aplokšņu paplāte"},{"UUID":"68ee1c70-70bf-43c0-8fd8-0693a42ef339","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Izvēles 520 lokšņu paplātes uzstādīšana Lai","descFull":"Izvēles 520 lokšņu paplātes uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izpakojiet izvēles paplāti un noņemiet visu iepakojumu. Turiet printeri virs papildu paplātes un pēc tam nolaidiet printeri vietā. Ja printera svars pārsniedz 20 kg (44 mārciņas), tā drošai pacelšanai nepieciešami divi vai vairāk cilvēki. Izņemiet standarta paplāti. Nostipriniet izvēles paplāti pie printera ar skrūvēm. Ievietojiet standarta paplāti. Noņemiet savienotāja pārsegu no printera aizmugures. Savienojiet paplātes savienotāju ar printeri, pēc tam uzstādiet pārsegu. Izvēles paplātes aizmugurējo daļu piestipriniet pie printera. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. Pievienojiet paplāti printera draiverī, lai tā būtu pieejama drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . 520 lokšņu paplātes uzstādīšana 520 lokšņu paplāte uzstādīšana aparatūras ierīce 520 lokšņu paplāte"},{"UUID":"a2e24197-87b0-4d3d-94ee-3a5863120875","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"520 lokšņu izvēles paplātes ar atvilktni","descFull":"520 lokšņu izvēles paplātes ar atvilktni uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izpakojiet izvēles paplāti un noņemiet visu iepakojumu. Bloķējiet ritenīti, lai novērstu atvilktnes izkustēšanos. Turiet printeri virs papildu paplātes un pēc tam nolaidiet printeri vietā. Ja printera svars pārsniedz 20 kg (44 mārciņas), tā drošai pacelšanai nepieciešami divi vai vairāk cilvēki. Izņemiet standarta paplāti. Nostipriniet izvēles paplāti pie printera ar skrūvēm. Ievietojiet standarta paplāti. Noņemiet savienotāja pārsegu no printera aizmugures. Savienojiet paplātes savienotāju ar printeri, pēc tam uzstādiet pārsegu. Izvēles paplātes aizmugurējo daļu piestipriniet pie printera. Noregulējiet līmeņošanas skrūves, lai visas printera puses atrastos vienādā augstumā. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. Pievienojiet paplāti printera draiverī, lai tā būtu pieejama drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . 520 lokšņu paplātes ar atvilktni uzstādīšana 520 lokšņu paplāte ar atvilktni uzstādīšana aparatūras opcija 520 lokšņu paplāte ar atvilktni"},{"UUID":"e97abef6-8dea-4c68-93c6-d88919007431","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"3 x 520 lokšņu izvēles paplātes","descFull":"3 x 520 lokšņu izvēles paplātes uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izpakojiet izvēles paplāti un noņemiet visu iepakojumu. Bloķējiet ritenīti, lai novērstu paplātes izkustēšanos. Turiet printeri virs papildu paplātes un pēc tam nolaidiet printeri vietā. Ja printera svars pārsniedz 20 kg (44 mārciņas), tā drošai pacelšanai nepieciešami divi vai vairāk cilvēki. Izņemiet standarta paplāti. Nostipriniet izvēles paplāti pie printera ar skrūvēm. Ievietojiet standarta paplāti. Noņemiet savienotāja pārsegu no printera aizmugures. Savienojiet paplātes savienotāju ar printeri, pēc tam uzstādiet pārsegu. Izvēles paplātes aizmugurējo daļu piestipriniet pie printera. Noregulējiet līmeņošanas skrūves, lai visas printera puses atrastos vienādā augstumā. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. Pievienojiet paplāti printera draiverī, lai tā būtu pieejama drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . 3 x 520 lokšņu paplātes uzstādīšana 3 x 520 lokšņu paplāte uzstādīšana aparatūras ierīce 3 x 520 lokšņu paplāte"},{"UUID":"56cdb1f7-a053-4518-8a65-eb92e2962e94","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Izvēles 2520 lokšņu tandēma paplātes uzstādīšana","descFull":"Izvēles 2520 lokšņu tandēma paplātes uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izpakojiet izvēles paplāti un noņemiet visu iepakojumu. Bloķējiet ritenīti, lai novērstu paplātes izkustēšanos. Turiet printeri virs papildu paplātes un pēc tam nolaidiet printeri vietā. Ja printera svars pārsniedz 20 kg (44 mārciņas), tā drošai pacelšanai nepieciešami divi vai vairāk cilvēki. Izņemiet standarta paplāti. Nostipriniet izvēles paplāti pie printera ar skrūvēm. Ievietojiet standarta paplāti. Noņemiet savienotāja pārsegu no printera aizmugures. Savienojiet paplātes savienotāju ar printeri, pēc tam uzstādiet pārsegu. Izvēles paplātes aizmugurējo daļu piestipriniet pie printera. Noregulējiet līmeņošanas skrūves, lai visas printera puses atrastos vienādā augstumā. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. Pievienojiet paplāti printera draiverī, lai tā būtu pieejama drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . 2520 lokšņu paplātes uzstādīšana 2520 lokšņu paplāte uzstādīšana aparatūras ierīce 2520 lokšņu paplāte"},{"UUID":"9c2e2121-bdc2-486b-89b1-4e8705e187e0","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Izvēles 2000 lokšņu paplātes uzstādīšana Lai","descFull":"Izvēles 2000 lokšņu paplātes uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izpakojiet izvēles paplāti un noņemiet visu iepakojumu. Noņemiet līmeņošanas skrūvi printera kreisajā pusē. Neizmetiet skrūvi. Pievienojiet fiksējošo kronšteinu printerim. Izmantojiet fiksējošo kronšteinu, kas iekļauts izvēles paplātes komplektācijā. Uzstādiet izvēles paplāti. Pievienojiet paplātes savienotāju printerim. Noregulējiet līmeņošanas skrūves, lai paplāte atrastos vienā augstumā ar printeri. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. Pievienojiet paplāti printera draiverī, lai tā būtu pieejama drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . 2000 lokšņu paplātes uzstādīšana 2000 lokšņu paplāte uzstādīšana aparatūras ierīce 2000 lokšņu paplāte"},{"UUID":"34e400d0-c3a2-4001-b2d5-89631a81b95c","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Faksa kartes uzstādīšana Faksa kartes","descFull":"Faksa kartes uzstādīšana Faksa kartes uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izmantojot plakano skrūvgriezi, noņemiet faksa pārsegu. Noņemiet cietā diska pārsegu. Noņemiet kontrollera plates aizsargu. Izpakojiet faksa karti. Pievienojiet faksa karti cietā diska pārsegam. Ievietojiet faksa savienotāja kabeli kontrollera plates nodalījumā. Uzstādiet cietā diska pārsegu. Savienojiet faksa savienotāja kabeli ar kontrollera plati. Piestipriniet kontrollera plates aizsargu. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. faksa karte uzstādīšana iekšējo ierīču uzstādīšana faksa karte"},{"UUID":"dda03c01-52f8-4ef7-a866-340e9b816f39","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Printera cietā diska uzstādīšana Printera","descFull":"Printera cietā diska uzstādīšana Printera cietā diska uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izpakojiet cieto disku, pēc tam noņemiet kronšteinu. Nepieskarieties cietā diska centram un nespiediet to. Noņemiet cietā diska pārsegu. Noņemiet kontrollera plates aizsargu. Ievietojiet cietā diska savienotāja kabeli kontrollera plates nodalījumā. Novietojiet cieto disku virs montāžas atverēm, pēc tam piespiediet tā, lai tas  noklikšķētu  vietā. Uzstādiet cietā diska pārsegu. Pievienojiet cietā diska savienotāja kabeli kontrollera platei. Piestipriniet kontrollera plates aizsargu. Pievienojiet elektrotīklam strāvas vadu un pēc tam ieslēdziet printeri. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. printera cietais disks uzstādīšana ierīču uzstādīšana printera cietais disks"},{"UUID":"cc1e4a6f-041f-4589-a83c-ae717c8fec2e","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Darba plaukta uzstādīšana Izslēdziet printeri.","descFull":"Darba plaukta uzstādīšana Izslēdziet printeri. Ar skrūvgriezi noņemiet pārsega plāksnes. Darba plaukta izpakošana Pievienojiet darba plauktu printerim. Piestipriniet plauktu printerim. Ieslēdziet printeri. darba plaukta uzstādīšana darba plaukts uzstādīšana"},{"UUID":"baefdcf7-c6ed-4ed0-8708-d27b3a7a3484","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Divu izvades nodalījumu uzstādīšana Izpakojiet","descFull":"Divu izvades nodalījumu uzstādīšana Izpakojiet divus izvades nodalījumus Divus izvades nodalījumus piestipriniet printerim. Lai padarītu nodalījumu pieejamu drukas darbiem, sākuma ekrānā pieskarieties  Settings Ierīce Apkope Izvēlne Konfigurēšana Apdarinātāja konfigurācija 2. izejas paplātes iestatījums Ieslēgts divu izvades nodalījumu uzstādīšana divi izvades nodalījumi uzstādīšana"},{"UUID":"49f3434f-1ad6-4f30-96fb-cff81cda8952","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Apdarinātāja ar skavotāju uzstādīšana Lai","descFull":"Apdarinātāja ar skavotāju uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Noņemiet standarta nodalījumu. Neizmetiet nodalījumu. Atveriet priekšējās durvis un pēc tam noņemiet zilo pogu. Neizmetiet pogu. Noņemiet standarta nodalījuma sānu pārsegu. Neizmetiet nodalījuma sānu pārsegu. Izpakojiet apdarinātāju ar skavotāju un noņemiet visu iepakojumu. Novietojiet apdarinātāju ar skavotāju ar aizmuguri uz leju un noņemiet visu iepakojumu. Noregulējiet kronšteinu. Ievietojiet apdarinātāju. Aizveriet priekšējās durvis. Pievienojiet apdarinātāju printerim. Izmantojiet apdarinātāja komplektācijā iekļautās skrūves. Piestipriniet apdarinātāja kabeli printerim. Izmantojiet apdarinātāja komplektācijā iekļautās skavas. Pievienojiet apdarinātāja kabeli printerim. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. Pievienojiet apdarinātāju printera draiverī, lai tas būtu pieejams drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . apdarinātāja ar skavotāju uzstādīšana apdarinātājs ar skavotāju uzstādīšana aparatūras ierīce apdarinātājs ar skavotāju"},{"UUID":"0e73a67c-6151-4a7d-a6f1-ab134d5ebff4","title":"Aparatūras ierīču uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"Apdarinātāja ar skavotāju, caurumotāju uzstādīšana","descFull":"Apdarinātāja ar skavotāju, caurumotāju uzstādīšana Lai izvairītos no elektrošoka riska gadījumā, ja piekļūstat kontrollera platei vai uzstādāt papildu aparatūru vai atmiņas ierīces tad, kad printeris jau ir uzstādīts, izslēdziet printeri un atvienojiet strāvas vadu no elektrotīkla pirms darbu turpināšanas. Ja printerim ir pievienotas citas ierīces, izslēdziet arī tās un atvienojiet visus printerim pievienotos kabeļus. Izslēdziet printeri. Strāvas vadu vispirms atvienojiet no elektrotīkla, pēc tam — no printera. Izpakojiet apdarinātāju ar skavotāju un caurumotāju un noņemiet visu iepakojumu. Ievietojiet apdarinātājā skavu kasetni. Ar plakano skrūvgriezi piestipriniet kronšteinus pie apdarinātāja. Ievietojiet nodalījumu apdarinātājā. Noņemiet standarta nodalījumu. Neizmetiet standarta nodalījumu. Atveriet priekšējās durvis un pēc tam noņemiet zilo pogu. Neizmetiet pogu. Noņemiet standarta nodalījuma sānu pārsegu. Neizmetiet nodalījuma sānu pārsegu. Ar plakano skrūvgriezi piestipriniet kronšteinus printera labajā pusē. Ievietojiet papīra transportētāju un nofiksējiet to ar skrūvēm. Izmantojiet apdarinātāja komplektācijā iekļautās skrūves. Aizveriet priekšējās durvis. Piestipriniet apdarinātāju pie printera. Noregulējiet līmeņošanas skrūves, lai visas apdarinātāja puses atrastos vienādā augstumā ar printeri. Atveriet apdarinātāja durvis un uzstādiet skrūvi apdarinātāja kreisajā pusē. Aizveriet apdarinātāja durvis. Pievienojiet papīra transportētāja kabeli apdarinātāja aizmugurē. Pievienojiet apdarinātāja kabeli printera aizmugurē. Pievienojiet strāvas vadu printerim, pēc tam — elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Ieslēdziet printeri. Pievienojiet apdarinātāju printera draiverī, lai tas būtu pieejams drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . Lai nodrošinātu apdarinātāja pieejamību drukāšanas darbiem, sākuma ekrānā pieskarieties  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Apdarinātāja konfigurēšana Caurumotāja konfigurēšana atlasiet konfigurāciju. apdarinātāja ar skavotāju, caurumotāju uzstādīšana uzstādīšana apdarinātājs ar skavotāju, caurumotāju"},{"UUID":"d2d23b10-9f5b-4b19-bd12-3a933b2ceb46","title":"Bezvadu drukas servera uzstādīšana","link":"installing-envelope-tray-topic.html","desc":"MarkNet N8372 Wireless Print Server","descFull":"MarkNet N8372 Wireless Print Server uzstādīšana Izslēdziet printeri. Uz mīkstas drānas bez plūksnām uzlejiet izopropanolu un pēc tam noslaukiet vietu ap USB portu. Uzstādiet bezvadu moduli. Stingri piespiediet, lai nodrošinātu, ka lente pielīp printera virsmai. Pārbaudiet, vai printera virsma ir sausa un uz tās nav mitruma kondensāta. Lai modulis stingri piestiprinātos printerim, nepieciešamas 72 stundas. Pārbaudiet, vai starp moduli un printeri nav atstarpes; ja nepieciešams, pēc tam uzstādiet starplikas moduli. Pievienojiet NFC karti. Ieslēdziet printeri. bezvadu drukas serveris uzstādīšana bezvadu drukas servera uzstādīšana MarkNet N8372 Wireless Print Server"},{"UUID":"0999538b-4667-4b84-8f60-52678be7f4e9","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Šis produkts nav aprīkots ar","descFull":"Šis produkts nav aprīkots ar bezvadu tīkla savienojamības tehnoloģiju. Lai iespējotu savienošanu ar bezvadu tīklu, iegādājieties un uzstādiet šādu opciju. Tālāk sniegtās norādes ir spēkā tikai tad, ja opcija ir instalēta. Lai iegūtu papildu informāciju par opcijas instalēšanu, skatiet sadaļu \"Bezvadu drukas servera instalēšana\"."},{"UUID":"aca20f92-2825-4597-9e5e-80d8debbfa8e","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Printera pievienošana Wi‑Fi tīklam Pirms","descFull":"Printera pievienošana Wi‑Fi tīklam Pirms darba sākšanas izpildiet tālāk norādītos nosacījumus. Printerī ir uzstādīts bezvadu modulis. Aktīvā adaptera  iestatījums ir  Automātiski . Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Tīklu pārskats Aktīvs adapteris . Ja lietojat vadības paneli Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Bezvadu Iestatīšana printera panelī Izvēlēties tīklu . Atlasiet Wi-Fi tīklu un pēc tam ierakstiet tīkla paroli. Printeros, kuri ir gatavi darbam Wi‑Fi tīklā, sākotnējās iestatīšanas laikā tiek parādīta uzvedne par Wi‑Fi tīkla iestatīšanu. Lexmark Mobile Assistant lietošana Atkarībā no savas mobilās ierīces lejupielādējiet Lexmark Mobile Assistant lietojumprogrammu no App Store veikala vai  Google Play  veikala. Printera sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Bezvadu Iestatīšana, izmantojot mobilo lietotni Printera ID . Savā mobilajā ierīcē palaidiet lietojumprogrammu un pēc tam apstipriniet, ka piekrītat lietošanas noteikumiem. Ja nepieciešams, piešķiriet atļaujas. Pieskarieties pie  Pievienot printerim Atvērt Wi‑Fi iestatījumus . Pievienojiet savu mobilo ierīci printera bezvadu tīklam. Atgriezieties lietojumprogrammā un pēc tam pieskarieties pie  Iestatīt Wi-Fi savienojumu Atlasiet Wi-Fi tīklu un pēc tam ierakstiet tīkla paroli. Pieskarieties pie  Gatavs . bezvadu tīkls printera pievienošana printera pievienošana bezvadu tīklam bezvadu tīklošana"},{"UUID":"fbdaf3fd-7a2c-4b52-837d-91473d29efd6","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Printera pievienošana bezvadu tīklam, izmantojot","descFull":"Printera pievienošana bezvadu tīklam, izmantojot Wi-Fi Protected Setup (WPS) Pirms darba sākšanas izpildiet tālāk norādītos nosacījumus. Piekļuves punkts (bezvadu maršrutētājs) ir WPS sertificēts vai saderīgs ar WPS. Papildinformāciju skatiet kopā ar piekļuves punktu piegādātajā dokumentācijā. Printerī ir uzstādīts bezvadu tīkla adapteris. Papildinformāciju skatiet kopā ar adapteri piegādātajos norādījumos. Aktīvā adaptera  iestatījums ir  Automātiski . Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Tīklu pārskats Aktīvs adapteris . Metodes ar pogu lietošana Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Bezvadu Wi‑Fi Protected Setup Sākšanas ar pogu metode . Izpildiet displejā redzamos norādījumus. Personas identifikācijas numura (Personal Identification Number — PIN) metodes lietošana Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Bezvadu Wi‑Fi Protected Setup Sākšanas ar PIN metode . Nokopējiet astoņu ciparu WPS PIN. Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet piekļuves punkta IP adresi. IP adresi skatiet kopā ar piekļuves punktu piegādātajā dokumentācijā. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Piekļūstiet WPS iestatījumiem. Papildinformāciju skatiet kopā ar piekļuves punktu piegādātajā dokumentācijā. Ievadiet astoņu ciparu PIN, pēc tam saglabājiet izmaiņas. Wi‑Fi Protected Setup bezvadu tīkls bezvadu tīkls Wi‑Fi Protected Setup pievienošana bezvadu tīklam PIN metodes izmantošana personas identifikācijas numura metode pievienošana bezvadu tīklam metodes ar pogu izmantošana metode ar pogu"},{"UUID":"b2a2cff3-5535-4d5c-997f-245b7a6c29e6","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Wi‑Fi Direct konfigurēšana Wi‑Fi Direct","descFull":"Wi‑Fi Direct konfigurēšana Wi‑Fi Direct  ir Wi-Fi-vienādranga tehnoloģija, kas ļauj bezvadu ierīcēm tieši pievienoties printerim ar iespējotu Wi-Fi Direct, neizmantojot piekļuves punktu (bezvadu maršrutētāju). Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Wi-Fi Direct . Konfigurējiet iestatījumus. Iespējot Wi‑Fi Direct  — ļauj printerim parādīt savu Wi‑Fi Direct tīklu. Wi‑Fi Direct nosaukums  — piešķir nosaukumu Wi‑Fi Direct tīklam. Wi‑Fi Direct parole  — lai veicinātu bezvadu drošību, piešķir paroli, kad tiek lietots vienādranga savienojums. Rādīt paroli iestatīšanas lapā  — rāda paroli tīkla iestatīšanas lapā. Automātiski akceptēt spiedpogas pieprasījumus  — ļauj printerim automātiski akceptēt savienojuma pieprasījumus. Automātiska spiedpogas pieprasījumu akceptēšana nav droša. Pēc noklusējuma Wi-Fi Direct tīkla parole nav redzama printera displejā. Lai parādītu paroli, iespējojiet paroles apskates ikonu. Sākuma ekrānā pieskarieties pie  Iestatījumi Drošība Dažādi Iespējot paroles/PIN apskati . Lai noskaidrotu Wi-Fi Direct tīkla paroli, to neparādot printera displejā, sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites Tīkls Tīkla iestatīšanas lapa . Wi‑Fi Direct konfigurēšana Wi‑Fi Direct konfigurēšana"},{"UUID":"90f0c9e7-69cc-44a6-a9a1-dd477baacd98","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Mobilās ierīces pievienošana printerim Pirms","descFull":"Mobilās ierīces pievienošana printerim Pirms mobilās ierīces pievienošanas pārbaudiet, vai ir konfigurēta Wi‑Fi Direct. Lai iegūtu papildinformāciju, skatiet:  . Pievienošana, izmantojot Wi‑Fi Direct Šie norādījumi attiecas tikai uz Android mobilajām ierīcēm. Mobilajā ierīcē atveriet iestatījumu izvēlni. Iespējojiet  Wi‑Fi  un pēc tam pieskarieties pie  Wi‑Fi Direct . Atlasiet printera Wi-Fi Direct nosaukumu. Apstipriniet pievienošanu printera vadības panelī. Pievienošana, izmantojot Wi‑Fi Mobilajā ierīcē atveriet iestatījumu izvēlni. Pieskarieties pie  Wi‑Fi  un pēc tam atlasiet printera Wi‑Fi Direct nosaukumu. Pirms Wi-Fi Direct nosaukuma tiek pievienota virkne DIRECT-xy (kur x un y ir divas nejaušas rakstzīmes). Ierakstiet Wi‑Fi Direct paroli. mobilās ierīces pievienošana printerim mobila ierīce pievienošana printerim Wi‑Fi Direct iespējošana Wi‑Fi Direct iespējošana"},{"UUID":"d401bee0-8937-413c-baa7-84c6b8790708","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Wi‑Fi Direct Datora pievienošana printerim","descFull":"Wi‑Fi Direct Datora pievienošana printerim Pirms datora pievienošanas pārbaudiet, vai ir konfigurēta Wi‑Fi Direct. Lai iegūtu papildinformāciju, skatiet:  . Windows lietotājiem Atveriet  Printeri un skeneri  un pēc tam noklikšķiniet uz  Pievienot printeri vai skeneri . Noklikšķiniet uz  Rādīt Wi-Fi Direct printerus  un pēc tam atlasiet printera Wi‑Fi Direct nosaukumu. Printera displejā iegaumējiet printera astoņu ciparu PIN. Ievadiet PIN datorā. Ja printera draiveris vēl nav instalēts, Windows lejupielādē attiecīgo draiveri. Macintosh lietotājiem Noklikšķiniet uz bezvadu ikonas un pēc tam atlasiet printera Wi‑Fi Direct nosaukumu. Pirms Wi-Fi Direct nosaukuma tiek pievienota virkne DIRECT-xy (kur x un y ir divas nejaušas rakstzīmes). Ierakstiet Wi‑Fi Direct paroli. Kad atvienojat Wi-Fi Direct tīklu, pārslēdziet datoru atpakaļ uz tā iepriekšējo tīklu. dators pievienošana printerim datora pievienošana printerim"},{"UUID":"66dc4609-2b82-4509-ab35-0e6e2fae372a","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Wi‑Fi tīkla deaktivizēšana Sākuma ekrānā","descFull":"Wi‑Fi tīkla deaktivizēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Tīklu pārskats Aktīvs adapteris Standarta tīkls . Izpildiet displejā redzamos norādījumus. Wi‑Fi tīkls deaktivizēšana Wi‑Fi tīkla deaktivizēšana"},{"UUID":"972794c6-4909-46f8-bba1-7b7ac511b946","title":"Tīklošana","link":"networking-intro-topic.html","desc":"Printera savienojuma pārbaude Sākuma ekrānā","descFull":"Printera savienojuma pārbaude Sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites Tīkls Tīkla iestatīšanas lapa . Skatiet tīkla iestatīšanas lapas pirmo sadaļu un pārliecinieties, vai statuss ir Pievienots. Ja statuss ir Nav pievienots, iespējams, LAN savienojuma punkts nav aktīvs vai ir radusies tīkla kabeļa darbības kļūme. Palīdzību jautājiet savam administratoram. drukāšana tīkla iestatīšanas lapa tīkla iestatīšanas lapas drukāšana tīkla iestatīšanas lapa drukāšana"},{"UUID":"de60adbe-6134-4c13-9510-7122f8cf36d1","title":"Uzstādīšana, instalēšana un konfigurēšana","link":"setting-up-serial-printing-topic.html","desc":"Seriālās drukāšanas iestatīšana (tikai Windows)","descFull":"Seriālās drukāšanas iestatīšana (tikai Windows) Pirms darba sākšanas pārbaudiet, vai printerī ir uzstādīts seriālais iekšējo risinājumu ports. Printerī iestatiet parametrus. Vadības panelī pārvietojieties uz porta iestatījumu izvēlni. Atrodiet seriālā porta iestatījumu izvēlni un pēc tam koriģējiet iestatījumus, ja nepieciešams. Piemērojiet izmaiņas. Datorā atveriet printeru mapi un atlasiet savu printeri. Atveriet printera rekvizītus un pēc tam sarakstā atlasiet COM portu. Ierīču pārvaldniekā iestatiet COM porta parametrus. Seriālā drukāšana samazina drukāšanas ātrumu. Nodrošiniet, lai seriālais kabelis ir pievienots printera seriālajam portam. seriālās drukāšanas iestatīšana seriālā drukāšana iestatīšana"},{"UUID":"90ca779d-7d8e-4c5f-8902-fe42c4ffbbda","title":"Printera drošība","link":"locating-security-slot-topic.html","desc":"Drošības slota atrašana Printeris ir","descFull":"Drošības slota atrašana Printeris ir aprīkots ar drošības slēdža funkciju. Lai garantētu printera un cietā diska drošu atrašanos savā vietā, piestipriniet ar vairākumu klēpjdatoru saderīgu drošības slēdzi, kā parādīts. drošības slots atrašana drošības slota atrašana"},{"UUID":"81058da7-937e-4b4f-9c9b-f67b7e41a2a2","title":"Printera drošība","link":"erasing-printer-memory-topic.html","desc":"Printera atmiņas dzēšana Lai printerī","descFull":"Printera atmiņas dzēšana Lai printerī izdzēstu energoatkarīgu atmiņu vai buferī esošos datus, izslēdziet printeri. Lai izdzēstu energoneatkarīgu atmiņu, ierīces un tīkla iestatījumus, drošības iestatījumus un iegultos risinājumus, rīkojieties šādi: Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Dzēšana, pārtraucot lietošanu . Pieskarieties pie izvēles rūtiņas  Sanitizēt visu informāciju energoneatkarīgajā atmiņā  un pēc tam pieskarieties pie  DZĒST . Pieskarieties pie  Sākt sākotnējās iestatīšanas vedni  vai  Printerim jāatrodas bezsaistē  un pēc tam pieskarieties pie  Tālāk . Sāciet darbību. Šis process iznīcina arī šifrēšanas atslēgu, ko izmanto lietotāja datu aizsardzībai. Iznīcinot šifrēšanas atslēgu, datus nevar atgūt. energoatkarīga atmiņa dzēšana energoneatkarīga atmiņa dzēšana printera atmiņa dzēšana dzēšana printera atmiņa"},{"UUID":"3219a573-497e-43d0-a56a-bfe78aad6d6b","title":"Printera drošība","link":"erasing-printer-storage-drive-topic.html","desc":"Printera krātuves diska dzēšana Sākuma","descFull":"Printera krātuves diska dzēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Dzēšana, pārtraucot lietošanu . Atkarībā no printerī instalētā krātuves diska veiciet kādu no šīm darbībām: Ja izmantojat cieto disku, pieskarieties izvēles rūtiņai  Sanitizēt visu informāciju cietajā diskā , pieskarieties  DZĒST  un pēc tam atlasiet datu dzēšanas metodi. Cietā diska sanitizēšanas process var ilgt no dažām minūtēm līdz vairāk nekā stundai; šajā laikā printeris nevar veikt citus uzdevumus. Ja izmantojat viedo krātuves disku, pieskarieties  Izdzēst viedo krātuves disku  un pēc tam pieskarieties  DZĒST , lai dzēstu visus lietotāja datus. Sāciet darbību. krātuves disks dzēšana printera krātuves diska dzēšana cietais disks dzēšana viedais krātuves disks dzēšana"},{"UUID":"40a0aff7-f5dc-4741-8555-a73b4547e91c","title":"Printera drošība","link":"restoring-factory-default-settings-topic.html","desc":"Rūpnīcas noklusējuma iestatījumu atjaunošana Sākuma","descFull":"Rūpnīcas noklusējuma iestatījumu atjaunošana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Atjaunot rūpnīcas noklusējumus . Pieskarieties pie  Atjaunot iestatījumus atlasiet tos iestatījumus, ko vēlaties atjaunot, ATJAUNOT . Sāciet darbību. rūpnīcas noklusējuma iestatījumi atjaunošana printera iestatījumi rūpnīcas noklusējumu atjaunošana"},{"UUID":"fe8dc96e-1254-406a-b1d5-131cce433e97","title":"Printera drošība","link":"statement-of-volatility-topic.html","desc":"Paziņojums par energoatkarību Atmiņas veidi","descFull":"Paziņojums par energoatkarību Atmiņas veidi un to apraksti Atmiņas veids Apraksts Energoatkarīga atmiņa Printerī tiek lietota standarta brīvpiekļuves atmiņa (RAM), lai vienkāršu drukas un kopēšanas darbu laikā buferī īslaicīgi ievietotu lietotāja datus. Energoneatkarīga atmiņa Printerī var izmanto divu veidu energoneatkarīgu atmiņu: EEPROM un NAND (zibatmiņa). Abos veidos tiek glabāta operētājsistēmas, printera iestatījumu un tīkla informācija. Tiek glabāti arī skenera un grāmatzīmju iestatījumi un iegultie risinājumi. Cietā diska krātuves diskdzinis Dažos printeros var būt uzstādīts cietais disks. Printera cietais disks ir paredzēts no printera atkarīgām funkcijām. Cietais disks ļauj printerim saglabāt buferī ievietotos lietotāja datus no sarežģītiem drukas darbiem, kā arī veidlapu datus un fontu datus. Viedais krātuves disks (ISD) Dažiem printeriem var būt uzstādīts ISD. ISD izmanto energoneatkarīgu zibatmiņu, lai glabātu lietotāja datus no sarežģītiem drukas darbiem, kā arī veidlapu datus un fontu datus. Izdzēsiet visu uzstādīto printera atmiņas ierīču saturu šādos gadījumos: Printeris netiek izmantots. Printera cietais disks vai ISD ir nomainīts. Printeris ir pārvietots uz citu nodaļu vai atrašanās vietu. Printera apkopi veic jūsu uzņēmumam nepiederoša persona. Printeris apkopes nolūkos ir pārvietots ārpus jūsu uzņēmuma telpām. Printeris ir pārdots citai organizācijai. Atbrīvojoties no krātuves diska, ņemiet vērā sava uzņēmuma politikas un procedūras. paziņojums par energoatkarību energoatkarīga atmiņa energoneatkarīga atmiņa cietā diska krātuves diskdzinis viedais krātuves disks printera atmiņas dzēšana printera datu drošība"},{"UUID":"b8f97613-0d7b-4df2-92cb-f95af1d9d52a","title":"Drukāt","link":"printing-from-computer-h2-topic.html","desc":"Drukāšana no datora Ja drukājat","descFull":"Drukāšana no datora Ja drukājat uz etiķetēm, kartona un aploksnēm, pirms dokumenta drukāšanas printerī iestatiet papīra izmērus un veidu. Dokumentā, kuru vēlaties izdrukāt, atveriet dialoglodziņu Drukāšana. Ja nepieciešams, koriģējiet iestatījumus. Izdrukājiet dokumentu. drukāšana no datora dokumenti, drukāšana no datora drukāšana no datora"},{"UUID":"51dea877-7f8d-46b3-912c-b00afc6264ff","title":"Drukāšana no mobilās ierīces","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukāšana no mobilās ierīces, izmantojot","descFull":"Drukāšana no mobilās ierīces, izmantojot pakalpojumu Lexmark Mobile Print Drukāšana no mobilās ierīces, izmantojot pakalpojumu Lexmark Mobile Print Lexmark  Pakalpojums Mobile Print ļauj nosūtīt dokumentus un attēlus tieši uz atbalstītu Lexmark printeri. Atveriet dokumentu un pēc tam nosūtiet vai kopīgojiet dokumentu pakalpojumā Lexmark Mobile Print. Dažas trešo pušu lietojumprogrammas var neatbalstīt sūtīšanas vai kopīgošanas funkciju. Papildinformāciju skatiet kopā ar lietojumprogrammu piegādātajā dokumentācijā. Atlasiet printeri. Izdrukājiet dokumentu. Lexmark Mobile Print lietošana dokumenti, drukāšana no mobilās ierīces mobila ierīce drukāšana no"},{"UUID":"a810091e-f2f8-4159-81e2-7a9467526856","title":"Drukāšana no mobilās ierīces","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukāšana no mobilās ierīces, izmantojot","descFull":"Drukāšana no mobilās ierīces, izmantojot Lexmark Print Lexmark  Print ir mobilās drukāšanas risinājums, kas paredzēts mobilajām ierīcēm ar operētājsistēmu Android  6.0 vai jaunāku versiju. Tas ļauj sūtīt dokumentus un attēlus uz tīklā pievienotiem printerim un drukas pārvaldības serveriem. Pārliecinieties, vai esat lejupielādējis Lexmark Print lietojumprogrammu no  Google Play  veikala, un iespējojiet to mobilajā ierīcē. Nodrošiniet, lai printeris un mobilā ierīce ir pievienoti vienam tīklam. Savā mobilajā ierīcē atlasiet dokumentu failu pārvaldniekā. Nosūtiet vai kopīgojiet dokumentu ar Lexmark Print. Dažas trešo pušu lietojumprogrammas var neatbalstīt sūtīšanas vai kopīgošanas funkciju. Papildinformāciju skatiet kopā ar lietojumprogrammu piegādātajā dokumentācijā. Atlasiet printeri un pēc tam koriģējiet iestatījumu, ja nepieciešams. Izdrukājiet dokumentu. Lexmark Print lietošana dokumenti, drukāšana no mobilās ierīces mobila ierīce drukāšana no"},{"UUID":"dd5c8bd6-3f7a-47a3-a15c-976517e5879a","title":"Drukāšana no mobilās ierīces","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukāšana no mobilās ierīces, izmantojot","descFull":"Drukāšana no mobilās ierīces, izmantojot Mopria drukāšanas pakalpojumu Mopria  drukāšanas pakalpojums ir mobilās drukāšanas risinājums, kas paredzēts mobilajām ierīcēm ar operētājsistēmu  Android  5.0 vai jaunāku versiju. Tas ļauj tieši drukāt no jebkura printera ar Mopria sertifikātu. Pārliecinieties, vai esat lejupielādējis Mopria drukāšanas pakalpojuma lietojumprogrammu no  Google Play  veikala, un iespējojiet to mobilajā ierīcē. Savā Android mobilajā ierīcē palaidiet saderīgu lietojumprogrammu vai atlasiet dokumentu failu pārvaldniekā. Pieskarieties pie  Drukāt . Atlasiet printeri un pēc tam koriģējiet iestatījumu, ja nepieciešams. Pieskarieties pie  . Mopria drukāšanas pakalpojums drukāšana no mobilās ierīces mobila ierīce drukāšana no drukāšana izmantojot Mopria drukāšanas pakalpojumu"},{"UUID":"35a88749-694c-4072-9d7c-ac9fbb67cf7d","title":"Drukāšana no mobilās ierīces","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukāšana no mobilās ierīces, izmantojot","descFull":"Drukāšana no mobilās ierīces, izmantojot AirPrint AirPrint programmatūras funkcija ir mobilās drukāšanas risinājums, kas ļauj drukāt tieši no Apple ierīcēm, izmantojot AirPrint sertificētu printeri. Nodrošiniet, lai Apple ierīce un printeris ir pievienoti vienam tīklam. Ja tīklam ir vairāki bezvadu centrmezgli, pārbaudiet, vai abas ierīces ir pievienotas vienam apakštīklam. Šo lietojumprogrammu atbalsta tikai dažas Apple ierīces. Mobilās ierīces failu pārvaldniekā atlasiet dokumentu vai palaidiet saderīgu lietojumprogrammu. Pieskarieties pie  Drukāt . Atlasiet printeri un pēc tam koriģējiet iestatījumu, ja nepieciešams. Izdrukājiet dokumentu. AirPrint lietošana drukāšana no mobilās ierīces mobila ierīce drukāšana no"},{"UUID":"e7946928-b1b0-4397-a3ed-9e4008653c99","title":"Drukāšana no mobilās ierīces","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Drukāšana no mobilās ierīces, izmantojot","descFull":"Drukāšana no mobilās ierīces, izmantojot Wi‑Fi Direct® Wi‑Fi Direct  ir drukāšanas pakalpojums, kas ļauj drukāt, izmantojot jebkuru pakalpojumam Wi‑Fi Direct gatavu printeri. Pārbaudiet, vai mobilā ierīce ir pievienota printera bezvadu tīklam. Lai iegūtu papildinformāciju, skatiet:  . Savā mobilajā ierīcē palaidiet saderīgu lietojumprogrammu vai atlasiet dokumentu failu pārvaldniekā. Atkarībā no mobilās ierīces veiciet kādu no šīm darbībām: Pieskarieties pie  Drukāt . Pieskarieties pie  Drukāt . Pieskarieties pie  Drukāt . Atlasiet printeri un pēc tam koriģējiet iestatījumu, ja nepieciešams. Izdrukājiet dokumentu. Wi‑Fi Direct drukāšana no mobilās ierīces drukāšana no mobilās ierīces mobila ierīce drukāšana no drukāšana izmantojot Wi‑Fi Direct"},{"UUID":"2660cccc-ad61-43bf-8a4e-9f0729fe12fa","title":"Drukāt","link":"printing-from-flash-drive-topic.html","desc":"Drukāšana no zibatmiņas diska Ievietojiet","descFull":"Drukāšana no zibatmiņas diska Ievietojiet zibatmiņas disku. Ja ievietojat zibatmiņas disku, kamēr tiek rādīts kļūdas ziņojums, printeris ignorē zibatmiņas disku. Ja ievietojat zibatmiņas disku, kamēr printeris apstrādā citus drukas darbus, printera displejā tiek parādīts ziņojums  Aizņemts . Displejā pieskarieties pie izdrukājamā dokumenta. Ja nepieciešams, konfigurējiet drukāšanas iestatījumus. Izdrukājiet dokumentu. Lai izdrukātu citu dokumentu, pieskarieties pie  USB disks . Lai izvairītos no datu zaudēšanas vai nepareizas printera darbības, nepieskarieties zibatmiņas diskam vai printerim šeit attēlotajā apgabalā, kamēr notiek drukāšana no atmiņas ierīces, tās lasīšana vai rakstīšana tajā. drukāšana no zibatmiņas diska zibatmiņas disks drukāšana no"},{"UUID":"b3b4a065-5e85-4f92-99d2-77b0810a0ef6","title":"Drukāt","link":"supported-flash-drives-and-file-types-topic.html","desc":"Atbalstīto zibatmiņas disku un failu","descFull":"Atbalstīto zibatmiņas disku un failu veidi Zibatmiņas diski Lexar JumpDrive S70 (16GB un 32GB) SanDisk Cruzer Micro (16GB un 32GB) PNY Attaché (16GB un 32GB) Printeris atbalsta ātrdarbīgus zibatmiņas diskus ar pilna ātruma standartu. Zibatmiņas diskiem ir jāatbalsta failu iedales tabulas (File Allocation Table — FAT) sistēma. Failu veidi Atbalstītie failu veidi Dokumenti Attēli PDF (1.7 vai vecāka versija) Microsoft failu formāti (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG vai JPG TIFF vai TIF GIF BMP PNG PCX DCX atbalstītie zibatmiņas diski zibatmiņas diski atbalstīts atbalstītie failu veidi failu veidi atbalstīts"},{"UUID":"18a42de4-2435-45c2-8d84-0da8b2ebb641","title":"Drukāt","link":"configuring-confidential-jobs-topic.html","desc":"Konfidenciālu darbu konfigurēšana Sākuma ekrānā","descFull":"Konfidenciālu darbu konfigurēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Drošība Konfidenciālas drukāšana iestatīšana . Konfigurējiet iestatījumus. Izvēlnes  Konfidenciālas drukāšanas iestatīšana  vienumi un to apraksti Iestatījums Apraksts Maksimālais nederīga PIN skaits Iestatiet, cik reižu var ievadīt nederīgu PIN. Kad tiek sasniegts šis ierobežojums, konkrētajam lietotājvārdam atbilstošie drukas darbi tiek izdzēsti. Konfidenciālu darbu derīguma termiņš Katram aizturētajam darbam iestatiet individuālu derīguma termiņu, pirms tas automātiski tiek izdzēsts no printera atmiņas, cietā diska vai viedā krātuves diska. Aizturētais darbs ir  Konfidenciāls ,  Atkārtots ,  Rezervēts  vai  Pārbaudāms . Atkārtotu darbu derīguma termiņš Iestatiet derīguma termiņu drukas darbiem, kurus vēlaties atkārtot. Pārbaudāmu darbu derīguma termiņš Iestatiet derīguma termiņu tāda darba eksemplāra drukāšanai, lai pārbaudītu kvalitāti pirms pārējo eksemplāru drukāšanas. Rezervētu darbu derīguma termiņš Iestatiet derīguma termiņu tādiem darbiem, kurus vēlaties saglabāt printerī, lai drukātu vēlāk. Pieprasīt visu darbu aizturēšanu Iestatiet printeri aizturēt visus drukas darbus. Paturēt dublētus dokumentus Iestatiet, lai printeris paturētu visus dokumentus ar vienādu faila nosaukumu. konfidenciāli drukas darbi konfigurēšana aizturēti darbi derīguma termiņa iestatīšana drukas darbu glabāšana drukas darbu atkārtošana drukas darbu pārbaude"},{"UUID":"47d0a952-54bb-464d-9dfa-758f16a27ace","title":"Drukāt","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Konfidenciālu un citu aizturētu darbu","descFull":"Konfidenciālu un citu aizturētu darbu drukāšana Windows lietotājiem Kad dokuments ir atvērts, noklikšķiniet uz  Fails Drukāt . Atlasiet printeri un pēc tam noklikšķiniet uz  Rekvizīti ,  Preferences ,  Opcijas  vai  Iestatīšana . Noklikšķiniet uz  Drukāšana un aizturēšana . Atlasiet  Izmantot drukāšanu un aizturēšanu  un pēc tam piešķiriet lietotājvārdu. Atlasiet drukas darba veidu (konfidenciāls, atkārtots, rezervēts vai pārbaudāms). Ja atlasāt  Konfidenciāli , iestatiet drukas darba drošību ar personas identifikācijas numuru (personal identification number — PIN). Noklikšķiniet uz  Labi  vai  Drukāt . Printera sākuma ekrānā izpildiet drukas darbu. Ja ir konfidenciāli drukas darbi, pieskarieties pie  Aizturēti darbi  atlasiet savu lietotājvārdu Konfidenciāli  ievadiet PIN  atlasiet drukas darbu  konfigurējiet iestatījumus Drukāt . Ja ir citi drukas darbi, pieskarieties pie  Aizturēti darbi  atlasiet savu lietotājvārdu  atlasiet drukas darbu  konfigurējiet iestatījumus Drukāt Macintosh lietotājiem AirPrint izmantošana Kad dokuments ir atvērts, izvēlieties  Fails Drukāt . Atlasiet printeri un pēc tam nolaižamajā izvēlnē pēc izvēlnes  Orientācija  izvēlieties  Drukāšanas PIN . Iespējojiet  Drukāt ar PIN  un pēc tam ievadiet četru ciparu PIN. Noklikšķiniet uz  Drukāt . Printera sākuma ekrānā izpildiet drukas darbu. Pieskarieties pie  Aizturēti darbi  atlasiet sava datora nosaukumu Konfidenciāli  ievadiet PIN atlasiet drukas darbu Drukāt . Printera draivera izmantošana Kad dokuments ir atvērts, izvēlieties  Fails Drukāt . Atlasiet printeri un pēc tam nolaižamajā izvēlnē pēc izvēlnes  Orientācija  izvēlieties  Drukāšana un aizturēšana . Izvēlieties  Konfidenciāla drukāšana  un pēc tam ievadiet četru ciparu PIN. Noklikšķiniet uz  Drukāt . Printera sākuma ekrānā izpildiet drukas darbu. Pieskarieties pie  Aizturēti darbi  atlasiet sava datora nosaukumu Konfidenciāli atlasiet drukas darbu  ievadiet PIN Drukāt . drukāšana aizturēti darbi drukāšana konfidenciāli drukas darbi konfidenciāli drukas darbi drukāšana aizturēti darbi drukāšana"},{"UUID":"c1d19697-c7d2-42f3-9de9-16c91aebc715","title":"Drukāt","link":"printing-font-sample-list-h2-topic.html","desc":"Fontu paraugu saraksta drukāšana Sākuma","descFull":"Fontu paraugu saraksta drukāšana Sākuma ekrānā pieskarieties pie  Iestatījumi  Atskaites Drukāšana Fontu drukāšana . Pieskarieties pie  PCL fonti  vai  PS fonti . drukāšana fontu paraugu saraksts fontu paraugu saraksta drukāšana fontu paraugu saraksts drukāšana"},{"UUID":"42a1e482-40fb-41c5-b3a0-728654273ba8","title":"Drukāt","link":"printing-directory-list-h2-topic.html","desc":"Direktoriju saraksta drukāšana Sākuma ekrānā","descFull":"Direktoriju saraksta drukāšana Sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites Drukāšana Direktoriju drukāšana . drukāšana direktoriju saraksts direktoriju saraksta drukāšana direktoriju saraksts drukāšana"},{"UUID":"9028b99b-0ad6-4c96-9ee5-f2438704c7dc","title":"Drukāt","link":"placing-separator-sheets-topic.html","desc":"Atdalošo lapu ievietošana starp eksemplāriem","descFull":"Atdalošo lapu ievietošana starp eksemplāriem Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Izkārtojums Atdalošās lapas Starp eksemplāriem . Izdrukājiet dokumentu. atdalošās lapas novietošana atdalošo lapu ievietošana"},{"UUID":"56e5c4a1-7310-42d6-a497-8d14d4d5587c","title":"Drukāt","link":"stapling-printed-sheets-topic.html","desc":"Izdrukāto lapu skavošana Windows lietotājiem","descFull":"Izdrukāto lapu skavošana Windows lietotājiem Kad dokuments ir atvērts, noklikšķiniet uz  Fails Drukāt . Atlasiet printeri un pēc tam noklikšķiniet uz  Rekvizīti ,  Preferences ,  Opcijas  vai  Iestatīšana . Noklikšķiniet uz  Papīrs/apdarinātājs . Ja nepieciešams, konfigurējiet papīra iestatījumus. Izvēlnē Apdare atlasiet skavošanas iestatījumu. Noklikšķiniet uz  Labi  vai  Drukāt . Macintosh lietotājiem Kad dokuments ir atvērts, izvēlieties  Fails Drukāt . Atlasiet printeri un pēc tam nolaižamajā izvēlnē pēc izvēlnes  Orientācija  izvēlieties  Apdare . Noklikšķiniet uz  Skavošana  un pēc tam atlasiet iestatījumu. Noklikšķiniet uz  Drukāt . izdrukāto lapu skavošana izdrukātās lapas skavošana"},{"UUID":"db22149c-99ce-4556-bcb0-dbf91e3f45ae","title":"Drukāt","link":"punching-holes-printed-sheets-topic.html","desc":"Caurumošana izdrukātās lapās Pirms darba","descFull":"Caurumošana izdrukātās lapās Pirms darba sākšanas pārbaudiet, vai ir konfigurēti caurumotāja iestatījumi. Sākuma ekrānā pieskarieties  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Apdarinātāja konfigurēšana Caurumotāja konfigurēšana   atlasiet konfigurāciju. Windows lietotājiem Kad dokuments ir atvērts, noklikšķiniet uz  Fails Drukāt . Atlasiet printeri un pēc tam noklikšķiniet uz  Rekvizīti ,  Preferences ,  Opcijas  vai  Iestatīšana . Noklikšķiniet uz  Papīrs/apdarinātājs . Ja nepieciešams, konfigurējiet papīra iestatījumus. Izvēlnē Apdare atlasiet caurumošanas iestatījumu. Noklikšķiniet uz  Labi  vai  Drukāt . Macintosh lietotājiem Kad dokuments ir atvērts, izvēlieties  Fails Drukāt . Atlasiet printeri un pēc tam nolaižamajā izvēlnē pēc izvēlnes Orientācija atlasiet  Apdare . Noklikšķiniet uz Caurumošana  un pēc tam atlasiet iestatījumu. Noklikšķiniet uz  Drukāt . caurumošana izdrukātās lapās izdrukātās lapas caurumošana"},{"UUID":"0ec0bf33-d5d8-4941-9651-866584d5c022","title":"Drukāt","link":"using-offset-stacking-printed-sheets-topic.html","desc":"Kaudzīšu ofseta lietošana izdrukātajās lapās","descFull":"Kaudzīšu ofseta lietošana izdrukātajās lapās Windows lietotājiem Kad dokuments ir atvērts, noklikšķiniet uz  Fails Drukāt . Atlasiet printeri un pēc tam noklikšķiniet uz  Rekvizīti ,  Preferences ,  Opcijas  vai  Iestatīšana . Noklikšķiniet uz  Papīrs/apdarinātājs . Ja nepieciešams, konfigurējiet papīra iestatījumus. Izvēlnē Apdare atlasiet iestatījumu Ofsets. Noklikšķiniet uz  Labi  vai  Drukāt . Macintosh lietotājiem Kad dokuments ir atvērts, izvēlieties  Fails Drukāt . Atlasiet printeri un pēc tam nolaižamajā izvēlnē pēc izvēlnes  Orientācija  izvēlieties  Apdare . Noklikšķiniet uz  Ofsets  un pēc tam atlasiet iestatījumu. Noklikšķiniet uz  Drukāt . kaudzīšu ofsets izdrukātajās lapās izdrukātās lapas ofsets, kaudzītes"},{"UUID":"ea284ebc-db5c-47fb-9e66-560741bc564a","title":"Drukāt","link":"canceling-print-job-topic.html","desc":"Drukas darba atcelšana Sākuma ekrānā","descFull":"Drukas darba atcelšana Sākuma ekrānā pieskarieties pie  . Atlasiet atceļamo darbu. Darbu varat arī atcelt, pieskaroties pie  Darbu rinda . drukas darbs atcelšana drukas darba atcelšana"},{"UUID":"aaea2e23-54b4-459e-a5e7-03919cf90878","title":"Drukāt","link":"adjusting-toner-darkness-topic.html","desc":"Tonera intensitātes koriģēšana Sākuma ekrānā","descFull":"Tonera intensitātes koriģēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte . Izvēlnē Tonera intensitāte koriģējiet iestatījumus. tonera intensitāte koriģēšana tonera intensitātes koriģēšana"},{"UUID":"6c07b594-d910-4272-969c-c4e6dbb1b9ac","title":"Kopēšana","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Automātiskā dokumentu padevēja vai skenera","descFull":"Automātiskā dokumentu padevēja vai skenera stikla lietošana Papīra ievietošana ADF paplātē un novietošana uz skenera stikla Automātiskais dokumentu padevējs (Automatic document feeder — ADF) Skenera stikls Izmantojiet ADF dokumentiem ar vairākām lapām vai abpusēji apdrukātiem dokumentiem. Oriģinālo dokumentu ievietojiet ar apdrukāto pusi uz augšu. Izmantojot dokumentu ar vairākām lapām, pirms ievietošanas noteikti nolīdziniet priekšējo malu. Noteikti pielāgojiet ADF vadotnes atbilstoši ievietojamā papīra platumam. Izmantojiet skenera stiklu vienas lapas dokumentiem, grāmatu lapām, nelieliem materiāliem (piemēram, pastkartēm vai fotoattēliem), kodoskopa plēvēm, fotopapīram vai plānam apdrukājamajam materiālam (piemēram, izgriezumiem no žurnāliem). Novietojiet dokumentu ar apdrukāto pusi uz leju stūrī ar bultiņu. kopēšana automātiskais dokumentu padevējs (Automatic document feeder — ADF) lietošana kopēšana skenera stikla lietošana"},{"UUID":"0ca23105-57b0-4e98-b484-7a2973eaf280","title":"Kopēšana","link":"making-copies-topic.html","desc":"Kopēšana Ievietojiet oriģinālo dokumentu ADF","descFull":"Kopēšana Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Lai attēls netiktu apgriezts, pārliecinieties, vai sakrīt oriģinālā dokumenta un izdrukas papīra izmēri. Sākuma ekrānā pieskarieties pie  Kopēšana  un pēc tam norādiet kopiju skaitu. Ja nepieciešams, koriģējiet kopēšanas iestatījumus. Kopējiet dokumentu. Lai ātri kopētu, sākuma ekrānā pieskarieties pie  . kopēšana ADF lietošana kopēšana skenera stikla lietošana kopēšana kopēšana no atlasītā paplāte kopēšana uz dažādu izmēru papīra dažādi papīra izmēri, kopēšana"},{"UUID":"2458b1c3-44a0-4c82-bb62-ddccf1da1025","title":"Kopēšana","link":"copying-photos-topic.html","desc":"Fotoattēlu kopēšana Novietojiet fotoattēlu uz","descFull":"Fotoattēlu kopēšana Novietojiet fotoattēlu uz skenera stikla. Sākuma ekrānā pieskarieties pie  Kopēšana Saturs Satura veids Fotoattēls . Pieskarieties pie  Satura avots  un pēc tam atlasiet iestatījumu, kas vislabāk atbilst oriģinālajam fotoattēlam. Kopējiet fotoattēlu. kopēšana fotoattēli fotoattēli, kopēšana"},{"UUID":"2a4e0500-273d-4245-b304-1020b7a20ed2","title":"Kopēšana","link":"copying-transparencies-or-letterhead-topic.html","desc":"Kopēšana uz veidlapām Ievietojiet oriģinālo","descFull":"Kopēšana uz veidlapām Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Kopēšana Kopēt no atlasiet oriģinālā dokumenta izmērus. Pieskarieties pie  Kopēt uz  un pēc tam atlasiet papīra avotu, kurā atrodas veidlapa. Ja daudzfunkciju padevējā ievietojāt veidlapu, pieskarieties pie  Kopēt uz Daudzfunkciju padevējs atlasiet papīra izmērus Veidlapa . Kopējiet dokumentu. kopēšana uz veidlapas veidlapa kopēšana uz"},{"UUID":"14f08e0c-761e-4398-8dce-67d8d9fe2dc9","title":"Kopēšana","link":"copying-on-both-sides-of-paper-topic.html","desc":"Kopēšana uz abām papīra pusēm","descFull":"Kopēšana uz abām papīra pusēm Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Kopēšana Puses . Pieskarieties pie  No 1 puses uz 2 pusēm  vai  No 2 pusēm uz 2 pusēm . Kopējiet dokumentu. kopēšana uz abām papīra pusēm divpusēja kopēšana"},{"UUID":"8d0cf2be-23d5-4187-a3d4-247e9c3f496b","title":"Kopēšana","link":"reducing-enlarging-copies-topic.html","desc":"Kopiju samazināšana vai palielināšana Ievietojiet","descFull":"Kopiju samazināšana vai palielināšana Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Kopēšana Mērogs atlasiet mēroga vērtību. Ja pēc iestatījuma  Mērogs  vērtības iestatīšanas maināt oriģinālā dokumenta vai izdrukas izmērus, mēroga vērtība tiek atiestatīta uz  Automātiski . Kopējiet dokumentu. kopijas izmēru samazināšana kopijas izmēru palielināšana"},{"UUID":"c7196272-f4a6-4c32-97db-4806cd29d2c4","title":"Kopēšana","link":"collating-copies-topic.html","desc":"Kopiju salikšana Ievietojiet oriģinālo dokumentu","descFull":"Kopiju salikšana Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Kopēt Salikt Ieslēgts [1,2,1,2,1,2] . Kopējiet dokumentu. kopiju salikšana vairāku kopiju kārtošana"},{"UUID":"dbc9e8b9-0a12-4e32-9e69-1828ed250a5f","title":"Kopēšana","link":"placing-separator-sheets-between-copies-topic.html","desc":"Atdalošo lapu ievietošana starp eksemplāriem","descFull":"Atdalošo lapu ievietošana starp eksemplāriem Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Kopēšana Atdalošās lapas . Koriģējiet iestatījumus. Nosūtiet kopēšanas darbu. atdalošo lapu ievietošana starp eksemplāriem kopēšana"},{"UUID":"54c874ba-5759-4c69-b791-a453aca61940","title":"Kopēšana","link":"saving-paper-topic.html","desc":"Vairāku lapu kopēšana uz vienas","descFull":"Vairāku lapu kopēšana uz vienas loksnes Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Kopēšana Lapas vienā pusē . Koriģējiet iestatījumus. Kopējiet dokumentu. vairāku lapu kopēšana uz vienas loksnes papīra taupīšana tonera taupīšana"},{"UUID":"2b65d9bf-6c23-4232-864a-1499f7885909","title":"Kopēšana","link":"copying-cards-topic.html","desc":"Karšu kopēšana Novietojiet karti uz","descFull":"Karšu kopēšana Novietojiet karti uz skenēšanas stikla. Sākuma ekrānā pieskarieties pie  Kopēšana Kopēt no . Pieskarieties pie  ID karte . Kopējiet karti. kopēšana kartes kartes kopēšana"},{"UUID":"99ea65b0-d0a7-45b0-bd57-2992a731a666","title":"Kopēšana","link":"stapling-copies-topic.html","desc":"Kopiju skavošana Ievietojiet oriģinālo dokumentu","descFull":"Kopiju skavošana Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Lai attēls netiktu apgriezts, pārliecinieties, vai sakrīt oriģinālā dokumenta un izdrukas papīra izmēri. Sākuma ekrānā pieskarieties pie  Kopēšana  un pēc tam norādiet kopiju skaitu. Ja nepieciešams, koriģējiet kopēšanas iestatījumus. Pieskarieties  Apdare Skavošana  un atlasiet skavošanas iestatījumu. Kopējiet dokumentu. kopiju skavošana eksemplāri skavošana"},{"UUID":"d51b5d17-b4c1-4055-9005-5e82314d80da","title":"Kopēšana","link":"punching-holes-copies-topic.html","desc":"Caurumošana kopijās Ievietojiet oriģinālo dokumentu","descFull":"Caurumošana kopijās Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Lai attēls netiktu apgriezts, pārliecinieties, vai sakrīt oriģinālā dokumenta un izdrukas papīra izmēri. Sākuma ekrānā pieskarieties pie  Kopēšana  un pēc tam norādiet kopiju skaitu. Ja nepieciešams, koriģējiet kopēšanas iestatījumus. Pieskarieties  Apdare Caurumošana  un atlasiet caurumošanas iestatījumu. Kopējiet dokumentu. caurumošana kopijās eksemplāri caurumošana"},{"UUID":"17868eb2-eb98-408d-a9c5-9203985cb274","title":"Kopēšana","link":"using-offset-stacking-copies-topic.html","desc":"Kaudzīšu ofseta lietošana kopijām Ievietojiet","descFull":"Kaudzīšu ofseta lietošana kopijām Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Lai attēls netiktu apgriezts, pārliecinieties, vai sakrīt oriģinālā dokumenta un izdrukas papīra izmēri. Sākuma ekrānā pieskarieties pie  Kopēšana  un pēc tam norādiet kopiju skaitu. Ja nepieciešams, koriģējiet kopēšanas iestatījumus. Pieskarieties  Ofseta lapas  un pēc tam atlasiet iestatījumu. Kopējiet dokumentu. kaudzīšu ofsets kopijās eksemplāri ofsets, kaudzītes"},{"UUID":"ef38e85a-8952-4bad-ac54-27f2a9238374","title":"Kopēšana","link":"creating-copy-shortcut-topic.html","desc":"Kopēšanas īsceļa izveide Sākuma ekrānā","descFull":"Kopēšanas īsceļa izveide Sākuma ekrānā pieskarieties pie  Kopēšana . Koriģējiet iestatījumus un pēc tam pieskarieties pie  . Izveidojiet īsceļu. īsceļa izveide kopēšana īsceļa pievienošana kopēšana īsceļš, izveide kopēšana"},{"UUID":"4dd8153c-5c49-419e-9cf8-3547963f6c10","title":"E-pasts:","link":"using-ADF-and-scanner-glass-e-mail-topic.html","desc":"Automātiskā dokumentu padevēja vai skenera","descFull":"Automātiskā dokumentu padevēja vai skenera stikla lietošana Papīra ievietošana ADF paplātē un novietošana uz skenera stikla Automātiskais dokumentu padevējs (Automatic document feeder — ADF) Skenera stikls Izmantojiet ADF dokumentiem ar vairākām lapām vai abpusēji apdrukātiem dokumentiem. Oriģinālo dokumentu ievietojiet ar apdrukāto pusi uz augšu. Izmantojot dokumentu ar vairākām lapām, pirms ievietošanas noteikti nolīdziniet priekšējo malu. Noteikti pielāgojiet ADF vadotnes atbilstoši ievietojamā papīra platumam. Izmantojiet skenera stiklu vienas lapas dokumentiem, grāmatu lapām, nelieliem materiāliem (piemēram, pastkartēm vai fotoattēliem), kodoskopa plēvēm, fotopapīram vai plānam apdrukājamajam materiālam (piemēram, izgriezumiem no žurnāliem). Novietojiet dokumentu ar apdrukāto pusi uz leju stūrī ar bultiņu. e-pasta ziņojumu sūtīšana automātiskais dokumentu padevējs (Automatic document feeder — ADF) lietošana e-pasta ziņojumu sūtīšana skenera stikla lietošana"},{"UUID":"0bec32e8-4727-49a9-b352-6259197bcf8f","title":"E-pasts:","link":"sending-email-topic.html","desc":"E-pasta ziņojuma sūtīšana Pirms darba","descFull":"E-pasta ziņojuma sūtīšana Pirms darba sākšanas pārbaudiet, vai ir konfigurēti SMTP iestatījumi. Lai iegūtu papildinformāciju, skatiet:  . Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  E-pasts  un pēc tam ievadiet nepieciešamo informāciju. Ja nepieciešams, konfigurējiet skenēšanas iestatījumus. Nosūtiet e-pasta ziņojumu. e-pasts sūtīšana e-pasta sūtīšana"},{"UUID":"b3d8f868-f85e-4d2b-a1bf-1f127a16acf1","title":"E-pasts:","link":"creating-email-shortcut-topic.html","desc":"E-pasta īsceļa izveide Sākuma ekrānā","descFull":"E-pasta īsceļa izveide Sākuma ekrānā pieskarieties pie  E-pasts . Koriģējiet iestatījumus un pēc tam pieskarieties pie  . Izveidojiet īsceļu. īsceļa izveide e-pasts īsceļa pievienošana e-pasts īsceļš, izveide e-pasts e-pasta īsceļš izveide"},{"UUID":"7873178f-65e4-4dc9-940e-751cbdc358ef","title":"Fakss","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"Automātiskā dokumentu padevēja vai skenera","descFull":"Automātiskā dokumentu padevēja vai skenera stikla lietošana Papīra ievietošana ADF paplātē un novietošana uz skenera stikla Automātiskais dokumentu padevējs (Automatic document feeder — ADF) Skenera stikls Izmantojiet ADF dokumentiem ar vairākām lapām vai abpusēji apdrukātiem dokumentiem. Oriģinālo dokumentu ievietojiet ar apdrukāto pusi uz augšu. Izmantojot dokumentu ar vairākām lapām, pirms ievietošanas noteikti nolīdziniet priekšējo malu. Noteikti pielāgojiet ADF vadotnes atbilstoši ievietojamā papīra platumam. Izmantojiet skenera stiklu vienas lapas dokumentiem, grāmatu lapām, nelieliem materiāliem (piemēram, pastkartēm vai fotoattēliem), kodoskopa plēvēm, fotopapīram vai plānam apdrukājamajam materiālam (piemēram, izgriezumiem no žurnāliem). Novietojiet dokumentu ar apdrukāto pusi uz leju stūrī ar bultiņu. faksa sūtīšana automātiskais dokumentu padevējs (Automatic document feeder — ADF) lietošana faksa sūtīšana skenera stikla lietošana"},{"UUID":"0f7e88d7-0472-4000-bb8d-155f325f656d","title":"Fakss","link":"sending-fax-topic.html","desc":"Faksa sūtīšana Pārbaudiet, vai fakss","descFull":"Faksa sūtīšana Pārbaudiet, vai fakss ir konfigurēts. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Ja lietojat vadības paneli Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Fakss  un pēc tam ievadiet nepieciešamo informāciju. Ja nepieciešams, koriģējiet iestatījumus. Nosūtiet faksu. Ja lietojat datoru Pirms darba sākšanas pārbaudiet, vai ir instalēts faksa draiveris. Lai iegūtu papildinformāciju, skatiet:  . Windows lietotājiem Dokumentā, kuru vēlaties nosūtīt pa faksu, atveriet dialoglodziņu  Drukāšana . Atlasiet printeri un pēc tam noklikšķiniet uz  Rekvizīti ,  Preferences ,  Opcijas  vai  Iestatīšana . Noklikšķiniet uz  Fakss Iespējot faksu Vienmēr parādīt iestatījumus pirms faksa sūtīšanas  un pēc tam ievadiet adresāta numuru. Ja nepieciešams, konfigurējiet citus faksa iestatījumus. Nosūtiet faksu. Macintosh lietotājiem Kad dokuments ir atvērts, izvēlieties  Fails Drukāt . Atlasiet to printeri, kuram aiz nosaukuma ir pievienots  ‑ Fakss . Laukā  Kam  ievadiet adresāta numuru. Ja nepieciešams, konfigurējiet citus faksa iestatījumus. Nosūtiet faksu. faksa sūtīšana fakss sūtīšana"},{"UUID":"13f68254-a169-4466-bd1d-214a71fc5a3b","title":"Fakss","link":"scheduling-fax-topic.html","desc":"Faksa ieplānošana Pārbaudiet, vai fakss","descFull":"Faksa ieplānošana Pārbaudiet, vai fakss ir konfigurēts. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Fakss Kam ievadiet faksa numuru Gatavs . Pieskarieties pie  Sūtīšanas laiks , konfigurējiet datumu un laiku, pēc tam pieskarieties pie  Labi . Nosūtiet faksu. faksa ieplānošana fakss, ieplānošana"},{"UUID":"b1e7a776-72ae-400e-8916-553275091850","title":"Fakss","link":"creating-fax-destination-shortcut-topic.html","desc":"Faksa galamērķa īsceļa izveide Pārbaudiet,","descFull":"Faksa galamērķa īsceļa izveide Pārbaudiet, vai fakss ir konfigurēts. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Sākuma ekrānā pieskarieties pie  Fakss Uz . Ievadiet adresāta numuru un pēc tam pieskarieties pie  Gatavs . Koriģējiet iestatījumus un pēc tam pieskarieties pie  . Izveidojiet īsceļu. īsceļa izveide faksa galamērķis īsceļa pievienošana faksa galamērķis īsceļš, izveide faksa galamērķis faksa galamērķa īsceļš izveide"},{"UUID":"b1b7bce4-9bd3-4ff7-9314-2ac29b12e2d8","title":"Fakss","link":"changing-fax-resolution-topic.html","desc":"Faksa izšķirtspējas maiņa Pārbaudiet, vai","descFull":"Faksa izšķirtspējas maiņa Pārbaudiet, vai fakss ir konfigurēts. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Fakss  un pēc tam ievadiet nepieciešamo informāciju. Pieskarieties pie  Izšķirtspēja  un pēc tam atlasiet iestatījumu. Nosūtiet faksu. faksa izšķirtspēja maiņa faksa izšķirtspējas maiņa"},{"UUID":"bd94de45-9228-41bd-bb19-62896615b126","title":"Fakss","link":"adjusting-fax-darkness-topic.html","desc":"Faksa intensitātes koriģēšana Pārbaudiet, vai","descFull":"Faksa intensitātes koriģēšana Pārbaudiet, vai fakss ir konfigurēts. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Fakss  un pēc tam ievadiet nepieciešamo informāciju. Pieskarieties pie  Intensitāte  un pēc tam koriģējiet iestatījumu. Nosūtiet faksu. faksa intensitātes koriģēšana faksa intensitāte koriģēšana"},{"UUID":"1af142d6-08e1-4707-8a81-33b42ba833fc","title":"Fakss","link":"printing-fax-log-topic.html","desc":"Faksa žurnāla drukāšana Pārbaudiet, vai","descFull":"Faksa žurnāla drukāšana Pārbaudiet, vai ir konfigurēts analogais fakss vai etherFAX. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites Fakss . Pieskarieties pie  Faksa darbu žurnāls  vai  Faksa zvanu žurnāls . faksa žurnāls drukāšana faksa žurnāla drukāšana"},{"UUID":"fa0226b3-db6c-4af5-b837-b0858cb2c563","title":"Fakss","link":"blocking-junk-faxes-topic.html","desc":"Nevēlamu faksu bloķēšana Pārbaudiet, vai","descFull":"Nevēlamu faksu bloķēšana Pārbaudiet, vai ir konfigurēts analogais fakss vai etherFAX. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Faksa saņemšanas iestatījumi Administratora vadīklas . Norādiet iestatījuma  Bloķēt faksus, ja nav norādīts vārds  vērtību  Ieslēgts . nevēlami faksi bloķēšana nevēlamu faksu bloķēšana"},{"UUID":"5b1edaf7-b2c1-45de-a6b5-1b85625dfd67","title":"Fakss","link":"holding-faxes-topic.html","desc":"Faksu aizturēšana Pārbaudiet, vai ir","descFull":"Faksu aizturēšana Pārbaudiet, vai ir konfigurēts analogais fakss vai etherFAX. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Faksa saņemšanas iestatījumi Faksu aizturēšana . Atlasiet režīmu. faksu aizturēšana saņemti faksi aizturēšana fakss aizturēšana"},{"UUID":"4a326987-7cf0-4946-b8b6-7df1dac33f77","title":"Fakss","link":"forwarding-fax-topic.html","desc":"Faksa pāradresēšana Pārbaudiet, vai ir","descFull":"Faksa pāradresēšana Pārbaudiet, vai ir konfigurēts analogais fakss vai etherFAX. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Izveidojiet galamērķa īsceļu. Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Īsceļi Pievienot īsceļu . Atlasiet īsceļa veidu un pēc tam konfigurējiet iestatījumus. Iegaumējiet īsceļa numuru. Piemērojiet izmaiņas. Noklikšķiniet uz  Iestatījumi Fakss Faksa iestatīšana Faksa saņemšanas iestatījumi Administratora vadīklas . Izvēlnē  Faksa pāradresēšana  atlasiet  Pāradresēt  vai  Drukāt un pāradresēt . Izvēlnē  Pāradresēt šim:  atlasiet adresāta veidu un pēc tam ierakstiet īsceļa numuru. Piemērojiet izmaiņas. faksa pāradresēšana fakss pāradresēšana"},{"UUID":"bb479596-fae4-426c-88cb-ae2869366b70","title":"Skenēšana","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"Automātiskā dokumentu padevēja vai skenera","descFull":"Automātiskā dokumentu padevēja vai skenera stikla lietošana Papīra ievietošana ADF paplātē un novietošana uz skenera stikla Automātiskais dokumentu padevējs (Automatic document feeder — ADF) Skenera stikls Izmantojiet ADF dokumentiem ar vairākām lapām vai abpusēji apdrukātiem dokumentiem. Oriģinālo dokumentu ievietojiet ar apdrukāto pusi uz augšu. Izmantojot dokumentu ar vairākām lapām, pirms ievietošanas noteikti nolīdziniet priekšējo malu. Noteikti pielāgojiet ADF vadotnes atbilstoši ievietojamā papīra platumam. Izmantojiet skenera stiklu vienas lapas dokumentiem, grāmatu lapām, nelieliem materiāliem (piemēram, pastkartēm vai fotoattēliem), kodoskopa plēvēm, fotopapīram vai plānam apdrukājamajam materiālam (piemēram, izgriezumiem no žurnāliem). Novietojiet dokumentu ar apdrukāto pusi uz leju stūrī ar bultiņu. skenēšana automātiskais dokumentu padevējs (Automatic document feeder — ADF) lietošana skenēšana skenera stikla lietošana"},{"UUID":"a5860d55-75e9-480e-b380-d23b058af17f","title":"Skenēšana","link":"scanning-to-computer-topic.html","desc":"Skenēšana uz datoru Pirms darba","descFull":"Skenēšana uz datoru Pirms darba sākšanas nodrošiniet, lai dators un printeris ir pievienoti vienam tīklam. Windows lietotājiem Lexmark utilītas ScanBack lietošana Datorā palaidiet Lexmark utilītu ScanBack un pēc tam noklikšķiniet uz  Tālāk . Lai lejupielādētu utilītu, apmeklējiet vietni  www.lexmark.com/downloads . Noklikšķiniet uz  Iestatīšana  un pēc tam pievienojiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Noklikšķiniet uz  Aizvērt Tālāk . Atlasiet oriģinālā dokumenta izmērus un pēc tam noklikšķiniet uz  Tālāk . Atlasiet faila formātu un skenēšanas izšķirtspēju un pēc tam noklikšķiniet uz  Tālāk . Ievadiet unikālu skenēšanas profila nosaukumu un pēc tam noklikšķiniet uz  Tālāk . Pārlūkojiet, lai atrastu vietu, kur vēlaties saglabāt skenēto dokumentu, izveidojiet faila nosaukumu un pēc tam noklikšķiniet uz  Tālāk . Lai atkārtoti lietotu skenēšanas profilu, iespējojiet  Izveidot īsceļu  un pēc tam izveidojiet unikālu īsceļa nosaukumu. Noklikšķiniet uz  Pabeigt . Ievietojiet oriģinālo dokumentu automātiskajā dokumentu padevējā vai novietojiet to uz skenera stikla. Printera sākuma ekrānā pieskarieties pie  Skenēšanas profili Skenēt uz datoru  un pēc tam atlasiet skenēšanas profilu. Pārliecinieties, vai sākuma ekrānā ir pievienoti  skenēšanas profili . Lai iegūtu papildinformāciju, skatiet:  . Windows lietotājiem Funkcijas Windows faksu sūtīšana un skenēšana lietošana Pārbaudiet, vai printeris ir pievienots datoram. Lai iegūtu papildinformāciju, skatiet:  . Ievietojiet oriģinālo dokumentu automātiskajā dokumentu padevējā vai novietojiet to uz skenera stikla. Datorā atveriet funkciju  Windows faksu sūtīšana un skenēšana . Izvēlnē  Avots  atlasiet skenera avotu. Ja nepieciešams, koriģējiet skenēšanas iestatījumus. Skenējiet dokumentu. Macintosh lietotājiem Pārbaudiet, vai printeris ir pievienots datoram. Lai iegūtu papildinformāciju, skatiet:  . Ievietojiet oriģinālo dokumentu automātiskajā dokumentu padevējā vai novietojiet to uz skenera stikla. Datorā veiciet kādu no šīm darbībām: Atveriet  Attēla tveršana . Atveriet  Printeri un skeneri  un pēc tam atlasiet printeri. Noklikšķiniet uz  Skenēt Atvērt skeneri . Skenera  logā veiciet vienu vai vairākas no šīm darbībām: Atlasiet, kur vēlaties saglabāt skenēto dokumentu. Atlasiet oriģinālā dokumenta izmērus. Lai skenētu no ADF,  izvēlnē Skenēšana  atlasiet  Dokumentu padevējs  vai iespējojiet  Izmantot dokumentu padevēju . Ja nepieciešams, konfigurējiet skenēšanas iestatījumus. Noklikšķiniet uz  Skenēt . skenēšana uz datoru dators, skenēšana uz Lexmark utilīta ScanBack lietošana"},{"UUID":"585c96d9-060c-4f18-9fd3-84d806e2bf87","title":"Skenēšana","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Skenēšana uz FTP serveri Ievietojiet","descFull":"Skenēšana uz FTP serveri Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  FTP  un pēc tam ievadiet vajadzīgo informāciju. Ja nepieciešams, konfigurējiet citus FTP iestatījumus. Nosūtiet FTP darbu. FTP serveris, skenēšana uz vadības paneļa lietošana skenēšana uz FTP serveri skenēšana uz FTP serveri vadības paneļa lietošana"},{"UUID":"08f88994-8f20-4b6a-b558-26b43425798d","title":"Skenēšana","link":"creating-FTP-shortcut-topic.html","desc":"FTP īsceļa izveide Sākuma ekrānā","descFull":"FTP īsceļa izveide Sākuma ekrānā pieskarieties pie  FTP . Ievadiet FTP servera adresi un pēc tam pieskarieties pie  . Izveidojiet īsceļu. īsceļa izveide FTP adrese īsceļa pievienošana FTP adrese FTP adrese īsceļa izveide īsceļš, izveide FTP adrese"},{"UUID":"f26eea71-b6c5-415c-b6dd-8e0e8d27007a","title":"Skenēšana","link":"s2a-scanning-to-network-folders-topic.html","desc":"Skenēšana tīkla mapē Ievietojiet oriģinālo","descFull":"Skenēšana tīkla mapē Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Sākuma ekrānā pieskarieties pie  Skenēšanas centrs . Iespējams, ir mainīta ikona un nosaukums. Papildinformāciju jautājiet savam administratoram. Veiciet kādu no tālāk norādītajām darbībām. Atlasiet adresātu. Izmantojot SFTP, kā porta numuru iestatiet  22 . Izmantojiet īsceļu, pieskaroties pie   un pēc tam sarakstā atlasot īsceļu. Skenējiet dokumentu. skenēšana tīkla mapē SMB skenēšana"},{"UUID":"68426d46-8b6a-44f5-960b-7b67d0b3a9ef","title":"Skenēšana","link":"creating-network-folder-shortcut-topic.html","desc":"Tīkla mapes īsceļa izveide Atveriet","descFull":"Tīkla mapes īsceļa izveide Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Īsceļi Pievienot īsceļu . Izvēlnē Īsceļa veids atlasiet  Tīkla mape  un pēc tam konfigurējiet iestatījumus. Piemērojiet izmaiņas. tīkla mape īsceļa izveide īsceļa izveide tīkla mape"},{"UUID":"ac575a98-18fb-4594-beb0-ab77e27e0ec2","title":"Skenēšana","link":"scanning-to-flash-drive-topic.html","desc":"Skenēšana uz zibatmiņas disku Ievietojiet","descFull":"Skenēšana uz zibatmiņas disku Ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Ievietojiet zibatmiņas disku. Pieskarieties pie  Skenēt uz USB  un koriģējiet iestatījumus, ja nepieciešams. Lai skenēto dokumentu saglabātu mapē, pieskarieties pie  Skenēt uz , atlasiet mapi un pēc tam pieskarieties pie  Skenēt šeit . Ja netiek parādīts  USB diska  ekrāns, vadības panelī pieskarieties pie  USB disks . Skenējiet dokumentu. Lai izvairītos no datu zaudēšanas vai nepareizas printera darbības, nepieskarieties zibatmiņas diskam vai printerim šeit attēlotajā apgabalā, kamēr notiek drukāšana no atmiņas ierīces, tās lasīšana vai rakstīšana tajā. skenēšana uz zibatmiņas disku zibatmiņas disks skenēšana uz"},{"UUID":"5288c568-beb3-4244-a9e3-81acd39114c8","title":"Printera izvēļņu izmantošana","link":"menu-map-mfp-topic.html","desc":"Izvēļņu karte Ierīce Preferences ekonomiskais","descFull":"Izvēļņu karte Ierīce Preferences ekonomiskais režīms Attālā operatora panelis Paziņojumi Enerģijas pārvaldība Anonīma datu apkopšana Pieejamība Atjaunot rūpnīcas noklusējumus Apkope Sākuma ekrāna pielāgošana Par šo printeri Drukāt Izkārtojums Apdare Iestatīšana Kvalitāte Darbu uzskaite PDF PostScript PCL Attēls Papīrs Paplāšu konfigurēšana Apdrukājamā materiāla konfigurēšana Kopēšana Kopēšanas noklusējuma iestatījumi Fakss Faksa noklusējumi E-pasts E-pasta iestatīšana E-pasta noklusējuma iestatījumi Tīmekļa saites iestatīšana FTP FTP noklusējuma iestatījumi USB disks Skenēšana no zibatmiņas diska drukāšana no zibatmiņas diska Tīkls/porti Tīklu pārskats Bezvadu Wi‑Fi Direct AirPrint mobilo pakalpojumu pārvaldība Ethernet TCP/IP SNMP IPSec 802.1x LPD konfigurēšana HTTP/FTP iestatījumi ThinPrint USB Ārējas piekļuves tīklam ierobežošana Drošība Pieteikšanās veidi USB ierīču plāna izveide Drošības audita žurnāls Pieteikšanās ierobežojumi Konfidenciālas drukāšana iestatīšana Diska šifrēšana Dzēst pagaidu datu failus Risinājumu LDAP iestatījumi Dažādi Cloud Services Cloud Services reģistrēšana Atskaites Izvēļņu iestatījumu lapa Ierīce Drukāt Īsceļi Fakss Tīkls Problēmu novēršana Drukas kvalitātes testa lapas Skenera tīrīšana printera izvēlnes"},{"UUID":"75d41396-3c22-4138-9d9d-de5c9a16862c","title":"Ierīce","link":"preferences-topic.html","desc":"Preferences Izvēlnes  Preferences ","descFull":"Preferences Izvēlnes  Preferences  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Displeja valoda [Valodu saraksts] Iestatiet displejā attēlotā teksta valodu. Valsts/reģions [Valstu vai reģionu saraksts] Norādiet, kurā valstī vai reģionā ir konfigurēta printera darbība. Sākotnējās iestatīšanas palaišana Izslēgts * Ieslēgts Palaidiet iestatīšanas vedni. Tastatūra Tastatūras veids [Valodu saraksts] Atlasiet valodu kā tastatūras veidu. Visas  tastatūras veida  vērtības var nebūt redzamas, var būt nepieciešama speciāla aparatūra, lai tās būtu redzamas. Attēlotā informācija Displeja teksts 1  ( IP adrese *) Displeja teksts 2  ( Datums/laiks *) Pielāgots teksts 1 Pielāgots teksts 2 Norādiet, kāda informācija ir jārāda sākuma ekrānā. Datums un laiks Konfigurēt Pašreizējais datums un laiks Manuāli iestatīt datumu un laiku Datuma formāts  (MM‑DD‑GGGG*) Laika formāts  (12 stundas AM/PM*) Laika zona  (UTC‑5:00*) Tīkla laika protokols Iespējot NTP  ( Ieslēgts *) NTP serveris Iespējot autentifikāciju  ( Nav *) Konfigurējiet printera datumu un laiku, kā arī tīkla laika protokolu. Papīra izmēri ASV * Metriskā sistēma Norādiet papīra izmēru mērvienību. Sākotnējo papīra izmēru iestatījumu nosaka sākotnējās iestatīšanas vednī izvēlētā valsts vai reģions. Ekrāna spilgtums 20–100% (100*) Koriģējiet displeja spilgtumu. Piekļuve zibatmiņas diskam Atspējots Iespējots * Iespējojiet piekļuvi zibatmiņas diskam. Atļaut fona noņemšanu Izslēgts Ieslēgts * Norādiet, vai fona noņemšana ir atļauta. Atļaut pielāgotu darbu skenēšanu Izslēgts Ieslēgts * Norādiet, vai kopēšanas, skenēšanas un faksa darbos ir jārāda iestatījums  Pielāgotu darbu skenēšana . Šis izvēlnes iestatījums ir redzams tikai tad, ja ir uzstādīts cietais disks. Vienas lapas skenēšana plakanvirsmā Izslēgts * Ieslēgts Iestatiet, lai printeris skenētu jebkāda veida darbus kā vienu lapu, izmantojot skenera stiklu. Pēc viena plakanvirsmas skenēšanas darba pabeigšanas printerī tiek parādīts sākuma ekrāns, nevis uzvednes. Ierīces skaņas Izslēgt visas skaņas  ( Izslēgts *) Pogu informācijas atskaņošana  ( Ieslēgts *) Piekļuve ierīces informācijas atskaņošanai  ( Ieslēgts *) Skaļums  (5*) ADF ievietošanas signāls  ( Ieslēgts *) Brīdinājumu kontrole  ( Viens *) Kasetnes brīdinājums  ( Viens *) Skaļruņa režīms  ( Vienmēr izslēgts *) Zvanītāja skaļums  ( Izslēgts *) Konfigurējiet printera skaņas iestatījumus. Ekrāna taimauts 5-300 sekundes (60*) Iestatiet, pēc cik dīkstāves sekundēm displejā tiek parādīts sākuma ekrāns vai printeris automātiski atsakās no lietotāja konta. izvēlne Preferences"},{"UUID":"57e8b719-064d-47fb-9a2c-ae34ea059c89","title":"Ierīce","link":"preferences-topic.html","desc":"Ekonomiskais režīms Izvēlnes  Ekonomiskais","descFull":"Ekonomiskais režīms Izvēlnes  Ekonomiskais režīms  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Drukāt Puses 1 puse 2 puses Norādiet, vai jādrukā uz vienas papīra puses vai abām. Drukāt Lapas vienā pusē Izslēgts * 2 lapas vienā pusē 3 lapas vienā pusē 4 lapas vienā pusē 6 lapas vienā pusē 9 lapas vienā pusē 12 lapas vienā pusē 16 lapas vienā pusē Drukājiet vairākus lapas attēlus uz vienas papīra loksnes puses. Drukāt Tonera intensitāte 1–5 (4*) Nosakiet, cik gaiši vai tumši ir teksta attēli. Drukāt Krāsu taupīšana Izslēgts * Ieslēgts Samaziniet tonera daudzumu, kas tiek lietots grafiku un attēlu drukāšanai. Kopēšana Puses No 1 puses uz 1 puses * No 1 puses uz 2 pusēm No 2 pusēm uz 1 puses No 2 pusēm uz 2 pusēm Norādiet skenēšanas darbību, ņemot vērā oriģinālo dokumentu. Kopēšana Lapas vienā pusē Izslēgts * 2 portreta orientācijas lapas 4 portreta orientācijas lapas 2 ainavas orientācijas lapas 4 ainavas orientācijas lapas Norādiet skenēšanas darbību, ņemot vērā oriģinālo dokumentu. Kopēšana Intensitāte 1–9 (5*) Norādiet skenēto attēlu intensitāti. izvēlne ekonomiskais režīms"},{"UUID":"b8cb4b05-7e0c-45c8-9799-8f974b9ab8ae","title":"Ierīce","link":"preferences-topic.html","desc":"Attālā operatora panelis Izvēlnes ","descFull":"Attālā operatora panelis Izvēlnes  Attālā operatora panelis  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Ārējs VNC savienojums Neatļaut * Atļaut Pievienojiet virtuālās tīklskaitļošanas (Virtual Network Computing — VNC) klientu attālā operatora panelim. Autentifikācijas veids Nav * Standarta autentificēšana Iestatiet autentifikācijas veidu, piekļūstot VNS klienta serverim. VNC parole Norādiet paroli, lai pievienotos VNC klienta serverim. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Autentifikācijas veids  iestatījums ir  Standarta autentificēšana . izvēlne Attālā operatora panelis"},{"UUID":"5d6ef596-68cd-4596-9c3b-82c69dc9afef","title":"Ierīce","link":"preferences-topic.html","desc":"Paziņojumi Izvēlnes  Paziņojumi ","descFull":"Paziņojumi Izvēlnes  Paziņojumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Atskaņot signālu, ja ievietots ADF Izslēgts Ieslēgts * Iespējojiet skaņas signāla atskaņošanu, ievietojot papīru ADF. Brīdinājumu vadība Izslēgts Vienreizējs * Nepārtraukts Iestatiet brīdinājuma skaņas signāla atskaņošanas reižu skaitu, ja printera darbībā ir nepieciešama lietotāja iejaukšanās. Izejmateriāli Izejmateriālu aprēķina rādīšana Rādīt aprēķinu * Nerādīt aprēķinu Skatiet aptuvenu izejmateriālu statusu. Izejmateriāli Kasetnes brīdinājums  ( Viens *) Skavotāja brīdinājums  ( Izslēgts *) Caurumotāja brīdinājums  ( Izslēgts *) Iestatiet brīdinājuma skaņas signāla atskaņošanas reižu skaitu, ja tonera kasetnes uzpildes līmenis ir zems, skavotāja kasetne ir tukša vai caurumotāja tvertne ir pilna vai tās nav. Opcija  Skavotāja brīdinājums  un  Caurumotāja brīdinājums  ir redzama tikai tad, ja ir uzstādītas izvades ierīces. Izejmateriāli Pielāgoti izejmateriālu paziņojumi Iestatiet, lai printera izmantotā ierīce aprēķina izejmateriālu lietojumu un parāda pielāgotus paziņojumus, ja lietotājam ir jāveic kāda darbība. Šis izvēlnes vienums ir pieejams tikai serverī Embedded Web Server. E-pasta brīdinājumu iestatīšana E-pasta iestatīšana Primārā SMTP vārteja Primārās SMTP vārtejas ports  (25*) Sekundārā SMTP vārteja Sekundārās SMTP vārtejas ports  (25*) SMTP taimauts  (30 sekundes*) Atbildes adrese Vienmēr izmantot SMTP noklusējuma atbildes adresi  ( Izslēgts *) Izmantot SSL/TLS  ( Atspējots )* Nepieciešams uzticams sertifikāts  ( Ieslēgts *) SMTP servera autentifikācija  ( Nav nepieciešama autentifikācija )* Ierīces iniciēts e-pasts  ( Nav )* Lietotāja iniciēts e-pasts  ( Nav *) Izmantot aktīva direktorija ierīces akreditācijas datus  ( Izslēgts *) Ierīces lietotāja ID Ierīces parole Kerberos 5 REALM NTLM domēns Atspējot kļūdu “SMTP serveris nav iestatīts”  ( Izslēgts )* Konfigurējiet printera e-pasta iestatījumus. E-pasta brīdinājumu iestatīšana Iestatīt e-pasta sarakstus un brīdinājumus 1. e-pasta saraksts 2. e-pasta saraksts E-pasta notikumi Norādiet e-pasta adreses un iespējojiet e-pasta brīdinājumu notikumus. Šis izvēlnes vienums ir pieejams tikai serverī Embedded Web Server. Kļūdu novēršana Iestrēguša papīra palīdzība Izslēgts Ieslēgts * Iestatiet printeri automātiski drukāt tukšas vai daļēji apdrukātas lapas, kad iestrēgušais papīrs ir izņemts. Kļūdu novēršana Automātiski turpināt Izslēgts Ieslēgts * (5 sekundes) Ļaujiet printerim automātiski turpināt darba apstrādi vai drukāšanu pēc tam, kad ir novērsti konkrēti printera darbības traucējumi, kam ir nepieciešama lietotāja iejaukšanās. Kļūdu novēršana Automātiski palaist atkārtoti Automātiski palaist atkārtoti Palaist atkārtoti dīkstāves režīmā Vienmēr palaist atkārtoti * Nekad nepalaist atkārtoti Iestatiet printera restartēšanu kļūdas gadījumā. Kļūdu novēršana Automātiski palaist atkārtoti Maksimālais automātiskas atkārtotas palaišanas reižu skaits 1–20 (2*) Iestatiet, cik reižu printeris var tikt automātiski palaists atkārtoti. Kļūdu novēršana Automātiski palaist atkārtoti Atkārtotas automātiskās palaišanas logs 1-525600 sekundes (720*) Iestatiet, pēc kāda laika printeris veic automātisku atkārtotu palaišanu. Kļūdu novēršana Automātiski palaist atkārtoti Automātiskas atkārtotas palaišanas uzskaite Parādiet tikai lasāmu informāciju par atkārtotas palaišanas uzskaiti. Kļūdu novēršana Automātiski palaist atkārtoti Atiestatīt automātiskas atkārtotas palaišanas uzskaiti Atcelt Turpināt Atiestatiet  Automātiskas atkārtotas palaišanas uzskaite . Kļūdu novēršana Parādīt kļūdu par īsu papīru Ieslēgts Automātiski notīrīt * Iestatiet, lai printeris rādītu ziņojumu, ja ir īss papīrs. Īss papīrs ir saistīts ar ievietotā papīra izmēriem. Kļūdu novēršana Lapas aizsardzība Izslēgts * Ieslēgts Iestatiet, lai printeris pirms drukāšanas atmiņā apstrādātu visu lapu. Iestrēguša papīra satura atkopšana Iestrēguša papīra atkopšana Izslēgts Ieslēgts Automātiski * Iestatiet, lai printeris atkārtoti drukā iestrēgušās lapas. Iestrēguša papīra satura atkopšana Skenerī iestrēguša papīra atkopšana Darba līmenis Lapas līmenis * Norādiet, kā atsākt skenēšanas darbu pēc tam, kad ir izņemts iestrēdzis papīrs. izvēlne Paziņojumi"},{"UUID":"d9f58ba6-ce9a-481e-9741-e956a329b6f0","title":"Ierīce","link":"preferences-topic.html","desc":"Enerģijas pārvaldība Izvēlnes  Enerģijas","descFull":"Enerģijas pārvaldība Izvēlnes  Enerģijas pārvaldība  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Miega režīma profils Drukāt no miega režīma Palikt nomodā pēc drukāšanas Aktivizēt miega režīmu pēc drukāšanas * Iestatiet, lai printeris pēc drukāšanas paliktu nomodā vai atgrieztos miega režīmā. Miega režīma profils Pieskarties, lai pamodinātu no dziļā miega Izslēgts * Ieslēgts Pamodiniet printeri no dziļā miega režīma, pieskaroties printera displejam. Taimauti Miega režīms 1–114 minūtes (15*) Iestatiet dīkstāves laiku, pirms printeris sāk strādāt miega režīmā. Taimauti Hibernēšanas taimauts Atspējots 1 stunda 2 stundas 3 stundas 6 stundas 1 diena 2 dienas 3 dienas * 1 nedēļa 2 nedēļas 1 mēnesis Iestatiet, pēc kāda laika printeris izslēdzas. Taimauti Hibernēšanas taimauts savienojuma gadījumā Hibernēšanas režīms Nehibernēt * Iestatiet  Hibernēšanas taimauts , lai izslēgtu printeri, ja ir aktīvs Ethernet savienojums. Enerģijas režīmu grafiks Grafiki Pievienot jaunu grafiku Izveidojiet grafiku, pēc kura printeris sāk darboties miega vai hibernēšanas režīmā. izvēlne Enerģijas pārvaldība"},{"UUID":"7ed4be39-0c47-46bd-9666-e85da9b1d784","title":"Ierīce","link":"preferences-topic.html","desc":"Anonīma datu apkopšana Izvēlnes ","descFull":"Anonīma datu apkopšana Izvēlnes  Anonīma datu apkopšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Anonīma datu apkopšana Ierīces lietošanas un veiktspējas informācija Nav * Sūtiet uzņēmumam Lexmark informāciju par printera lietošanu un veiktspēju. Sūtiet ražotājam informāciju par printera lietošanu un veiktspēju. Iestatījums  Anonīmu datu sūtīšanas laiks  ir redzams tikai tad, ja  Anonīma datu apkopšana  opcija ir  Ierīces lietošana un veiktspēja . Anonīmu datu sūtīšanas laiks Sākuma laiks Beigu laiks izvēlne Anonīma datu apkopšana"},{"UUID":"9f888761-f756-4095-aaeb-18263952eb11","title":"Ierīce","link":"preferences-topic.html","desc":"Pieejamība Izvēlnes Pieejamība vienumi un","descFull":"Pieejamība Izvēlnes Pieejamība vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Divreiz nospiesta taustiņa intervāls 0–5 (0*) Iestatiet sekunžu skaitu, kuru laikā printeris neņem vērā, ja pievienotās tastatūras taustiņi tiek piespiesti divas reizes. Atkārtotas taustiņa darbības sākotnējā atlikšana 0,25–5 (1*) Iestatiet sākotnējo atlikšanas ilgumu sekundēs, pirms atkārtoti piespiests taustiņš veic atkārtotu darbību. Šis izvēlnes vienums ir redzams tikai tad, ja printerim ir pievienota tastatūra. Taustiņa atkārtošanas ātrums 0,5-30 (30*) Iestatiet, cik reižu sekundē taustiņš jāpiespiež, lai tas tiktu atkārtots. Šis izvēlnes vienums ir redzams tikai tad, ja printerim ir pievienota tastatūra. paildzināt ekrāna taimautu Izslēgts * Ieslēgts Ļaujiet lietotājam palikt esošajā atrašanās vietā un atiestatiet opcijas  Ekrāna taimauts  taimeri, kad paiet tā noteiktais laiks, nevis lieciet lietotājam atgriezties sākuma ekrānā. Austiņu skaļums 1–10 (5*) Koriģējiet austiņu skaļumu. Šis izvēlnes vienums ir redzams tikai tad, ja printerim ir pievienotas austiņas. Iespējot balss norādes, ja ir pievienotas austiņas Izslēgts * Ieslēgts Iespējojiet balss norādes, ja printerim ir pievienotas austiņas. Izrunāt paroles/PIN Izslēgts * Ieslēgts Iestatiet printeri skaļi izrunāt paroles vai personas identifikācijas numurus. Šis izvēlnes vienums ir redzams tikai tad, ja printerim ir pievienotas austiņas vai skaļrunis. Runas ātrums Ļoti lēns Lēns Normāls * Ātrs Ātrāks Ļoti ātrs Straujš Ļoti straujš Visātrākais Iestatiet balss norāžu runas ātrumu. Šis izvēlnes vienums ir redzams tikai tad, ja printerim ir pievienotas austiņas vai skaļrunis. izvēlne Pieejamība"},{"UUID":"436d6a20-7354-4792-a843-a90494755365","title":"Ierīce","link":"preferences-topic.html","desc":"Atjaunot rūpnīcas noklusējumus Izvēlnes ","descFull":"Atjaunot rūpnīcas noklusējumus Izvēlnes  Atjaunot rūpnīcas noklusējumus   vienumi un to apraksti Izvēlnes vienums Apraksts Atjaunot iestatījumus Atjaunot visus iestatījumus Atjaunot printera iestatījumus Atjaunot tīkla iestatījumus Atjaunot faksa iestatījumus Atjaunot lietotnes iestatījumus Atjaunojiet printera noklusējuma iestatījumus. izvēlne Atjaunot rūpnīcas noklusējumus"},{"UUID":"62ad9cf4-1187-4c7a-8652-77622538202b","title":"Apkope","link":"preferences-topic.html","desc":"izvēlne Konfigurēšana Izvēlnes Konfigurēšana ","descFull":"izvēlne Konfigurēšana Izvēlnes Konfigurēšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. USB konfigurēšana USB PnP 1* 2 Mainiet printera USB draivera režīmu, lai uzlabotu tā saderību ar personālo datoru. USB konfigurēšana USB skenēšana uz lokālu Ieslēgts * Izslēgts Iestatiet, vai draiveris USB ierīci uzskaita kā vienkāršu USB ierīci (viens interfeiss) vai kā saliktu USB ierīci (vairāki interfeisi). USB konfigurēšana USB ātrums Pilns Automātiski * Iestatiet USB porta darbību pilnā ātrumā un atspējojiet tā ātrdarbības funkciju. Paplāšu konfigurēšana Izmēru noteikšana Paplātes [x] noteikšana Izslēgts Ieslēgts * Oficio/Folio noteikšana Folio * Oficio (Meksika) Statement/A5 noteikšana Noteikt Statement * Noteikt A5 Executive/B5 noteikšana Noteikt Exec * Noteikt B5 Iestatiet, lai paplāte automātiski noteiktu tajā ievietotā papīra izmērus. Paplāšu konfigurēšana Paplāšu pievienošana Automātiski * Izslēgts Iestatiet, lai printeris pievienotu tādas paplātes, kurām ir vienādi papīra veida un izmēru iestatījumi. Paplāšu konfigurēšana Parādīt paplātes ievietošanas ziņojumu Izslēgts Tikai nezināmiem izmēriem * Vienmēr Parādiet ziņojumu, lai lietotājs pēc paplātes ievietošanas varētu mainīt papīra izmēru un veida iestatījumus. Paplāšu konfigurēšana Papīra uzvednes Automātiski * Daudzfunkciju padevējs Manuāla papīra padeve Iestatiet, kurā papīra avotā lietotājam ir jāievieto materiāls, kad tiek parādīta uzvedne par papīra ievietošanu. Lai redzētu  Daudzfunkciju padevējs , izvēlnē  Papīrs  iestatījumam  Konfigurēt daudzfunkciju padevēju  izvēlieties  Kasete . Paplāšu konfigurēšana Aplokšņu uzvednes Automātiski * Daudzfunkciju padevējs Manuāla aplokšņu padeve Iestatiet, kurā papīra avotā lietotājam ir jāievieto materiāls, kad tiek parādīta uzvedne par aploksnes ievietošanu. Lai redzētu  Daudzfunkciju padevējs , izvēlnē  Papīrs  iestatījumam  Konfigurēt daudzfunkciju padevēju  izvēlieties  Kasete . Paplāšu konfigurēšana Uzvedņu darbība Vaicāt lietotājam * Turpināt Izmantot pašreizējo Iestatiet, lai printerī atrisinātu ar papīra vai aplokšņu maiņu saistītas uzvednes. Paplāšu konfigurēšana Aplokšņu paplātes iestatījumi Izslēgts * Ieslēgts Iespējojiet aplokšņu paplātes iespēju drukāt aploksnes. Paplāšu konfigurēšana Vairāki universāli izmēri Izslēgts * Ieslēgts Iestatiet paplāti tā, lai tā atbalstītu vairākus universālos papīra izmērus. Atskaites Izvēļņu iestatījumu lapa Notikumu žurnāls Notikumu žurnāla kopsavilkums Drukājiet atskaites par printera izvēļņu iestatījumiem, statusiem un notikumu žurnāliem. Izejmateriālu patēriņš un uzskaite Notīrīt izejmateriālu lietojuma vēsturi Atiestatiet izejmateriālu patēriņa vēsturi, piemēram, lapu skaitu un atlikušo dienu skaitu, uz rūpnīcas iestatījumiem. Izejmateriālu patēriņš un uzskaite Pielāgojumi lieliem apdrukājamiem materiāliem Izslēgts * Ieslēgts Opcija ļauj veikt pielāgojumus, drukājot uz lieliem vai bieziem materiāliem. Izejmateriālu patēriņš un uzskaite ITM atiestatīšana Atiestatīt melnās kasetnes uzskaiti Atiestatīt ciāna krāsas kasetnes uzskaiti Atiestatīt madženta krāsas kasetnes uzskaiti Atiestatīt dzeltenās krāsas kasetnes uzskaiti Atiestatīt apkopes uzskaiti Pēc jauna izejmateriāla vienuma vai apkopes komplekta uzstādīšanas atiestatiet uzskaites informāciju. Izejmateriālu patēriņš un uzskaite Secīgi pārklājumu diapazoni Koriģējiet krāsu pārklājuma līmeni katram drukāšanas diapazonam. Printera emulācijas PPDS emulācija Izslēgts * Ieslēgts Iestatiet, lai printeris atpazītu un lietotu PPDS datu straumi. Printera emulācijas PS emulācija Izslēgts Ieslēgts * Iestatiet, lai printeris atpazītu un lietotu PS datu straumi. Printera emulācijas Iespējot Prescribe Izslēgts * Ieslēgts Aktivizējiet Prescribe. Ir jāinstalē Prescribe licence. Printera emulācijas Emulatora drošība Lapas taimauts 0–60 (60*) Iestatiet lapas taimautu emulācijas laikā. Printera emulācijas Emulatora drošība Atiestatīt emulatoru pēc darba Izslēgts * Ieslēgts Atiestatiet emulatoru pēc drukas darba. Printera emulācijas Emulatora drošība Atspējot piekļuvi printera ziņojumiem Izslēgts Ieslēgts * Emulācijas laikā atspējojiet piekļuvi printera ziņojumiem. Faksa konfigurēšana Faksa atbalsts samazinātas enerģijas režīmā Atspējot miega režīmā Atļaut miega režīmā Automātiski * Iestatiet, lai fakss pāriet miega režīmā, ja printeris konstatē, ka tas ir nepieciešams. Faksa konfigurēšana Faksa krātuves atrašanās vieta NAND Disks * Iestatiet visu faksa ziņojumu krātuves atrašanās vietu. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks vai ISD. Printera konfigurēšana Režīms Tikai melnā krāsa Izslēgts * Ieslēgts Drukājiet darbus, kas nav kopijas, pelēktoņu režīmā. Printera konfigurēšana Krāsu pārklāšana Izslēgts 1 2* 3 4 5 Uzlabojiet izdruku, lai kompensētu nepareizus printera iestatījumus. Printera konfigurēšana Fonta asums 0–150 (24*) Iestatiet teksta punkta lieluma vērtību, zem kuras tiek izmantoti augstas frekvences ekrāni, kad tiek drukāti fontu dati. Piemērām, ja vērtība ir 24, visi fonti ar 24 vai mazāk punktiem izmanto augstas frekvences ekrānus. Ierīces darbības Klusais režīms Izslēgts * Ieslēgts Iestatiet printeri darboties  klusajā režīmā . Iespējojot šo iestatījumu, tiek palēnināta kopējā printera veiktspēja. Ierīces darbības Paneļa izvēlnes Izslēgts Ieslēgts * Iespējojiet piekļuvi printera izvēlnēm no vadības paneļa. Ierīces darbības Drošais režīms Izslēgts * Ieslēgts Iestatiet, lai printeris darbotos īpašā režīmā, kurā tas mēģina nodrošināt pēc iespējas plašāku funkciju klāstu, neskatoties uz zināmām problēmām. Piemēram, ja ir izvēlēts iestatījums  Ieslēgts  un nedarbojas dupleksās drukāšanas moduļa motors, printeris dokumentus drukā uz vienas puses, pat ja tas ir divpusējās drukāšanas darbs. Ierīces darbības Minimālā kopēšanas atmiņa 80 MB* 100 MB Iestatiet kopēšanas darbu glabāšanai atvēlēto minimālo atmiņas apjomu. Ierīces darbības Notīrīt pielāgotu statusu Izdzēsiet lietotāja norādītas virknes  noklusējuma  vai  citos  pielāgotos ziņojumos. Ierīces darbības Notīrīt visus attāli iestatītus ziņojumus Izdzēsiet visus attāli iestatītos ziņojumus. Ierīces darbības Automātiski parādīt kļūdu ekrānus Izslēgts Ieslēgts * Parādiet ekrānā esošu kļūdu ziņojumus, ja printera sākuma ekrāns ir neaktīvs tik ilgi, cik norādīts. Ierīces darbības Ņemt vērā orientāciju, veicot ātro kopēšanu Izslēgts * Ieslēgts Iespējojiet printeri izmantot izvēlnes  Kopēšana  iestatījumu Orientācija, kad tiek sūtīti ātrās kopēšanas darbi. Lietotņu konfigurēšana LES lietojumprogrammas Izslēgts Ieslēgts * Iespējojiet Lexmark Embedded Solutions (LES) lietojumprogrammas. Apdarinātāja konfigurācija 2. izejas paplātes iestatījums Izslēgts * Ieslēgts Opcija iespējo otrās izvades tvertnes lietošanu. Skenera konfigurēšana Skenera manuāla reģistrēšana Ātrais drukāšanas tests Izdrukājiet ātrā testa mērķa lapu. Nodrošiniet, lai piemaļu rindstarpa ir vienāda visā mērķa lapā. Ja tā nav, ir jāatiestata printera piemales. Skenera konfigurēšana Skenera manuāla reģistrēšana Priekšējā ADF reģistrēšana Aizmugurējā ADF reģistrēšana Plakanvirsmas reģistrēšana Manuāli reģistrējiet plakanvirsmu un ADF pēc ADF, skenera stikla vai kontrollera plates nomaiņas. Skenera konfigurēšana Atiestatīt apkopes uzskaiti Pēc ADF apkopes komplekta nomaiņas atiestatiet uzskaiti. Skenera konfigurēšana Malu dzēšana Plakanvirsmas malu dzēšana  (3*) ADF malu dzēšana  (3*) Iestatiet neapdrukājamā apgabala izmērus milimetros, kas jāievēro ap ADF vai plakanvirsmas skenēšanas darbiem. Skenera konfigurēšana Atspējot skeneri Nē * Jā Tikai ADF Atspējojiet skeneri, ja tas nedarbojas pareizi. Skenera konfigurēšana Tiff bitu secība CPU Endianness * Little Endian Big Endian Iestatiet TIFF formātā skenēta materiāla bitu secību. Skenera konfigurēšana Precīzs Tiff rindu skaits joslā Ieslēgts * Izslēgts Iestatiet TIFF formātā skenēta materiāla taga RowsPerStrip vērtību. izvēlne izvēlne Konfigurēšana"},{"UUID":"5d6b28d5-3760-4abf-be6c-8a85a345f01f","title":"Apkope","link":"preferences-topic.html","desc":"Dzēšana, pārtraucot lietošanu Izvēlnes ","descFull":"Dzēšana, pārtraucot lietošanu Izvēlnes  Dzēšana, pārtraucot lietošanu  vienumi un to apraksti Izvēlnes vienums Apraksts Dzēšana, pārtraucot lietošanu Atmiņas pēdējā sanitizēšanas reize Cietā diska pēdējā sanitizēšanas reize ISD pēdējā dzēšanas reize Parādiet tikai lasāmu informāciju par to, kad pēdējo reizi tika izdzēsta printera atmiņa vai krātuves diskdzinis. Opcija  Cietā diska pēdējā sanitizēšanas reize  ir pieejama tikai tad, ja ir uzstādīts cietais disks. Dzēšana, pārtraucot lietošanu Sanitizēt visu energoneatkarīgās atmiņas informāciju Izdzēst visus printera un tīkla iestatījumus Izdzēst visas lietojumprogrammas un lietojumprogrammu iestatījumus Izdzēst visus īsceļus un īsceļu iestatījumus Sanitizēt visu informāciju cietajā diskā Izdzēst lejupielādes (izdzēst visus makro, fontus, PFO utt.) Izdzēst buferī ievietotos darbus Izdzēst aizturētus darbus Izdzēst viedo krātuves disku Notīriet visu informāciju energoneatkarīgajā atmiņā un krātuves diskdzinī. Opcija  Sanitizēt visu informāciju cietajā diskā  ir pieejama tikai tad, ja ir uzstādīts cietais disks. izvēlne Dzēšana, pārtraucot lietošanu"},{"UUID":"0ed0de6a-3ff0-4a85-961a-2a0ce67847d7","title":"Ierīce","link":"preferences-topic.html","desc":"Sākuma ekrāna pielāgošana Šī izvēlne","descFull":"Sākuma ekrāna pielāgošana Šī izvēlne ir redzama tikai serverī Embedded Web Server. Izvēlnes  Sākuma ekrāna pielāgošana  vienums un tā apraksts Izvēlne Apraksts Kopēšana E-pasts Fakss Aizturēti faksi Izpildīt aizturētus faksus Statuss/izejmateriāli Darbu rinda Iestatījumi Valodas maiņa Adrešu grāmata Grāmatzīmes Aizturēti darbi USB disks FTP Skenēšanas profili Bloķēt ierīci skenēšanas centrs Card Copy īsceļu centrs Norādiet, kuras ikonas rādīt sākuma ekrānā. izvēlne Sākuma ekrāna pielāgošana"},{"UUID":"eb130a35-66b0-46ec-a76e-9885f3cdbf20","title":"Ierīce","link":"preferences-topic.html","desc":"Par šo printeri Izvēlnes ","descFull":"Par šo printeri Izvēlnes  Par šo printeri  vienumi un to apraksti Izvēlnes vienums Apraksts Pamatlīdzekļa etiķete Norādiet printera identitāti. Maksimālais garums ir 32 rakstzīmes. Printera atrašanās vieta Norādiet printera atrašanās vietu. Maksimālais garums ir 63 rakstzīmes. Sazinieties ar Norādiet printera kontaktpersonas informāciju. Maksimālais garums ir 63 rakstzīmes. Programmaparatūras versija Parādiet printerī uzstādītās programmatūras versiju. Motors Skatiet printera motora numuru. Sērijas numurs Skatiet printera sērijas numuru. Eksportēt konfigurācijas failu USB Eksportējiet konfigurācijas failu zibatmiņas diskā. Eksportēt saspiestus žurnālus USB Eksportējiet saspiestos žurnālfailus zibatmiņas diskā. Sūtīt žurnālus Nosūtiet informāciju par printera žurnālu uzņēmumam Lexmark. izvēlne Par šo printeri"},{"UUID":"9c971ec4-cdd2-41c6-91f2-b21bb677d86d","title":"Drukāt","link":"layout-topic.html","desc":"Izkārtojums Izvēlnes  Izkārtojums ","descFull":"Izkārtojums Izvēlnes  Izkārtojums  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Puses 1 puse 2 puses Norādiet, vai jādrukā uz vienas papīra puses vai abām. Apvēršanas veids Garā mala * Īsā mala Nosakiet, kura papīra mala ir saistīta, veicot divpusējo drukāšanu. Tukšas lapas Drukāt Nedrukāt * Drukājiet tukšas lapas, kas tiek iekļautas drukas darbā. Salikt Izslēgts (1,1,1,2,2,2) Ieslēgts (1,2,1,2,1,2) * Drukājot vairākus darba eksemplārus, drukas darba lapas varat salikt konkrētā secībā. Atdalošās lapas Nav * Starp eksemplāriem Starp darbiem Starp lapām Drukājot ievietojiet tukšas atdalošās lapas. Atdalošo lapu avots Paplāte  [x] (1*) Daudzfunkciju padevējs Norādiet atdalošās lapas papīra avotu. Lapas vienā pusē Izslēgts * 2 lapas vienā pusē 3 lapas vienā pusē 4 lapas vienā pusē 6 lapas vienā pusē 9 lapas vienā pusē 12 lapas vienā pusē 16 lapas vienā pusē Drukājiet vairākus lapas attēlus uz vienas papīra loksnes puses. Lapas vienā pusē, virziens Horizontāli * Apvērsti horizontāli Vertikāli Apvērsti vertikāli Norādiet vairāku lapu attēlu novietojumu, ja tiek lietota izvēlne  Lapas vienā pusē . Lapas vienā pusē, orientācija Automātiski * Ainava Portrets Norādiet vairāku lapu attēlu orientāciju, ja tiek lietota izvēlne  Lapas vienā pusē . Lapas vienā pusē, apmale Nav * Nepārtraukta Drukājiet apmali ap katru lapas attēlu, ja tiek lietota izvēlne  Lapas vienā pusē . Eksemplāri 1-9999 (1*) Norādiet katra drukas darba eksemplāru skaitu. Drukas apgabals Normāls * Ietilpināt lapā Visa lapa Iestatiet papīra loksnes apdrukājamo apgabalu. izvēlne Izkārtojums"},{"UUID":"dc41965c-9544-469f-b278-9515c1fce4c5","title":"Drukāt","link":"layout-topic.html","desc":"Apdare Izvēlnes  Apdare ","descFull":"Apdare Izvēlnes  Apdare  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Skavot darbu Izslēgts * 1 skava, augšējais kreisais stūris 2 skavas, pa kreisi 1 skava, augšējais labais stūris 2 skavas, augšā 1 skava, apakšējais kreisais stūris 2 skavas, apakšā 1 skava, apakšējais labais stūris 2 skavas, pa labi Norādiet skavošanas vietu visiem drukas darbiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar skavotāju. Skavošanas pārbaude Sākt Pārbaudiet, vai apdarinātājs ar skavotāju darbojas pareizi. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar skavotāju. Caurumotājs Izslēgts * Ieslēgts Veidojiet caurumus uz izdruku malas. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar caurumotāju. Caurumotāja režīms 2 caurumi 3 caurumi 4 caurumi Iestatiet caurumotāja režīmu izdrukām. 3 caurumi  ir ASV rūpnīcas noklusējuma iestatījums. Starptautiskais rūpnīcas noklusējuma iestatījums ir  4 caurumi . Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar caurumotāju. Ofseta lapas Nav * Starp eksemplāriem Starp darbiem Iestatiet ofsetu katram drukas darbam vai katram drukas darba eksemplāram. Iestatījums  Starp eksemplāriem  nosaka ofsetu katram drukas darbam, ja opcijas  Salikt  iestatījums ir  Ieslēgts  [1,2,1,2,1,2]. Ja opcijas  Salikt  iestatījums ir  Izslēgts  [1,1,1,2,2,2], ofsets tiek iestatīts katrai izdrukāto lapu kopai, piemēram, visām lapām, kas norādītas kā 1. lapa un visām, kas norādītas kā 2. lapa. Izvēloties  Starp darbiem , visam drukas darbam tiek iestatīta vienāda ofseta pozīcija neatkarīgi no izdruku skaita. izvēlne Apdare"},{"UUID":"96dca17e-ce9f-401c-ad0f-8fc6acd19aa3","title":"Drukāt","link":"layout-topic.html","desc":"Iestatīšana Izvēlnes Iestatīšana vienumi un","descFull":"Iestatīšana Izvēlnes Iestatīšana vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Printera valoda PCL emulācija PS emulācija * Iestatiet printera valodu. Printera noklusējuma valodas iestatīšana datorprogrammai tik un tā ļauj sūtīt drukas darbus, kuros izmantota cita printera valoda. Darbu gaidīšana Izslēgts * Ieslēgts Paturiet drukas darbus, kuru drukāšanai ir nepieciešami izejmateriāli, lai varētu drukāt tos darbus, kuriem nav nepieciešami trūkstošie izejmateriāli. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts printera cietais disks. Uzdevuma aizturēšanas taimauts 0 – 255  ( 30 *) Iestatiet, cik sekundes printeris gaida lietotāja iejaukšanos, pirms tiek aizturēti darbi, kuru veikšanai nepieciešami resursi, kas nav pieejami. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Printera lietojums Maksimāls ātrums Maksimāla produktivitāte * Nosakiet, kā attīstītāja vienībām jādarbojas drukāšanas laikā. Ja iestatījums ir  Maksimāla produktivitāte  un tiek drukātas tikai melnas lapas, attīstītāja vienības darbojas lēnāk vai apstājas. Ja iestatījums ir  Maksimāls ātrums , attīstītāja vienības vienmēr darbojas drukāšanas laikā neatkarīgi no tā, vai tiek drukātas krāsu vai melnas lapas. Lejupielādes mērķis RAM * Disks Norādiet, kur jāsaglabā visi printerī lejupielādētie pastāvīgie resursi. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts printera cietais disks. Resursu taupīšana Izslēgts * Ieslēgts Nosakiet, kas printerim ir jādara ar lejupielādētajiem resursiem, kad tiek saņemts darbs, kura izpildei nepieciešams vairāk atmiņas, nekā ir pieejams. Ja iestatījums ir  Izslēgts , printeris patur lejupielādētos resursus tikai līdz brīdim, kad ir nepieciešama atmiņa. Resursi, kas ir saistīti ar neaktīvo printera valodu, tiek izdzēsti. Ja iestatījums ir  Ieslēgts , printeris patur visus pastāvīgos lejupielādētos resursus visās valodās. Ja nepieciešams, printeris parāda ziņojumu, ka atmiņa ir pilna, nevis izdzēš pastāvīgos resursus. Visa darba drukāšanas secība Alfabētiski * Jaunākie vispirms Vecākie vispirms Norādiet secību, kad izvēlaties drukāt visus aizturētos un konfidenciālos darbus. izvēlne Iestatīšana"},{"UUID":"76bc6e61-cc23-4bfa-93a9-a8c75a58a67c","title":"Drukāt","link":"layout-topic.html","desc":"Kvalitāte Izvēlnes  Kvalitāte ","descFull":"Kvalitāte Izvēlnes  Kvalitāte  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Drukāšanas režīms Melnbalts Krāsu * Iestatiet, kā printeris ģenerē krāsu saturu. Drukas izšķirtspēja 2400 Image Q * 1200 dpi Iestatiet izdruku izšķirtspēju. Tonera intensitāte 1–5 (4*) Nosakiet, cik gaiši vai tumši ir teksta attēli. Pustoņi Normāls * Detalizēti Uzlabojiet izdruku, nodrošinot gludākas līnijas un asākas malas. Krāsu taupīšana Izslēgts * Ieslēgts Samaziniet tonera daudzumu, kas tiek lietots grafiku un attēlu drukāšanai. Ja vērtība ir  Ieslēgts , šis iestatījums ignorē iestatījuma  Tonera intensitāte  vērtību. RGB spilgtums no ‑6 līdz 6 (0*) Koriģējiet katra RGB un pelēkā objekta spilgtumu lapā. Šis iestatījums neietekmē tos failus, kuros tiek lietotas CMYK krāsu specifikācijas. RGB kontrasts no ‑6 līdz 6 (0*) Koriģējiet katra RGB un pelēkā objekta kontrastu lapā. Šis iestatījums neietekmē tos failus, kuros tiek lietotas CMYK krāsu specifikācijas. RGB piesātinājums 0–5 (0*) Paturiet melnbaltās vērtības, kad koriģējat katra objekta krāsu vērtības lapā. Šis iestatījums neietekmē tos failus, kuros tiek lietotas CMYK krāsu specifikācijas. Attēlveidošanas papildu iestatījumi Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Krāsu balanss Ciāna  (0*) Madženta  (0*) Dzeltena  (0*) Melna  (0*) Koriģējiet katrai krāsai lietotā tonera daudzumu. Krāsu balanss Atiestatīt noklusējumu Atiestatiet visiem krāsu iestatījumiem to noklusējuma vērtības. Krāsu korekcija Izslēgts Automātiski * Manuāli Modificējiet krāsu iestatījumus, kādi tiek lietoti dokumentu drukāšanai. Izvēloties  Izslēgts , printeris saņem krāsu korekciju no programmatūras. Izvēloties  Automātiski , printeris katram objektam izdrukātajā lapā lieto dažādus krāsu profilus. Izvēloties  Manuāli , katram objektam izdrukātajā lapā varat pielāgot RGB vai CMYK krāsu konversiju. Krāsu paraugi Drukāt krāsu paraugus Izdrukājiet parauga lapu katrai RGB un CMYK krāsu konvertēšanas tabulai, kas tiek izmantota printerī. Krāsu koriģēšana Kalibrējiet printeri, lai izdrukā pielāgotu krāsu variantus. Parauga krāsu aizstāšana Iestatīt pielāgotu CMYK Piešķiriet konkrētas CMYK vērtības divdesmit nosauktajām parauga krāsām. izvēlne Kvalitāte"},{"UUID":"e1cd0fcf-f0bb-49c2-8d47-17626db5d00e","title":"Drukāt","link":"layout-topic.html","desc":"Darbu uzskaite Izvēlnes  Darbu","descFull":"Darbu uzskaite Izvēlnes  Darbu uzskaite  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Darbu uzskaite Izslēgts * Ieslēgts Iestatiet, lai printeris veido žurnālu par saņemtajiem drukas darbiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīta zibatmiņa vai cietais disks. Uzskaites žurnāla intervāls Katru dienu Katru nedēļu Katru mēnesi * Norādiet, cik bieži printeris veido žurnālfailu. Žurnāla darbība intervāla beigās Nav * Sūtīt pa e-pastu pašreizējo žurnālu Sūtīt pa e-pastu pašreizējo žurnālu un izdzēst Publicēt pašreizējo žurnālu Publicēt pašreizējo žurnālu un izdzēst Norādiet, kas printerim jādara intervāla beigās. Iestatījumā  Uzskaites žurnāla intervāls  norādītā vērtība nosaka, kad tiek aktivizēta šī darbība. Žurnāls, kad gandrīz pilns Izslēgts Ieslēgts  (5)* Norādiet, kāds ir maksimālais žurnālfaila lielums, pēc kura sasniegšanas printeris izpilda komandu  Žurnāla darbība, kad gandrīz pilns . Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīta zibatmiņa vai cietais disks. Žurnāla darbība, kad gandrīz pilns Nav * Sūtīt pa e-pastu pašreizējo žurnālu Sūtīt pa e-pastu pašreizējo žurnālu un izdzēst Sūtīt pa e-pastu vecāko žurnālu un izdzēst Publicēt pašreizējo žurnālu Publicēt pašreizējo žurnālu un izdzēst Publicēt vecāko žurnālu un izdzēst Izdzēst pašreizējo žurnālu Izdzēst vecāko žurnālu Izdzēst visus, izņemot pašreizējo Izdzēst visus žurnālus Norādiet, kas printerim ir jādara, kad cietais disks ir gandrīz pilns. Iestatījumā  Žurnāls, kad gandrīz pilns  norādītā vērtība nosaka, kad tiek aktivizēta šī darbība. Žurnāla darbība, kad pilns Nav * Sūtīt pa e-pastu pašreizējo žurnālu un izdzēst Sūtīt pa e-pastu vecāko žurnālu un izdzēst Publicēt pašreizējo žurnālu un izdzēst Publicēt vecāko žurnālu un izdzēst Izdzēst pašreizējo žurnālu Izdzēst vecāko žurnālu Izdzēst visus, izņemot pašreizējo Izdzēst visus žurnālus Norādiet, kāda ir printera darbība, kad ir sasniegts maksimālais cietā diska ierobežojums (100 MB). Žurnāla publicēšanas URL Norādiet, kur printeris publicē darbu uzskaites žurnālus. E-pasta adrese, uz kuru sūtīt žurnālus Norādiet e-pasta adresi, uz kuru printeris sūta darbu uzskaites žurnālus. Žurnālfaila prefikss Norādiet, kāds prefikss ir jāizmanto žurnālfailiem. Kā noklusējuma žurnālfaila prefikss tiek lietots pašreizējā resursdatora nosaukums, kas norādīts izvēlnē  TCP/IP . izvēlne Darbu uzskaite"},{"UUID":"af0efe1c-19a2-46b4-b944-37de8b31d74b","title":"Drukāt","link":"layout-topic.html","desc":"PDF Izvēlnes  PDF ","descFull":"PDF Izvēlnes  PDF  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Mērogot un ietilpināt Izslēgts * Ieslēgts Mērogojiet lapas saturu, lai tas ietilptu atlasītā papīra izmēros. Piezīmes Drukāt Nedrukāt * Norādiet, vai drukāt piezīmes PDF failos. Drukāt PDF kļūdu Izslēgts Ieslēgts * Iespējojiet PDF kļūdas drukāšanu. izvēlne PDF"},{"UUID":"9c24372e-9fb5-4942-9698-1e5762231d8d","title":"Drukāt","link":"layout-topic.html","desc":"PostScript Izvēlnes  PostScript ","descFull":"PostScript Izvēlnes  PostScript  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Drukāt PS kļūdu Izslēgts * Ieslēgts Izdrukājiet lapu, kurā ir PostScript® kļūda. Kad rodas kļūda, darba apstrāde tiek pārtraukta, printeris izdrukā kļūdas ziņojumu un atlikušais drukas darbs netiek izpildīts. Minimālais rindiņas platums 1–30 (2*) Iestatiet minimālo vilkuma platumu. Darbos, kas tiek drukāti 1200 dpi kvalitātē, vērtību izmanto tieši. Bloķēt PS startēšanas režīmu Izslēgts Ieslēgts * Atspējojiet SysStart failu. Iespējojot SysStart failu jūsu printeris vai tīkls tiek pakļauts drošības riskiem. Attēlu nogludināšana Izslēgts * Ieslēgts Uzlabojiet zemas izšķirtspējas attēlu kontrastu un asumu. Šis iestatījums neietekmē attēlus, kuru izšķirtspēja ir 300 dpi vai augstāka. Fontu prioritāte Rezidenti * Zibatmiņa/disks Izveidojiet fontu meklēšanas secību. Izvēloties iestatījumu  Rezidenti , pieprasīto fontu printeris meklē savā atmiņā un tikai pēc tam meklē cietajā diskā vai viedajā krātuves diskā (ISD). Izvēloties iestatījumu  Zibatmiņa/disks , pieprasīto fontu printeris meklē cietajā diskā vai ISD un tikai pēc tam meklē printera atmiņā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks vai ISD. Gaidīšanas taimauts Izslēgts Ieslēgts * ( 40 sekundes ) Iespējojiet printeri gaidīt papildu datus, iekams drukas darbs tiek atcelts. izvēlne PostScript"},{"UUID":"7db28c3d-f27f-4b55-b427-508ebb93d23a","title":"Drukāt","link":"layout-topic.html","desc":"PCL Izvēlnes  PCL ","descFull":"PCL Izvēlnes  PCL  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Fonta avots Rezidenti * Disks Lejupielāde Zibatmiņas disks Visi Atlasiet avotu, kurā ir noklusējuma fonta atlase. Opcijas  Disks  un  Zibatmiņas disks  ir redzamas tikai tad, ja ir instalēts nebojāts un neaizsargāts cietais disks vai zibatmiņas disks, kas satur fontus. Izvēlne  Lejupielāde  ir redzama tikai tad, ja printera atmiņā ir lejupielādētie fonti. Fonta nosaukums [Pieejamo fontu saraksts] ( Courier *) Atlasiet fontu no norādītā fontu avota. Simbolu kopa [Pieejamo simbolu kopu saraksts] (10U PC‑8*) Norādiet katram fonta nosaukumam atbilstošo simbolu kopu. Simbolu kopa ir alfabēta un ciparu rakstzīmju, pieturzīmju un īpašo simbolu kopa. Simbolu kopas atbalsta dažādas valodas vai konkrētas programmas, piemēram, matemātikas simbolu izmantošanu zinātniskā tekstā. Rakstzīmju iestatne 0,08-100,00 (10,00*) Norādiet rakstzīmju iestatni fiksētiem vai vienplatuma fontiem. Rakstzīmju iestatne  attiecas uz fiksēta lieluma rakstzīmju skaitu vienā collā horizontāli rakstīta teksta. Orientācija Portrets * Ainava Apvērsts portrets Apvērsta ainava Norādiet teksta un attēlu orientāciju lapā. Rindiņu skaits lapā 1-255 Norādiet teksta rindiņu skaitu katrā lapā, kas tiek drukāta, izmantojot PCL® datu straumi. Šis izvēlnes vienums aktivizē vertikālus izlaidumus, lai atlasītais skaits pieprasīto rindiņu tiktu drukātas starp lapas noklusējuma piemalēm. 60 ir ASV rūpnīcas noklusējuma iestatījums. 64 ir starptautiskais rūpnīcas noklusējuma iestatījums. PCL5 minimālais rindiņas platums 1–30 (2*) Iestatiet sākotnējo minimālo vilkuma platumu. PCLXL minimālais rindiņas platums 1–30 (2*) A4 platums 198 mm* 203 mm Iestatiet loģiskās lapas platumu, drukājot uz A4 izmēra papīra. Loģiskā lapa ir vieta uz fiziskās lapas, uz kuras tiek drukāti dati. Automātiska CR pēc LF Ieslēgts Izslēgts * Iestatiet printeri veikt rakstatgriezi (carriage return — CR) pēc rindpadeves (line feed — LF) vadības komandas. Rakstatgrieze ir mehānisms, kas printerim dod komandu pārvietot kursoru tās pašas rindiņas sākuma pozīcijā. Automātiska LF pēc CR Ieslēgts Izslēgts * Iestatiet printeri veikt rindpadevi (line feed — LF) pēc rakstatgriezes vadības komandas. Paplāšu pārnumurēšana Piešķirt daudzfunkciju padevēju Piešķirt paplāti  [x] Piešķirt manuālu papīra padevi Piešķirt manuālu aploksnes padevi Konfigurējiet printeri darbībai ar dažādiem printera draiveriem vai pielāgotām lietojumprogrammām, kas izmanto atšķirīgus avota piešķīrumus, lai pieprasītu norādīto papīra avotu. Paplāšu pārnumurēšana Skatīt rūpnīcas noklusējumus Parādiet rūpnīcas noklusējuma vērtību, kāda ir piešķirta katram papīra avotam. Paplāšu pārnumurēšana Atiestatīt noklusējumu Atjaunojiet paplāšu pārnumurēšanas vērtību rūpnīcas noklusējumus. Drukāšanas taimauts Izslēgts Ieslēgts * (90 sekundes) Iestatiet printeri pabeigt drukas darbu pēc tam, kad tas ir atradies dīkstāvē norādīto laika periodu. izvēlne PCL"},{"UUID":"90cba557-a6ca-4715-8158-10d0f6c39cb9","title":"Drukāt","link":"layout-topic.html","desc":"Attēls Izvēlnes  Attēls ","descFull":"Attēls Izvēlnes  Attēls  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Automātiska ietilpināšana Ieslēgts Izslēgts * Atlasiet attēlam piemērotākos no pieejamajiem papīra izmēru un orientācijas iestatījumiem. Ja izvēlaties iestatījumu  Ieslēgts , šis izvēlnes vienums pārlabo attēla mēroga un orientācijas iestatījumus. Apmaiņa Izslēgts * Ieslēgts Apmainiet divtoņu un vienkrāsainus attēlus. Šis izvēlnes vienums neattiecas uz GIF vai JPEG formāta attēliem. Mērogošana Enkurs augšā pa kreisi Vislabākā ietilpināšana * Enkurs centrā Ietilpināt augstumu/platumu Ietilpināt augstumu Ietilpināt platumu Koriģējiet attēlu, lai tas ietilpst apdrukājamā apgabalā. Ja opcijas  Automātiskā ietilpināšana  iestatījums ir  Ieslēgts , opcijas  Mērogošana  iestatījums automātiski ir  Vislabākā ietilpināšana . Orientācija Portrets * Ainava Apvērsts portrets Apvērsta ainava Norādiet teksta un attēlu orientāciju lapā. izvēlne Attēls"},{"UUID":"d231cd06-dfb7-41c2-8153-a97b3b207336","title":"Papīrs","link":"tray-configuration-topic.html","desc":"Paplāšu konfigurēšana Izvēlnes  Paplāšu","descFull":"Paplāšu konfigurēšana Izvēlnes  Paplāšu konfigurēšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Noklusējuma avots Paplāte  [x] (1*) Daudzfunkciju padevējs Manuāla papīra padeve Manuāla aplokšņu padeve Iestatiet visu drukas darbu papīra avotu. Papīra izmēri/veids Paplāte  [x] Daudzfunkciju padevējs Manuāla papīra padeve Manuāla aplokšņu padeve Norādiet katrā papīra avotā ievietotā papīra izmērus vai veidu. Aizvietošanas izmēri Izslēgts Statement/A5 Letter/A4 11 x 17/A3 Visi norādītie * Iestatiet printeri aizstāt norādītos papīra izmērus, ja nepieciešamo izmēru papīrs nav ievietots nevienā papīra avotā. Izvēloties iestatījumu  Izslēgts , lietotājam tiek pieprasīts ievietot nepieciešamo izmēru papīru. Iestatījums  Visi norādītie  ļauj izvēlēties visus pieejamos aizvietošanas iestatījumus. Konfigurēt daudzfunkciju padevēju Kasete * Manuāli Pirmais Norādiet daudzfunkciju padevēja darbību. Ja ir atlasīta opcija  Kasete , daudzfunkciju padevējs tiek konfigurēts kā automātiskais papīra avots. Opcija  Manuāli  iestata, ka daudzfunkciju padevējs tiek izmantots tikai drukas darbiem ar manuālu padevi. Ja ir atlasīta opcija  Pirmais , daudzfunkciju padevējs tiek konfigurēts kā primārais papīra avots. izvēlne Paplāšu konfigurēšana"},{"UUID":"013ff72f-4dda-49f2-823b-44b4b4c7c245","title":"Apdrukājamā materiāla konfigurēšana","link":"tray-configuration-topic.html","desc":"Universālā iestatīšana Izvēlnes  Universālā","descFull":"Universālā iestatīšana Izvēlnes  Universālā iestatīšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Mērvienības Collas Milimetri Norādiet universālo papīra izmēru mērvienību. Collas  ir ASV rūpnīcas noklusējuma iestatījums.  Milimetri  ir starptautiskais rūpnīcas noklusējuma iestatījums. Portreta platums 3,5-19 collas (8,5*) 88,9-482,6 mm (216*) Iestatiet universālo papīra izmēru portreta platumu. Portreta augstums 3,5-19 collas (14*) 88,9-482,6 mm (356*) Iestatiet universālo papīra izmēru portreta augstumu. Padeves virziens Īsā mala * Garā mala Iestatiet printeri ņemt papīru īsās vai garās malas virzienā. Iestatījums  Garā mala  ir redzams tikai tad, ja visgarākā mala ir īsāka nekā atbalstītais maksimālais platums. Vairāki universāli izmēri Paplāte [x] Daudzfunkciju padevējs Piešķiriet unikālu izmēru vairākiem universālajiem izmēriem, kas ievietoti katrā papīra avotā. Šis iestatījums parādās tikai, ja tas iespējots izvēlnē  Ierīce . Sākuma ekrānā pieskarieties  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Paplāšu konfigurēšana Vairāki universāli izmēri . izvēlne Universālā iestatīšana"},{"UUID":"54cd4238-6e97-4e5e-983e-fb7b440cf8b1","title":"Apdrukājamā materiāla konfigurēšana","link":"tray-configuration-topic.html","desc":"Pielāgoti skenēšanas izmēri Izvēlnes ","descFull":"Pielāgoti skenēšanas izmēri Izvēlnes  Pielāgoti skenēšanas izmēri  vienumi un to apraksti Izvēlnes vienums Apraksts Pielāgoti skenēšanas izmēri   [x] Skenēšanas izmēru nosaukums Platums 1-8,5 collas (8,5*) 25,4-215,9 mm (215,9*) Augstums 1-25 collas (11*) 25,4-635 mm (279,4*) Orientācija Portrets * Ainava 2 skenēti materiāli uz vienas puses Izslēgts * Ieslēgts Piešķiriet skenēšanas izmēru nosaukumu un konfigurējiet skenēšanas iestatījumus. izvēlne Pielāgoti skenēšanas izmēri"},{"UUID":"3583515b-885c-4731-a514-f9b1ee2b6e90","title":"Apdrukājamā materiāla konfigurēšana","link":"tray-configuration-topic.html","desc":"Apdrukājamo materiālu veidi Izvēlnes ","descFull":"Apdrukājamo materiālu veidi Izvēlnes  Apdrukājamā materiāla veidi  vienumi un to apraksti Izvēlnes vienums Apraksts Vienkāršs Kartons Pārstrādāts Spīdīgs Etiķetes Augstas kvalitātes Aploksne Raupja aploksne Veidlapa Iepriekš apdrukāts Krāsains Viegls Smags Raupjš/kokvilnas Pielāgots veids  [X] Norādiet papīra tekstūru, svaru un orientāciju. izvēlne Apdrukājamo materiālu veidi"},{"UUID":"64b319d8-3d67-4f15-ae87-74e37936fc44","title":"Kopēšana","link":"copy-defaults-topic.html","desc":"Kopēšanas noklusējuma iestatījumi Izvēlnes ","descFull":"Kopēšanas noklusējuma iestatījumi Izvēlnes  Kopēšanas noklusējuma iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Satura veids Teksts Teksts/fotoattēls * Fotoattēls Grafikas Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta saturu. Satura avots Melnbalts lāzerprinteris Krāsu lāzerprinteris * Strūklprinteris Fotoattēls/filma Žurnāls Laikraksts Iespiedmašīna Cits Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta avotu. Puses No 1 puses uz 1 puses * No 1 puses uz 2 pusēm No 2 pusēm uz 1 puses No 2 pusēm uz 2 pusēm Norādiet skenēšanas darbību, ņemot vērā oriģinālo dokumentu. Atdalošās lapas Nav * Starp eksemplāriem Starp darbiem Starp lapām Norādiet, vai drukāšanas laikā ir jāievieto tukšas atdalošās lapas. Atdalošo lapu avots Paplāte  [x] (1*) Daudzfunkciju padevējs Norādiet atdalošās lapas papīra avotu. Krāsas Izslēgts Ieslēgts * Automātiski, Iestatiet, lai printeris ģenerētu krāsu izvadi no skenētā darba. Lapas vienā pusē Izslēgts * 2 portreta orientācijas lapas 4 portreta orientācijas lapas 2 ainavas orientācijas lapas 4 ainavas orientācijas lapas Norādiet, cik lapas attēlu ir jādrukā uz vienas papīra loksnes puses. Drukāt lapas apmales Izslēgts * Ieslēgts Drukājot vairākas lapas uz vienas loksnes, izvietojiet apmali ap katru attēlu. Salikt Izslēgts [1,1,1,2,2,2] Ieslēgts [1,2,1,2,1,2] * Secīgi drukājiet vairākus eksemplārus. Ofseta lapas Nav * Starp eksemplāriem Starp darbiem Iestatiet ofsetu katram drukas darbam vai katram drukas darba eksemplāram. Iestatījums  Starp eksemplāriem  nosaka ofsetu katram drukas darbam, ja opcijas  Salikt  iestatījums ir  Ieslēgts [1,2,1,2,1,2] . Ja opcijas  Salikt  iestatījums ir  Izslēgts [1,1,1,2,2,2] , ofsets tiek iestatīts katrai izdrukāto lapu kopai, piemēram, visām pirmajām un visām otrajām lapām. Izvēloties  Starp darbiem , visam drukas darbam tiek iestatīta vienāda ofseta pozīcija neatkarīgi no izdruku skaita. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar caurumotāju. Skavošana Izslēgts * 1 skava, augšējais kreisais stūris 2 skavas, pa kreisi 1 skava, augšējais labais stūris 2 skavas, augšā 1 skava, apakšējais kreisais stūris 2 skavas, apakšā 1 skava, apakšējais labais stūris 2 skavas, pa labi 4 skavas Norādiet skavošanas vietu visiem drukas darbiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs. Caurumotājs Izslēgts * 2 caurumi 3 caurumi 4 caurumi Izduriet caurumus izdrukā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar caurumotāju. Izmērs “Kopēt no” [Papīra izmēru saraksts] Iestatiet oriģinālā dokumenta papīra izmērus. Formāts  Letter  ir ASV rūpnīcas noklusējuma iestatījums. Formāts  A4  ir starptautiskais rūpnīcas noklusējuma iestatījums. Avots “Kopēt uz” Paplāte  [x] (1*) Daudzfunkciju padevējs Automātiska izmēru atbilstība Norādiet kopēšanas darbu papīra avotu. Temperatūra no ‑4 līdz 4 (0*) Norādiet, vai izdrukai ir jābūt vēsākos vai siltākos toņos. Intensitāte no 1 līdz 9 (5*) Koriģējiet skenētā attēla intensitāti. Eksemplāru skaits 1-9999 (1*) Norādiet eksemplāru skaitu. Galvene/kājene Kreisā galvene Vidējā galvene Labā galvene Kreisā kājene Vidējā kājene Labā kājene Norādiet galvenes vai kājenes informāciju, kas jāizmanto skenētajā attēlā. Pārklājums Konfidenciāli Kopēšana Melnraksts Steidzami Pielāgots Izslēgts * Norādiet pārklājuma tekstu, kāds jādrukā katrā eksemplārā. Pielāgots pārklājums Ierakstiet tekstu izvēlnes  Pārklājums  iestatījumā  Pielāgots . Attēlveidošanas papildu iestatījumi Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Krāsu balanss Ciāna–sarkana no -4 līdz 4 (0*) Madženta–zaļa no -4 līdz 4 (0*) Dzeltena–zila no -4 līdz 4 (0*) Koriģējiet ciāna, madženta un dzeltenās krāsas intensitāti. Krāsas atmešana Krāsas atmešana  ( Nav *) Sarkanās krāsas noklusējuma slieksnis  (128*) Zaļās krāsas noklusējuma slieksnis  (128*) Zilās krāsas noklusējuma slieksnis  (128*) Norādiet, kura krāsa ir jāatmet skenēšanas laikā, kā arī koriģējiet šīs krāsas atmešanas sliekšņa iestatījumu. Automātiska krāsu noteikšana Krāsu jutība 1–9 (5*) Apgabala jutīgums 1–9 (5*) Konfigurējiet automātiskās krāsu noteikšanas iestatījumu. Kontrasts Labākais atbilstoši saturam * 0–5 Norādiet skenētā attēla kontrastu. Fona noņemšana Fona noteikšana Atkarībā no satura* Fiksēts Līmenis no ‑4 līdz 4 (0*) Noņemiet oriģinālajā dokumentā fona krāsu vai attēla troksni. Izvēloties  Atkarībā no satura , tiek noņemta oriģinālā dokumenta fona krāsa. Izvēloties  Fiksēts , fotoattēlā tiek noņemts attēla troksnis. Automātiska centrēšana Izslēgts * Ieslēgts Saturs tiek līdzināts lapas centrā. Spoguļattēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta spoguļattēlu. Negatīvs attēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta negatīvu attēlu. Ēnu detalizētība no ‑4 līdz 4 (0*) Koriģējiet ēnu detalizētību oriģinālajā dokumentā. Skenēt no malas līdz malai Izslēgts * Ieslēgts Skenējiet oriģinālo dokumentu no malas līdz malai. Asums 1–5 (3*) Koriģējiet skenētā attēla asumu. Administratora vadīklas Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Atļaut krāsainas kopijas Izslēgts Ieslēgts * Drukājiet krāsu kopijas. Atļaut prioritāras kopijas Izslēgts Ieslēgts * Pārtrauciet drukas darbu, lai veiktu kopēšanu. Pielāgotu darbu skenēšana Izslēgts * Ieslēgts Iestatiet, lai printeris skenētu pirmo oriģinālo dokumentu kopu, izmantojot norādītos iestatījumus, un pēc tam skenētu nākamo kopu ar tiem pašiem vai citiem iestatījumiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Atļaut saglabāt kā īsceļu Izslēgts Ieslēgts * Saglabājiet kopēšanas iestatījumus kā īsceļu. Parauga kopija Izslēgts * Ieslēgts Pirms vairāku eksemplāru drukāšanas izdrukājiet parauga kopiju, lai pārbaudītu kvalitāti. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. izvēlne Kopēšanas noklusējuma iestatījumi"},{"UUID":"0f505ee4-8ac5-4d4d-bc86-649b0418b645","title":"Faksa noklusējumi","link":"fax-defaults-subgroup.html","desc":"Faksa režīms Izvēlnes  Faksa","descFull":"Faksa režīms Izvēlnes  Faksa režīms  vienumi un to apraksti Izvēlnes vienums Apraksts Faksa režīms Fakss Faksa serveris Atspējots Atlasiet faksa režīmu. Rūpnīcas noklusējuma iestatījums var atšķirties atkarībā no printera modeļa. izvēlne Faksa režīms"},{"UUID":"a02492de-a80a-4ec0-8cc8-49a94fdd0158","title":"Faksa noklusējumi","link":"fax-defaults-subgroup.html","desc":"Faksa iestatīšana Šī izvēlne ir","descFull":"Faksa iestatīšana Šī izvēlne ir pieejama tikai printeriem, kas reģistrēti etherFax portālā vai aprīkoti ar faksa karti. Vispārīgi faksa iestatījumi Izvēlnes  Vispārīgi faksa iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Faksa nosaukums Identificējiet savu faksa aparātu. Faksa numurs Identificējiet savu faksa numuru. Faksa ID Faksa nosaukums Faksa numurs * Paziņojiet faksa saņēmējiem savu faksa nosaukumu vai faksa numuru. Iespējot manuālu faksu Izslēgts * Ieslēgts Ieslēdziet printerī manuālā faksa funkciju. Lai varētu izmantot šo izvēlnes vienumu, ir nepieciešams līnijas sadalītājs un tālruņa klausule. Izmantojiet parasto tālruņa līniju, lai atbildētu uz ienākošu faksa darbu un sastādītu faksa numuru. Lai uzreiz piekļūtu manuālā faksa funkcijai, tastatūrā pieskarieties pie  #  un  0 . Atmiņas lietojums Saņemt visu Lielākoties saņemt Vienādi * Lielākoties sūtīt Sūtīt visu Iestatiet printera iekšējās atmiņas apjomu, kas ir atvēlēts faksu izmantošanai. Šis izvēlnes vienums novērš atmiņas bufera izmantošanu un nesekmīgus faksus. Atcelt faksus Atļaut * Neatļaut Atceliet izejošos un ienākošos faksus. Zvanītāja ID Izslēgts Ieslēgts Cits Iespējojiet zvanītāja ID šablonu. Šis iestatījums parādās tikai tad, ja sākotnējās iestatīšanas vednī atlasītā valsts vai reģions atbalsta vairākus zvanītāju ID šablonus. Faksa numura maskēšana Izslēgts * No kreisās puses No labās puses Norādiet izejoša faksa numura maskēšanas formātu. Maskējamie cipari 0–58 (0*) Norādiet, cik cipari ir jāmaskē izejošā faksa numurā. Iespējot līnijas savienojuma noteikšanu Izslēgts Ieslēgts * Nosakiet, vai tālruņa līnija ir pievienota printerim. Notikumu noteikšana ir tūlītēja. Iespējot nepareizā kontaktligzdā pievienotas līnijas noteikšanu Izslēgts Ieslēgts * Nosakiet, vai tālruņa līnija ir pievienota pareizajam printera portam. Notikumu noteikšana ir tūlītēja. Iespējot paplašinājuma izmantošanas atbalstu Izslēgts Ieslēgts * Nosakiet, vai tālruņa līniju izmanto cita ierīce, piemēram, cits tālrunis, kas ir pievienots tai pašai līnijai. Notikumu noteikšana ir tūlītēja. Optimizēt faksa saderību Konfigurējiet printera faksa funkcionalitāti, lai nodrošinātu optimālu saderību ar citiem faksa aparātiem. Faksa pārraide T.38 Analogs G.711 etherFAX Iestatiet faksa pārraides metodi. Šis izvēlnes vienums ir redzams tikai tad, ja printerī ir instalēta etherFAX vai Fax over IP (FoIP) licenču kopa. HTTPS faksa iestatījumi Šī izvēlne ir redzama tikai tad, ja  Faksa pārraide  iestatījums ir  etherFAX . Izvēlnes  HTTPS faksa iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. HTTPS pakalpojuma URL Norādiet etherFAX pakalpojuma URL. HTTPS starpniekserveris Norādiet starpniekservera URL. HTTPS starpniekservera lietotājs Norādiet starpniekservera lietotājvārdu un paroli. HTTPS starpniekservera parole Faksa sūtīšanas šifrēšana Atspējots Iespējots * Nepieciešams Iespējojiet izejošo faksa ziņojumu šifrēšanu. Faksa saņemšanas šifrēšana Atspējots Iespējots * Nepieciešams Iespējojiet ienākošo faksa ziņojumu šifrēšanu. HTTPS faksa statuss Parādiet etherFAX saziņas statusu. Faksa sūtīšanas iestatījumi Izvēlnes  Faksa sūtīšanas iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Izšķirtspēja Standarta * Smalka Ļoti smalka Īpaši smalka Iestatiet skenētā attēla izšķirtspēju. Opcijas  Standarta  un  Ļoti smalka  parādās tikai, ja iestatījums  Iespējot krāsainu skenētu dokumentu sūtīšanu pa faksu  ir iestatīts uz  Izslēgts pēc noklusējuma . Augstāka izšķirtspēja paildzina faksa pārraides laiku, un tai ir nepieciešams vairāk atmiņas. Oriģināla izmēri [Papīra izmēru saraksts] (Dažādi izmēri*) Norādiet oriģinālā dokumenta izmērus. Orientācija Portrets * Ainava Norādiet oriģinālā dokumenta orientāciju. Puses Izslēgts * Īsā mala Garā mala Ja skenējat uz abām dokumenta pusēm, norādiet oriģinālā dokumenta orientāciju. Satura veids Teksts * Teksts/fotoattēls Fotoattēls Grafikas Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta saturu. Satura avots Melnbalts lāzerprinteris Krāsu lāzerprinteris * Strūklprinteris Fotoattēls/filma Žurnāls Laikraksts Iespiedmašīna Cits Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta avotu. Intensitāte 1–9 (5*) Koriģējiet skenētā attēla intensitāti. Kopā ar PABX Ieslēgts Izslēgts * Iestatiet printeri sastādīt faksa numuru, negaidot, kad tiks atpazīts centrāles gatavības signāls. Privātā automātiskā atzara centrāle (Private Automated Branch Exchange — PABX) ir tālruņa tīkls, kas ļauj vienam piekļuves numuram piedāvāt vairākas līnijas, uz kurām var zvanīt. Numura sastādīšanas signāla režīms Nepārtraukts signāls * Pārtraukts signāls Norādiet ienākošo vai izejošo faksu numura sastādīšanas signāla režīmu. Attēlveidošanas papildu iestatījumi Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Krāsu balanss Ciāna–sarkana no -4 līdz 4 (0*) Madženta–zaļa no -4 līdz 4 (0*) Dzeltena–zila no -4 līdz 4 (0*) Koriģējiet krāsas intensitāti skenēšanas laikā. Krāsas atmešana Krāsas atmešana  ( Nav *) Sarkanās krāsas noklusējuma slieksnis  (128*) Zaļās krāsas noklusējuma slieksnis  (128*) Zilās krāsas noklusējuma slieksnis  (128*) Norādiet, kura krāsa ir jāatmet skenēšanas laikā, kā arī koriģējiet šīs krāsas atmešanas sliekšņa iestatījumu. Kontrasts Labākais atbilstoši saturam * 0 1 2 3 4 5 Iestatiet izvades kontrastu. Fona noņemšana Līmenis no ‑4 līdz 4 (0*) Koriģējiet skenētajā attēlā redzamo fona daudzumu. Spoguļattēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta spoguļattēlu. Negatīvs attēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta negatīvu attēlu. Ēnu detalizētība no ‑4 līdz 4 (0*) Koriģējiet skenētajā attēlā redzamo ēnu detalizētību. Skenēt no malas līdz malai Ieslēgts Izslēgts * Atļaujiet skenēt oriģinālo dokumentu no malas līdz malai. Asums 1–5 (3*) Koriģējiet skenētā attēla asumu. Temperatūra no ‑4 līdz 4 (0*) Norādiet, vai izdrukai ir jābūt vēsākos vai siltākos toņos. Administratora vadīklas Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Automātiski atkārtot zvanu 0–9 (5*) Pielāgojiet zvana atkārtošanas mēģinājumu skaitu, ņemot vērā faksu saņemošo ierīču aktivitātes līmeni. Atkārtotas zvanīšanas periodiskums 1–200 minūtes (3*) Paildziniet laiku starp zvana atkārtošanas mēģinājumiem, lai palielinātos iespēja sekmīgi nosūtīt faksu. Iespējot ECM Ieslēgts * Izslēgts Aktivizējiet faksa darbu kļūdu novēršanas režīmu (Error Correction Mode — ECM). ECM konstatē un novērš faksa pārraides procesā radušās kļūdas, kuras izraisījuši tālruņa līnijas traucējumi un vājš signāls. Iespējot skenētu dokumentu sūtīšanu pa faksu Ieslēgts * Izslēgts Nosūtiet pa faksu dokumentus, kas ir skenēti, izmantojot printeri. Draivera savienojums ar faksu Ieslēgts * Izslēgts Ļaujiet printera draiverim sūtīt faksus. Atļaut saglabāt kā īsceļu Ieslēgts * Izslēgts Saglabājiet faksa numurus printerī kā īsceļus. Maksimāls ātrums 33600 * 14400 9600 4800 2400 Iestatiet maksimālo faksa sūtīšanas ātrumu. Pielāgotu darbu skenēšana Izslēgts * Ieslēgts Ieslēdziet pielāgotu darbu skenēšanu pēc noklusējuma. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks vai viedais krātuves disks (ISD). Skenēšanas priekšskatījums Izslēgts * Ieslēgts Skatiet skenētā dokumenta priekšskatījumu displejā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks vai ISD. Iespējot krāsainu skenētu dokumentu sūtīšanu pa faksu Izslēgts pēc noklusējuma * Ieslēgts pēc noklusējuma Nekad neizmantot Izmantot vienmēr Iespējojiet krāsainu dokumentu skenēšanu sūtīšanai pa faksu. Krāsainus faksus automātiski konvertēt par vienkrāsainiem faksiem Ieslēgts * Izslēgts Visi izejošie krāsainie faksi tiek konvertēti par melnbaltiem faksiem. Apstiprināt faksa numuru Izslēgts * Ieslēgts Lūdziet lietotājam apstiprināt faksa numuru. Numura sastādīšanas prefikss Iestatiet numura sastādīšanas prefiksu. Numura sastādīšanas prefiksa noteikumi Izveidojiet numura sastādīšanas noteikumu. Faksa saņemšanas iestatījumi Izvēlnes  Faksa saņemšanas iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Faksa darbu gaidīšana Nav * Toneris Toneris un izejmateriāli Noņemiet no drukas darbu rindas faksa darbus, kuru izpildei ir nepieciešami īpaši resursi, kas nav pieejami. Zvana signāli pirms atbildes 1–25 (3*) Iestatiet, pēc cik zvana signāliem ierīce atbild uz ienākošiem zvaniem. Automātiska samazināšana Ieslēgts * Izslēgts Mērogojiet ienākošu faksu, lai tas ietilptu lapā. Papīra avots Paplāte  [X] Automātiski * Iestatiet ienākošo faksu drukāšanai izmantojamo papīra avotu. Puses Ieslēgts Izslēgts * Drukājiet uz abām papīra pusēm. Atdalošās lapas Nav * Pirms darba Pēc darba Norādiet, vai drukāšanas laikā ir jāievieto tukšas atdalošās lapas. Atdalošo lapu avots Paplāte  [X] (1*) Norādiet atdalošās lapas papīra avotu. Izvades nodalījums Standarta nodalījums Norādiet saņemto faksu izvades nodalījumu. Faksa kājene Ieslēgts Izslēgts * Katras saņemtā faksa lapas apakšdaļā drukājiet pārraides informāciju. Faksa kājenes laikspiedols Saņemt * Drukāt Katras saņemtā faksa lapas apakšdaļā drukājiet laikspiedolu. Caurumotājs Izslēgts * 2 caurumi 3 caurumi 4 caurumi Norādiet caurumošanas funkciju ienākošajiem faksiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar caurumotāju. Skavošana Izslēgts * 1 skava 2 skavas 4 skavas Norādiet skavošanas funkciju ienākošajiem faksiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar skavotāju. Faksu aizturēšana Aizturēta faksa režīms Izslēgts * Vienmēr ieslēgts Manuāli Pēc plāna Atlieciet saņemto faksu drukāšanu, līdz tā tiek atļauta. Faksu aizturēšana Faksu aizturēšanas plāns Piešķiriet faksu aizturēšanas plānu. Šis iestatījums ir redzams tikai tad, ja opcijas  Aizturēta faksa režīms  iestatījums ir  Pēc plāna . Administratora vadīklas Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Iespējot faksu saņemšanu Ieslēgts * Izslēgts Iestatiet printeri saņemt faksus. Iespējot krāsainu faksu saņemšanu Ieslēgts * Izslēgts Iestatiet printeri saņemt krāsainus faksus. Iespējot zvanītāja ID Ieslēgts Izslēgts * Attēlojiet ienākošā zvana tālruņa numuru vadības panelī. Bloķēt faksus, ja nav norādīts vārds Ieslēgts Izslēgts * Bloķējiet ienākošos faksus, kuri ir sūtīti no ierīces, nenorādot stacijas ID vai faksa ID. Aizliegto faksu saraksts Pievienot aizliegtu faksu Norādiet bloķējamus tālruņa numurus. Atbildēt uz Visi zvani * Tikai viens zvans Tikai divi zvani Tikai trīs zvani Tikai viens vai divi zvani Tikai viens vai trīs zvani Tikai divi vai trīs zvani Iestatiet atšķirīgu zvana signālu ienākošajam faksam. Automātiska atbilde Ieslēgts * Izslēgts Iestatiet printeri automātiski saņemt faksus. Manuālas atbildes kods 0-9 (9*) Manuāli ievadiet kodu, izmantojot tālruņa numuru sastādīšanas tastatūru, lai sāktu faksa saņemšanu. Šis izvēlnes vienums ir redzams tikai tad, ja printerim un tālrunim ir kopīga līnija. Šis izvēlnes vienums ir redzams tikai tad, ja printeris ir iestatīts saņemt faksus manuāli. Faksu pāradresēšana Drukāt * Drukāt un pāradresēt Pāradresēt Norādiet, vai pāradresēt saņemtu faksu. Pāradresēt šim: 1. adresāts 2. adresāts Norādiet, uz kurieni pāradresēt saņemtu faksu. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Faksu pāradresēšana  iestatījums ir  Drukāt un pāradresēt  vai  Pāradresēt . Maksimāls ātrums 33600* 14400 9600 4800 2400 Iestatiet maksimālo faksa pārraides ātrumu. Faksa titullapa Izvēlnes  Faksa titullapa  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Faksa titullapa Izslēgts pēc noklusējuma * Ieslēgts pēc noklusējuma Nekad neizmantot Izmantot vienmēr Konfigurējiet faksa titullapas iestatījumus. Iekļaut lauku Kam Izslēgts * Ieslēgts Iekļaut lauku No Izslēgts * Ieslēgts No Iekļaut lauku Ziņojums Izslēgts * Ieslēgts Ziņojums: Iekļaut logotipu Izslēgts * Ieslēgts Iekļaut kājeni [x] Izslēgts * Ieslēgts Kājene [x] Faksa žurnāla iestatījumi Izvēlnes  Faksa žurnāla iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Pārraides žurnāla intervāls Vienmēr * Nekad Tikai kļūdai Norādiet, cik bieži printeris veido pārraides žurnālu. Pārraides žurnāla darbība Drukāt Izslēgts Ieslēgts * E-pasts Izslēgts * Ieslēgts Drukājiet vai nosūtiet pa e-pastu žurnālu, ja faksa pārraide bija sekmīga vai radās pārraides kļūda. Saņemšanas kļūdu žurnāls Nekad nedrukāt * Drukāt kļūdas gadījumā Drukājiet žurnālu, ja radās faksa saņemšanas kļūmes. Automātiski drukāt žurnālus Ieslēgts * Izslēgts Drukājiet žurnālu visos faksa darbības gadījumos. Žurnāla papīra avots Paplāte  [x] (1*) Norādiet žurnālu drukāšanai izmantojamo papīra avotu. Žurnālos attēlojamā informācija Attālā faksa nosaukums * Sastādītais numurs Identificējiet sūtītāju, norādot attālo faksa nosaukumu vai faksa numuru. Iespējot darbu žurnālu Ieslēgts * Izslēgts Skatiet kopsavilkumu par visiem faksa darbiem. Iespējot izsaukumu žurnālu Ieslēgts * Izslēgts Skatiet kopsavilkumu par faksa zvanu vēsturi. Žurnāla izvades nodalījums Standarta nodalījums * Nodalījums [x] Norādiet izdrukāto žurnālu izvades nodalījumu. Skaļruņa iestatījumi Izvēlnes  Skaļruņa iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Skaļruņa režīms Vienmēr izslēgts * Vienmēr ieslēgts Ieslēgts līdz savienojumam Iestatiet faksa skaļruņa režīmu. Skaļruņa skaļums Zems * Augsts Koriģējiet faksa skaļruņa skaļumu. Zvanītāja skaļums Izslēgts * Ieslēgts Iespējojiet zvanītāja skaļumu. VoIP iestatījumi Izvēlnes  VoIP iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. VoIP protokols SIP * H.323 Iestatiet IP balss pārraides (Voice over Internet Protocol — VoIP) protokolu. STUN serveris Norādiet STUN serveri, lai to aizsargātu ugunsmūri. Piespiedu faksa režīms Izslēgts Ieslēgts * Faksa zvana sākumā pārslēdziet VoIP vārteju no analogās uz T.38. Piespiedu faksa režīma aizkave 0–15 (7*) Iestatiet, pēc cik sekundēm jāsūta vēl viens  Piespiedu faksa režīms  uzaicinājums. SIP iestatījumi Izvēlnes  SIP iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Starpniekserveris Norādiet tās sistēmas IP adresi, kas pārvērš tālruņa zvanu par IP adresi, uz kuru tiek sūtīts fakss. Reģistrētājs Norādiet tās sistēmas nosaukumu vai IP adresi, kas nodrošina SIP klientu reģistrāciju. Lietotājs Norādiet SIP starpniekservera lietotājvārdu. Parole Norādiet SIP reģistrētājam izmantoto paroli. Autorizēšanās ID Norādiet SIP reģistrētāja lietotājvārdu. Ja iestatījums Autorizēšanās ID nav iestatīts, tā vietā tiek izmantots lauka  Lietotājs  lietotājvārds. Reģistrēšanās pārraide UDP * TCP Iestatiet reģistrēšanās SIP pārraides veidu. Ienākošo zvanu pārraide UDP * TCP UDP un TCP Iestatiet ienākošo zvanu SIP pārraides veidu. Izejošo zvanu pārraide UDP * TCP Iestatiet izejošo zvanu SIP pārraides veidu. Izejošais starpniekserveris Norādiet izejošo starpniekserveri, lai pārsūtītu visu SIP saziņu. Sazinieties ar Norādiet SIP kontaktpersonas vārdu. Nodalījums Norādiet SIP nodalījuma nosaukumu. Ja iestatījums Nodalījums nav iestatīts, tā vietā tiek izmantots lauka  Sazinieties ar  vārds. SIP reģistrācijas statuss Skatiet SIP reģistrācijas statusu. H.323 iestatījumi Izvēlnes  H.323 iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Vārteja Norādiet H.323 vārtejas IP adresi. Vārtzinis Norādiet H.323 vārtzini. Lietotājs Norādiet ar H.323 vārteju izmantoto lietotājvārdu. Parole Norādiet H.323 vārtejas paroli. Iespējot ātru sākumu Izslēgts * Ieslēgts Iespējojiet ātru sākumu. Atspējot H.245 tunelēšanu Izslēgts * Ieslēgts Atspējojiet H.323 tunelēšanu. Atspējot vārtziņa atklāšanu Izslēgts Ieslēgts * Atspējojiet H.323 vārtziņa atklāšanu. T.38 iestatījumi Izvēlnes  T.38 iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Indikatora redundance 0–5 (3*) Iestatiet, cik reižu tiek atkārtots faksa indikators T.38 saziņā. Lēna redundance 0–5 (3*) Iestatiet, cik reižu tiek atkārtoti lēni dati T.38 saziņā. Ātra redundance 0–5 (1*) Iestatiet, cik reižu tiek atkārtoti ātri dati T.38 saziņā. izvēlne Faksa iestatīšana"},{"UUID":"b4a21c1a-0479-4466-bba5-35b54d148325","title":"Faksa noklusējumi","link":"fax-defaults-subgroup.html","desc":"Faksa servera iestatīšana Vispārīgi faksa","descFull":"Faksa servera iestatīšana Vispārīgi faksa iestatījumi Izvēlnes  Vispārīgi faksa iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Adresāta formāts Norādiet faksa adresātu. Ja vēlaties izmantot faksa numuru, pirms numura ierakstiet numura zīmi (#). Atbildes adrese Norādiet atbildes adresi, uz kuru sūtāms fakss. Tēma Norādiet faksa tēmu un ziņojumu. Ziņojums Iespējot analogā faksa saņemšanu Izslēgts * Ieslēgts Iestatiet printeri automātiski saņemt analogus faksus. faksa servera e-pasta iestatījumi Izvēlnes  Faksa servera e-pasta iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Lietot SMTP serveri e-pasta funkcijai Ieslēgts Izslēgts * Izmantojiet e-pasta vienkāršā pasta pārsūtīšanas protokola (Simple Mail Transfer Protocol — SMTP) iestatījumus, lai saņemtu un sūtītu faksa ziņojumus. Ja iestatījums ir  Ieslēgts , netiek rādīts neviens cits izvēlnes  Faksa servera e-pasta iestatījumi  iestatījums. Primārā SMTP vārteja Ievadiet primārā SMTP servera IP adresi vai resursdatora nosaukumu. Primārās SMTP vārtejas ports 1–65535 (25*) Ievadiet primārā SMTP servera porta numuru. Sekundārā SMTP vārteja Ievadiet sekundārā vai rezerves SMTP servera IP adresi vai resursdatora nosaukumu. Sekundārās SMTP vārtejas ports 1–65535 (25*) Ievadiet sekundārā vai rezerves SMTP servera porta numuru. SMTP taimauts 5–30 (30*) Iestatiet laika periodu, pēc kura iestājas printera taimauts, ja SMTP serveris neatbild. Atbildes adrese Norādiet atbildes adresi, uz kuru sūtāms fakss. Izmantot SSL/TLS Atspējots * Varbūtēji Nepieciešams Norādiet, vai sūtīt faksu, izmantojot šifrētu saiti. Pieprasīt uzticamu sertifikātu Izslēgts Ieslēgts * Norādiet uzticamu sertifikātu, piekļūstot SMTP serverim. SMTP servera autentifikācija Nav nepieciešama autentifikācija * Pieteikšanās/parasta NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Iestatiet SMTP servera autentifikācijas veidu. Ierīces iniciēts e-pasts Nav * Lietot ierīces SMTP akreditācijas datus Norādiet, vai ierīces iniciētai e-pasta izmantošanai ir nepieciešami akreditācijas dati. Lietotāja iniciēts e-pasts Nav * Lietot ierīces SMTP akreditācijas datus Lietot sesijas lietotāja ID un paroli Lietot sesijas e-pasta adresi un paroli Lietotāja uzvedne Norādiet, vai lietotāja iniciētai e-pasta izmantošanai ir nepieciešami akreditācijas dati. Izmantot aktīva direktorija ierīces akreditācijas datus Izslēgts * Ieslēgts Iespējojiet lietotāja akreditācijas datu un grupu galamērķu lietošanu, lai pievienotos SMTP serverim. Ierīces lietotāja ID Norādiet lietotāja ID un paroli, lai pievienotos SMTP serverim. Ierīces parole Kerberos 5 REALM Norādiet Kerberos 5 autentificēšanas protokola nozarojumu. NTLM domēns Norādiet NTLM drošības protokola domēna nosaukumu. Atspējot kļūdu “SMTP serveris nav iestatīts” Izslēgts* Ieslēgts Paslēpiet kļūdas ziņojumu “SMTP serveris nav iestatīts”. faksa servera skenēšanas iestatījumi Izvēlnes  Faksa servera skenēšanas iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Attēla formāts TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Norādiet skenētā attēla faila formātu. Satura veids Teksts * Teksts/fotoattēls Fotoattēls Grafikas Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta saturu. Satura avots Melnbalts lāzerprinteris Krāsu lāzerprinteris * Strūklprinteris Fotoattēls/filma Žurnāls Laikraksts Iespiedmašīna Cits Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta avotu. Faksa izšķirtspēja Standarta * Smalka Ļoti smalka Īpaši smalka Iestatiet faksa izšķirtspēju. Puses Izslēgts * Īsā mala Garā mala Ja skenējat uz abām dokumenta pusēm, norādiet oriģinālā dokumenta orientāciju. Intensitāte 1–9 (5*) Iestatiet izdrukas intensitāti. Orientācija Portrets * Ainava Norādiet teksta un attēlu orientāciju lapā. Oriģināla izmēri [Papīra izmēru saraksts] Iestatiet oriģinālā dokumenta papīra izmērus. Dažādi izmēri  ir ASV rūpnīcas noklusējuma iestatījums. A4 ir starptautiskais rūpnīcas noklusējuma iestatījums. Šis iestatījums var atšķirties atkarībā no printera modeļa. Izmantot vairāku lapu TIFF Izslēgts Ieslēgts * Izvēlieties vienas lapas vai vairāku lapu TIFF failus. izvēlne Faksa servera iestatīšana"},{"UUID":"9facda4f-e409-448f-8627-3f51e70ef983","title":"E-pasts:","link":"email-setup-topic.html","desc":"E-pasta iestatīšana Izvēlnes  E-pasta","descFull":"E-pasta iestatīšana Izvēlnes  E-pasta iestatīšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Primārā SMTP vārteja Ievadiet primārā SMTP servera IP adresi vai resursdatora nosaukumu, lai sūtītu e-pasta ziņojumus. Primārās SMTP vārtejas ports 1–65535 (25*) Ievadiet primārā SMTP servera porta numuru. Sekundārā SMTP vārteja Ievadiet sekundārā vai rezerves SMTP servera IP adresi vai resursdatora nosaukumu. Sekundārās SMTP vārtejas ports 1–65535 (25*) Ievadiet sekundārā vai rezerves SMTP servera porta numuru. SMTP taimauts 5–30 sekundes (30*) Iestatiet laika periodu, pēc kura iestājas printera taimauts, ja SMTP serveris neatbild. Atbildes adrese E-pasta ziņojumā norādiet atbildes adresi. Vienmēr izmantot SMTP noklusējuma atbildes adresi Ieslēgts Izslēgts * Vienmēr izmantojiet noklusējuma atbildes adresi SMTP serverī. Izmantot SSL/TLS Atspējots * Varbūtēji Nepieciešams Norādiet, vai sūtīt e-pasta ziņojumu, izmantojot šifrētu saiti. Pieprasīt uzticamu sertifikātu Izslēgts Ieslēgts * Pieprasiet uzticamu sertifikātu, piekļūstot SMTP serverim. SMTP servera autentifikācija Nav nepieciešama autentifikācija * Pieteikšanās/parasta NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Iestatiet SMTP servera autentifikācijas veidu. Ierīces iniciēts e-pasts Nav * Lietot ierīces SMTP akreditācijas datus Norādiet, vai ierīces iniciētai e-pasta izmantošanai ir nepieciešami akreditācijas dati. Lietotāja iniciēts e-pasts Nav * Lietot ierīces SMTP akreditācijas datus Lietot sesijas lietotāja ID un paroli Lietot sesijas e-pasta adresi un paroli Lietotāja uzvedne Norādiet, vai lietotāja iniciētai e-pasta izmantošanai ir nepieciešami akreditācijas dati. Izmantot aktīva direktorija ierīces akreditācijas datus Izslēgts * Ieslēgts Norādiet, vai lietotāja iniciētai e-pasta izmantošanai ir nepieciešami akreditācijas dati. Ierīces lietotāja ID Norādiet lietotāja ID un paroli, lai pievienotos SMTP serverim. Ierīces parole Kerberos 5 REALM Norādiet Kerberos 5 autentificēšanas protokola nozarojumu. NTLM domēns Norādiet NTLM drošības protokola domēna nosaukumu. Atspējot kļūdu “SMTP serveris nav iestatīts” Izslēgts * Ieslēgts Paslēpiet kļūdas ziņojumu “SMTP serveris nav iestatīts”. izvēlne E-pasta iestatīšana"},{"UUID":"c950df2d-5fc5-44ef-8ac7-4311462181da","title":"E-pasts:","link":"email-setup-topic.html","desc":"E-pasta noklusējuma iestatījumi Izvēlnes ","descFull":"E-pasta noklusējuma iestatījumi Izvēlnes  E-pasta noklusējuma iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Tēma: Norādiet e-pasta ziņojuma tēmu un saturu. Ziņojums: Faila nosaukums Norādiet skenētā dokumenta faila nosaukumu. Formāts JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) CSV (.csv) Norādiet skenētā dokumenta faila formātu. Izvēlnes vienumi var atšķirties atkarībā no printera modeļa. Globālie OCR iestatījumi Atpazītās valodas Automātiska pagriešana Noņemt traipus Automātiski uzlabot kontrastu Konfigurējiet optiskās rakstzīmju atpazīšanas (optical character recognition — OCR) iestatījumus. Šis izvēlnes vienums ir redzams tikai tad, ja esat iegādājies un instalējis OCR risinājumu. PDF iestatījumi PDF versija  (1.5*) Arhivēšanas versija  (A‑1a*) Ļoti saspiests  ( Izslēgts *) Drošs  ( Izslēgts *) Arhivēšana (PDF/A)  ( Izslēgts *) Konfigurējiet skenētā dokumenta PDF iestatījumus. Opcija  Arhivēšanas versija  un  Arhivēšana (PDF/A)  tiek atbalstīta tikai tad, ja  PDF versija  ir 1.4. Opcija  Ļoti saspiests  ir redzama tikai tad, ja ir uzstādīts cietais disks. Satura veids Teksts Teksts/fotoattēls * Fotoattēls Grafikas Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta satura veidu. Satura avots Melnbalts lāzerprinteris * Krāsu lāzerprinteris Strūklprinteris Fotoattēls/filma Žurnāls Laikraksts Iespiedmašīna Cits Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta satura avotu. Krāsas Melnbalts Pelēks Krāsu * Automātiski, Iestatiet, lai printeris tvertu krāsainu vai melnbaltu faila saturu. Izšķirtspēja 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Iestatiet skenētā attēla izšķirtspēju. Intensitāte 1–9 (5*) Koriģējiet skenētā attēla intensitāti. Orientācija Portrets * Ainava Norādiet oriģinālā dokumenta orientāciju. Oriģināla izmēri Dažādi izmēri * Iestatiet oriģinālā dokumenta papīra izmērus. Puses Izslēgts * Īsā mala Garā mala Ja skenējat uz abām dokumenta pusēm, norādiet oriģinālā dokumenta orientāciju. Attēlveidošanas papildu iestatījumi Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Krāsu balanss Ciāna  (0*) Madženta  (0*) Dzeltena  (0*) Koriģējiet ciāna, madženta un dzeltenās krāsas intensitāti. Krāsas atmešana Krāsas atmešana Nav * Sarkanā Zaļa Zila Sarkanās krāsas noklusējuma slieksnis 0–255 (128*) Zaļās krāsas noklusējuma slieksnis 0–255 (128*) Zilās krāsas noklusējuma slieksnis 0–255 (128*) Norādiet, kura krāsa ir jāatmet skenēšanas laikā, kā arī koriģējiet šīs krāsas atmešanas sliekšņa iestatījumu. Automātiska krāsu noteikšana Krāsu jutība 1–9 (5*) Apgabala jutīgums 1–9 (5*) E-pasta bitu dziļums 1 bits * 8 biti Minimālā skenēšanas izšķirtspēja 75 dpi 150 dpi 200 dpi 300 dpi * Konfigurējiet automātiskās krāsu noteikšanas iestatījumu. JPEG kvalitāte Labākais atbilstoši saturam * 5–95 Iestatiet skenētā attēla JPEG kvalitāti. Kontrasts Labākais atbilstoši saturam * 0–5 Norādiet skenētā attēla kontrastu. Fona noņemšana Fona noteikšana Atkarībā no satura * Fiksēts Līmenis  no ‑4 līdz 4 (0*) Noņemiet oriģinālajā dokumentā fona krāsu vai attēla troksni. Izvēloties  Atkarībā no satura , tiek noņemta oriģinālā dokumenta fona krāsa. Izvēloties  Fiksēts , fotoattēlā tiek noņemts attēla troksnis. Spoguļattēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta spoguļattēlu. Negatīvs attēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta negatīvu attēlu. Ēnu detalizētība no ‑4 līdz 4 (0*) Koriģējiet ēnu detalizētību skenētajā attēlā. Skenēt no malas līdz malai Izslēgts * Ieslēgts Skenējiet oriģinālo dokumentu no malas līdz malai. Asums 1–5 (3*) Koriģējiet skenētā attēla asumu. Temperatūra no ‑4 līdz 4 (0*) Iegūstiet zilāku vai sarkanāku oriģinālā dokumenta izdruku. Tukšas lapas Tukšu lapu noņemšana  ( Nenoņemt *) Tukšu lapu noteikšana  (5*) Norādiet skenēšanas iestatījumu saistībā ar tukšām lapām oriģinālajā dokumentā. Administratora vadīklas Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Maksimālais e-pasta ziņojuma lielums 0–65535 (0*) Iestatiet katra e-pasta ziņojuma pieļaujamo faila lielumu. Lieluma kļūdas ziņojums Norādiet kļūdas ziņojumu, ko printeris nosūta, ja e-pasta ziņojums pārsniedz pieļaujamo faila lielumu. Varat ievadīt līdz 1024 rakstzīmēm. Galamērķu ierobežojumi Ierobežojiet e-pasta ziņojumu sūtīšanu uz sarakstā iekļautiem konkrētiem domēna nosaukumiem. Lai atdalītu domēnus, izmantojiet komatu. Nosūtīt man kopiju Nekad netiek rādīts * Ieslēgts pēc noklusējuma Izslēgts pēc noklusējuma Vienmēr ieslēgts Nosūtiet sev e-pasta ziņojuma kopiju. Atļaut tikai savus e-pastus Izslēgts * Ieslēgts Iestatiet printeri sūtīt e-pasta ziņojumus tikai sev. Izmantot cc:/bcc: Izslēgts * Ieslēgts Iespējojiet e-pasta ziņojuma kopiju un diskrēto kopiju. Izmantot vairāku lapu TIFF Izslēgts Ieslēgts * Iespējojiet vairāku TIFF attēlu skenēšanu vienā TIFF failā. TIFF saspiešanas līmenis JPEG LZW * Norādiet TIFF failu saspiešanas veidu. Teksta noklusējums 5–95 (75*) Iestatiet skenētā satura teksta kvalitāti. Teksta/fotoattēla noklusējums 5–95 (75*) Iestatiet skenētā satura teksta un fotoattēla kvalitāti. Fotoattēla noklusējums 5–95 (50*) Iestatiet skenētā satura fotoattēla kvalitāti. Koriģēt ADF šķībumu Izslēgts * Ieslēgts Iestatiet, lai printeris skenētajos dokumentos koriģētu sašķiebtus attēlus, izmantojot ADF. Pārraides žurnāls Drukāt žurnālu * Nedrukāt žurnālu Drukāt tikai kļūdas gadījumā Izdrukājiet skenēto e-pastu pārraides žurnālu. Žurnāla papīra avots Paplāte  [x] (1*) Daudzfunkciju padevējs Norādiet e-pasta žurnālu drukāšanai izmantojamo papīra avotu. Pielāgotu darbu skenēšana Izslēgts * Ieslēgts Iestatiet, lai printeris skenētu pirmo oriģinālo dokumentu kopu, izmantojot norādītos iestatījumus, un pēc tam nākamo kopu ar tiem pašiem vai citiem iestatījumiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Skenēšanas priekšskatījums Izslēgts Ieslēgts * Parādiet oriģinālā dokumenta skenējuma priekšskatījumu. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Atļaut saglabāt kā īsceļu Izslēgts Ieslēgts * Saglabājiet e-pasta adresi kā īsceļu. E-pasta attēli tiek sūtīti kā Pielikums * Tīmekļa saite Norādiet, kā jāsūta e-pastā iekļautie attēli. Atiestatīt e-pasta informāciju pēc sūtīšanas Izslēgts Ieslēgts * Pēc e-pasta nosūtīšanas atiestatiet lauka Kam, Tēma, Ziņojums un Faila nosaukums noklusējuma vērtības. izvēlne E-pasta noklusējuma iestatījumi"},{"UUID":"e6b529c2-9250-4cfb-84a0-a311e9374e0e","title":"E-pasts:","link":"email-setup-topic.html","desc":"Tīmekļa saites iestatīšana Izvēlnes ","descFull":"Tīmekļa saites iestatīšana Izvēlnes  Tīmekļa saites iestatīšana  vienumi un to apraksti Izvēlnes vienums Apraksts Serveris Norādiet tā servera akreditācijas datus, kurā tiek viesoti e-pastā iekļautie attēli. Pieteikumvārds Parole Ceļš Faila nosaukums Tīmekļa saite izvēlne Tīmekļa saites iestatīšana"},{"UUID":"034ea888-cd0b-48cf-875b-754a8b8361e1","title":"FTP","link":"ftp-defaults-topic.html","desc":"FTP noklusējuma iestatījumi Izvēlnes ","descFull":"FTP noklusējuma iestatījumi Izvēlnes  FTP noklusējuma iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Formāts JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) Norādiet skenētā attēla faila formātu. Globālie OCR iestatījumi Atpazītās valodas Automātiska pagriešana * Noņemt traipus Automātiski uzlabot kontrastu Konfigurējiet optiskās rakstzīmju atpazīšanas (optical character recognition — OCR) iestatījumus. Šī izvēlne ir redzama tikai tad, ja esat iegādājies un instalējis OCR risinājumu. PDF iestatījumi PDF versija  (1.5*) Arhivēšanas versija  ( A‑1a *) Ļoti saspiests  ( Izslēgts *) Drošs  ( Izslēgts *) Arhivēšana (PDF/A)  ( Izslēgts *) Konfigurējiet skenētā attēla PDF iestatījumus. Opcija  Ļoti saspiests  ir redzama tikai tad, ja ir uzstādīts cietais disks. Satura veids Teksts Teksts/fotoattēls * Grafikas Fotoattēls Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta satura veidu. Satura avots Melnbalts lāzerprinteris Krāsu lāzerprinteris * Strūklprinteris Fotoattēls/filma Žurnāls Laikraksts Iespiedmašīna Cits Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta satura avotu. Krāsas Melnbalts Pelēks Krāsu * Automātiski, Iestatiet, lai printeris tvertu krāsainu vai melnbaltu faila saturu. Izšķirtspēja 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Iestatiet skenētā attēla izšķirtspēju. Intensitāte 1–9 (5*) Koriģējiet skenētā attēla intensitāti. Orientācija Portrets * Ainava Norādiet oriģinālā dokumenta orientāciju. Oriģināla izmēri Dažādi izmēri * Iestatiet oriģinālā dokumenta papīra izmērus. Puses Izslēgts * Garā mala Īsā mala Ja skenējat uz abām dokumenta pusēm, norādiet orientāciju. Faila nosaukums Norādiet skenētā attēla faila nosaukumu. Attēlveidošanas papildu iestatījumi Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Krāsu balanss Ciāna  (0*) Madženta  (0*) Dzeltena  (0*) Koriģējiet ciāna, madženta un dzeltenās krāsas intensitāti. Krāsas atmešana Krāsas atmešana  ( Nav *) Sarkanās krāsas noklusējuma slieksnis  (128*) Zaļās krāsas noklusējuma slieksnis  (128*) Zilās krāsas noklusējuma slieksnis  (128*) Norādiet, kura krāsa ir jāatmet skenēšanas laikā, kā arī koriģējiet šīs krāsas atmešanas sliekšņa iestatījumu. Automātiska krāsu noteikšana Krāsu jutība  (5*) Apgabala jutīgums  (5*) FTP bitu dziļums  (1 bits*) Minimālā skenēšanas izšķirtspēja  (300 dpi*) Konfigurējiet automātiskās krāsu noteikšanas iestatījumu. JPEG kvalitāte Labākais atbilstoši saturam * 5–95 Iestatiet skenētā attēla JPEG kvalitāti. Kontrasts Labākais atbilstoši saturam * 0 1 2 3 4 5 Norādiet skenētā attēla kontrastu. Fona noņemšana Fona noteikšana ( Atkarībā no satura *) Līmenis (0*) Noņemiet oriģinālajā dokumentā fona krāsu vai attēla troksni. Izvēloties  Atkarībā no satura , tiek noņemta oriģinālā dokumenta fona krāsa. Izvēloties  Fiksēts , fotoattēlā tiek noņemts attēla troksnis. Spoguļattēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta spoguļattēlu. Negatīvs attēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta negatīvu attēlu. Ēnu detalizētība no ‑4 līdz 4 (0*) Koriģējiet ēnu detalizētību skenētajā attēlā. Skenēt no malas līdz malai Izslēgts * Ieslēgts Atļaujiet skenēt oriģinālo dokumentu no malas līdz malai. Asums 1–5 (3*) Koriģējiet skenētā attēla asumu. Temperatūra no ‑4 līdz 4 (0*) Iegūstiet zilāku vai sarkanāku oriģinālā dokumenta izdruku. Tukšas lapas Tukšu lapu noņemšana  ( Noņemt *) Tukšu lapu noteikšana  (5*) Norādiet skenēšanas iestatījumu saistībā ar tukšām lapām oriģinālajā dokumentā. Administratora vadīklas Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Teksta noklusējums 5–95 (75*) Iestatiet skenētā attēla teksta kvalitāti. Teksta/fotoattēla noklusējums 5–95 (75*) Iestatiet skenētā attēla teksta un fotoattēla kvalitāti. Fotoattēla noklusējums 5–95 (50*) Iestatiet skenētā fotoattēla kvalitāti. Izmantot vairāku lapu TIFF Ieslēgts * Izslēgts Iespējojiet vairāku TIFF attēlu skenēšanu vienā TIFF failā. TIFF saspiešanas līmenis LZW * JPEG Norādiet TIFF failu saspiešanas veidu. Pārraides žurnāls Drukāt žurnālu * Nedrukāt žurnālu Drukāt tikai kļūdas gadījumā Izdrukājiet skenēto FTP pārraides žurnālu. Žurnāla papīra avots Paplāte  [x] (1*) Daudzfunkciju padevējs Norādiet FTP žurnālu drukāšanai izmantojamo papīra avotu. Pielāgotu darbu skenēšana Izslēgts * Ieslēgts Iestatiet, lai printeris skenētu pirmo oriģinālo dokumentu kopu, izmantojot norādītos iestatījumus, un pēc tam skenētu nākamo kopu ar tiem pašiem vai citiem iestatījumiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Skenēšanas priekšskatījums Izslēgts Ieslēgts * Parādiet oriģinālā dokumenta priekšskatījumu. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Atļaut saglabāt kā īsceļu Izslēgts Ieslēgts * Saglabājiet FTP adresi kā īsceļu. izvēlne FTP noklusējuma iestatījumi"},{"UUID":"55a80715-fdf4-4220-b2c4-27f061e4d6eb","title":"USB disks","link":"flash-drive-scan-topic.html","desc":"Skenēšana no zibatmiņas diska Izvēlnes","descFull":"Skenēšana no zibatmiņas diska Izvēlnes  Skenēšana no zibatmiņas diska  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Formāts JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) Norādiet skenētā attēla faila formātu. Globālie OCR iestatījumi Atpazītās valodas Automātiska pagriešana Noņemt traipus Automātiski uzlabot kontrastu Konfigurējiet optiskās rakstzīmju atpazīšanas (optical character recognition — OCR) iestatījumus. Šī izvēlne ir redzama tikai tad, ja esat iegādājies un instalējis OCR risinājumu. PDF iestatījumi PDF versija  (1.5*) Arhivēšanas versija  (A‑1a*) Ļoti saspiests  ( Izslēgts *) Drošs  ( Izslēgts *) Arhivēšana (PDF/A)  ( Izslēgts *) Konfigurējiet skenētā attēla PDF iestatījumus. Opcija  Arhivēšanas versija  un  Arhivēšana (PDF/A)  tiek atbalstīta tikai tad, ja  PDF versija  ir 1.4. Opcija  Ļoti saspiests  ir redzama tikai tad, ja ir uzstādīts cietais disks. Satura veids Teksts Teksts/fotoattēls * Grafikas Fotoattēls Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta satura veidu. Satura avots Melnbalts lāzerprinteris Krāsu lāzerprinteris * Strūklprinteris Fotoattēls/filma Žurnāls Laikraksts Iespiedmašīna Cits Uzlabojiet izdruku, ņemot vērā oriģinālā dokumenta satura avotu. Krāsas Melnbalts Pelēks Krāsu * Automātiski, Iestatiet, lai printeris tvertu krāsainu vai melnbaltu faila saturu. Izšķirtspēja 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Iestatiet skenētā attēla izšķirtspēju. Intensitāte 1–9 (5*) Koriģējiet skenētā attēla intensitāti. Orientācija Portrets * Ainava Norādiet oriģinālā dokumenta orientāciju. Oriģināla izmēri Dažādi izmēri * Iestatiet oriģinālā dokumenta papīra izmērus. Puses Izslēgts * Garā mala Īsā mala Ja skenējat uz abām dokumenta pusēm, norādiet oriģinālā dokumenta orientāciju. Faila nosaukums Norādiet skenētā attēla faila nosaukumu. Attēlveidošanas papildu iestatījumi Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Krāsu balanss Ciāna (0*) Madženta (0*) Dzeltena (0*) Koriģējiet ciāna, madženta un dzeltenās krāsas intensitāti. Krāsas atmešana Krāsas atmešana  ( Nav *) Sarkanās krāsas noklusējuma slieksnis (128*) Zaļās krāsas noklusējuma slieksnis (128*) Zilās krāsas noklusējuma slieksnis (128*) Norādiet, kura krāsa ir jāatmet skenēšanas laikā, kā arī koriģējiet šīs krāsas atmešanas sliekšņa iestatījumu. Automātiska krāsu noteikšana Krāsu jutība (5*) Apgabala jutīgums  (5*) Skenēšanas bitu dziļums  (1 bits*) Minimālā skenēšanas izšķirtspēja  (300 dpi*) Konfigurējiet automātiskās krāsu noteikšanas iestatījumu. JPEG kvalitāte Labākais atbilstoši saturam * 5–95 Iestatiet skenētā attēla JPEG kvalitāti. Kontrasts Labākais atbilstoši saturam * 0–5 Norādiet skenētā attēla kontrastu. Fona noņemšana Fona noteikšana Atkarībā no satura * Fiksēts Līmenis (0*) Noņemiet oriģinālajā dokumentā fona krāsu vai attēla troksni. Izvēloties  Atkarībā no satura , tiek noņemta oriģinālā dokumenta fona krāsa. Izvēloties  Fiksēts , fotoattēlā tiek noņemts attēla troksnis. Spoguļattēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta spoguļattēlu. Negatīvs attēls Izslēgts * Ieslēgts Izveidojiet oriģinālā dokumenta negatīvu attēlu. Ēnu detalizētība no ‑4 līdz 4 (0*) Koriģējiet ēnu detalizētību skenētajā attēlā. Skenēt no malas līdz malai Izslēgts * Ieslēgts Skenējiet oriģinālo dokumentu no malas līdz malai. Asums 1–5 (3*) Koriģējiet skenētā attēla asumu. Temperatūra no ‑4 līdz 4 (0*) Iegūstiet zilāku vai sarkanāku oriģinālā dokumenta izdruku. Tukšas lapas Tukšu lapu noņemšana  ( Noņemt *) Tukšu lapu noteikšana  (5*) Norādiet skenēšanas iestatījumu saistībā ar tukšām lapām oriģinālajā dokumentā. Administratora vadīklas Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Teksta noklusējums 5–95 (75*) Iestatiet skenētā attēla teksta kvalitāti. Teksta/fotoattēla noklusējums 5–95 (75*) Iestatiet skenētā attēla teksta un fotoattēla kvalitāti. Fotoattēla noklusējums 5–95 (50*) Iestatiet skenētā fotoattēla kvalitāti. Izmantot vairāku lapu TIFF Izslēgts Ieslēgts * Iespējojiet vairāku TIFF attēlu skenēšanu vienā TIFF failā. TIFF saspiešanas līmenis LZW * JPEG Norādiet TIFF failu saspiešanas veidu. Pielāgotu darbu skenēšana Izslēgts * Ieslēgts Iestatiet, lai printeris skenētu pirmo oriģinālo dokumentu kopu, izmantojot norādītos iestatījumus, un pēc tam skenētu nākamo kopu ar tiem pašiem vai citiem iestatījumiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Skenēšanas priekšskatījums Izslēgts Ieslēgts * Parādiet oriģinālā dokumenta skenējuma priekšskatījumu. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Koriģēt ADF šķībumu Izslēgts Ieslēgts * Iestatiet, lai printeris skenētajos dokumentos koriģētu sašķiebtus attēlus, izmantojot ADF. izvēlne Skenēšana no zibatmiņas diska"},{"UUID":"cd0eb301-9dc8-4fc3-8b9b-83435e5c64f5","title":"USB disks","link":"flash-drive-scan-topic.html","desc":"drukāšana no zibatmiņas diska Izvēlnes","descFull":"drukāšana no zibatmiņas diska Izvēlnes  Drukāšana no zibatmiņas diska  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Eksemplāru skaits 1-9999 (1*) Iestatiet eksemplāru skaitu. Papīra avots Paplāte  [x] (1*) Daudzfunkciju padevējs Manuāla papīra padeve Manuāla aplokšņu padeve Iestatiet drukas darbu papīra avotu. Salikt (1,1,1) (2,2,2) (1,2,3) (1,2,3)* Drukājot vairākus darba eksemplārus, drukas darba lapas varat salikt konkrētā secībā. Puses 1 puse 2 puses Norādiet, vai jādrukā uz vienas papīra puses vai abām. Skavošana Izslēgts * 1 skava, augšējais kreisais stūris 2 skavas, pa kreisi 1 skava, augšējais labais stūris 2 skavas, augšā 1 skava, apakšējais kreisais stūris 2 skavas, apakšā 1 skava, apakšējais labais stūris 2 skavas, pa labi 4 skavas Norādiet skavošanas vietu visiem drukas darbiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar skavotāju. Caurumotājs Izslēgts * 2 caurumi 3 caurumi 4 caurumi Iestatiet caurumotāja režīmu visiem drukas darbiem. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts apdarinātājs ar caurumotāju. Ofseta lapas Nav * Starp eksemplāriem Starp darbiem Iestatiet ofsetu katram drukas darbam vai katram drukas darba eksemplāram. Iestatījums  Starp eksemplāriem  nosaka ofsetu katram drukas darbam, ja opcijas  Salikt  iestatījums ir  Ieslēgts  [1,2,1,2,1,2]. Ja opcijas  Salikt  iestatījums ir  Izslēgts  [1,1,1,2,2,2], ofsets tiek iestatīts katrai izdrukāto lapu kopai, piemēram, visām lapām, kas norādītas kā 1. lapa un visām, kas norādītas kā 2. lapa. Izvēloties  Starp darbiem , visam drukas darbam tiek iestatīta vienāda ofseta pozīcija neatkarīgi no izdruku skaita. Apvēršanas veids Garā mala * Īsā mala Nosakiet, kura papīra mala ir saistīta, veicot divpusējo drukāšanu. Lapas vienā pusē Izslēgts * 2 lapas vienā pusē 3 lapas vienā pusē 4 lapas vienā pusē 6 lapas vienā pusē 9 lapas vienā pusē 12 lapas vienā pusē 16 lapas vienā pusē Drukājiet vairākus lapas attēlus uz vienas papīra loksnes puses. Lapas vienā pusē, virziens Horizontāli * Apvērsti horizontāli Apvērsti vertikāli Vertikāli Norādiet vairāku lapu attēlu novietojumu, ja tiek lietota izvēlne  Lapas vienā pusē . Lapas vienā pusē, orientācija Automātiski * Ainava Portrets Norādiet vairāku lapu attēlu orientāciju, ja tiek lietota izvēlne  Lapas vienā pusē . Lapas vienā pusē, apmale Nav * Nepārtraukta Drukājiet apmali ap katru lapas attēlu, ja tiek lietota izvēlne  Lapas vienā pusē . Atdalošās lapas Izslēgts * Starp eksemplāriem Starp darbiem Starp lapām Drukājot ievietojiet tukšas atdalošās lapas. Atdalošo lapu avots Paplāte  [x] (1*) Daudzfunkciju padevējs Norādiet atdalošās lapas papīra avotu. Tukšas lapas Nedrukāt * Drukāt Drukājiet darbā tukšas lapas. izvēlne drukāšana no zibatmiņas diska"},{"UUID":"a910244a-d366-4ca5-af73-b4c473651013","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"Tīklu pārskats Izvēlnes  Tīklu","descFull":"Tīklu pārskats Izvēlnes  Tīklu pārskats  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Aktīvs adapteris Automātiski * Standarta tīkls Bezvadu Norādiet tīkla savienojuma veidu. Izvēlne  Bezvadu  ir pieejama tikai tajos printeros, kas ir pievienoti bezvadu tīklam. Tīkla statuss Skatiet printera tīkla savienojuma statusu. Rādīt tīkla statusu printerī Izslēgts Ieslēgts * Skatiet tīkla statusu displejā. Ātrums, dupleksi Skatiet pašreiz aktīvās tīkla kartes ātrumu. IPv4 Skatiet IPv4 adresi. Visas IPv6 adreses Skatiet visas IPv6 adreses. Atiestatīt drukas serveri Atiestatiet visus aktīvos tīkla savienojumus ar printeri. Šis iestatījums noņem visus tīkla konfigurācijas iestatījumus. Tīkla darba taimauts Izslēgts Ieslēgts * (90  sekundes ) Iestatiet laika periodu, pēc kura printeris atceļ tīkla drukas darbu. Lapa Reklāmkarogs Izslēgts * Ieslēgts Izdrukājiet lapu Reklāmkarogs. Opcijas Skenēt uz datoru porta diapazons Norādiet derīgu porta diapazonu printeriem, kas atrodas aiz portu bloķējošā ugunsmūra. Iespējot tīkla savienojumus Izslēgts Ieslēgts * Iespējojiet, lai printeris varētu izveidot savienojumu ar tīklu. Iespējot LLDP Izslēgts * Ieslēgts Printerī iespējojiet saites slāņa noteikšanas protokolu (Link Layer Discovery Protocol — LLDP). izvēlne Tīklu pārskats"},{"UUID":"53dbfc9a-b4a8-4225-af45-7b61d34d1cdc","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"Bezvadu Šī izvēlne ir pieejama","descFull":"Bezvadu Šī izvēlne ir pieejama tikai tajos printeros, kas ir pievienoti Wi-Fi tīklam, vai printeros, kuros ir bezvadu tīkla adapteris. Izvēlnes  Bezvadu  iestatījumi un to apraksti Izvēlnes vienums Apraksts Iestatīšana, izmantojot mobilo lietotni Konfigurējiet Wi‑Fi savienojumu, izmantojot Lexmark Mobile Assistant. Iestatīšana printera panelī Izvēlēties tīklu Pievienot Wi-Fi tīklu Tīkla nosaukums Tīkla režīms Infrastruktūra Bezvadu drošības režīms Atspējots * WEP WPA2/WPA - Personal WPA2 - Personal 802.1x - RADIUS Konfigurējiet Wi-Fi savienojumu, izmantojot vadības paneli. 802.1x - RADIUS  var konfigurēt, tikai izmantojot serveri Embedded Web Server. Wi‑Fi Protected Setup WPS automātiskā noteikšana Izslēgts Ieslēgts * Sākšanas ar pogu metode Sākšanas ar PIN metode Izveidojiet Wi-Fi tīklu un iespējojiet tīkla drošību. Opcija  WPS automātiskā noteikšana  ir redzama tikai tad, ja  bezvadu drošības režīma  iestatījums ir  WEP . Sākšanas ar pogu metode  ļauj pievienot printeri Wi-Fi tīklam, konkrētā laika periodā nospiežot pogas gan uz printera, gan piekļuves punkta (bezvadu maršrutētāja). Sākšanas ar PIN metode  ļauj pievienot printeri Wi-Fi tīklam, ja printera PIN tiek ievadīts piekļuves punkta bezvadu iestatījumos. Tīkla režīms BSS veids Infrastruktūra * Norādiet tīkla režīmu. Saderība 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2,4 GHz/5 GHz) 802.11a/n/ac (5 GHz) Norādiet Wi-Fi tīkla standartu. Opcija  802.11a/b/g/n/ac (2,4 GHz/5 GHz))  un  802.11a/n/ac (5 GHz)  ir redzama tikai tad, ja ir instalēta Wi‑Fi opcija. Bezvadu drošības režīms Atspējots * WEP WPA2/WPA-Personal WPA2-Personal 802.1x - RADIUS Iestatiet drošības režīmu, kāds jāizmanto, kad printeris tiek pievienots Wi-Fi ierīcēm. 802.1x - RADIUS  var konfigurēt, tikai izmantojot serveri Embedded Web Server. WEP autentifikācijas režīms Automātiski * Atvērts Kopīgs Iestatiet, kāds printerī ir protokola WEP tips. Šis izvēlnes vienums ir redzams tikai tad, ja  bezvadu drošības režīma  iestatījums ir  WEP . Iestatīt WEP atslēgu Norādiet WEP paroli, lai veidotu drošu Wi-Fi savienojumu. WPA2/WPA Personal AES Iespējojiet Wi-Fi drošību, izmantojot Wi-Fi aizsargāto pieeju (WPA). Šis izvēlnes vienums ir redzams tikai tad, ja  bezvadu drošības režīma  iestatījums ir  WPA2/WPA-Personal . Iestatīt sākotnēji kopīgotu atslēgu Iestatiet droša Wi-Fi savienojuma paroli. WPA2-Personal AES Iespējojiet Wi-Fi drošību, izmantojot WPA2. Šis izvēlnes vienums ir redzams tikai tad, ja  bezvadu drošības režīma  iestatījums ir  WPA2-Personal . 802.1x šifrēšanas režīms WPA+ WPA2 * Iespējojiet Wi-Fi drošību, izmantojot 802.1x standartu. Šis izvēlnes vienums ir redzams tikai tad, ja  bezvadu drošības režīma  iestatījums ir  802.1x - RADIUS . 802.1x - RADIUS  var konfigurēt, tikai izmantojot serveri Embedded Web Server. IPv4 Iespējot DHCP Ieslēgts * Izslēgts Iestatīt statisku IP adresi IP adrese Tīkla maska Vārteja Iespējojiet un konfigurējiet printerī IPv4 iestatījumus. IPv6 Iespējot IPv6 Ieslēgts * Izslēgts Iespējot DHCPv6 Ieslēgts Izslēgts * Bezpavalstnieciskas adreses automātiska konfigurēšana Ieslēgts * Izslēgts DNS servera adrese Manuāli piešķirta IPv6 adrese Manuāli piešķirts IPv6 maršrutētājs Adreses prefikss Visas IPv6 adreses Visu IPv6 maršrutētāju adreses Iespējojiet un konfigurējiet printerī IPv6 iestatījumus. Tīkla adrese UAA LAA Skatiet tīkla adreses. PCL SmartSwitch Izslēgts Ieslēgts * Iestatiet printeri automātiski pārslēgt PCL emulāciju, ja tas ir nepieciešams drukas darbam neatkarīgi no printera noklusējuma valodas. Ja iestatījums  PCL SmartSwitch  ir izslēgts, printeris nepārbauda ienākošos datus un izmanto noklusējuma printera valodu, kas norādīta izvēlnē  Iestatīšana . PS SmartSwitch Izslēgts Ieslēgts * Iestatiet printeri automātiski pārslēgt PS emulāciju, ja tas ir nepieciešams drukas darbam neatkarīgi no printera noklusējuma valodas. Ja iestatījums  PS SmartSwitch  ir izslēgts, printeris nepārbauda ienākošos datus un izmanto noklusējuma printera valodu, kas norādīta izvēlnē  Iestatīšana . Darbu ievietošana buferī Ieslēgts Izslēgts * Pirms drukāšanas īslaicīgi saglabājiet drukas darbus printera cietajā diskā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Mac binārais PS Automātiski * Ieslēgts Izslēgts Iestatiet printeri apstrādāt Macintosh bināros PostScript drukas darbus. Iestatījums  Ieslēgts  liek apstrādāt neapstrādātus binārus PostScript drukas darbus. Iestatījums  Izslēgts  liek filtrēt drukas darbus, izmantojot standarta protokolu. izvēlne Bezvadu"},{"UUID":"e711e669-fb4f-4345-9c7c-bf8029ba79fc","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Izvēlnes  Wi‑Fi","descFull":"Wi‑Fi Direct Izvēlnes  Wi‑Fi Direct  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Iespējot Wi‑Fi Direct Ieslēgts Izslēgts * Iestatiet, lai printeris tieši veidotu savienojumu ar Wi-Fi ierīcēm. Wi‑Fi Direct nosaukums Norādiet Wi-Fi Direct tīkla nosaukumu. Wi‑Fi Direct parole Iestatiet paroli, lai autentificētu un pārbaudītu lietotājus Wi‑Fi savienojumā. Rādīt paroli iestatīšanas lapā Izslēgts Ieslēgts * Rādiet  Wi‑Fi Direct paroli tīkla iestatīšanas lapā . Ieteicamā kanāla numurs 1–11 Automātiski * Iestatiet vēlamo Wi‑Fi tīkla kanālu. Grupas īpašnieka IP adrese Norādiet grupas īpašnieka IP adresi. Automātiski akceptēt sākšanas ar pogu pieprasījumus Izslēgts * Ieslēgts Automātiski akceptējiet pieprasījumus izveidot savienojumu ar tīklu. Automātiska klientu akceptēšana nav droša. izvēlne Wi‑Fi Direct"},{"UUID":"2735e7f2-8ffa-4e6d-824d-360e1f29fa0f","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"AirPrint Šī izvēlne ir redzama","descFull":"AirPrint Šī izvēlne ir redzama tikai serverī Embedded Web Server. Izvēlnes  AirPrint  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Visas AirPrint funkcijas Skatiet printera AirPrint statusu. Iespējot AirPrint Ieslēgts * Izslēgts Iespējojiet AirPrint funkciju. Šis izvēlnes vienums parādās tikai, ja Internet Printing Protocol (IPP) vai mDNS ir atspējots. Bonjour nosaukums Šeit identificēts printera apzīmējums un atrašanās vieta. Uzņēmuma nosaukums Organizācijas vienība Printera atrašanās vieta Printera garums Printera platums Printera augstums Vairāk opciju izvēlne AirPrint"},{"UUID":"df5ddbe7-36a6-457a-bbb9-11431824d294","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"mobilo pakalpojumu pārvaldība Šī izvēlne","descFull":"mobilo pakalpojumu pārvaldība Šī izvēlne ir redzama tikai serverī Embedded Web Server. Izvēlnes  Mobilo pakalpojumu pārvaldība  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Iespējot IPP drukāšanu Ieslēgts * Izslēgts Opcija nodrošina drukāšanu no mobilajām ierīcēm, izmantojot protokolu Internet Printing Protocol (IPP). Iespējot IPP faksu Ieslēgts * Izslēgts Opcija ļauj sūtīt faksus, izmantojot protokolu Internet Printing Protocol (IPP). Iespējot IPP, izmantojot USB Ieslēgts * Izslēgts Opcija ļauj drukāt skenēšanas darbus, izmantojot USB savienojumu. Iespējot skenēšanu Ieslēgts * Izslēgts Opcija nodrošina skenēšanu, izmantojot eSCL protokolu. Iespējot Mopria Discovery Ieslēgts * Izslēgts Opcija nodrošina to, ka printeri var atpazīt ierīces ar iespējotu Mopria. izvēlne mobilo pakalpojumu pārvaldība"},{"UUID":"e011b1ce-e686-410d-949b-834ba25f03a0","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"Ethernet Izvēlnes  Ethernet ","descFull":"Ethernet Izvēlnes  Ethernet  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Tīkla ātrums Skatiet aktīvā tīkla adaptera ātrumu. IPv4 Iespējot DHCP  ( Ieslēgts *) Iestatīt statisku IP adresi Konfigurējiet IPv4 iestatījumus. IPv6 Iespējot IPv6  ( Ieslēgts *) Iespējot DHCPv6  ( Izslēgts *) Bezpavalstnieciskas adreses automātiska konfigurēšana  ( Ieslēgts *) DNS servera adrese Manuāli piešķirta IPv6 adrese Manuāli piešķirts IPv6 maršrutētājs Adreses prefikss (64*) Visas IPv6 adreses Visu IPv6 maršrutētāju adreses Konfigurējiet IPv6 iestatījumus. Tīkla adrese UAA LAA Norādiet tīkla adresi. PCL SmartSwitch Izslēgts Ieslēgts * Iestatiet printeri automātiski pārslēgt PCL emulāciju, ja tas ir nepieciešams drukas darbam neatkarīgi no printera noklusējuma valodas. Ja šis iestatījums ir atspējots, printeris nepārbauda ienākošos datus un izmanto noklusējuma printera valodu, kas norādīta izvēlnē  Iestatīšana . PS SmartSwitch Izslēgts Ieslēgts * Iestatiet printeri automātiski pārslēgt PostScript emulāciju, ja tas ir nepieciešams drukas darbam neatkarīgi no printera noklusējuma valodas. Ja šis iestatījums ir atspējots, printeris nepārbauda ienākošos datus un izmanto noklusējuma printera valodu, kas norādīta izvēlnē  Iestatīšana . Darbu ievietošana buferī Izslēgts * Ieslēgts Pirms drukāšanas īslaicīgi saglabājiet darbus cietajā diskā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Mac binārais PS Automātiski * Ieslēgts Izslēgts Iestatiet printeri apstrādāt Macintosh bināros PostScript drukas darbus. Izvēloties iestatījumu  Automātiski , drukas darbi no datoriem tiek apstrādāti, izmantojot Windows vai Macintosh operētājsistēmas. Iestatījums  Izslēgts  liek filtrēt PostScript drukas darbus, izmantojot standarta protokolu. Energoefektīvs Ethernet Ieslēgts Izslēgts Automātiski * Samaziniet enerģijas patēriņu, kad printeris nesaņem datus no Ethernet tīkla. izvēlne Ethernet"},{"UUID":"6d571d87-e965-4861-883f-c2462e0397a5","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"TCP/IP Šī izvēlne ir redzama","descFull":"TCP/IP Šī izvēlne ir redzama tikai tīkla printeros vai printeros, kas ir pievienoti drukas serveriem. Izvēlnes  TCP/IP  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Iestatīt resursdatora nosaukumu Iestatiet pašreizējo TCP/IP resursdatora nosaukumu. Domēna nosaukums Iestatiet domēna nosaukumu. Atļaut DHCP/BOOTP atjaunināt NTP serveri Ieslēgts * Izslēgts Atļaujiet DHCP un BOOTP klientiem atjaunināt printera NTP iestatījumus. Nulles konfigurācijas nosaukums Norādiet nulles konfigurācijas tīkla pakalpojuma nosaukumu. Iespējot automātisku IP Ieslēgts * Izslēgts Automātiski piešķiriet IP adresi. DNS servera adrese Norādiet pašreizējo domēna nosaukumu sistēmas (DNS) servera adresi. Rezerves DNS servera adrese Norādiet rezerves DNS servera adreses. Rezerves DNS servera 2. adrese Rezerves DNS servera 3. adrese Domēna meklēšanas secība Norādiet domēnu nosaukumu sarakstu, kurā meklēt printeri un tā resursus, kas atrodas dažādos domēnos tīklā. Iespējot DDNS Izslēgts * Ieslēgts Atjauniniet dinamiskās DNS iestatījumus. DDNS TTL 300-31 536 000 sekundes (3600*) Norādiet pašreizējos DDNS iestatījumus. Noklusējuma TTL 5-254 sekundes (254*) DDNS atsvaidzināšanas laiks 300-31 536 000 sekundes (6 048 00*) Iespējot mDNS Ieslēgts * Izslēgts Atjauniniet multiraides DNS iestatījumus. WINS servera adrese Norādiet Windows interneta nosaukumdošanas pakalpojuma (WINS) servera adresi. Iespējot BOOTP Izslēgts * Ieslēgts Atļaujiet BOOTP piešķirt printerim IP adresi. Ierobežoto serveru saraksts Norādiet TCP savienojumu IP adresi. Lai atdalītu IP adreses, izmantojiet komatu. Varat pievienot līdz 50 IP adresēm. Ierobežoto serveru saraksta opcijas Bloķēt visus portus* Bloķēt tikai drukāšanu Bloķēt tikai drukāšanu un HTTP Norādiet, kā sarakstā iekļautās IP adreses var piekļūt drukāšanas funkcijai. MTU 256-1500 (1500*) Norādiet maksimālās pārraides vienības (MTU) parametru TCP savienojumiem. Neapstrādātas drukas ports 1–65 535 (9100*) Norādiet neapstrādātas drukas porta skaitli tīklā pievienotajiem printeriem. Izejošās plūsmas maksimālais ātrums Atspējots * Iespējots 100-1 000 000 (100 000*) Iespējojiet printera maksimālās pārraides līmeni. Iespējot TLSv1.0 Ieslēgts * Izslēgts Iespējojiet TLSv1.0 protokolu. Iespējot TLSv1.1 Ieslēgts * Izslēgts Iespējojiet TLSv1.1 protokolu. SSL šifrēšanas saraksts Norādiet šifrēšanas algoritmus, kas ir jāizmanto SSL vai TLS savienojumiem. izvēlne TCP/IP"},{"UUID":"36fb395d-9ea7-4d2c-a613-91623fd86db2","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"SNMP Šī izvēlne ir redzama","descFull":"SNMP Šī izvēlne ir redzama tikai tīkla printeros vai printeros, kas ir pievienoti drukas serveriem. Izvēlnes  SNMP  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. SNMP versija 1 un 2c Iespējots Izslēgts Ieslēgts * Atļaut SNMP kopu Izslēgts Ieslēgts * Iespējot PPM MIB Izslēgts Ieslēgts * SNMP kopiena Konfigurējiet vienkāršā tīkla pārvaldības protokola (Simple Network Management Protocol — SNMP) versijas 1 un 2c, lai instalētu printera draiverus un lietojumprogrammas. SNMP versija 3 Iespējots Izslēgts Ieslēgts * Konteksta nosaukums Iestatīt lasīšanas/rakstīšanas akreditācijas datus Lietotājvārds Autentificēšanas parole Konfidencialitātes parole Iestatīt tikai lasīšanas akreditācijas datus Lietotājvārds Autentificēšanas parole Konfidencialitātes parole Autentifikācijas jaucējkods MD5 SHA1 * Minimālais autentifikācijas līmenis Bez autentificēšanas, bez konfidencialitātes Autentificēšana, bez konfidencialitātes Autentificēšana, konfidencialitāte * Konfidencialitātes algoritms DES AES‑128 * Konfigurējiet SNMP versiju 3, lai uzstādītu un atjauninātu printera drošību. izvēlne SNMP"},{"UUID":"56457383-a160-4422-8d5f-c8f0c2540dd8","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"IPSec Šī izvēlne ir redzama","descFull":"IPSec Šī izvēlne ir redzama tikai tīkla printeros vai printeros, kas ir pievienoti drukas serveriem. Izvēlnes  IPSec  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Iespējot IPSec Izslēgts * Ieslēgts Iespējojiet protokolu IPSec (Internet Protocol Security — IPSec). Pamata konfigurācija Noklusējums * Saderība Drošs Iestatiet IPSec pamata konfigurāciju. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Iespējot IPSec  iestatījums ir  Ieslēgts . DH (Diffie‑Hellman) grupas priekšlikums modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Iestatiet IPSec pamata konfigurāciju. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Pamata konfigurācija  iestatījums ir  Saderība . Ieteiktā šifrēšanas metode 3DES AES * Iestatiet šifrēšanas metodi. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Pamata konfigurācija  iestatījums ir  Saderība . Ieteiktā autentificēšanas metode SHA1 SHA256 * SHA512 Iestatiet autentificēšanas metodi. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Pamata konfigurācija  iestatījums ir  Saderība . IKE SA darbības laiks (stundas) 1 2 4 8 24* Norādiet IKE SA derīguma periodu. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Pamata konfigurācija  iestatījums ir  Drošs . IPSec SA darbības laiks (stundas) 1 2 4 8* 24 Norādiet IPSec SA derīguma periodu. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Pamata konfigurācija  iestatījums ir  Drošs . IPSec ierīces sertifikāts Norādiet IPSec sertifikātu. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Iespējot IPSec  iestatījums ir  Ieslēgts . Autentificēti savienojumi, izmantojot iepriekš zināmu atslēgu Resursdators  [x] Konfigurējiet autentificētus printera savienojumus. Šie izvēlnes vienumi ir redzami tikai tad, ja opcijas  Iespējot IPSec  iestatījums ir  Ieslēgts . Sertificēt autentificētus savienojumus Resursdators  [x]  Adrese[/apakštīkls] izvēlne IPSec"},{"UUID":"e167585d-6875-49c8-8939-3296d4bcd4b0","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"802.1x Šī izvēlne ir redzama","descFull":"802.1x Šī izvēlne ir redzama tikai tīkla printeros vai printeros, kas ir pievienoti drukas serveriem. Izvēlnes  802.1x  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Aktīvs Izslēgts * Ieslēgts Ļaujiet printerim pievienoties tīkliem, kuros jāveic autentifikācija, lai varētu piekļūt. 802.1X autentificēšana Ierīces pieteikšanās vārds Ierīces pieteikšanās parole Pārbaudīt Serve sertifikātu  ( Ieslēgts *) Iespējot notikumu reģistrēšanu  ( Izslēgts *) 802.1x ierīces sertifikāts Konfigurējiet 802.1x savienojuma autentificēšanas iestatījumus. Atļautie autentificēšanas mehānismi EAP ‑ MD5  ( Ieslēgts *) EAP - MSCHAPv2  ( Ieslēgts *) LEAP  ( Ieslēgts *) PEAP  ( Ieslēgts *) EAP - TLS  ( Ieslēgts *) EAP - TTLS  ( Ieslēgts *) TTLS autentificēšanas metode  ( MSCHAPv2 *) Konfigurējiet 802.1x savienojuma atļautos autentificēšanas mehānismus. izvēlne 802.1x"},{"UUID":"37612c13-ff35-4d20-b897-ea012e2fb755","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"LPD konfigurēšana Šī izvēlne ir","descFull":"LPD konfigurēšana Šī izvēlne ir redzama tikai tīkla printeros vai printeros, kas ir pievienoti drukas serveriem. Izvēlnes  LDP konfigurēšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. LPD taimauts 0–65535 sekundes (90*) Iestatiet taimautu, lai Line Printer Daemon (LPD) serveris pārtrauktu nebeidzami gaidīt uzkārušos vai nederīgus drukas darbus. LPD reklāmkaroga lapa Izslēgts * Ieslēgts Drukājiet reklāmkaroga lapu visos LPD drukas darbos. Reklāmkaroga lapa ir drukas darba pirmā lapa, kas tiek izmantota, lai atdalītu drukas darbus un identificētu drukas darba pieprasītāju. LPD noslēguma lapa Izslēgts * Ieslēgts Drukājiet noslēguma lapu visos LPD drukas darbos. Noslēguma lapa ir drukas darba pēdējā lapa. LPD rakstatgriezes pārslēgšana Izslēgts * Ieslēgts Iespējojiet rakstatgriezes pārslēgšanu. Rakstatgrieze ir mehānisms, kas printerim dod komandu pārvietot kursoru tās pašas rindiņas sākuma pozīcijā. izvēlne LPD konfigurēšana"},{"UUID":"6f565a8f-82ad-475f-a6b0-7b64e866ef44","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"HTTP/FTP iestatījumi Izvēlnes  HTTP/FTP","descFull":"HTTP/FTP iestatījumi Izvēlnes  HTTP/FTP iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Starpniekserveris HTPP starpniekservera IP adrese HTTP noklusējuma IP ports FTP starpniekservera IP adrese FTP noklusējuma IP ports Autentificēšana Lietotājvārds Parole Vietējie domēni Konfigurējiet HTTP un FTP servera iestatījumus. Citi iestatījumi Iespējot HTTP serveri  ( Ieslēgts *) Piekļūstiet serverim Embedded Web Server, lai pārraudzītu un pārvaldītu printeri. Citi iestatījumi Iespējot HTPPS  ( Ieslēgts *) Iespējojiet protokolu Hypertext Transfer Protocol Secure (HTTPS), lai šifrētu tos datus, kas tiek pārraidīti uz drukas serveri un no tā. Citi iestatījumi Piespiedu HTTP savienojumi  ( Izslēgts *) Iestatiet, lai printeris noteikti izmantotu HTTPS savienojumus. Citi iestatījumi Iespējot FTP/TFTP  ( Ieslēgts *) Sūtiet failus, izmantojot FTP/TFTP. Citi iestatījumi HTTPS ierīces sertifikāts  ( noklusējums *) Skatiet printerī lietoto HTTP ierīces sertifikātu. Citi iestatījumi HTTP/FTP pieprasījumu taimauts  (30*) Norādiet, pēc cik ilga laika tiek pārtraukts servera savienojums. Citi iestatījumi HTTP/FTP pieprasījumu atkārtojumi  (3*) Iestatiet, cik reižu tiek atkārtoti mēģināts izveidot HTTP/FTP servera savienojumu. izvēlne HTTP/FTP iestatījumi"},{"UUID":"ca1ce52a-0d18-4c12-ad89-531770fbda15","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"ThinPrint Izvēlnes  ThinPrint ","descFull":"ThinPrint Izvēlnes  ThinPrint  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Iespējot ThinPrint Izslēgts * Ieslēgts Drukājiet, izmantojot serveri ThinPrint. Porta numurs 4000–4999 (4000*) Iestatiet ThinPrint servera porta numuru. Joslas platums (biti sekundē) 100-1000000 (0*) Iestatiet datu pārraides ātrumu ThinPrint vidē. Paketes lielums (kilobaitos) 0-64000 (0*) Iestatiet paketes izmēru datu pārraidīšanai. izvēlne ThinPrint"},{"UUID":"0a445bad-ee86-4af7-9a6a-eae887e781ba","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"USB Izvēlnes  USB ","descFull":"USB Izvēlnes  USB  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. PCL SmartSwitch Izslēgts Ieslēgts * Iestatiet printeri pārslēgt PCL emulāciju, ja tas ir nepieciešams drukas darbam, kas ir saņemts, izmantojot USB portu, neatkarīgi no printera noklusējuma valodas. Ja šis iestatījums ir atspējots, printeris nepārbauda ienākošos datus un izmanto noklusējuma printera valodu, kas norādīta izvēlnē  Iestatīšana . PS SmartSwitch Izslēgts Ieslēgts * Iestatiet printeri pārslēgt PostScript emulāciju, ja tas ir nepieciešams drukas darbam, kas ir saņemts, izmantojot USB portu, neatkarīgi no printera noklusējuma valodas. Ja šis iestatījums ir atspējots, printeris nepārbauda ienākošos datus un izmanto noklusējuma printera valodu, kas norādīta izvēlnē  Iestatīšana . Darbu ievietošana buferī Izslēgts * Ieslēgts Pirms drukāšanas īslaicīgi saglabājiet darbus cietajā diskā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts cietais disks. Mac binārais PS Automātiski * Ieslēgts Izslēgts Iestatiet printeri apstrādāt Macintosh bināros PostScript drukas darbus. Izvēloties iestatījumu  Automātiski , drukas darbi no datoriem tiek apstrādāti, izmantojot Windows vai Macintosh operētājsistēmas. Iestatījums  Izslēgts  liek filtrēt PostScript drukas darbus, izmantojot standarta protokolu. Iespējot USB portu Izslēgts Ieslēgts * Iespējojiet priekšējo USB diska portu. izvēlne USB"},{"UUID":"6960134f-1ac3-462f-819a-4049c0ba7578","title":"Tīkls/porti","link":"network-overview-topic.html","desc":"Ārējas piekļuves tīklam ierobežošana Izvēlnes","descFull":"Ārējas piekļuves tīklam ierobežošana Izvēlnes  Ārējas piekļuves tīklam ierobežošana  iestatījumu vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Ārējas piekļuves tīklam ierobežošana Izslēgts * Ieslēgts Ierobežojiet piekļuvi tīkla vietnēm. Ārējā tīkla adrese Norādiet tīkla adreses, kurām ir ierobežota piekļuve. E-pasta adrese paziņojumiem Norādiet e-pasta adresi, uz kuru sūtīt paziņojumus par reģistrētajiem notikumiem. Ping biežums 1–300 (10*) Norādiet tīkla vaicājumu intervālu sekundēs. Tēma Norādiet paziņojuma e-pasta tēmu un ziņojumu. Ziņojums izvēlne Ārējas piekļuves tīklam ierobežošana"},{"UUID":"b2d19a8c-3dd2-4b18-8379-976d6f3f0475","title":"Cloud Services","link":"cloud-services-enrollment-topic.html","desc":"Cloud Services reģistrēšana Izvēlnes ","descFull":"Cloud Services reģistrēšana Izvēlnes  Cloud Services reģistrēšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Skatīt papildinformāciju Skatiet papildu informācija par Lexmark Cloud Services lietošanu. Iespējot saziņu ar Lexmark Cloud Services Izslēgts * Ieslēgts Iespējojiet, lai printeris varētu sazināties ar Lexmark Cloud Services. Skatīt pašreizējo stāvokli Skatiet printera un Lexmark Cloud Services savienojuma stāvokli. izvēlne Cloud Services reģistrēšana"},{"UUID":"4c731162-43cc-4f95-ad62-660c15fd7bbe","title":"Pieteikšanās metodes","link":"login-methods-subgroup.html","desc":"atļauju pārvaldīšana Izvēlnes  Atļauju","descFull":"atļauju pārvaldīšana Izvēlnes  Atļauju pārvaldīšana  vienumi un to apraksti Izvēlnes vienums Apraksts Piekļuve funkcijām Piekļūt adrešu grāmatai lietotnēs Modificēt adrešu grāmatu Pārvaldīt īsceļus Izveidot profilus Pārvaldīt grāmatzīmes drukāšana no zibatmiņas diska Krāsu drukāšana no zibatmiņas diska Skenēšana no zibatmiņas diska Kopēšanas funkcija Krāsainu kopiju drukāšana Krāsas atmešana E‑pasta funkcija Faksa funkcija FTP funkcija Izpildīt aizturētus faksus Piekļuve aizturētiem darbiem Lietošanas profili Atcelt darbus ierīcē Valodas maiņa Interneta drukas protokols (Internet Printing Protocol — IPP) Sākt skenēšanu attāli Melnbalta druka Krāsu druka Tīkla mape — skenēšana Cietais disks — drukāšana Cietais disks — krāsu druka Cietais disks — skenēšana Kontrolējiet piekļuvi printera funkcijām. Dažu izvēļņu vienumi ir redzami tikai tad, ja ir uzstādīts cietais disks vai viedais krātuves disks. Administratīvās izvēlnes Izvēlne Drošība Izvēlne Tīkls/porti Izvēlne Papīrs Izvēlne Atskaites Funkciju konfigurēšanas izvēlnes Izvēlne Izejmateriāli Izvēlne Ierīces karte Izvēlne Servisa inženieris Izvēlne Ierīce Kontrolējiet piekļuvi printera izvēļņu iestatījumiem. Ierīču pārvaldība Attāla pārvaldība Programmaparatūras atjaunināšana Lietotņu konfigurēšana Operatora paneļa bloķēšana Embedded Web Server piekļuve Importēt/eksportēt visus iestatījumus Dzēšana, pārtraucot lietošanu Cloud Services reģistrēšana Kontrolējiet piekļuvi printera pārvaldības iespējām. Lietotnes Jaunas lietotnes Slaidrāde Mainīt fona tapeti Ekrānsaudzētājs Card Copy skenēšanas centrs Pielāgotais skenēšanas centrs  [x] Kontrolējiet piekļuvi printera lietojumprogrammām. izvēlne atļauju pārvaldīšana"},{"UUID":"8b127bd0-a3c6-47d2-906a-81e6f3a62ad4","title":"Pieteikšanās metodes","link":"login-methods-subgroup.html","desc":"Vietējie konti Izvēlnes  Vietējie","descFull":"Vietējie konti Izvēlnes  Vietējie konti  vienumi un to apraksti Izvēlnes vienums Apraksts Grupu/atļauju pārvaldīšana Parādiet sarakstu ar visām printerī saglabātajām grupām. Pievienot lietotāju Lietotājvārds/parole Lietotājvārds Parole PIN Izveidojiet vietējos kontus un norādiet to piekļuvi printera funkcijām, administratīvajām izvēlnēm, printera pārvaldības opcijām un lietojumprogrammām. izvēlne Vietējie konti"},{"UUID":"5b7f55f9-b897-4817-8b17-75dfc08ec54f","title":"Pieteikšanās metodes","link":"login-methods-subgroup.html","desc":"Noklusējuma pieteikšanās metodes Šī izvēlne","descFull":"Noklusējuma pieteikšanās metodes Šī izvēlne ir redzama tikai tad, ja izvēlnē  Vietējie konti  tiek konfigurēti iestatījumi. Izvēlnes Noklusējuma pieteikšanās metodes vienumi un to apraksti Izvēlnes vienums Apraksts Vadības panelis Lietotājvārds/parole Lietotājvārds Parole PIN Norādiet noklusējuma pieteikšanās metodi, lai piekļūtu vadības panelim. Pārlūks Lietotājvārds/parole Lietotājvārds Parole PIN Norādiet noklusējuma pieteikšanās metodi, lai piekļūtu pārlūkam. izvēlne Noklusējuma pieteikšanās metodes"},{"UUID":"05978f90-6950-4c6a-96cf-7e01eb61f3c8","title":"Drošība","link":"login-methods-subgroup.html","desc":"USB ierīču grafika izveide Izvēlnes","descFull":"USB ierīču grafika izveide Izvēlnes  USB ierīču grafika izveide  vienumi un to apraksti Izvēlnes vienums Apraksts Grafiki Pievienot jaunu grafiku Ieplānojiet piekļuvi priekšējam USB portam. izvēlne USB ierīču grafika izveide"},{"UUID":"0d266476-4a48-424b-a855-477983b241c6","title":"Drošība","link":"login-methods-subgroup.html","desc":"Drošības audita žurnāls Izvēlnes ","descFull":"Drošības audita žurnāls Izvēlnes  Drošības audita žurnāls  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Iespējot auditu Izslēgts * Ieslēgts Reģistrējiet notikumus drošā audita žurnālā un attālajā Syslog. Iespējot attālo Syslog Izslēgts * Ieslēgts Sūtiet audita žurnālus uz attālu serveri. Attālais Syslog serveris Norādiet attālo Syslog serveri. Attālais Syslog ports 1–65535 (514*) Norādiet attālo Syslog portu. Attālā Syslog metode Normāls UDP * Stunnel Norādiet Syslog metodi, lai pārraidītu reģistrētos notikumus uz attālu serveri. Attālā Syslog funkcija 0 — Kernel ziņojumi 1 — lietotāja līmeņa ziņojumi 2 — pasta sistēma 3 — sistēmas dēmoni 4 — drošības/autorizācijas ziņojumi * 5 — Syslog iekšēji ģenerētie ziņojumi 6 — rindprintera apakšsistēma 7  — tīkla jaunumu apakšsistēma 8 — UUCP apakšsistēma 9 — pulksteņa dēmons 10 — drošības/autorizācijas ziņojumi 11 — FTP dēmons 12 — NTP apakšsistēma 13 — žurnāla audits 14 — žurnāla brīdinājums 15 — pulksteņa dēmons 16 — vietējai izmantošanai 0 (local0) 17 — vietējai izmantošanai 1 (local1) 18 — vietējai izmantošanai 2 (local2) 19 — vietējai izmantošanai 3 (local3) 20 — vietējai izmantošanai 4 (local4) 21 — vietējai izmantošanai 5 (local5) 22 — vietējai izmantošanai 6 (local6) 23 — vietējai izmantošanai 7 (local7) Norādiet funkcijas kodu, kuru printeris izmanto, sūtot reģistrētos notikumus uz attālu serveri. Reģistrējamo notikumu nozīmīgums 0 — ārkārtas situācija 1 — trauksme 2 — kritisks notikums 3 — kļūda 4 — brīdinājums * 5 — paziņojums 6 — informatīvs paziņojums 7 — atkļūdošana Norādiet reģistrējamo ziņojumu un notikumu iedalījumu pēc prioritātes līmeņa. Attālajā Syslog nereģistrētie notikumi Izslēgts * Ieslēgts Sūtiet visus notikumus uz attālo serveri neatkarīgi no to nozīmīguma. Administratora e-pasta adrese Sūtiet administratoram e-pasta paziņojumus par reģistrētajiem notikumiem. Sūtīt pa e-pastu brīdinājumu par izdzēstu žurnālu Izslēgts * Ieslēgts Sūtiet administratoram e-pasta paziņojumu par žurnāla ieraksta dzēšanu. Sūtīt pa e-pastu brīdinājumu par žurnāla aplaušanu Izslēgts * Ieslēgts Sūtiet administratoram e-pasta paziņojumu, ja žurnāls ir pilns un tiek sākta vecāko ierakstu pārrakstīšana. Visu darbību reģistrēšana Aplauzt vecākos ierakstus * Nosūtīt žurnālu pa e-pastu, pēc tam izdzēst visus ierakstus Atrisiniet žurnāla glabāšanas problēmas, kad žurnāls ir aizpildījis visu tam paredzēto vietu atmiņā. Sūtīt pa e-pastu brīdinājumu par % aizpildījumu Izslēgts * Ieslēgts Sūtiet administratoram e-pasta paziņojumu, kad žurnāls ir aizpildījis tam paredzēto vietu atmiņā. % aizpildījuma brīdinājuma līmenis 1–99 (90*) Sūtīt pa e-pastu brīdinājumu par eksportētu žurnālu Izslēgts * Ieslēgts Sūtiet administratoram e-pasta paziņojumu par žurnāla eksportēšanu. Sūtīt pa e-pastu brīdinājumu par žurnāla iestatījumu maiņu Izslēgts * Ieslēgts Sūtiet administratoram e-pasta paziņojumu, ja ir iestatīta opcija  Iespējot auditu . Žurnāla rindiņu beigas LF (\\n) * CR (\\r) CRLF (\\r\\n) Norādiet, kā žurnālfailā tiek pabeigta katra rindiņa. Digitāli parakstīt eksportētos žurnālus Izslēgts * Ieslēgts Pievienojiet digitālu parakstu katram eksportētajam žurnālfailam. Dzēst žurnālu Izdzēsiet visus audita žurnālus. Eksportēt žurnālu Syslog (RFC 5424) Syslog (RFC 3164) CSV Eksportējiet drošības žurnālu zibatmiņas diskā. izvēlne Drošības audita žurnāls"},{"UUID":"423819d4-1948-40fc-a77e-e696cbe3eb56","title":"Drošība","link":"login-methods-subgroup.html","desc":"Pieteikšanās ierobežojumi Izvēlnes  Pieteikšanās","descFull":"Pieteikšanās ierobežojumi Izvēlnes  Pieteikšanās ierobežojumi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Pieteikšanās kļūmes 1–10 (3*) Norādiet nesekmīgu pieteikšanās mēģinājumu skaitu, pirms lietotājs tiek bloķēts. Kļūmju laika periods 1–60 minūtes (5*) Norādiet laika periodu starp nesekmīgiem pieteikšanās mēģinājumiem, pirms lietotājs tiek bloķēts. Slēguma laiks 1–60 minūtes (5*) Norādiet bloķēšanas ilgumu. Tīmekļa pieteikšanās taimauts 1–120 minūtes (10*) Norādiet attālās pieteikšanās aizturi, pirms notiek automātiska lietotāja atteikšanās. izvēlne Pieteikšanās ierobežojumi"},{"UUID":"04eeab52-bf07-4eae-9c2b-77276ae41eb5","title":"Drošība","link":"login-methods-subgroup.html","desc":"Konfidenciālas drukāšana iestatīšana Izvēlnes ","descFull":"Konfidenciālas drukāšana iestatīšana Izvēlnes  Konfidenciālas drukāšanas iestatīšana  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Maksimālais nederīga PIN skaits 2–10 Iestatiet, cik reižu var ievadīt nederīgu PIN. Kad tiek sasniegts šis ierobežojums, konkrētajam lietotājvārdam atbilstošie drukas darbi tiek izdzēsti. Konfidenciālu darbu derīguma termiņš Izslēgts * 1 stunda 4 stundas 24 stundas 1 nedēļa Katram aizturētajam darbam iestatiet individuālu derīguma termiņu, pirms tas automātiski tiek izdzēsts no printera atmiņas vai cietā diska. Aizturētais darbs ir  Konfidenciāls ,  Atkārtots ,  Rezervēts  vai  Pārbaudāms . Atkārtotu darbu derīguma termiņš Izslēgts * 1 stunda 4 stundas 24 stundas 1 nedēļa Iestatiet derīguma termiņu drukas darbam, kuru vēlaties atkārtot. Pārbaudāmu darbu derīguma termiņš Izslēgts * 1 stunda 4 stundas 24 stundas 1 nedēļa Iestatiet derīguma termiņu tāda darba eksemplāra drukāšanai, lai pārbaudītu kvalitāti pirms pārējo eksemplāru drukāšanas. Rezervētu darbu derīguma termiņš Izslēgts * 1 stunda 4 stundas 24 stundas 1 nedēļa Iestatiet derīguma termiņu tādiem darbiem, kurus vēlaties saglabāt printerī, lai drukātu vēlāk. Pieprasīt visu darbu aizturēšanu Izslēgts * Ieslēgts Iestatiet printeri aizturēt visus drukas darbus. Paturēt dublētus dokumentus Izslēgts * Ieslēgts Iestatiet, lai printeris paturētu visus dokumentus ar vienādu faila nosaukumu. izvēlne Konfidenciālas drukāšana iestatīšana"},{"UUID":"dea92358-7d61-4fa7-8c4c-5c970d0ea20e","title":"Drošība","link":"login-methods-subgroup.html","desc":"Diska šifrēšana Šis izvēlnes vienums","descFull":"Diska šifrēšana Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts printera cietais disks vai viedais krātuves disks. Izvēlnes  Diska šifrēšana  vienumi un to apraksti Izvēlnes vienums Apraksts Cietais disks Parāda cietā diska šifrēšanas statusu. Viedais krātuves disks Parāda viedā krātuves diska (ISD) šifrēšanas statusu. ISD tiek automātiski atspējots, ja ir uzstādīts cietais disks. izvēlne Diska šifrēšana"},{"UUID":"55fae89e-1414-4b3e-bec8-d51f60cc2d52","title":"Drošība","link":"login-methods-subgroup.html","desc":"Dzēst pagaidu datu failus Izvēlnes","descFull":"Dzēst pagaidu datu failus Izvēlnes Dzēst pagaidu datu failus vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Saglabāts iebūvētajā atmiņā Izslēgts * Ieslēgts Dzēsiet failus, kas ir saglabāti printera atmiņā. Saglabāts cietajā diskā Dzēšana 1 reizi * Dzēšana 3 reizes Dzēšana 7 reizes Dzēsiet visus failus, kas ir saglabāti printera cietajā diskā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts printera cietais disks. izvēlne Dzēst pagaidu datu failus"},{"UUID":"d4a92f4b-bfc6-4a30-99e2-d2a83145a599","title":"Drošība","link":"login-methods-subgroup.html","desc":"Risinājumu LDAP iestatījumi Izvēlnes ","descFull":"Risinājumu LDAP iestatījumi Izvēlnes  Risinājumu LDAP iestatījumi  vienumi un to apraksti Izvēlnes vienums Apraksts Sekot LDAP attiecinājumiem Izslēgts * Ieslēgts Dažādos domēna serveros meklējiet tāda lietotāja kontu, kurš ir pieteicies. LDAP sertifikāta pārbaude Jā Nē * Iespējojiet LDAP sertifikātu verifikāciju. izvēlne Risinājumu LDAP iestatījumi"},{"UUID":"bbf3eadd-d0e0-4f5c-bf85-5dfe2dfcea03","title":"Drošība","link":"login-methods-subgroup.html","desc":"Dažādi Izvēlnes  Dažādi ","descFull":"Dažādi Izvēlnes  Dažādi  vienumi un to apraksti Izvēlnes vienums Apraksts Zvaigznīte (*) blakus vērtībai norāda rūpnīcas noklusējuma iestatījumu. Aizsargātas funkcijas Rādīt * Slēpt Parādiet visas funkcijas, kuras aizsargā funkciju piekļuves vadība (Function Access Control — FAC), neatkarīgi no lietotājam piešķirtās drošības atļaujas. Izvēloties  Slēpt , tiek rādītas tikai tās ar FAC aizsargātās funkcijas, kurām lietotājs var piekļūt. Drukāšanas atļauja Izslēgts * Ieslēgts Ļaujiet lietotājam pirms drukāšanas pieteikties. Noklusējuma drukāšanas atļaujas pieteikumvārds Lietotājvārds/parole * Lietotājvārds Iestatiet  Drukāšanas atļaujas  noklusējuma pieteikumvārdu. Drošības atiestatīšanas tiltslēgs Iespējot piekļuvi “Viesis” * Bez ietekmes Norādiet, kāda lietotājam ir piekļuve printerim. Iespējot piekļuvi “Viesis”  ļauj ikvienam lietotājam piekļūt visiem printera iestatījumiem. Bez ietekmes  var liegt piekļuvi printerim, ja nav pieejama nepieciešamā drošības informācija. Lietot viedo krātuves disku lietotāja datiem Izslēgts Ieslēgts * Iespējojiet, lai viedais krātuves disks saglabātu lietotāja datus. Šis izvēlnes vienums atspējots, ja ir uzstādīts cietais disks. Minimālais PIN garums 0-32 (0*) Norādiet paroles garumu. Iespējot paroles/PIN apskati Izslēgts * Ieslēgts Parādiet paroli vai personas identifikācijas numuru. izvēlne Dažādi"},{"UUID":"24a12be9-0966-4255-ab03-009fa1f20c33","title":"Atskaites","link":"menu-settings-page-topic.html","desc":"Izvēļņu iestatījumu lapa Izvēlnes ","descFull":"Izvēļņu iestatījumu lapa Izvēlnes  Izvēļņu iestatījumu lapa  vienums un tā apraksts Izvēlnes vienums Apraksts Izvēļņu iestatījumu lapa Izdrukājiet atskaiti ar printera izvēlnēm. izvēlne Izvēļņu iestatījumu lapa"},{"UUID":"df0154fe-561a-4bca-b707-f483fbe4a5fe","title":"Atskaites","link":"menu-settings-page-topic.html","desc":"Ierīce Ierīce Izvēlnes  Ierīce","descFull":"Ierīce Ierīce Izvēlnes  Ierīce  vienumi un to apraksti Izvēlnes vienums Apraksts Ierīces informācija Izdrukājiet atskaiti ar informāciju par printeri. Ierīces statistikas dati Izdrukājiet atskaiti par printera lietojumu un izejmateriālu statusu. Profilu saraksts Izdrukājiet sarakstu ar printerī saglabātajiem profiliem. Atskaite par pamatlīdzekli Izdrukājiet diagnosticēšanas rīku, lai noteiktu drukāšanas problēmas. Lai saturs netiktu apgriezts, atskaiti drukājiet uz Letter vai A4 formāta papīra. izvēlne Ierīce"},{"UUID":"59b5d2af-946d-4af3-aa7e-cd6d7a1f606d","title":"Atskaites","link":"menu-settings-page-topic.html","desc":"Drukāt Izvēlnes Drukāšana vienumi un","descFull":"Drukāt Izvēlnes Drukāšana vienumi un to apraksti Izvēlnes vienums Apraksts Fontu drukāšana PCL fonti PS Fonti Izdrukājiet paraugus un informāciju par fontiem, kas ir pieejami katrā printera valodā. Demonstrācijas lapas drukāšana Demonstrācijas lapa Izdrukājiet lapu, kurā redzamas printera funkcijas un atbalstītie risinājumi. Direktoriju drukāšana Izdrukājiet resursus, kas ir saglabāti zibatmiņas diskā vai printera cietajā diskā. Šis izvēlnes vienums ir redzams tikai tad, ja ir uzstādīts zibatmiņas disks vai printera cietais disks. izvēlne Drukāt"},{"UUID":"ab39d090-d81d-4918-a307-0e12b8f91c14","title":"Atskaites","link":"menu-settings-page-topic.html","desc":"Īsceļi Izvēlnes  Īsceļi ","descFull":"Īsceļi Izvēlnes  Īsceļi  vienumi un to apraksti Izvēlnes vienums Apraksts Visi īsceļi Izdrukājiet atskaiti, kurā ir uzskaitīti visi printerī saglabātie īsceļi. Faksa īsceļi  ir redzams tikai tad, ja ir uzstādīts fakss. Faksa īsceļi Kopēšanas īsceļi E-pasta īsceļi FTP īsceļi Tīkla mapes īsceļi izvēlne Īsceļi"},{"UUID":"7f0754ca-7b17-4216-bfc6-cd65d087dea1","title":"Atskaites","link":"menu-settings-page-topic.html","desc":"Fakss Šī izvēlne ir redzama","descFull":"Fakss Šī izvēlne ir redzama tikai tad, ja ir konfigurēts fakss un  Iespējot darbu žurnālu  iestatījums ir  Ieslēgts . Izvēlnes  Fakss  vienumi un to apraksti Izvēlnes vienums Apraksts Faksa darbu žurnāls Izdrukājiet atskaiti par pēdējiem 200 izpildītajiem faksa darbiem. Faksa izsaukumu žurnāls Izdrukājiet atskaiti par pēdējiem 100 mēģinātajiem, saņemtajiem un bloķētajiem zvaniem. izvēlne Fakss"},{"UUID":"0d871449-7b8d-4025-bdc9-c22525c7241d","title":"Atskaites","link":"menu-settings-page-topic.html","desc":"Tīkls Izvēlnes  Tīkls ","descFull":"Tīkls Izvēlnes  Tīkls  vienums un tā apraksts Izvēlnes vienums Apraksts Tīkla iestatīšanas lapa Izdrukājiet lapu, kurā ir redzams konfigurētais tīkls un printera bezvadu iestatījumi. Šis izvēlnes vienums ir pieejams tikai tīkla printeros vai printeros, kas ir pievienoti drukas serveriem. Wi‑Fi Direct pieslēgušies klienti Izdrukājiet lapu, kurā ir to ierīču saraksts, kas ir pieslēgtas printerim, izmantojot Wi‑Fi Direct. Šis izvēlnes vienums ir redzams tikai tad, ja opcijas  Iespējot Wi‑Fi Direct  iestatījums ir  Ieslēgts . izvēlne Tīkls"},{"UUID":"44e05de8-cf12-40bd-b7a1-d1971ad003ee","title":"Printera izvēļņu izmantošana","link":"troubleshooting-menu-topic.html","desc":"Problēmu novēršana Izvēlnes Problēmu novēršana","descFull":"Problēmu novēršana Izvēlnes Problēmu novēršana vienumi un to apraksti Izvēlnes vienums Apraksts Drukas kvalitātes testa lapas Izdrukājiet parauga lapas, lai atrastu un labotu drukas kvalitātes defektus. Skenera tīrīšana Izdrukājiet norādījumus, kā tīrīt skeneri. izvēlne Problēmu novēršana Drukas kvalitātes testa lapas Skenera tīrīšana"},{"UUID":"9deba113-63b2-4240-bd24-403b784eb405","title":"Printera izvēļņu izmantošana","link":"printing-menu-settings-page-topic.html","desc":"Izvēļņu iestatījumu lapas  drukāšana","descFull":"Izvēļņu iestatījumu lapas  drukāšana Sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites  Izvēļņu iestatījumu lapa . drukāšana Izvēļņu iestatījumu lapa Izvēļņu iestatījumu lapa drukāšana printera izvēlnes"},{"UUID":"46c1b2c7-b49d-4eed-86c8-80e46f496f2a","title":"Printera uzturēšana","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Detaļu un izejmateriālu statusa pārbaude","descFull":"Detaļu un izejmateriālu statusa pārbaude Sākuma ekrānā pieskarieties pie  Statuss/izejmateriāli . Atlasiet detaļas vai izejmateriālus, kurus vēlaties pārbaudīt. Varat arī piekļūt šim iestatījumam, pieskaroties sākuma ekrāna augšpuses sadaļai. detaļu un izejmateriālu statusa pārbaude izejmateriālu statuss pārbaude detaļu statuss pārbaude"},{"UUID":"3d9c9d70-2ce3-47f6-8045-f6690d3cd963","title":"Printera uzturēšana","link":"configuring-supply-notifications-topic.html","desc":"Izejmateriālu paziņojumu konfigurēšana Atveriet tīmekļa","descFull":"Izejmateriālu paziņojumu konfigurēšana Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi Ierīce Paziņojumi . Izvēlnē Izejmateriāli noklikšķiniet uz  Pielāgoti izejmateriālu paziņojumi . Atlasiet paziņojumu katram izejmateriāla vienumam. Piemērojiet izmaiņas. izejmateriālu paziņojumi konfigurēšana izejmateriālu paziņojumu konfigurēšana"},{"UUID":"a17501fb-ff29-459e-ac2f-e352ef38024c","title":"Printera uzturēšana","link":"setting-up-e-mail-alert-topic.html","desc":"E-pasta brīdinājumu iestatīšana Konfigurējiet printeri","descFull":"E-pasta brīdinājumu iestatīšana Konfigurējiet printeri sūtīt e-pasta brīdinājumus, ja izejmateriālu uzpildes līmenis kļūst zems, ir jāmaina vai jāpapildina papīrs vai ir iestrēdzis papīrs. Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama printera sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Iestatījumi Ierīce Paziņojumi E‑pasta brīdinājumu iestatīšana  un pēc tam konfigurējiet iestatījumus. Papildinformāciju par SMTP iestatījumiem vaicājiet savam e-pasta pakalpojuma sniedzējam. Piemērojiet izmaiņas. Noklikšķiniet uz  E-pasta sarakstu un brīdinājumu iestatīšana  un pēc tam konfigurējiet iestatījumus. Piemērojiet izmaiņas. e-pasta brīdinājumi iestatīšana e-pasta brīdinājumu iestatīšana"},{"UUID":"8195b7d1-e3f4-4e3e-b7b6-28577b4cc850","title":"Printera uzturēšana","link":"viewing-reports-topic.html","desc":"Atskaišu skatīšana Sākuma ekrānā pieskarieties","descFull":"Atskaišu skatīšana Sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites . Atlasiet atskaiti, ko vēlaties skatīt. atskaišu skatīšana atskaites printera statuss atskaites printera lietojums"},{"UUID":"719b77ae-18c0-4747-9053-4bb86562c6d8","title":"Detaļu un izejmateriālu pasūtīšana","link":"ordering-parts-and-supplies-group.html","desc":"Lai pasūtītu izejmateriālus ASV, sazinieties","descFull":"Lai pasūtītu izejmateriālus ASV, sazinieties ar uzņēmumu Lexmark pa tālruni 1-800-539-6275 un uzziniet, kur jūsu reģionā atrodas Lexmark pilnvaroti izejmateriālu izplatītāji. Ja atrodaties citā valstī vai reģionā, apmeklējiet vietni  www.lexmark.com  vai jautājiet informāciju printera iegādes vietā. Par izejmateriālu pasūtīšanas iespējām jautājiet printera iegādes vietā. Visu izejmateriālu patēriņš tiek aprēķināts pieņemot, ka tiek drukāts uz Letter vai A4 formāta vienkārša papīra. Ja netiek uzturēta optimāla printera veiktspēja vai mainītas detaļas un izejmateriāli, var tikt bojāts printeris. oriģinālas detaļas un izejmateriāli"},{"UUID":"6804b3df-5bd0-408b-812e-2c927c862852","title":"Detaļu un izejmateriālu pasūtīšana","link":"ordering-parts-and-supplies-group.html","desc":"Oriģinālo Lexmark detaļu un izejmateriālu","descFull":"Oriģinālo Lexmark detaļu un izejmateriālu lietošana Lexmark printeris ir izstrādāts tā, ka vislabāk tas darbojas ar oriģinālajām Lexmark detaļām un izejmateriāliem. Ja izmantojat trešās puses izejmateriālus vai detaļas, tas var ietekmēt printera un attēlveidošanas komponentu veiktspēju, uzticamību vai darba mūžu. Tas var arī ietekmēt garantijas darbību. Uz bojājumiem, kas ir radušies trešās puses detaļu un izejmateriālu izmantošanas dēļ, garantija neattiecas. Visi patēriņa indikatori ir izstrādāti darbībai ar Lexmark detaļām un izejmateriāliem, un to uzrādītie rezultāti var būt neparedzami, ja tiek izmantotas trešās puses detaļas un izejmateriāli. Ja attēlveidošanas komponents tiek izmantots ilgāk nekā paredzēts, Lexmark printeris vai saistītie komponenti var tikt bojāti. Izejmateriālus un detaļas, uz kurām neattiecas atgriešanas programmas līguma noteikumi, var atiestatīt un atjaunot. Tomēr ražotāja garantija neattiecas uz bojājumiem, kurus izraisījuši neoriģināli izejmateriāli un detaļas. Ja atiestatāt izejmateriāla vai detaļas skaitītāju, neveicot atbilstošu atjaunošanu, printeris var tikt bojāts. Pēc izejmateriāla vai detaļas skaitītāja atiestatīšanas printerī var tikt rādīts kļūdas ziņojums, norādot, ka atiestatītā vienība ir ievietota. oriģinālo Lexmark detaļu un izejmateriālu lietošana oriģinālas Lexmark detaļas un izejmateriāli"},{"UUID":"159a293d-3e60-436b-8884-ee7337d6bfda","title":"Detaļu un izejmateriālu pasūtīšana","link":"ordering-parts-and-supplies-group.html","desc":"Tonera kasetnes pasūtīšana Aprēķinātās kasetnes","descFull":"Tonera kasetnes pasūtīšana Aprēķinātās kasetnes produktivitātes pamatā ir ISO/IEC 19798 standarts. Ja ilgstošu laika periodu tiek ļoti maz drukāts, tas var negatīvi ietekmēt faktisko produktivitāti. Par tonera kasetņu pasūtīšanas iespējām jautājiet printera iegādes vietā. Lexmark CX930, CX931 tonera kasetnes Vienums Visā pasaulē Tonera kasetnes Ciāna 85D0HC0 Madženta 85D0HM0 Dzeltena 85D0HY0 Melna 85D0HK0 5K tonera kasetnes Ciāna 85D00C0 Madženta 85D00M0 Dzeltena 85D00Y0 Melna 85D00K0 Lexmark XC9325, XC9335 tonera kasetnes Vienums Visā pasaulē Ciāna 24B7519 Madženta 24B7520 Dzeltena 24B7521 Melna 24B7522 izejmateriālu pasūtīšana tonera kasetne tonera kasetne pasūtīšana"},{"UUID":"91a19c8e-5b82-49d4-9f64-a5e047311c4a","title":"Detaļu un izejmateriālu pasūtīšana","link":"ordering-parts-and-supplies-group.html","desc":"Fotorezistora vienības pasūtīšana Par fotorezistora","descFull":"Fotorezistora vienības pasūtīšana Par fotorezistora vienības pasūtīšanas iespējām jautājiet printera iegādes vietā. Fotorezistora vienības un to daļas numuri Vienums Visā pasaulē Fotorezistora vienība 85D0P00 Fotorezistora vienība, 3 vienību komplekts 85D0Q00 izejmateriālu pasūtīšana fotorezistora vienība fotorezistora vienība pasūtīšana"},{"UUID":"4495aa57-36a0-41bc-a4dd-f40a20ac5994","title":"Detaļu un izejmateriālu pasūtīšana","link":"ordering-parts-and-supplies-group.html","desc":"Izlietotā tonera tvertnes pasūtīšana Par","descFull":"Izlietotā tonera tvertnes pasūtīšana Par izlietotā tonera tvertnes pasūtīšanas iespējām jautājiet printera iegādes vietā. Izlietotā tonera tvertne un tās daļas numurs Vienums Daļas numurs Izlietotā tonera tvertne 85D0W00 izejmateriālu pasūtīšana izlietotā tonera tvertne izlietotā tonera tvertne pasūtīšana"},{"UUID":"26449f3a-7d79-4c7e-8e1f-219c733e406f","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Tonera kasetnes nomaiņa Atveriet priekšējās","descFull":"Tonera kasetnes nomaiņa Atveriet priekšējās durvis. Izņemiet lietoto tonera kasetni. Izpakojiet jauno tonera kasetni. Sakratiet tonera kasetni, lai vienmērīgi izlīdzinātu toneri. Ievietojiet jauno tonera kasetni. Atbloķējiet izlietotā tonera tvertni. Izņemiet izlietotā tonera tvertni. Lai toneris neizlītu, novietojiet tvertni vertikālā pozīcijā. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Novietojiet drukas galviņas tīrītāju atpakaļ savā vietā. Ievietojiet jauno izlietotā tonera tvertni tā, lai tā  noklikšķētu  vietā. Nofiksējiet izlietotā tonera tvertni. Aizveriet durvis. tonera kasetne nomaiņa izejmateriālu nomaiņa tonera kasetne"},{"UUID":"33ae5685-637b-4579-9860-ead97846351c","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Izlietotā tonera tvertnes nomaiņa Atveriet","descFull":"Izlietotā tonera tvertnes nomaiņa Atveriet priekšējās durvis. Atbloķējiet izlietotā tonera tvertni. Izņemiet izmantoto izlietotā tonera tvertni. Lai toneris neizlītu, novietojiet tvertni vertikālā pozīcijā. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Novietojiet drukas galviņas tīrītāju atpakaļ vietā. Izpakojiet jauno izlietotā tonera tvertni. Ievietojiet jauno izlietotā tonera tvertni tā, lai tā  noklikšķētu  vietā. Nofiksējiet izlietotā tonera tvertni. Aizveriet durvis. izejmateriālu nomaiņa izlietotā tonera tvertne izlietotā tonera tvertne nomaiņa"},{"UUID":"ab9a3edd-3fca-4bed-b9e7-d27bd0a85a4d","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Fotorezistora vienības nomaiņa Atveriet priekšējās","descFull":"Fotorezistora vienības nomaiņa Atveriet priekšējās durvis. Atbloķējiet izlietotā tonera tvertni. Izņemiet izlietotā tonera tvertni. Lai toneris neizlītu, novietojiet tvertni vertikālā pozīcijā. Atbloķējiet nolietoto fotorezistora vienību. Lai izvairītos no tonera piesārņojuma, nepieskarieties fotorezistora vienības galam. Noņemiet nolietoto fotorezistora vienību. Izpakojiet jauno fotorezistora vienību. Fotorezistora vienība nedrīkst atrasties tiešā gaismas ietekmē ilgāk par vienu minūti. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindram. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet jauno fotorezistora vienību un nofiksējiet tās lejasdaļu. Noņemiet iepakojuma materiālu, pēc tam nofiksējiet augšējo daļu. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Novietojiet tīrītāju atpakaļ savā vietā. Ievietojiet jauno izlietotā tonera tvertni tā, lai tā  noklikšķētu  vietā. Nofiksējiet izlietotā tonera tvertni. Aizveriet durvis. fotorezistora vienība nomaiņa fotorezistora vienības nomaiņa"},{"UUID":"7a47cc38-cf6d-4684-8f0d-f1c4477b8aea","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"520 lokšņu paplātes ieliktņa nomaiņa 520 lokšņu","descFull":"520 lokšņu paplātes ieliktņa nomaiņa 520 lokšņu paplātes ieliktņa nomaiņa Izņemiet lietoto paplātes ieliktni. Izpakojiet jauno paplātes ieliktni un noņemiet visu iepakojumu. Ievietojiet jauno paplātes ieliktni. detaļu nomaiņa 520 lokšņu paplātes ievietošana 520 lokšņu paplātes ievietošana nomaiņa"},{"UUID":"67f0f810-b7e9-4434-a2fc-c541d2e0cc21","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Termofiksatora nomaiņa Izslēdziet printeri. Atveriet","descFull":"Termofiksatora nomaiņa Izslēdziet printeri. Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Atbloķējiet lietoto termofiksatoru. Izņemiet lietoto termofiksatoru. Izpakojiet jauno termofiksatoru. Ievietojiet jauno termofiksatoru. Fiksējiet jauno termofiksatoru. Aizveriet durvis. Ieslēdziet printeri. termofiksators nomaiņa detaļu nomaiņa termofiksators"},{"UUID":"4b58096e-e873-414c-96f0-d9cb67b56aca","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Pārneses bloka nomaiņa Izslēdziet printeri.","descFull":"Pārneses bloka nomaiņa Izslēdziet printeri. Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Izņemiet lietoto pārneses bloku. Izpakojiet jauno pārneses bloku. Ievietojiet jauno pārneses bloku, līdz tas  ar klikšķi  atrodas vietā. Aizveriet durvis A un pēc tam aizveriet priekšējās durvis. Ieslēdziet printeri. detaļu nomaiņa pārneses bloks pārneses bloks nomaiņa"},{"UUID":"07926557-0f31-438e-9066-d53f7db1ef6b","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Pārneses moduļa nomaiņa Izslēdziet printeri.","descFull":"Pārneses moduļa nomaiņa Izslēdziet printeri. Atbloķējiet izlietotā tonera tvertni. Izņemiet izlietotā tonera tvertni. Lai toneris neizlītu, novietojiet tvertni vertikālā pozīcijā. Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Atbloķējiet un pēc tam izvelciet nolietoto pārneses moduli. Izņemiet lietoto pārneses moduli. Izpakojiet jauno pārneses moduli. Nepieskarieties pārneses lentei. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet jauno pārneses moduli, līdz tas  ar klikšķi  atrodas vietā. Nofiksējiet jauno pārneses moduli, pēc tam aizveriet durvis A. Ievietojiet jauno izlietotā tonera tvertni tā, lai tā  noklikšķētu  vietā. Nofiksējiet izlietotā tonera tvertni. Ieslēdziet printeri. izejmateriālu nomaiņa pārneses modulis pārneses modulis nomaiņa"},{"UUID":"a64ab70b-65a5-43e5-925e-ad1f6533a80b","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"paplātes ruļļu komplekta nomaiņa paplātes","descFull":"paplātes ruļļu komplekta nomaiņa paplātes ruļļu komplekta nomaiņa Izslēdziet printeri. Izņemiet standarta paplāti. Izņemiet lietoto paplātes ruļļu komplektu. Lai izvairītos no elektrostatiskās izlādes savainojumiem, pirms piekļūt vai pieskarties printera iekšējām daļām, pieskarieties printera metāla korpusam. Izpakojiet lietoto paplātes ruļļu komplektu. Ievietojiet jauno paplātes ruļļu komplektu, līdz tas  noklikšķ  vietā. Ievietojiet paplāti. Ieslēdziet printeri. paplātes ruļļu komplekts nomaiņa detaļu nomaiņa paplātes ruļļu komplekts"},{"UUID":"e478163c-0e8d-4920-b95a-2e7f5ae49cca","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"ADF ruļļu komplekta nomaiņa Izslēdziet","descFull":"ADF ruļļu komplekta nomaiņa Izslēdziet printeri. Atveriet ADF augšējo vāku. s Noņemiet atdalītāja ruļļa vāku. Izņemiet lietoto atdalītāja rulli. Izpakojiet jauno atdalītāja rulli. Ievietojiet jauno atdalītāja rulli. Ievietojiet atdalītāja ruļļa vāku, līdz tas  noklikšķ  vietā. Izņemiet lietoto atdalītāja ruļļa bloku. Izpakojiet jauno atdalītāja ruļļa bloku. Ievietojiet jauno atdalītāja ruļļa bloku, līdz tas  noklikšķ  vietā. Aizveriet ADF augšējo vāku. Ieslēdziet printeri. ADF ruļļa komplekts nomaiņa detaļu nomaiņa ADF ruļļa komplekts atdalītāja rullis nomaiņa atdalītāja ruļļa bloks nomaiņa"},{"UUID":"f0fbd30d-8656-4c2f-82b0-b2b226b0d3c6","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Drukas galviņas tīrītāja nomaiņa Atveriet","descFull":"Drukas galviņas tīrītāja nomaiņa Atveriet priekšējās durvis. Noņemiet lietoto drukas galviņas tīrītāju. Izpakojiet jauno drukas galviņas tīrītāju. Ievietojiet jauno drukas galviņas tīrītāju. Aizveriet durvis. detaļu nomaiņa drukas galviņas tīrītājs drukas galviņas tīrītājs nomaiņa"},{"UUID":"34f0b820-a76c-4212-bee7-8b8b5df16694","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"2000 lokšņu paplātes ruļļu komplekta nomaiņa","descFull":"2000 lokšņu paplātes ruļļu komplekta nomaiņa 2000 lokšņu paplātes ruļļu komplekta nomaiņa Izslēdziet printeri. Pavirziet paplāti pa kreisi. Atveriet durvis J, pēc tam atveriet ruļļu komplekta vāku. Sameklējiet un noņemiet veco ruļļu komplektu. Izpakojiet jauno ruļļu komplektu. Ievietojiet jauno ruļļu komplektu. Aizveriet ruļļu komplekta vāku un pēc tam aizveriet durvis J. Ievietojiet paplāti atpakaļ. Ieslēdziet printeri. 2000 lokšņu paplātes ruļļu komplekts nomaiņa detaļu nomaiņa 2000 lokšņu paplātes ruļļu komplekts"},{"UUID":"d61bf8a1-ccee-45a8-af97-99c6155ef744","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"ADF atdalītāja ruļļa vāka nomaiņa","descFull":"ADF atdalītāja ruļļa vāka nomaiņa ADF atdalītāja ruļļa vāka nomaiņa Atveriet ADF augšējo vāku. Noņemiet veco atdalītāja ruļļa vāku. Izpakojiet jauno atdalītāja ruļļa vāku. Ievietojiet jauno atdalītāja ruļļa vāku, līdz tas  noklikšķ  vietā. Aizveriet ADF augšējo vāku. ADF atdalītāja ruļļa vāks nomaiņa detaļu nomaiņa ADF atdalītāja ruļļa vāks"},{"UUID":"a172d4e8-262c-429e-ae4d-1246109fb522","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Aizmugurējā apakšējā savienotāja vāka nomaiņa","descFull":"Aizmugurējā apakšējā savienotāja vāka nomaiņa Aizmugurējā apakšējā savienotāja vāka nomaiņa Noņemiet veco aizmugurējo apakšējo savienotāja vāku. Izpakojiet jauno aizmugurējo apakšējo savienotāja vāku. Ievietojiet jauno aizmugurējā savienotāja vāku, līdz tas  noklikšķ  vietā. detaļu nomaiņa apakšējā aizmugurējā savienotāja vāks apakšējā aizmugurējā savienotāja vāks nomaiņa"},{"UUID":"796b1950-73dd-4a66-affb-5b54fcf34ab6","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"ADF nodalījuma papīra aiztura nomaiņa","descFull":"ADF nodalījuma papīra aiztura nomaiņa Noņemiet veco ADF nodalījuma papīra aizturi. Izpakojiet jauno ADF nodalījuma papīra aizturi. Ievietojiet jauno ADF nodalījuma papīra aizturi. detaļu nomaiņa ADF nodalījuma papīra aizturētājs ADF nodalījuma papīra aizturētājs nomaiņa"},{"UUID":"55a8ec95-6056-42fc-ba04-8e7790da1726","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Apkopes skaitītāja atiestatīšana Sākuma ekrānā","descFull":"Apkopes skaitītāja atiestatīšana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Izejmateriālu patēriņš un uzskaite . Pieskarieties pie  Atiestatīt apkopes uzskaiti . apkopes uzskaite atiestatīšana apkopes skaitītāja atiestatīšana"},{"UUID":"00500282-d77e-409f-941d-81500275f0fa","title":"Detaļu un izejmateriālu nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Izejmateriālu patēriņa uzskaites atiestatīšana Sākuma","descFull":"Izejmateriālu patēriņa uzskaites atiestatīšana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Izejmateriālu patēriņš un uzskaite . Atlasiet to skaitītāju, kuru vēlaties atiestatīt. Izejmateriālus un detaļas, uz kurām neattiecas atgriešanas programmas līguma noteikumi, var atiestatīt un atjaunot. Tomēr ražotāja garantija neattiecas uz bojājumiem, kurus izraisījuši neoriģināli izejmateriāli un detaļas. Ja atiestatāt izejmateriāla vai detaļas skaitītāju, neveicot atbilstošu atjaunošanu, printeris var tikt bojāts. Pēc izejmateriāla vai detaļas skaitītāja atiestatīšanas printerī var tikt rādīts kļūdas ziņojums, norādot, ka atiestatītā vienība ir ievietota. Izejmateriālus un detaļas, uz kurām neattiecas izlietošanas un atgriešanas programmas līguma noteikumi, var atiestatīt un atjaunot. Tomēr ražotāja garantija neattiecas uz bojājumiem, kurus izraisījuši neoriģināli izejmateriāli un detaļas. Ja atiestatāt izejmateriāla vai detaļas skaitītāju, neveicot atbilstošu atjaunošanu, printeris var tikt bojāts. Pēc izejmateriāla vai detaļas skaitītāja atiestatīšanas printerī var tikt rādīts kļūdas ziņojums, norādot, ka atiestatītā vienība ir ievietota. izejmateriālu patēriņa uzskaite atiestatīšana izejmateriālu patēriņa uzskaites atiestatīšana"},{"UUID":"e12f0424-1207-4d0f-9a8d-7cbb4ced428f","title":"Skavu kasetnes nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Skavu kasetnes nomaiņa apdarinātājā ar","descFull":"Skavu kasetnes nomaiņa apdarinātājā ar skavotāju Atveriet apdarinātāja durvis. Izņemiet skavu kasetnes turētāju. Izņemiet tukšo skavu kasetni. Izpakojiet jauno skavu kasetni. Ievietojiet jauno skavu kasetni turētājā tā, lai tā  noklikšķētu  vietā. Ievietojiet skavu kasetnes turētāju, līdz tas  ar klikšķi  atrodas vietā. Aizveriet durvis. izejmateriālu nomaiņa skavu kasetne skavu kasetne nomaiņa"},{"UUID":"39cb357a-7487-4508-bb2e-626b564edb39","title":"Skavu kasetnes nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Skavu kasetnes nomaiņa apdarinātājā ar","descFull":"Skavu kasetnes nomaiņa apdarinātājā ar skavotāju, caurumotāju Atveriet apdarinātāja durvis. Izņemiet skavu kasetnes turētāju. Izņemiet tukšo skavu kasetni. Izpakojiet jauno skavu kasetni. Ievietojiet jauno skavu kasetni tā, lai tā  noklikšķētu  vietā. Ievietojiet skavu kasetnes turētāju. Aizveriet durvis. izejmateriālu nomaiņa skavu kasetne skavu kasetne nomaiņa"},{"UUID":"e11ce038-28a6-4e90-9718-22a9e34c6573","title":"Skavu kasetnes nomaiņa","link":"replacing-toner-cartridge-topic.html","desc":"Standarta skavu kasetnes turētāja nomaiņa","descFull":"Standarta skavu kasetnes turētāja nomaiņa Standarta skavu kasetnes turētāja nomaiņa Atveriet apdarinātāja durvis. Izņemiet veco skavu kasetnes turētāju. Izņemiet skavu kasetni. Izpakojiet jauno skavu kasetnes turētāju. Ievietojiet skavu kasetni jaunajā turētājā tā, lai tā  noklikšķētu  vietā. Ievietojiet jauno skavu kasetnes turētāju tā, lai tas  noklikšķētu  vietā. Aizveriet apdarinātāja durvis. detaļu nomaiņa skavu kasetnes turētājs skavu kasetnes turētājs nomaiņa"},{"UUID":"1adfea92-eff7-450b-aa37-53dc2bc5404c","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"Printera tīrīšana Lai izvairītos no","descFull":"Printera tīrīšana Lai izvairītos no elektrošoka riska, tīrot printera korpusa ārpusi, pirms darba turpināšanas atvienojiet strāvas vadu no elektrotīkla un visus kabeļus no printera. Veiciet šo uzdevumu ik pēc pāris mēnešiem. Printera garantija neattiecas uz printera bojājumiem, kas ir radušies, ar to nepareizi apejoties. Izslēdziet printeri un pēc tam atvienojiet strāvas vadu no elektrotīkla. Izņemiet papīru no standarta nodalījuma un daudzfunkciju padevēja. Notīriet ap printeri esošos putekļus, gružus un papīra gabaliņus, izmantojot mīkstu suku vai putekļu sūcēju. Noslaukiet printera ārējo korpusu ar mitru, mīkstu bezplūksnu drānu. Neizmantojiet ikdienas tīrīšanas un mazgāšanas līdzekļus, jo tie var sabojāt printera apdari. Pēc tīrīšanas pārbaudiet, vai visas printera virsmas ir sausas. Pievienojiet elektrotīklam strāvas vadu un pēc tam ieslēdziet printeri. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. printera tīrīšana tīrīšana printera korpusa iekšpuse tīrīšana printera korpusa ārpuse"},{"UUID":"e4b50ae2-df4e-4429-b40b-992089476296","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"Skārienekrāna tīrīšana Lai izvairītos no","descFull":"Skārienekrāna tīrīšana Lai izvairītos no elektrošoka riska, tīrot printera korpusa ārpusi, pirms darba turpināšanas atvienojiet strāvas vadu no elektrotīkla un visus kabeļus no printera. Izslēdziet printeri un pēc tam atvienojiet strāvas vadu no elektrotīkla. Izmantojiet mitru, mīkstu drānu bez plūksnām, lai notīrītu skārienekrānu. Neizmantojiet ikdienas tīrīšanas un mazgāšanas līdzekļus, jo tie var sabojāt skārienekrānu. Pēc tīrīšanas pārbaudiet, vai skārienekrāns ir sauss. Pievienojiet elektrotīklam strāvas vadu un pēc tam ieslēdziet printeri. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. skārienekrāns tīrīšana skārienekrāna tīrīšana"},{"UUID":"9281e664-4bd7-4894-89ec-0aada93482c3","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"Skenera tīrīšana Atveriet skenera vāku.","descFull":"Skenera tīrīšana Atveriet skenera vāku. Izmantojiet mitru, mīkstu drānu bez plūksnām, lai notīrītu šīs vietas: ADF stikla paliktnis Skenera stikla paliktnis ADF stikls Skenera stikls Aizveriet skenera vāku. skeneris tīrīšana drukas kvalitāte skenera tīrīšana skenera tīrīšana"},{"UUID":"9f0ba34d-4ddd-4c09-9385-38f4ee705664","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"Drukas galviņas lēcu tīrīšana Drukas","descFull":"Drukas galviņas lēcu tīrīšana Drukas galviņas lēcu tīrīšana Atveriet priekšējās durvis. Atbloķējiet izlietotā tonera tvertni. Izņemiet izlietotā tonera tvertni. Lai toneris neizlītu, novietojiet tvertni vertikālā pozīcijā. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Novietojiet drukas galviņas tīrītāju atpakaļ vietā. Ievietojiet jauno izlietotā tonera tvertni tā, lai tā  noklikšķētu  vietā. Nofiksējiet izlietotā tonera tvertni. Aizveriet priekšējās durvis. drukas galviņas lēcas tīrīšana drukas galviņas lēcu tīrīšana"},{"UUID":"3aae1385-e566-41e5-819e-aa2ee870153a","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"Paplātes ruļļu komplekta tīrīšana Izslēdziet","descFull":"Paplātes ruļļu komplekta tīrīšana Izslēdziet printeri. Izņemiet standarta paplāti. Noņemiet paplātes ruļļu komplektu. Lai izvairītos no elektrostatiskās izlādes savainojumiem, pirms piekļūt vai pieskarties printera iekšējām daļām, pieskarieties printera metāla korpusam. Mīkstu drānu bez plūksnām samitriniet ūdenī un noslaukiet ar to padeves ruļļus. Ievietojiet paplātes ruļļu komplektu, līdz tas  noklikšķ  vietā. Ievietojiet paplāti. Ieslēdziet printeri. paplātes ruļļu komplekts tīrīšana paplātes ruļļu komplekta tīrīšana"},{"UUID":"0a3b4a64-9af1-49cf-8d95-b166eb8503aa","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"ADF ruļļu komplekta tīrīšana Izslēdziet","descFull":"ADF ruļļu komplekta tīrīšana Izslēdziet printeri. Atveriet ADF augšējo vāku. Noņemiet atdalītāja ruļļa vāku. Izņemiet atdalītāja rulli. Mīkstu drānu bez plūksnām samitriniet ūdenī un noslaukiet ar to padeves ruļļus komplektu. Ievietojiet atdalītāja rulli. Ievietojiet atdalītāja ruļļa vāku, līdz tas  noklikšķ  vietā. Izņemiet atdalītāja ruļļa bloku. Mīkstu drānu bez plūksnām samitriniet ūdenī un noslaukiet ar to padeves ruļļus komplektu. Ievietojiet atdalītāja ruļļa bloku, līdz tas  noklikšķ  vietā. Aizveriet ADF augšējo vāku. Ieslēdziet printeri. ADF ruļļa komplekts tīrīšana ADF ruļļu komplekta tīrīšana"},{"UUID":"0e39e9bf-b8be-4a38-b8dc-8608b24f4159","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"2000 lokšņu paplātes ruļļu komplekta tīrīšana","descFull":"2000 lokšņu paplātes ruļļu komplekta tīrīšana Izslēdziet printeri. Pavirziet paplāti pa kreisi. Atveriet durvis J, pēc tam atveriet ruļļu komplekta vāku. Sameklējiet un noņemiet paplātes ruļļu komplektu. Mīkstu drānu bez plūksnām samitriniet ūdenī un noslaukiet ar to padeves ruļļus komplektu. Ievietojiet ruļļu komplektu. Aizveriet ruļļu komplekta vāku un pēc tam aizveriet durvis J. Ievietojiet paplāti atpakaļ. Ieslēdziet printeri. 2000 lokšņu paplātes padeves ruļļi tīrīšana 2000 lokšņu paplātes padeves ruļļu tīrīšana"},{"UUID":"1c9557ac-35eb-4064-b6dc-c7bc8a99d0b1","title":"Printera detaļu tīrīšana","link":"cleaning-printer-topic.html","desc":"Caurumotāja tvertnes iztukšošana Paceliet papīra","descFull":"Caurumotāja tvertnes iztukšošana Paceliet papīra transportētāja pārsegu F. Izņemiet un iztukšojiet caurumotāja tvertni. Ievietojiet caurumotāja tvertni. Aizveriet pārsegu. caurumotāja tvertne iztukšošana caurumotāja tvertnes iztukšošana"},{"UUID":"b578b6a9-0380-4c3a-8469-b9b4f80e584b","title":"Enerģijas un papīra taupīšana","link":"configuring-power-save-mode-settings-topic.html","desc":"Enerģijas taupīšanas režīma iestatījumu konfigurēšana","descFull":"Enerģijas taupīšanas režīma iestatījumu konfigurēšana Miega režīms Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Enerģijas pārvaldība Taimauti Miega režīms . Norādiet, pēc cik ilga dīkstāves laika printerī tiek aktivizēts  miega režīms . hibernēšanas režīms Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Enerģijas pārvaldība Taimauti Hibernēšanas taimauts . Izvēlieties, pēc cik ilga dīkstāves laika printerī tiek aktivizēts miega režīms. Lai  hibernēšanas taimauts  darbotos, opcijas  Hibernēt  iestatījumam ir jābūt  Hibernēšanas taimauts pieslēdzoties . Serveris Embedded Web Server ir atspējots, kad printeris ir  hibernēšanas režīmā . Miega režīms konfigurēšana hibernēšanas režīms konfigurēšana vides iestatījumi enerģijas taupīšanas režīmi konfigurēšana"},{"UUID":"7b4a8862-134d-48cb-a02d-d058801e4a53","title":"Enerģijas un papīra taupīšana","link":"configuring-power-save-mode-settings-topic.html","desc":"Displeja spilgtuma koriģēšana Sākuma ekrānā","descFull":"Displeja spilgtuma koriģēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Preferences . Izvēlnē  Ekrāna spilgtums  koriģējiet iestatījumu. displeja spilgtums koriģēšana spilgtuma koriģēšana displejam"},{"UUID":"64b3ac59-398a-45d5-bdd8-1a0e432c1ad4","title":"Enerģijas un papīra taupīšana","link":"configuring-power-save-mode-settings-topic.html","desc":"Izejmateriālu taupīšana Drukājiet uz abām","descFull":"Izejmateriālu taupīšana Drukājiet uz abām papīra pusēm. Divpusējā drukāšana ir printera draivera noklusējuma iestatījums. Drukājiet vairākas lapas uz vienas papīra loksnes. Pirms dokumenta drukāšanas apskatiet to, izmantojot priekšskatīšanas funkciju. Izdrukājiet vienu dokumenta eksemplāru un pārbaudiet tā saturu un formātu. izejmateriālu taupīšana izejmateriāli taupīšana"},{"UUID":"915ac41b-74cc-49bf-89e8-e3edef19d4ac","title":"Printera uzturēšana","link":"moving-printer-topic.html","desc":"Printera pārvietošana uz citu vietu","descFull":"Printera pārvietošana uz citu vietu Printera pārvietošana uz citu vietu Ja printera svars pārsniedz 20 kg (44 mārciņas), tā drošai pacelšanai nepieciešami divi vai vairāk cilvēki. Lai izvairītos no aizdegšanās vai elektrošoka riska, izmantojiet tikai to strāvas vadu, kas iekļauts šī produkta komplektācijā, vai ražotāja apstiprinātu rezerves daļu. Pārvietojot printeri, ievērojiet šīs vadlīnijas, lai izvairītos no traumām vai printera sabojāšanas: Pārbaudiet, vai visas durvis un paplātes ir aizvērtas. Izslēdziet printeri un pēc tam atvienojiet strāvas vadu no elektrotīkla. Atvienojiet visus vadus un kabeļus no printera. Ja printerim ir atsevišķas uz grīdas novietojamas papildu paplātes vai izvades ierīces, atvienojiet tās pirms printera pārvietošanas. Ja printerim ir ritenīši, uzmanīgi aizripiniet to uz jauno atrašanās vietu. Ievērojiet piesardzību, šķērsojot sliekšņus un grīdas savienojumus. Ja printerim nav ritenīšu, bet tam ir papildu paplātes vai izvades ierīces, noņemiet izvades ierīces un izceliet no printera paplātes. Nemēģiniet vienlaicīgi pacelt printeri un citas ierīces. Vienmēr izmantojiet printera rokturus, lai to paceltu. Ja printera pārvietošanai tiek izmantoti rati, to virsmai jābūt tādai, lai pilnībā varētu novietot visu printeri. Ja aparatūras pārvietošanai tiek izmantoti rati, to virsmai jābūt tādai, lai pilnībā varētu novietot visu aparatūru. Turiet printeri stāvus pozīcijā. Izvairieties no lieliem triecieniem. Novietojot printeri, pārliecinieties, vai jūsu pirksti neatrodas zem tā. Nodrošiniet, lai ap printeri būtu pietiekami daudz brīvas vietas. Printera garantija neattiecas uz printera bojājumiem, kas ir radušies, to nepareizi pārvietojot. printera pārvietošana"},{"UUID":"3d817fd8-c6ef-4f5c-904f-129f4d4896c9","title":"Printera uzturēšana","link":"shipping-printer-topic.html","desc":"Printera piegāde Piegādes norādījumus skatiet","descFull":"Printera piegāde Piegādes norādījumus skatiet vietnē  http://support.lexmark.com  vai sazinieties ar klientu atbalstu. Piegādājot printeri, izmantojiet oriģinālo iepakojumu vai sazinieties ar printera iegādes vietu. printeris piegāde printera piegāde"},{"UUID":"e37f5b94-b352-41b5-967b-d20a19f05311","title":"Problēmas novēršana","link":"print-quality-problems-topic.html","desc":"Drukas kvalitātes problēmas Atrodiet attēlu,","descFull":"Drukas kvalitātes problēmas Atrodiet attēlu, kurā ir redzama jūsu drukas kvalitātes problēma, un pēc tam noklikšķiniet uz saites zem attēla, lai lasītu darbības, kas jāveic problēmas novēršanai."},{"UUID":"78eb26f8-43dc-42c7-ab8e-fd3ceef987ec","title":"Problēmas novēršana","link":"printer-error-codes-topic.html","desc":"Printera kļūdu kodi Kļūdu kodi","descFull":"Printera kļūdu kodi Kļūdu kodi un to risinājumi Kļūdu kodi Kļūdas ziņojums Risinājums 2.01 Nepieciešami materiāli. Pieskarieties  Atcelt darbu  un pasūtiet nepieciešamos materiālus. Lai iegūtu papildinformāciju, skatiet  . 3.01 Standarta izvades uztvērējs ir pilns. Izņemiet papīru no uztvērēja, tad pieskarieties  Turpināt . 3.21, 3.22, 3.23, 3.24 Izņemt papīru aiz [x]. paplātes. Izņemiet norādīto paplāti. Izņemiet jebkādu iestrēgušo papīru šajā zonā.  Ievietojiet paplāti. 7.13, 7.23, 7.33, 7.43, 7.53 Ievietojiet [x]. paplāti Izmēģiniet kādu no šīm darbībām: Ievietojiet norādīto paplāti. Atceliet pašreizējo drukas darbu. 8.01 Aizveriet priekšējās durvis. Aizveriet priekšējās durvis, ja vien netiek veikta apkope. 8.02, 8.03, 8.04, 8.05 Aizveriet [x] durvis. Aizveriet norādītās durvis, ja vien netiek veikta apkope. 8.06 Pievienojiet 5. paplāti. Pabīdiet paplāti pa kreisi un tad bīdiet to atpakaļ vietā. 8.07 Aizveriet papīra transportētāja pārsegu F. Turiet papīra transportētāja pārsegu F aizvērtu, ja vien netiek veikta apkope. 8.08 Aizveriet apdarinātāja ar skavotāju priekšējās durvis. Aizveriet apdarinātāja priekšējās durvis, ja vien netiek veikta apkope. 8.09 Aizveriet apdarinātāja ar skavotāju un caurumotāju augšējo vāku. Aizveriet apdarinātāja augšējo vāku, ja vien netiek veikta apkope. 9.00 Printeris tika restartēts. Pēdējais darbs var būt nepilnīgs. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. 11.11, 11.21, 11.31, 11.41, 11.51 Ievietojiet [source] papīru [type] [size]. Norādītajā paplātē ievietojiet papīru. Lai iegūtu papildinformāciju, skatiet  . 11.12, 11.22, 11.32, 11.42, 11.52 Ievietojiet [source] papīru [type] [size] [orientation]. 11.81, 11.91 Ievietojiet daudzfunkciju padevējā papīru [type] [size]. Ievietojiet daudzfunkciju padevējā papīru. Lai iegūtu papildinformāciju, skatiet  . 11.82, 11.92 Ievietojiet daudzfunkciju padevējā papīru [type] [size] [orientation]. 12.11, 12.21, 12.31, 12.41, 12.51 Mainiet [source] uz [type] [size]. Izvelciet norādīto paplāti un pēc tam ievietojiet pareizā veida un izmēru papīru. Lai iegūtu papildinformāciju, skatiet  . 12.12, 12.22, 12.32, 12.42, 12.52 Mainiet [source] uz [type] [size] [orientation]. 12.91 Mainiet daudzfunkciju padevējā uz [type] [size]. Izņemiet papīru un pēc tam ievietojiet pareizā veida un izmēru papīru. Lai iegūtu papildinformāciju, skatiet  . 12.92 Mainiet daudzfunkciju padevējā uz [type] [size] [orientation]. 31.00 Ievietojiet caurumotāja tvertni. Atveriet papīra transportētāja pārsegu F. Izņemiet caurumotāja tvertni. Ievietojiet caurumotāja tvertni. 31.35 Izņemiet un ievietojiet atpakaļ trūkstošo vai nereaģējošo izlietotā tonera tvertni. Atveriet priekšējās durvis. Atbloķējiet, pēc tam izņemiet izlietotā tonera tvertni. Lai toneris neizlītu, novietojiet tvertni vertikālā pozīcijā. Ievietojiet izlietotā tonera tvertni un pēc tam nofiksējiet to. Aizveriet priekšējās durvis. 31.40, 31.41, 31.42, 31.43 Izņemiet un ievietojiet atpakaļ trūkstošo vai nereaģējošo [krāsa] kasetni. Atveriet priekšējās durvis. Noņemiet kasetni. Ievietojiet kasetni. Aizveriet priekšējās durvis. 31.60, 31.61, 31.62, 31.63 Izņemiet un ievietojiet atpakaļ trūkstošo vai nereaģējošo [krāsa] fotorezistora vienību. Atveriet priekšējās durvis. Atbloķējiet, pēc tam izņemiet izlietotā tonera tvertni. Lai toneris neizlītu, novietojiet tvertni vertikālā pozīcijā. Atbloķējiet un tad izņemiet fotorezistora vienību. Ievietojiet jauno fotorezistora vienību un nofiksējiet to vietā. Ievietojiet izlietotā tonera tvertni un pēc tam nofiksējiet to. Aizveriet priekšējās durvis. 32.40, 31.41, 31.42, 31.43 Nomainiet neatbalstītu [krāsa] kasetni. Skatiet  . 32.60, 32.61, 32.62, 32.63 Nomainiet neatbalstītu [krāsa] fotorezistoru. Skatiet  . 34.00 Papīrs ir pārāk īss. Iestatiet papīra izmēru atbilstoši paplātē ievietotajam papīram. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . 34.10, 34.20, 34.30, 34.40, 34.50 Pārbaudiet [avots], pielāgojiet vadotnes un orientāciju. Izvelciet norādīto paplāti un tad pārliecinieties, ka papīrs ir ievietots pareizi. Lai iegūtu papildinformāciju, skatiet  . 34.90 Pārbaudiet daudzfunkciju padevēju, pielāgojiet vadotnes un orientāciju. Nodrošiniet, lai papīrs būtu ievietots pareizi. Lai iegūtu papildinformāciju, skatiet  . 37.10 Nepietiek atmiņas, lai saliktu darbu. Izmēģiniet kādu no šīm darbībām: Pieskarieties pie  Turpināt , lai drukātu saglabāto darba daļu un sāktu salikt pārējo drukas darbu. Atceliet pašreizējo drukas darbu. 37.30 Nepietiek atmiņas, daži aizturētie darbi tika izdzēsti. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. 38.10 Atmiņa pilna. Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. Atceliet pašreizējo drukas darbu. Uzstādiet lielāku printera atmiņu. Samaziniet drukājamo lapu skaitu drukas darbā. 39.10 Sarežģīta lapa, daži dati, iespējams, nav izdrukāti. Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. Atceliet pašreizējo drukas darbu. Uzstādiet lielāku printera atmiņu. Izveidojiet vienkāršāku un mazāku drukas darbu un pēc tam sūtiet to drukāt vēlreiz. Samaziniet drukājamo lapu skaitu drukas darbā. Samaziniet lejupielādēto fontu skaitu un lielumu. Drukas darbā izdzēsiet nevajadzīgos fontus vai makro. Samaziniet attēlu skaitu drukas darbā. 51 Noteikts bojāts zibatmiņas disks. Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Nomainiet zibatmiņas karti. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. Atceliet pašreizējo drukas darbu. 52 Zibatmiņas diskā nepietiek brīvas vietas resursiem. Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. Izdzēsiet zibatmiņas diska atmiņā saglabātos fontus, makro un citus datus. Uzstādiet cieto disku. Lai iegūtu papildinformāciju, skatiet  . Lejupielādētie fonti un makro, kas iepriekš nebija saglabāti zibatmiņas diskā, tiek izdzēsti. 55.1 USB diska lasīšanas kļūda. Izņemiet USB Izņemiet zibatmiņas disku, lai turpinātu. 55.2 USB centrmezgla lasīšanas kļūda. Izņemiet centrmezglu. Izņemiet USB centrmezglu, lai turpinātu. 55.3 Atvienojiet un mainiet režīmu. 61 Izņemiet bojāto disku. Nomainiet bojāto krātuves disku. 62 Disks pilns. Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. Izdzēsiet cietajā diskā saglabātos fontus, makro un citus datus. Uzstādiet cieto disku. Lai iegūtu papildinformāciju, skatiet  . 63 Formatējiet disku. Tagad formatēšana izdzēš visu informāciju no krātuves diska. Lai krātuves formatētu disku, rīkojieties šādi: Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Dzēšana, pārtraucot lietošanu . Pieskarieties pie  Sanitizēt visu informāciju cietajā diskā  un pēc tam pieskarieties pie  DZĒST . 71.01 Faksa stacijas nosaukums nav iestatīts. Sazinieties ar sistēmas administratoru. Skatiet  . 71.02 Faksa stacijas numurs nav iestatīts. Sazinieties ar sistēmas administratoru. 71.03 Modemam nav pievienota analogā tālruņa līnija, fakss ir atspējots. Pārbaudiet savienojumu un līnijas signālu. Lai iegūtu papildinformāciju, skatiet  . 71.06 Nevar izveidot savienojumu ar HTTPS faksa serveri. Savienojums ar HTTPS faksa serveri ir atvienots. Pārbaudiet printera interneta savienojumu. 71.07 Printeris nav reģistrēts HTTPS Faksa serverī. Pārliecinieties, ka printeris ir pievienots ierīču sarakstam HTTPS Faksa servera portālā. Sazinieties ar sistēmas administratoru. 71.11 Faksa dalīšana. Faksa dalīšana nedarbojas. Sazinieties ar sistēmas administratoru. 71.12 Atmiņa pilna, nevar izdrukāt faksus. Pieskarieties pie  Drukāt visu , lai drukātu visus saglabātos faksus. 71.13 Atmiņa pilna. Nevar nosūtīt faksus. Izmēģiniet kādu no šīm darbībām: Turpiniet un mēģiniet nosūtīt faksu vēlreiz. Skenējiet vienlaikus vienu oriģinālā dokumenta lapu, sastādiet faksa numuru un pēc tam nosūtiet pa faksu dokumentu. 71.40 Printera laiks nav pareizs. Konfigurējiet printera laiku. Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Preferences Datums un laiks Konfigurēt . 72.01 E-pasta SMTP serveris nav iestatīts. Sazinieties ar sistēmas administratoru.  Izmēģiniet kādu no šīm darbībām: Iestatiet e-pasta funkciju. Lai iegūtu papildinformāciju, skatiet  . Atspējojiet kļūdas ziņojumu. Lai iegūtu papildinformāciju, skatiet  . 72.02 Web Link serveris nav iestatīts. Sazinieties ar sistēmas administratoru. Sazinieties ar savu sistēmas administratoru. 72.04 Faksa servera Adresāta formāts nav iestatīts. Sazinieties ar sistēmas administratoru. Izmēģiniet kādu no šīm darbībām: Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa servera iestatīšana Vispārīgi faksa iestatījumi .  Konfigurējiet  Adresāta formāta  iestatījumu. Sazinieties ar savu sistēmas administratoru. 80.21 Apkopes komplekta kalpošanas laiks beidzas Pieskarieties pie  Turpināt , lai dzēstu ziņojumu. 80.31 Nomainiet apkopes komplektu. Skatiet  . 81.31 Nomainiet rullīšu komplektu, pārsniegts ieteicamais ekspluatācijas laiks. Skatiet  . 82.22 Izlietotā tonera tvertne ir gandrīz pilna. Pieskarieties pie  Turpināt , lai dzēstu ziņojumu. 82.42 Nomainiet izlietotā tonera tvertni. Skatiet  . 83.20 Skavas tūlīt vai jau ir beigušās. Izmēģiniet kādu no šīm darbībām: Izņemiet un pēc tam ievietojiet skavu kasetni. Nomainiet skavu kasetni. Lai iegūtu papildinformāciju, skatiet  . 83.30 Skavas beigušās vai netiek padotas. 84.01 [Krāsa] fotorezistora vienība tuvojas zemam līmenim. Pieskarieties pie  Turpināt , lai dzēstu ziņojumu. 84.11 [Krāsa] fotorezistora vienības zems līmenis. 84.21 [Krāsa] fotorezistora vienības ļoti zems līmenis. 84.31 Nomainiet [krāsa] fotorezistora vienību, pārsniegts ieteicamais ekspluatācijas laiks. Skatiet  . 86.23 Drīz nepieciešama skenera apkope. Pieskarieties pie  Turpināt , lai dzēstu ziņojumu. 86.33 Nomainiet ADF komplektu, pārsniegts ieteicamais ekspluatācijas laiks. Skatiet  . 87.20 Caurumotāja tvertne gandrīz pilna. Pieskarieties pie  Turpināt , lai dzēstu ziņojumu. 87.30 Iztukšojiet caurumotāja tvertni. Atveriet papīra transportētāja pārsegu F.  Izņemiet caurumotāja tvertni un tad iztukšojiet. Ievietojiet caurumotāja tvertni. Aizveriet vāku. 88.00[x] [Krāsa] kasetnes uzpildes līmenis ir gandrīz zems Pieskarieties pie  Turpināt , lai dzēstu ziņojumu. 88.10[x] [Krāsa] kasetnes uzpildes līmenis ir zems. 88.20[x] [Krāsa] kasetnes uzpildes līmenis ir ļoti zems. 88.30[x], 88.40[x] Nomainiet [krāsa] kasetni. Skatiet  . 200.03, 240.06 Iestrēdzis papīrs, [sastrēguma virsraksts]. Skatiet  . 200.16[x], 241.16a Iestrēdzis papīrs, [sastrēguma virsraksts]. Skatiet  . 200.26[x], 200.36[x], 200.46[x], 200.56a, 202.95[x], 242.26, 242.33, 242.43, 243.33, 243.36, 243,43, 244,43, 244,46 Iestrēdzis papīrs, [sastrēguma virsraksts]. Skatiet  . 200.56a, 245.53[x], 245,56 Iestrēdzis papīrs, [sastrēguma virsraksts]. Skatiet  . 200.95, 201.96, 202.93, 202.94, 221.93, 221.95, 232.93, 240.25, 240.35, 240.55 Iestrēdzis papīrs, [sastrēguma virsraksts]. Skatiet  . 280.06 Lūdzu, ievietojiet no jauna oriģinālus ADF un sāciet darbu no jauna. Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Izņemiet, tad ielādējiet dokumentu atpakaļ ADF. Skenējiet dokumentu no skenera stikla. Pabeidziet darbu bez atlikušo lapu skenēšanas. Atceliet darbu. 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 281.11, 281.15, 281.16, 281.91, 281.95,\t281.96, 282.11, 282.13, 282.15, 282.91, 282.93, 282.95, 283.11, 283.13,\t283.15, 283.91, 283.93, 283.95, 284.11, 284.13, 284.15, 284.91, 284.93,\t284.95, 288.10,\t288.90, 295.01, 680.10 Skenera sastrēgums. Skatiet  . 280.13Q, 280.15Q, 295.01Q, 680.20Q Ievietojiet no jauna iestrēgušos oriģinālus. Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Izņemiet, tad ielādējiet dokumentu atpakaļ ADF. Skenējiet dokumentu no skenera stikla. Pabeidziet darbu bez atlikušo lapu skenēšanas. Atceliet darbu. 280.13K, 280.15K, 680.20K, 680.40K, 295.01K,  Ievietojiet oriģinālus no jauna un atsāciet darbu. Izmēģiniet kādu no šīm darbībām: Izņemiet, tad ielādējiet dokumentu atpakaļ ADF vai uz skenera stikla. Atceliet darbu. 420.11a, 420.13a, 420.15a, 420.15b, 420.54a, 420.54b, 425.13a Iestrēdzis papīrs, [sastrēguma virsraksts]. Skatiet  . 400.13, 400.13b, 420.13b, 420.15b, 420.54c, 450.23b, 450.91b, 451.33b, 454.23b, 454.25b, 457.25b Iestrēdzis papīrs, [sastrēguma virsraksts]. Skatiet  . 457.35b Iestrēdzis papīrs, [sastrēguma virsraksts]. Ja instalējāt apdarinātāju ar skavotāju, tad skatiet  . Ja instalējāt apdarinātāju ar skavotāju, caurumotāju, tad skatiet  . kļūdu kodi kļūdu ziņojumi"},{"UUID":"b1992cbf-80d0-49f2-9d63-bc513c1d3514","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Tukšas vai baltas lapas Pirms","descFull":"Tukšas vai baltas lapas Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana  Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai printerī tiek izmantota autentiska un atbalstīta Lexmark tonera kasetne. Pārbaudiet, vai printerī tiek izmantota autentiska un atbalstīta tonera kasetne. Ja kasetne netiek atbalstīta, ievietojiet atbalstītu kasetni. Izdrukājiet dokumentu. Vai printeris drukā tukšas vai baltas lapas? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai printeris drukā tukšas vai baltas lapas? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte tukšas lapas problēmu novēršana, drukas kvalitāte baltas lapas drukas kvalitātes problēmu novēršana baltas lapas drukas kvalitātes problēmu novēršana melnas lapas tukšas lapas baltas lapas"},{"UUID":"58fecd29-0fa0-4b05-8e54-8681ae64b0e3","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Tumša izdruka Pirms problēmas novēršanas","descFull":"Tumša izdruka Pirms problēmas novēršanas izdrukājiet kvalitātes parauga lapas, lai noteiktu trūkstošo krāsu. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana  Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Izmantojiet iestatījumu  Krāsu koriģēšana . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu koriģēšana . Izdrukājiet dokumentu. Vai izdruka ir pārāk tumša? Problēma ir novērsta. Atkarībā no operētājsistēmas samaziniet tonera intensitāti dialoglodziņā Drukāšanas preferences vai Drukāšana. Iestatījumus varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Tonera intensitāte . Izdrukājiet dokumentu. Vai izdruka ir pārāk tumša? Problēma ir novērsta. Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījumi atbilst paplātē ievietotajam papīram. Iestatījumus varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdruka ir pārāk tumša? Pārejiet pie 6. darbības. Nodrošiniet, lai papīram nav tekstūras vai raupjas apdares. Vai drukājat, izmantojot papīru ar tekstūru vai rupju papīru? Pārejiet pie 6. darbības. Nomainiet papīru ar tekstūru vai raupju apdari pret vienkāršu papīru. Izdrukājiet dokumentu. Vai izdruka ir pārāk tumša? Problēma ir novērsta. Ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz esat gatavs to izmantot. Izdrukājiet dokumentu. Vai izdruka ir pārāk tumša? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte tumša izdruka drukas kvalitātes problēmu novēršana tumša izdruka tumša izdruka"},{"UUID":"93e0caee-91a4-4d0f-afa8-5b689fc9f727","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Māņattēli Pirms problēmas novēršanas izdrukājiet","descFull":"Māņattēli Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Ievietojiet paplātē pareiza veida un svara papīru. Izdrukājiet dokumentu. Vai izdrukās ir māņattēli? Problēma ir novērsta. Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst paplātē ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdrukās ir māņattēli? Problēma ir novērsta. Izmantojiet iestatījumu  Krāsu koriģēšana . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu koriģēšana . Izdrukājiet dokumentu. Vai izdrukās ir māņattēli? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte izdrukās ir māņattēli drukas kvalitātes problēmu novēršana izdrukās ir māņattēli māņattēli"},{"UUID":"c079c2b3-5218-4820-b9f5-baa6885455b4","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Pelēks vai krāsains fons Pirms","descFull":"Pelēks vai krāsains fons Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Atkarībā no operētājsistēmas palieliniet tonera intensitāti dialoglodziņā Drukāšanas preferences vai Drukāšana. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Tonera intensitāte . Izdrukājiet dokumentu. Vai izdrukās ir pelēks vai krāsains fons? Problēma ir novērsta. Izmantojiet iestatījumu  Krāsu koriģēšana . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu koriģēšana . Izdrukājiet dokumentu. Vai izdrukās ir pelēks vai krāsains fons? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai izdrukās ir pelēks vai krāsains fons? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte pelēks vai krāsains fons drukas kvalitātes problēmu novēršana pelēks vai krāsains fons pelēks fons izdrukā krāsains fons izdrukā"},{"UUID":"34aa5307-de5c-4202-9a21-c16fbbe78928","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Nepareizas piemales Problēmas novēršanai veicamās","descFull":"Nepareizas piemales Problēmas novēršanai veicamās darbības Darbība Jā Nē Koriģējiet paplātes vadotnes atbilstoši ievietotajam papīram. Izdrukājiet dokumentu. Vai piemales ir pareizas? Problēma ir novērsta. Atkarībā no operētājsistēmas papīra izmērus varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai piemales ir pareizas? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . nepareizas piemales drukas problēmu novēršana nepareizas piemales problēmu novēršana, drukāšana nepareizas piemales"},{"UUID":"2cbeb34b-53db-4556-9a74-fa8223927d7e","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Gaiša izdruka Pirms problēmas novēršanas","descFull":"Gaiša izdruka Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Izmantojiet iestatījumu  Krāsu koriģēšana . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu koriģēšana . Izdrukājiet dokumentu. Vai izdruka ir gaiša? Problēma ir novērsta. Atkarībā no operētājsistēmas palieliniet tonera intensitāti dialoglodziņā Drukāšanas preferences vai Drukāšana. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Tonera intensitāte . Izdrukājiet dokumentu. Vai izdruka ir gaiša? Problēma ir novērsta. Izslēdziet iestatījumu  Krāsu taupīšana . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Krāsu taupīšana . Izdrukājiet dokumentu. Vai izdruka ir gaiša? Problēma ir novērsta. Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdruka ir gaiša? Problēma ir novērsta. Pārbaudiet, vai papīram nav tekstūras vai raupjas apdares. Vai drukājat, izmantojot papīru ar tekstūru vai rupju papīru? Pārejiet pie 7. darbības. Nomainiet papīru ar tekstūru vai raupju apdari pret vienkāršu papīru. Izdrukājiet dokumentu. Vai izdruka ir gaiša? Problēma ir novērsta. Ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz esat gatavs to izmantot. Izdrukājiet dokumentu. Vai izdruka ir gaiša? Problēma ir novērsta. Noņemiet, pēc tam ievietojiet izlietotā tonera tvertni. Izmantojiet iestatījumu  Krāsu koriģēšana . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu koriģēšana . Vai izdruka ir gaiša? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai izdruka ir pārāk gaiša? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte gaiša izdruka drukas kvalitātes problēmu novēršana gaiša izdruka gaiša izdruka"},{"UUID":"a50744fa-4f23-43f5-9fe8-690d7e49e1a9","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Nav krāsu Pirms problēmas novēršanas","descFull":"Nav krāsu Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Izņemiet trūkstošās krāsas fotorezistora vienību. Nepakļaujiet fotorezistora vienību tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindram. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienību. Izņemiet trūkstošās krāsas tonera kasetni. Ievietojiet trūkstošās krāsas tonera kasetni. Izdrukājiet dokumentu. Vai izdrukās trūkst dažu krāsu? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte nav krāsu drukas kvalitātes problēmu novēršana nav krāsu nav krāsu"},{"UUID":"88cb0eaf-fd40-4b7b-b82d-8816656ceadb","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Graudaina izdruka un punkti Pirms","descFull":"Graudaina izdruka un punkti Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai printerī nav noplūduša tonera netīrumu. Vai printerī nav noplūduša tonera? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Pārbaudiet, vai papīra izmēru un veida iestatījumi atbilst ievietotajam papīram. Nodrošiniet, lai papīram nav tekstūras vai raupjas apdares. Vai iestatījumi atbilst? Pārejiet pie 4. darbības. Atkarībā no operētājsistēmas papīra izmērus un papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījumi atbilst paplātē ievietotajam papīram. Iestatījumus varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdruka ir graudaina? Problēma ir novērsta. Ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz esat gatavs to izmantot. Izdrukājiet dokumentu. Vai izdruka ir graudaina? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai izdruka ir graudaina? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte graudaina izdruka un punkti drukas kvalitātes problēmu novēršana graudaina izdruka un punkti graudaina izdruka un punkti punkti izdrukātajā lapā"},{"UUID":"e36e8f5a-43f4-4eca-a5ef-0484d9f85221","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Sarullējies papīrs Problēmas novēršanai veicamās","descFull":"Sarullējies papīrs Problēmas novēršanai veicamās darbības Darbība Jā Nē Koriģējiet paplātes vadotnes atbilstoši ievietotajam papīram. Izdrukājiet dokumentu. Vai papīrs ir sarullējies? Problēma ir novērsta. Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai papīrs ir sarullējies? Problēma ir novērsta. Drukājiet uz otras papīra puses. Izņemiet papīru, apvērsiet to un pēc tam ievietojiet atpakaļ. Izdrukājiet dokumentu. Vai papīrs ir sarullējies? Problēma ir novērsta. Ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz esat gatavs to izmantot. Izdrukājiet dokumentu. Vai papīrs ir sarullējies? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte papīrs sarullējies drukas kvalitātes problēmu novēršana papīrs sarullējies"},{"UUID":"4a2d63cb-b97f-4c8c-bf41-38e2207d1031","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Šķība vai sašķiebusies izdruka Pirms","descFull":"Šķība vai sašķiebusies izdruka Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Izvelciet paplāti. Izņemiet papīru un pēc tam ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz esat gatavs to izmantot. Koriģējiet paplātes vadotnes atbilstoši ievietotajam papīram. Ievietojiet paplāti. Izdrukājiet dokumentu. Vai izdruka ir šķība vai sašķiebusies? Problēma ir novērsta. Pārbaudiet, vai drukājat uz atbalstīta papīra. Izdrukājiet dokumentu. Vai izdruka ir šķība vai sašķiebusies? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte sašķiebusies izdruka drukas kvalitātes problēmu novēršana sašķiebusies izdruka problēmu novēršana, drukas kvalitāte šķība izdruka drukas kvalitātes problēmu novēršana šķība izdruka šķība izdruka sašķiebusies izdruka"},{"UUID":"12c720cd-a963-44c3-a4f9-7d98e93eca15","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Aizpildīti krāsu vai melni attēli","descFull":"Aizpildīti krāsu vai melni attēli Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai printeris drukā aizpildītus krāsu vai melnus attēlus? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte aizpildīti krāsu vai melni attēli drukas kvalitātes problēmu novēršana aizpildīti krāsu vai melni attēli aizpildītas krāsas melni attēli"},{"UUID":"071d2212-0bf1-42ce-b614-8b3f9202f1bc","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Apgriezts teksts vai attēli Pirms","descFull":"Apgriezts teksts vai attēli Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Koriģējiet paplātes vadotnes atbilstoši ievietotajam papīram. Izdrukājiet dokumentu. Vai teksts vai attēls ir apgriezts? Problēma ir novērsta. Atkarībā no operētājsistēmas papīra izmērus varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst paplātē ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai teksts vai attēls ir apgriezts? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai teksts vai attēls ir apgriezts? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte nepilnīgs teksts vai attēli drukas kvalitātes problēmu novēršana nepilnīgs teksts vai attēli nepilnīgs teksts izdrukā nepilnīgi attēli izdrukā"},{"UUID":"8e2dab51-9dd2-454b-9d58-009cba31daa0","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Toneris viegli nobirst Pirms problēmas","descFull":"Toneris viegli nobirst Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai toneris nobirst? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte toneris viegli nobirst drukas kvalitātes problēmu novēršana toneris viegli nobirst toneris viegli nobirst"},{"UUID":"b5e46138-8db3-48ab-9beb-58aed1cac3ca","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Nevienmērīgs apdrukas blīvums Pirms problēmas","descFull":"Nevienmērīgs apdrukas blīvums Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Nomainiet fotorezistora vienības un pēc tam izdrukājiet dokumentu. Vai apdrukas blīvums ir nevienmērīgs? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte nevienmērīgs apdrukas blīvums drukas kvalitātes problēmu novēršana nevienmērīgs apdrukas blīvums nevienmērīgs apdrukas blīvums"},{"UUID":"b57c8cfc-223a-4892-a0c6-b3e09eb63570","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Horizontālas tumšas līnijas Pirms problēmas","descFull":"Horizontālas tumšas līnijas Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Ja izdrukās joprojām ir redzamas horizontālas tumšas līnijas, skatiet tēmu “Atkārtotas kļūdas”. Problēmas novēršanai veicamās darbības Darbība Jā Nē Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdrukās ir horizontālas tumšas līnijas? Problēma ir novērsta. Ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz to ir nepieciešams izmantot. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas tumšas līnijas? Problēma ir novērsta. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas tumšas līnijas? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas tumšas līnijas? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte horizontālas tumšas līnijas drukas kvalitātes problēmu novēršana horizontālas tumšas līnijas horizontālas tumšas līnijas"},{"UUID":"9cf37e0f-d45f-4b11-a75c-0146b5e59e99","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Vertikālas tumšas līnijas Pirms problēmas","descFull":"Vertikālas tumšas līnijas Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst paplātē ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdrukās ir vertikālas tumšas līnijas? Problēma ir novērsta. Ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz to ir nepieciešams izmantot. Izdrukājiet dokumentu. Vai izdrukās ir vertikālas tumšas līnijas? Problēma ir novērsta. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas tumšas līnijas? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai izdrukās ir vertikālas tumšas līnijas? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte izdrukās ir vertikālas tumšas līnijas drukas kvalitātes problēmu novēršana izdrukās ir vertikālas tumšas līnijas izdrukās ir vertikālas tumšas līnijas"},{"UUID":"19803067-0527-4070-812e-b30e2161edb6","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Horizontālas baltas līnijas Pirms problēmas","descFull":"Horizontālas baltas līnijas Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Ja izdrukās joprojām ir redzamas horizontālas baltas līnijas, skatiet tēmu “Atkārtotas kļūdas”. Problēmas novēršanai veicamās darbības Darbība Jā Nē Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst paplātē ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdrukās ir horizontālas baltas līnijas? Problēma ir novērsta. Norādītajā papīra avotā ievietojiet ieteicamo papīra veidu. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas baltas līnijas? Problēma ir novērsta. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas tumšas līnijas? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas baltas līnijas? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte horizontālas baltas līnijas drukas kvalitātes problēmu novēršana horizontālas baltas līnijas horizontālas baltas līnijas"},{"UUID":"b3e8cdea-ef61-49cb-8bae-b184fcaa3fb8","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Vertikālas baltas līnijas Pirms problēmas","descFull":"Vertikālas baltas līnijas Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst paplātē ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Izdrukājiet dokumentu. Vai izdrukās ir vertikālas baltas līnijas? Problēma ir novērsta. Pārbaudiet, vai izmantojat ieteicamo papīra veidu. Norādītajā papīra avotā ievietojiet ieteicamo papīra veidu. Izdrukājiet dokumentu. Vai izdrukās ir vertikālas baltas līnijas? Problēma ir novērsta. Noņemiet drukas galviņas tīrītāju un notīriet drukas galviņas lēcas. Izdrukājiet dokumentu. Vai izdrukās ir horizontālas tumšas līnijas? Problēma ir novērsta. Noņemiet fotorezistora vienības. Nepakļaujiet fotorezistora vienības tiešas gaismas ietekmei. Ilgāka atrašanās gaismā var radīt drukas kvalitātes problēmas. Nepieskarieties fotorezistora cilindriem. Tādējādi var tikt ietekmēta turpmāku drukas darbu kvalitāte. Ievietojiet fotorezistora vienības. Izdrukājiet dokumentu. Vai izdrukās ir vertikālas baltas līnijas? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukas kvalitāte vertikālas baltas līnijas drukas kvalitātes problēmu novēršana vertikālas baltas līnijas vertikālas baltas līnijas"},{"UUID":"4163d208-6b05-4c0b-a611-fed04f80b9d9","title":"Drukas kvalitāte ir slikta","link":"solving-printing-problems.html","desc":"Atkārtotas kļūdas Pirms problēmas novēršanas","descFull":"Atkārtotas kļūdas Pirms problēmas novēršanas izdrukājiet drukas kvalitātes testa lapas. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Problēmas novēršanai veicamās darbības Darbība Jā Nē Izmantojot apkopes kļūdu lineālu, nomēriet attālumu starp kļūdām, kas atkārtojas ietekmētās krāsas lapā. Nomainiet izejmateriālu, kas atbilst mērījumam ietekmētās krāsas lapā. Fotorezistora vienība 94,5 mm (3,72 collas) 38 mm (1,5 collas) Attīstītāja vienība 28,7 mm (1,13 collas) Izdrukājiet drukas kvalitātes testa lapas. Vai ir redzamas kļūdas? Nosakiet attālumu un pēc tam sazinieties ar  klientu atbalstu  vai servisa pārstāvi. Nosakiet attālumu un pēc tam sazinieties ar  tehnisko atbalstu  vai Dell printera pārstāvi. Problēma ir novērsta. Izmantojot apkopes kļūdu lineālu, nomēriet attālumu starp kļūdām, kas atkārtojas ietekmētās krāsas lapā. Nomainiet izejmateriālu, kas atbilst mērījumam ietekmētās krāsas lapā. Otrais pārneses rullis 56,5 mm (2,22 collas) Termofiksators 95,1 mm (3,74 collas) 82,5 mm (3,25 collas) Pārneses lente 56,8 mm (2,24 collas) 19,1 mm (0,75 collas) 31,7 mm (1,25 collas) 70,9 mm (2,79 collas) 41,0 mm (1,61 collas) Izdrukājiet drukas kvalitātes testa lapas. Vai ir redzamas kļūdas? Nosakiet attālumu un pēc tam sazinieties ar  klientu atbalstu  vai servisa pārstāvi. Nosakiet attālumu un pēc tam sazinieties ar  tehnisko atbalstu  vai Dell printera pārstāvi. Problēma ir novērsta. drukas kvalitātes problēmu novēršana izdrukās atkārtojas kļūdas problēmu novēršana, drukas kvalitāte izdrukās atkārtojas kļūdas izdrukās atkārtojas kļūdas"},{"UUID":"60accb7c-b423-4014-a69b-123e3966f926","title":"Drukāšanas problēmas","link":"solving-printing-problems.html","desc":"Drukas darbi netiek drukāti Problēmas","descFull":"Drukas darbi netiek drukāti Problēmas novēršanai veicamās darbības Darbība Jā Nē Dokumentā, kuru mēģināt izdrukāt, atveriet dialoglodziņu Drukāšana un pārbaudiet, vai esat atlasījis pareizo printeri. Izdrukājiet dokumentu. Vai dokuments tika izdrukāts? Problēma ir novērsta. Pārbaudiet, vai printeris ir ieslēgts. Novērsiet kļūdu ziņojumus, kas ir redzami displejā. Izdrukājiet dokumentu. Vai dokuments tika izdrukāts? Problēma ir novērsta. Pārbaudiet, vai porti darbojas un kabeļi ir droši pievienoti datoram un printerim. Papildinformāciju skatiet kopā ar printeri piegādātajā uzstādīšanas dokumentācijā. Izdrukājiet dokumentu. Vai dokuments tika izdrukāts? Problēma ir novērsta. Izslēdziet printeri, nogaidiet aptuveni 10 sekundes un pēc tam ieslēdziet printeri. Izdrukājiet dokumentu. Vai dokuments tika izdrukāts? Problēma ir novērsta. Noņemiet printera draiveri un pēc tam uzstādiet to atkārtoti. Izdrukājiet dokumentu. Vai dokuments tika izdrukāts? Problēma ir novērsta. Kontaktinformācija  klientu atbalstu . problēmu novēršana, drukāšana drukas darbi netiek drukāti drukas problēmu novēršana drukas darbi netiek drukāti neizdrukāti drukas darbi"},{"UUID":"e98008fd-c17c-4da7-9811-2275d767d211","title":"Drukāšanas problēmas","link":"solving-printing-problems.html","desc":"Konfidenciāli un citi aizturēti dokumenti","descFull":"Konfidenciāli un citi aizturēti dokumenti netiek drukāti Problēmas novēršanai veicamās darbības Darbība Jā Nē Vadības panelī pārbaudiet, vai dokumenti tiek rādīti  aizturēto darbu  sarakstā. Ja dokumenti nav iekļauti šajā sarakstā, izdrukājiet dokumentus, izmantojot opciju Drukāt un aizturēt. Izdrukājiet dokumentus. Vai dokumenti tika izdrukāti? Problēma ir novērsta. Iespējams, drukas darbs satur formatēšanas kļūdas vai nederīgus datus. Izdzēsiet drukas darbu un pēc tam nosūtiet to atkārtoti. Ja drukājat PDF failu, ģenerējiet jaunu failu un pēc tam izdrukājiet dokumentus. Vai dokumenti tika izdrukāti? Problēma ir novērsta. Ja drukājat, izmantojot internetu, iespējams, printeris vairāku darbu nosaukumus nolasa kā dublikātus. Windows lietotājiem Atveriet dialoglodziņu Drukāšanas preferences. Cilnē Drukāšana un aizturēšana noklikšķiniet uz  Izmantot drukāšanu un aizturēšanu  un pēc tam noklikšķiniet uz  Paturēt dublētus dokumentus . Ievadiet PIN un pēc tam saglabājiet izmaiņas. Nosūtiet drukas darbu. Macintosh lietotājiem Saglabājiet katru darbu atsevišķi un piešķiriet tam citu nosaukumu. Nosūtiet darbu atsevišķi. Vai dokumenti tika izdrukāti? Problēma ir novērsta. Izdzēsiet dažus aizturētus darbus, lai atbrīvotu vietu printera atmiņā. Izdrukājiet dokumentus. Vai dokumenti tika izdrukāti? Problēma ir novērsta. Palieliniet printera atmiņu. Izdrukājiet dokumentus. Vai dokumenti tika izdrukāti? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . problēmu novēršana, drukāšana konfidenciāli un citi aizturēti dokumenti netiek drukāti drukas problēmu novēršana konfidenciāli un citi aizturēti dokumenti netiek drukāti konfidenciāli dokumenti netiek drukāti aizturēti dokumenti netiek drukāti"},{"UUID":"941fb45d-3f31-412a-8598-a420b0aae7d8","title":"Drukāšanas problēmas","link":"solving-printing-problems.html","desc":"Darbs tiek izdrukāts no nepareizas","descFull":"Darbs tiek izdrukāts no nepareizas paplātes vai uz nepareiza papīra Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai drukājat uz pareiza papīra. Izdrukājiet dokumentu. Vai dokuments tiek drukāts uz pareiza papīra? Ievietojiet pareizu izmēru papīru un papīra veidu. Atkarībā no operētājsistēmas papīra izmērus un papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Iestatījumus varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Pārbaudiet, vai iestatījumi atbilst ievietotajam papīram. Izdrukājiet dokumentu. Vai dokuments tiek drukāts uz pareiza papīra? Problēma ir novērsta. Pārliecinieties, ka paplātes ir pievienotas. Lai iegūtu papildinformāciju, skatiet:  . Izdrukājiet dokumentu. Vai dokuments tiek drukāts no pareizās paplātes? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . drukas problēmu novēršana darbs tiek drukāts no nepareizas paplātes drukas problēmu novēršana darbs tiek drukāts uz nepareiza papīra problēmu novēršana, drukāšana darbs tiek drukāts no nepareizas paplātes problēmu novēršana, drukāšana darbs tiek drukāts uz nepareiza papīra darbs tiek drukāts no nepareizas paplātes darbs tiek drukāts uz nepareiza papīra"},{"UUID":"df99516a-3ab8-4359-aad3-e8b8cfcf5d7d","title":"Drukāšanas problēmas","link":"solving-printing-problems.html","desc":"Lēna drukāšana Problēmas novēršanai veicamās","descFull":"Lēna drukāšana Problēmas novēršanai veicamās darbības Darbība Jā Nē Nodrošiniet, lai printera kabelis ir droši pievienots printerim un datoram, drukas serverim, ierīcei vai citai tīkla ierīcei. Vai printeris drukā lēni? Problēma ir novērsta. Pārbaudiet, vai printeris nav  klusajā režīmā . Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Ierīces darbības Klusais režīms . Izdrukājiet dokumentu. Vai printeris drukā lēni? Problēma ir novērsta. Atkarībā no operētājsistēmas drukas izšķirtspēju varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Iestatiet izšķirtspēju uz  2400 Image Q . Izdrukājiet dokumentu. Vai printeris drukā lēni? Problēma ir novērsta. Atkarībā no operētājsistēmas papīra veidu varat norādīt dialoglodziņā Drukāšanas preferences vai Drukāšana. Pārbaudiet, vai iestatījums atbilst ievietotajam papīram. Iestatījumu varat arī mainīt printera vadības panelī. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Smagāks papīrs tiek drukāts lēnāk. Papīrs, kas ir plānāks par Letter, A4 un Legal, var tikt drukāts lēnāk. Izdrukājiet dokumentu. Vai printeris drukā lēni? Problēma ir novērsta. Nodrošiniet, lai printerī norādītie apdrukājamā papīra tekstūras un svara iestatījumi atbilst ievietotā papīra iestatījumiem. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Apdrukājamā materiāla konfigurēšana Apdrukājamo materiālu veidi . Papīrs ar raupju tekstūru un smags papīrs var tikt drukāts lēnāk. Izdrukājiet dokumentu. Vai printeris drukā lēni? Problēma ir novērsta. Noņemiet aizturētus darbus. Vai printeris drukā lēni? Problēma ir novērsta. Pārbaudiet, vai printeris nepārkarst. Ļaujiet, lai printeris pēc gara drukas darba atdziest. Ievērojiet ieteicamo vides temperatūru vietā, kur atrodas printeris. Lai iegūtu papildinformāciju, skatiet:  . Izdrukājiet dokumentu. Vai printeris drukā lēni? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. drukas problēmu novēršana lēna drukāšana problēmu novēršana, drukāšana lēna drukāšana lēna drukāšana"},{"UUID":"21268f3e-2dc0-4232-9a43-c43386564ae8","title":"Problēmas novēršana","link":"trb-printer-not-responding-topic.html","desc":"Printeris nereaģē Problēmas novēršanai veicamās","descFull":"Printeris nereaģē Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai strāvas vads ir pievienots elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Vai printeris reaģē? Problēma ir novērsta. Pārliecinieties, vai elektrotīkls ir atvienots, izmantojot slēdzi vai pārtraucēju. Vai elektrotīkls ir atvienots, izmantojot slēdzi vai pārtraucēju? Ieslēdziet slēdzi vai atiestatiet pārtraucēju. Pārbaudiet, vai printeris ir ieslēgts. Vai printeris ir ieslēgts? Ieslēdziet printeri. Pārbaudiet, vai printeris ir miega vai hibernēšanas režīmā. Vai printeris ir miega vai hibernēšanas režīmā? Nospiediet ieslēgšanas/izslēgšanas pogu, lai pamodinātu printeri. Pārbaudiet, vai printeri un datoru savienojošie kabeļi ir ievietoti pareizajos portos. Vai kabeļi ir ievietoti pareizajos portos? Ievietojiet kabeļus pareizajos portos. Izslēdziet printeri, uzstādiet aparatūras ierīces un pēc tam ieslēdziet printeri. Papildinformāciju skatiet kopā ar ierīci piegādātajā dokumentācijā. Vai printeris reaģē? Problēma ir novērsta. Uzstādiet pareizo printera draiveri. Vai printeris reaģē? Problēma ir novērsta. Izslēdziet printeri, nogaidiet aptuveni 10 sekundes un pēc tam ieslēdziet printeri. Vai printeris reaģē? Problēma ir novērsta. Sazinieties ar  klientu atbalsts . Sazinieties ar  tehniskais atbalsts . problēmu novēršana printeris nereaģē printeris nereaģē"},{"UUID":"9df53545-c7b4-446a-8109-fd210ca5aab7","title":"Problēmas novēršana","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Nevar lasīt zibatmiņas disku Problēmas","descFull":"Nevar lasīt zibatmiņas disku Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai printeris nav aizņemts, apstrādājot citu drukāšanas, kopēšanas, skenēšanas vai faksa darbu. Vai printeris ir gatavs? Pārejiet pie 3. darbības. Gaidiet, līdz printeris pabeidz apstrādāt citu darbu. Izņemiet un pēc tam ievietojiet zibatmiņas disku. Vai printeris atpazīst zibatmiņas disku? Problēma ir novērsta. Pārbaudiet, vai zibatmiņas disks ir ievietots priekšpuses USB portā. Zibatmiņas disks nedarbojas, ja tiek ievietots aizmugures USB portā. Vai zibatmiņas disks ir ievietots pareizajā portā? Pārejiet pie 5. darbības. Ievietojiet zibatmiņas disku pareizajā portā. Vai printeris atpazīst zibatmiņas disku? Problēma ir novērsta. Pārbaudiet, vai zibatmiņas disks tiek atbalstīts. Lai iegūtu papildinformāciju, skatiet:  . Vai zibatmiņas disks tiek atbalstīts? Pārejiet pie 7. darbības. Ievietojiet atbalstītu zibatmiņas disku. Vai printeris atpazīst zibatmiņas disku? Problēma ir novērsta. Izņemiet un pēc tam ievietojiet zibatmiņas disku. Vai printeris atpazīst zibatmiņas disku? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . nevar lasīt zibatmiņas disku problēmu novēršana, drukāšana drukas problēmu novēršana nevar lasīt zibatmiņas disku"},{"UUID":"375d6b70-329a-48d8-85d6-65125937895f","title":"Problēmas novēršana","link":"enabling-usb-port-topic.html","desc":"USB porta iespējošana Sākuma ekrānā","descFull":"USB porta iespējošana Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkli/porti USB Iespējot USB portu . USB ports iespējošana USB porta iespējošana"},{"UUID":"d4a3b7c8-45b2-41f2-91c8-0e6d21c546f9","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Izvairīšanās no sastrēgumiem Ievietojiet papīru","descFull":"Izvairīšanās no sastrēgumiem Ievietojiet papīru pareizi Nodrošiniet, lai paplātē ievietotais papīrs ir gluds. Pareiza un nepareiza papīra ievietošana Pareiza papīra ievietošana Nepareiza papīra ievietošana Neievietojiet un neizņemiet paplāti, kamēr printeris drukā. Neievietojiet pārāk daudz papīra. Nodrošiniet, lai ievietotā papīra daudzums nepārsniedz maksimālā papīra daudzuma indikatoru. Neslidiniet papīru paplātē. Ievietojiet papīru tā, kā parādīts attēlā. Nodrošiniet, lai papīra vadotnes ir novietotas pareizi un cieši nespiežas pie papīra vai aploksnēm. Pēc papīra ievietošanas stingri stumiet paplāti printerī. Izmantojiet ieteikto papīru Izmantojiet tikai ieteikto papīru vai speciālu apdrukājamo materiālu. Neievietojiet saburzītu, sagumzītu, mitru, salocītu vai sarullētu papīru. Pirms papīra ievietošanas izlieciet, pāršķirstiet to un nolīdziniet papīra malas. Neizmantojiet papīru, kas ir apgriezts manuāli. Vienā paplātē neievietojiet dažādu izmēru, svara vai veida papīru. Nodrošiniet, lai datorā vai printera vadības panelī ir iestatīti pareizi papīra izmēri un veids. Glabājiet papīru atbilstoši ražotāja ieteikumiem. iestrēdzis papīrs izvairīšanās sastrēgumi, papīrs izvairīšanās izvairīšanas no iestrēguša papīra"},{"UUID":"f5a25c84-4aa7-43b0-9c7f-9ab246654111","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Sastrēgumu vietu noteikšana Ja opcijas","descFull":"Sastrēgumu vietu noteikšana Ja opcijas  Iestrēguša papīra  palīdzība iestatījums ir  Ieslēgts , printeris izdrukā tukšas lapas vai daļēji apdrukātas lapas, kad iestrēgušais papīrs ir izņemts. Pārbaudiet, vai izdrukās nav tukšu lapu. Ja opcijas  Iestrēguša papīra  atkopšana iestatījums ir  Ieslēgts  vai  Automātiski , printeris atkārtoti izdrukā iestrēgušās lapas. Sastrēgumu vietas Sastrēgumu vietas 1 Daudzfunkciju padevējs 2 Durvis A 3 Automātiskais dokumentu padevējs 4 Standarta nodalījums 5 Horizontālās transportēšanas ierīce 6 Apdarinātājs ar skavotāju, caurumotāju 7 Standarta paplāte 8 2000 lokšņu paplāte 9 Apdarinātājs ar skavotāju 10 izvēles paplātes iestrēdzis papīrs atrašana sastrēgumu vietas noteikšana"},{"UUID":"192a0b38-dc39-4672-ab77-74216f7218ad","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums standarta paplātē Atveriet","descFull":"Papīra sastrēgums standarta paplātē Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Izvelciet standarta paplāti. Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Ievietojiet paplāti un pēc tam aizveriet durvis A. iestrēguša papīra izņemšana standarta paplātē iestrēguša papīra izņemšana standarta paplātē iestrēdzis papīrs standarta paplātē"},{"UUID":"f2a49537-b7b6-4ac5-9e15-7a594d40491d","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums izvēles paplātēs Atveriet","descFull":"Papīra sastrēgums izvēles paplātēs Atveriet durvis B. Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet durvis. Izvelciet izvēles 520 lokšņu paplāti vai 2000 lokšņu tandēma paplāti. Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Tandēma paplātē izvelciet rokturi C, pēc tam atveriet iekšējo pārsegu. Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet pārsegu, pēc tam ievietojiet rokturi C. Ievietojiet paplāti. iestrēguša papīra izņemšana durvīs B iestrēguša papīra izņemšana 520 lokšņu paplātē iestrēguša papīra izņemšana 2000 lokšņu tandēma paplātē iestrēguša papīra izņemšana durvīs B iestrēguša papīra izņemšana 520 lokšņu paplātē iestrēguša papīra izņemšana 2000 lokšņu tandēma paplātē papīra sastrēgums durvīs B papīra sastrēgums 520 lokšņu tandēma paplātē papīra sastrēgums 2000 lokšņu tandēma paplātē papīra sastrēgums izvēles paplātēs iestrēguša papīra izņemšana izvēles paplātēs iestrēguša papīra izņemšana izvēles paplātēs"},{"UUID":"f9470bec-1c71-4937-8bc7-dc9c04a15390","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums daudzfunkciju padevējā Izņemiet","descFull":"Papīra sastrēgums daudzfunkciju padevējā Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. iestrēguša papīra izņemšana daudzfunkciju padevējā iestrēguša papīra izņemšana daudzfunkciju padevējā papīra sastrēgums daudzfunkciju padevējā"},{"UUID":"744694e0-e6ce-4be2-b0fb-4cd80d6f7de5","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums 2000 lokšņu paplātē Pavirziet","descFull":"Papīra sastrēgums 2000 lokšņu paplātē Pavirziet paplāti pa kreisi. Atveriet durvis J un pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet durvis un virziet paplāti atpakaļ savā vietā. Izvelciet paplātes ieliktni un pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Iespiediet atpakaļ paplātes ieliktni. iestrēguša papīra izņemšana 2000 lokšņu paplātē iestrēguša papīra izņemšana 2000 lokšņu paplātē iestrēdzis papīrs 2000 lokšņu paplātē"},{"UUID":"aaade72e-dd97-43d9-874a-5caf0d19ca2e","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums durvīs A Papīra sastrēgums","descFull":"Papīra sastrēgums durvīs A Papīra sastrēgums durvīs A Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Izņemiet iestrēgušo papīru no jebkuras no tālāk minētajām vietām: Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Termofiksators Dupleksās drukāšanas modulis Durvis C Aizveriet durvis A. iestrēguša papīra izņemšana durvīs A iestrēguša papīra izņemšana dupleksās drukāšanas modulī iestrēguša papīra izņemšana durvīs C iestrēguša papīra izņemšana termofiksatorā iestrēguša papīra izņemšana termofiksatorā iestrēguša papīra izņemšana durvīs C iestrēguša papīra izņemšana dupleksās drukāšanas modulī iestrēguša papīra izņemšana durvīs A papīra sastrēgums durvīs A papīra sastrēgums dupleksās drukāšanas modulī Papīra sastrēgums termofiksatora zonā papīra sastrēgums durvīs C"},{"UUID":"43823515-8f7b-41cb-add7-ae4ea18b3953","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums standarta nodalījumā Atveriet","descFull":"Papīra sastrēgums standarta nodalījumā Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Atveriet durvis C un pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet durvis C un pēc tam aizveriet durvis A. Izņemiet iestrēgušo papīru no standarta nodalījuma. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. iestrēguša papīra izņemšana standarta nodalījumā iestrēguša papīra izņemšana standarta nodalījums iestrēdzis papīrs standarta nodalījumā"},{"UUID":"df71faec-7e23-4ed2-8767-b0f166e6d727","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums automātiskajā dokumentu padevējā","descFull":"Papīra sastrēgums automātiskajā dokumentu padevējā Noņemiet visus oriģinālos dokumentus no ADF paplātes. Atveriet ADF vāku. Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet ADF vāku. iestrēguša papīra izņemšana automātiskajā dokumentu padevējā iestrēdzis papīrs automātiskajā dokumentu padevējā iestrēguša papīra izņemšana automātiskajā dokumentu padevējā"},{"UUID":"26216624-9946-4405-83c1-6ab920d5f1b7","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums apdarinātājā ar skavotāju","descFull":"Papīra sastrēgums apdarinātājā ar skavotāju Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Atveriet durvis A1 un pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet durvis A1 un pēc tam aizveriet durvis A. Atveriet apdarinātāja augšējo pārsegu un pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet pārsegu. Atveriet apdarinātāja priekšējo pārsegu, pagrieziet pogu un izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet pārsegu. Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Atveriet durvis C un pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet durvis C un pēc tam aizveriet durvis A. iestrēguša papīra izņemšana apdarinātājā ar skavotāju iestrēguša papīra izņemšana apdarinātājā ar skavotāju iestrēdzis papīrs apdarinātājā ar skavotāju"},{"UUID":"56d8fe32-7d58-4d18-8f38-66040b73cc81","title":"Iestrēguša papīra izņemšana","link":"avoiding-jams-topic.html","desc":"Papīra sastrēgums apdarinātājā ar skavotāju,","descFull":"Papīra sastrēgums apdarinātājā ar skavotāju, caurumotāju Atveriet durvis A. Printera korpusa iekšpuse var būt karsta. Lai samazinātu risku gūt traumu, pieskaroties karstai detaļai, gaidiet, līdz virsma atdziest, un tikai pēc tam pieskarieties tai. Atveriet durvis A1 un pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet durvis A1 un pēc tam aizveriet durvis A. Paceliet papīra pārvietošanas pārsegu F, pēc tam izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet papīra transportētāja pārsegu. Pavelciet sviru uz apdarinātāja ar skavotāju un caurumotāju, pēc tam noceliet pārsegu. Izņemiet iestrēgušo papīru. Pārliecinieties, vai ir izņemti visi papīra gabaliņi. Aizveriet apdarinātāja pārsegu. iestrēguša papīra izņemšana apdarinātājā ar skavotāju, caurumotāju iestrēguša papīra izņemšana apdarinātājā ar skavotāju, caurumotāju papīra sastrēgums apdarinātājā ar skavotāju, caurumotāju"},{"UUID":"05c4c444-2e83-42e5-8030-e6968029f1f2","title":"Tīkla savienojuma problēmas","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Nevar atvērt Embedded Web Server","descFull":"Nevar atvērt Embedded Web Server Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai printeris ir ieslēgts. Atveriet printera serveri Embedded Web Server (EWS). Vai varat atvērt EWS? Problēma ir novērsta. Pārliecinieties, vai printera IP adrese ir pareiza. IP adrese ir redzama sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Atveriet EWS. Vai varat atvērt EWS? Problēma ir novērsta. Pārbaudiet, vai ir instalēts atbalstīts pārlūks: Internet Explorer 11 vai jaunāku versiju Microsoft Edge Safari 6 vai jaunāku versiju Google Chrome  32 vai jaunāku versiju Mozilla Firefox 24 vai jaunāku versiju Atveriet EWS. Vai varat atvērt EWS? Problēma ir novērsta. Pārbaudiet, vai darbojas tīkla savienojums. Ja savienojums nedarbojas, sazinieties ar administratoru. Atveriet EWS. Vai varat atvērt EWS? Problēma ir novērsta. Nodrošiniet, lai kabeļu savienojumi starp printeri un datoru ir droši. Papildinformāciju skatiet kopā ar printera serveri piegādātajā dokumentācijā. Atveriet EWS. Vai varat atvērt EWS? Problēma ir novērsta. Pārbaudiet, vai tīmekļa starpniekserveri ir atspējoti. Ja serveri ir atspējoti, sazinieties ar administratoru. Atveriet EWS. Vai varat atvērt EWS? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . nevar atvērt Embedded Web Server problēmu novēršana nevar atvērt Embedded Web Server"},{"UUID":"0bb75e4e-3644-44a1-92da-4e7122fb1217","title":"Tīkla savienojuma problēmas","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Printeri nevar pievienot Wi-Fi tīklam","descFull":"Printeri nevar pievienot Wi-Fi tīklam Problēmas novēršanai veicamās darbības Darbība Jā Nē Nodrošiniet, lai opcijas  Aktīvs adapteris  iestatījums ir  Automātiski . Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Tīklu pārskats Aktīvs adapteris Automātiski . Vai printeri var pievienot Wi‑Fi tīklam? Problēma ir novērsta. Pārbaudiet, vai ir atlasīts pareizais Wi‑Fi tīkls. Daži maršrutētāji var koplietot noklusējuma SSID. Vai mēģināt izveidot savienojumu ar pareizo Wi‑Fi tīklu? Pārejiet pie 4. darbības. Pievienojiet pareizajam Wi‑Fi tīklam. Lai iegūtu papildinformāciju, skatiet:  . Vai printeri var pievienot Wi‑Fi tīklam? Problēma ir novērsta. Pārbaudiet bezvadu drošības režīmu. Sākuma ekrānā pieskarieties pie  Iestatījumi Tīkls/porti Bezvadu Bezvadu drošības režīms . Vai ir atlasīts pareizais bezvadu drošības režīms? Pārejiet pie 6. darbības. Atlasiet pareizo bezvadu drošības režīmu. Vai printeri var pievienot Wi‑Fi tīklam? Problēma ir novērsta. Pārbaudiet, vai esat ievadījis pareizo tīkla paroli. Parolē pievērsiet uzmanību atstarpēm, cipariem un lielajiem/mazajiem burtiem. Vai printeri var pievienot Wi‑Fi tīklam? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . nevar pievienot printeri Wi‑Fi problēmu novēršana nevar pievienot printeri Wi‑Fi"},{"UUID":"2a863558-b836-48d8-a6f0-2e27b655c6a7","title":"Aparatūras ierīču problēmas","link":"trb-cannot-detect-internal-option-topic.html","desc":"Nevar noteikt iekšēju ierīci Problēmas","descFull":"Nevar noteikt iekšēju ierīci Problēmas novēršanai veicamās darbības Darbība Jā Nē Izslēdziet printeri, nogaidiet aptuveni 10 sekundes un pēc tam ieslēdziet printeri. Vai printeris atrod iekšēju ierīci? Problēma ir novērsta. Izdrukājiet izvēļņu iestatījumu lapu un pārbaudiet, vai iekšējā ierīce ir iekļauta uzstādīto ierīču sarakstā. Vai iekšējā ierīce ir norādīta sarakstā? Pārejiet pie 4. darbības. Pārbaudiet, vai iekšējā ierīce ir pareizi uzstādīta kontrollera platē. Izslēdziet printeri un pēc tam atvienojiet strāvas vadu no elektrotīkla. Pārliecinieties, vai iekšējā ierīce ir uzstādīta atbilstošā kontrollera plates savienotājā. Pievienojiet elektrotīklam strāvas vadu un pēc tam ieslēdziet printeri. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Vai printeris atrod iekšēju ierīci? Problēma ir novērsta. Pārbaudiet, vai iekšējā ierīce ir pieejama printera draiverī. Ja nepieciešams, printera draiverī manuāli pievienojiet iekšējo ierīci, lai tā būtu pieejama drukas darbiem. Lai iegūtu papildinformāciju, skatiet:  . Izdrukājiet dokumentu. Vai printeris atrod iekšēju ierīci? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . problēmu novēršana, printera ierīces nevar noteikt iekšēju ierīci printera ierīču problēmu novēršana nevar noteikt iekšēju ierīci iekšēja ierīce nav noteikta"},{"UUID":"32234395-5bcf-41b5-9be4-0556fe1604a1","title":"Aparatūras ierīču problēmas","link":"trb-cannot-detect-internal-option-topic.html","desc":"Noteikts bojāts zibatmiņas disks Izmēģiniet","descFull":"Noteikts bojāts zibatmiņas disks Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Nomainiet bojāto viedo krātuves disku. Sākuma ekrānā pieskarieties pie  Turpināt , lai ignorētu ziņojumu un turpinātu drukāt. Atceliet pašreizējo drukas darbu. printera ziņojumi Noteikts bojāts zibatmiņas disks bojāts viedais krātuves disks"},{"UUID":"45cb7999-bdf5-4751-a668-b9cac351f476","title":"Aparatūras ierīču problēmas","link":"trb-cannot-detect-internal-option-topic.html","desc":"Zibatmiņas diskā nepietiek brīvas vietas","descFull":"Zibatmiņas diskā nepietiek brīvas vietas resursiem Izmēģiniet vienu vai vairākas tālāk norādītās darbības. Pieskarieties pie  Turpināt , lai notīrītu ziņojumu un turpinātu drukāšanu. Izdzēsiet zibatmiņas diska atmiņā saglabātos fontus, makro un citus datus. Uzstādiet cieto disku. Lejupielādētie fonti un makro, kas iepriekš nebija saglabāti zibatmiņas diskā, tiek izdzēsti. printera ziņojumi Zibatmiņas diskā nepietiek brīvas vietas resursiem Zibatmiņas diskā nepietiek brīvas vietas resursiem"},{"UUID":"f3e3bf04-e73e-43ac-b1d9-b1b12b6b1fd8","title":"Izejmateriālu problēmas","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Tonera kasetnes nav vai tā","descFull":"Tonera kasetnes nav vai tā nereaģē Problēmas novēršanai veicamās darbības Darbība Jā Nē Atveriet priekšējās durvis. Izņemiet un pēc tam ievietojiet tonera kasetni. Vai tonera kasetnes trūkst vai tā nereaģē? Problēma ir novērsta. Pārbaudiet, vai printerī tiek izmantota autentiska un atbalstīta Lexmark tonera kasetne. Pārbaudiet, vai printerī tiek izmantota autentiska un atbalstīta tonera kasetne. Ja tonera kasetne netiek atbalstīta, ievietojiet atbalstītu kasetni. Vai tonera kasetnes trūkst vai tā nereaģē? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, izejmateriāli tonera kasetnes nav vai tā nereaģē tonera kasetnes nav vai tā nereaģē izejmateriālu problēmu novēršana tonera kasetnes nav vai tā nereaģē"},{"UUID":"2c60d561-a9e1-412e-8502-e3b77f5e7da9","title":"Izejmateriālu problēmas","link":"trb-missing-or-unresponsive-toner-cartridge-topic.html","desc":"Cits, nevis Lexmark izejmateriāls Cits,","descFull":"Cits, nevis Lexmark izejmateriāls Cits, nevis Dell izejmateriāls Cits, nevis printera ražotāja izejmateriāls Printeris ir konstatējis, ka printerī ir uzstādīts cits, nevis Lexmark izejmateriāls vai detaļa. Printeris ir konstatējis, ka printerī ir uzstādīts cits, nevis Dell izejmateriāls vai detaļa. Printeris ir konstatējis, ka printerī ir uzstādīts neatpazīts izejmateriāls vai detaļa. Lexmark printeris ir izstrādāts tā, ka vislabāk tas darbojas ar oriģinālajiem Lexmark izejmateriāliem un detaļām. Ja izmantojat trešās puses izejmateriālus vai detaļas, tas var ietekmēt printera un attēlveidošanas komponentu veiktspēju, uzticamību vai darba mūžu. Dell printeris ir izstrādāts tā, ka vislabāk tas darbojas ar oriģinālajiem Dell izejmateriāliem un detaļām. Ja izmantojat trešās puses izejmateriālus vai detaļas, tas var ietekmēt printera un attēlveidošanas komponentu veiktspēju, uzticamību vai darba mūžu. Printeris ir izstrādāts tā, ka vislabāk tas darbojas ar oriģinālajiem izejmateriāliem un detaļām, kuras ir izgatavojis printera ražotājs. Ja izmantojat trešās puses izejmateriālus vai detaļas, tas var ietekmēt printera un attēlveidošanas komponentu veiktspēju, uzticamību vai darba mūžu. Visi patēriņa indikatori ir izstrādāti darbībai ar Lexmark izejmateriāliem un detaļām, un to uzrādītie rezultāti var būt neparedzami, ja tiek izmantoti trešās puses izejmateriāli vai detaļas. Ja attēlveidošanas komponents tiek izmantots ilgāk nekā paredzēts, Lexmark printeris vai saistītie komponenti var tikt bojāti. Visi patēriņa indikatori ir izstrādāti darbībai ar Dell izejmateriāliem un detaļām, un to uzrādītie rezultāti var būt neparedzami, ja tiek izmantoti trešās puses izejmateriāli vai detaļas. Ja attēlveidošanas komponents tiek izmantots ilgāk nekā paredzēts, Dell printeris vai saistītie komponenti var tikt bojāti. Visi patēriņa indikatori ir izstrādāti darbībai ar printera ražotāja izgatavotiem izejmateriāliem un detaļām, un to uzrādītie rezultāti var būt neparedzami, ja tiek izmantoti trešās puses izejmateriāli vai detaļas. Ja attēlveidošanas komponents tiek izmantots ilgāk nekā paredzēts, printeris vai saistītie komponenti var tikt bojāti. Ja izmantojat trešās puses izejmateriālus vai detaļas, tas var ietekmēt garantijas segumu. Uz bojājumiem, kas ir radušies trešās puses izejmateriālu vai detaļu izmantošanas dēļ, garantija neattiecas. Lai apstiprinātu jebkuru no šiem riskiem un tos visus, kā arī lai turpinātu darbu, printerī izmantojot citus, nevis oriģinālus izejmateriālus vai detaļas, displejā pieskarieties un 15 sekundes turiet kļūdas ziņojumu ar diviem pirkstiem. Kad tiek parādīts apstiprinājuma dialoglodziņš, pieskarieties pie  Turpināt . Ja nevēlaties apstiprināt šos riskus, noņemiet trešās puses izejmateriālu vai detaļu no printera un uzstādiet oriģinālu Lexmark izejmateriālu vai detaļu. Lai iegūtu papildinformāciju, skatiet:  . Ja nevēlaties apstiprināt šos riskus, noņemiet trešās puses izejmateriālu vai detaļu no printera un uzstādiet oriģinālu Dell izejmateriālu vai detaļu. Ja nevēlaties apstiprināt šos riskus, noņemiet trešās puses izejmateriālu vai detaļu no printera un uzstādiet oriģinālu izejmateriālu vai detaļu, ko izgatavojis printera ražotājs. Ja printeris nedrukā pēc tam, kad ir notīrīts kļūdas ziņojums, atiestatiet izejmateriālu patēriņa uzskaiti. Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Izejmateriālu patēriņš un uzskaite . Atlasiet detaļu vai izejmateriālu, ko vēlaties atiestatīt, un pēc tam pieskarieties pie  Sākt . Izlasiet brīdinājuma ziņojumu un pēc tam pieskarieties pie  Turpināt . Ar diviem pirkstiem pieskarieties displejam un turiet 15 sekundes, lai notīrītu ziņojumu. Ja nevarat atiestatīt izejmateriālu patēriņa uzskaiti, atgrieziet izejmateriālu tā iegādes vietā. printera ziņojumi Cits, nevis Lexmark izejmateriāls Cits, nevis Lexmark izejmateriāls printera ziņojumi Cits, nevis Dell izejmateriāls Cits, nevis Dell izejmateriāls printera ziņojumi Cits, nevis printera ražotāja izejmateriāls Cits, nevis printera ražotāja izejmateriāls atiestatīšana izejmateriālu patēriņa uzskaite izejmateriālu patēriņa uzskaite atiestatīšana izejmateriālu patēriņa uzskaites atiestatīšana"},{"UUID":"16b5922e-f0cc-4b25-83ed-b7c7409c4a79","title":"Papīra padeves problēmas","link":"trb-envelope-seals-when-printing-topic.html","desc":"Drukājot uz aploksnes, tā aizlīp","descFull":"Drukājot uz aploksnes, tā aizlīp Problēmas novēršanai veicamās darbības Darbība Jā Nē Izmantojiet aploksni, kas ir uzglabāta sausā vidē. Drukājot uz ļoti mitrām aploksnēm, atloki var aizlipt. Nosūtiet drukas darbu. Vai aploksne drukājot aizlīp? Problēma ir novērsta. Nodrošiniet, lai papīra veida iestatījums ir Aploksne. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Nosūtiet drukas darbu. Vai aploksne drukājot aizlīp? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukāšana drukājot uz aploksnes, tā aizlīp drukas problēmu novēršana drukājot uz aploksnes, tā aizlīp drukājot uz aploksnes, tā aizlīp"},{"UUID":"ccbb58d9-87a7-4081-bd11-8e7de4915291","title":"Papīra padeves problēmas","link":"trb-envelope-seals-when-printing-topic.html","desc":"Saliktā drukāšana nedarbojas Problēmas novēršanai","descFull":"Saliktā drukāšana nedarbojas Problēmas novēršanai veicamās darbības Darbība Jā Nē Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Izkārtojums Salikt . Pieskarieties pie  Ieslēgts [1,2,1,2,1,2] . Izdrukājiet dokumentu. Vai dokuments tiek salikts pareizi? Problēma ir novērsta. Dokumentā, kuru vēlaties izdrukāt, atveriet dialoglodziņu Drukāšana un pēc tam atlasiet  Salikt . Izdrukājiet dokumentu. Vai dokuments tiek salikts pareizi? Problēma ir novērsta. Samaziniet drukājamo lapu skaitu. Izdrukājiet dokumentu. Vai lapas ir saliktas pareizi? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . drukas problēmu novēršana saliktā drukāšana nedarbojas problēmu novēršana, drukāšana saliktā drukāšana nedarbojas saliktā drukāšana nedarbojas"},{"UUID":"02c96950-0e97-46fb-a776-69db3ed19fe2","title":"Papīra padeves problēmas","link":"trb-envelope-seals-when-printing-topic.html","desc":"Paplāšu pievienošana nedarbojas Problēmas novēršanai","descFull":"Paplāšu pievienošana nedarbojas Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai paplātēm ir vienādi papīra izmēri un papīra veids. Pārbaudiet, vai papīra vadotnes ir novietotas pareizi. Izdrukājiet dokumentu. Vai paplātes tiek pievienotas pareizi? Problēma ir novērsta. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Iestatiet papīra izmērus un veidu atbilstoši saistītajās paplātēs ievietotajam papīram. Izdrukājiet dokumentu. Vai paplātes tiek pievienotas pareizi? Problēma ir novērsta. Nodrošiniet, lai  paplāšu pievienošanas  iestatījums ir  Automātiski . Lai iegūtu papildinformāciju, skatiet:  . Izdrukājiet dokumentu. Vai paplātes tiek pievienotas pareizi? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . problēmu novēršana, drukāšana paplāšu pievienošana nedarbojas drukas problēmu novēršana paplāšu pievienošana nedarbojas"},{"UUID":"e2e4a631-2e58-4de5-aa81-bf94beb30ff9","title":"Papīra padeves problēmas","link":"trb-envelope-seals-when-printing-topic.html","desc":"Papīrs bieži iestrēgst Problēmas novēršanai","descFull":"Papīrs bieži iestrēgst Problēmas novēršanai veicamās darbības Darbība Jā Nē Izņemiet paplāti. Pārbaudiet, vai papīrs ir ievietots pareizi. Pārbaudiet, vai papīra vadotnes ir novietotas pareizi. Nodrošiniet, lai ievietotā papīra daudzums nepārsniedz maksimālā papīra daudzuma indikatoru. Noteikti drukājiet, izmantojot ieteicamos papīra izmērus un veidu. Ievietojiet paplāti. Izdrukājiet dokumentu. Vai papīrs bieži iestrēgst? Problēma ir novērsta. Sākuma ekrānā pieskarieties pie  Iestatījumi Papīrs Paplāšu konfigurēšana Papīra izmēri/veids . Iestatiet pareizus papīra izmērus un veidu. Izdrukājiet dokumentu. Vai papīrs bieži iestrēgst? Problēma ir novērsta. Ievietojiet papīru no jaunas pakas. Papīrs uzsūc mitrumu, ja atrodas vietā ar augstu mitruma līmeni. Glabājiet papīru oriģinālajā iepakojumā, līdz esat gatavs to izmantot. Izdrukājiet dokumentu. Vai papīrs bieži iestrēgst? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, drukāšana papīrs bieži iestrēgst drukas problēmu novēršana papīrs bieži iestrēgst papīrs bieži iestrēgst"},{"UUID":"977a4414-db4f-4b61-b422-10e4bd4e81c0","title":"Papīra padeves problēmas","link":"trb-envelope-seals-when-printing-topic.html","desc":"Iestrēgušas lapas netiek drukātas atkārtoti","descFull":"Iestrēgušas lapas netiek drukātas atkārtoti Problēmas novēršanai veicamā darbība Darbība Jā Nē Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Paziņojumi Iestrēguša papīra satura atkopšana . Izvēlnē Iestrēguša papīra atkopšana pieskarieties pie  Ieslēgts  vai  Automātiski . Izdrukājiet dokumentu. Vai iestrēgušās lapas tika atkārtoti izdrukātas? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . problēmu novēršana, drukāšana iestrēgušas lapas netiek drukātas atkārtoti iestrēgušas lapas netiek drukātas atkārtoti"},{"UUID":"67521e94-441d-4396-82e7-ede03a0dcf3f","title":"E-pasta ziņojumu sūtīšanas problēmas","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Kļūdas ziņojuma “SMTP serveris nav","descFull":"Kļūdas ziņojuma “SMTP serveris nav iestatīts” atspējošana Sākuma ekrānā pieskarieties pie  Iestatījumi E‑pasts E‑pasta iestatīšana Atspējot kļūdu “SMTP serveris nav iestatīts” Ieslēgts . Lai novērstu kļūdas atkārtotu parādīšanos, veiciet vienu vai vairākas no šīm darbībām: Atjauniniet printera programmaparatūru. Lai iegūtu papildinformāciju, skatiet:  . Konfigurējiet e-pasta SMTP iestatījumus. Lai iegūtu papildinformāciju, skatiet:  . kļūda “SMTP serveris nav iestatīts” atspējošana problēmu novēršana kļūda “SMTP serveris nav iestatīts” kļūdas “SMTP serveris nav iestatīts” atspējošana"},{"UUID":"59ad686b-27fa-436d-a96c-098f7fa9041b","title":"E-pasta ziņojumu sūtīšanas problēmas","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Nevar nosūtīt e-pasta ziņojumus Problēmas","descFull":"Nevar nosūtīt e-pasta ziņojumus Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai e-pasta SMTP iestatījumi ir konfigurēti pareizi. Lai iegūtu papildinformāciju, skatiet  . Vai varat nosūtīt e-pasta ziņojumu? Problēma ir novērsta. Pārbaudiet, vai izmantojat pareizu paroli. Atkarībā no sava e‑pasta pakalpojumu sniedzēja izmantojiet savu konta paroli, lietotnes paroli vai autentifikācijas paroli. Lai iegūtu papildinformāciju, skatiet  . Vai varat nosūtīt e-pasta ziņojumu? Problēma ir novērsta. Pārbaudiet, vai printeris ir pievienots tīklam un tīkls ir savienots ar internetu. Vai varat nosūtīt e-pasta ziņojumu? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . e‑pasta problēmu novēršana nevar nosūtīt e-pasta ziņojumus problēmu novēršana, e‑pasts nevar nosūtīt e-pasta ziņojumus nevar nosūtīt e-pasta ziņojumus"},{"UUID":"a36fcc2c-4cb3-44b9-ade6-25ecedaacf57","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Netiek rādīts zvanītāja ID Šie norādījumi","descFull":"Netiek rādīts zvanītāja ID Šie norādījumi attiecas tikai uz tiem printeriem, kas atbalsta analogo faksu. Papildinformāciju skatiet sadaļā  Faksa funkcijas iestatīšana printerī . Problēmas novēršanai veicamās darbības Darbība Jā Nē Iespējojiet zvanītāja ID. Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Faksa saņemšanas iestatījumi Administratora vadīklas Iespējojiet zvanītāja ID . Vai zvanītāja ID tiek rādīts? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . problēmu novēršana, fakss netiek rādīts zvanītāja ID faksa problēmu novēršana netiek rādīts zvanītāja ID netiek rādīts zvanītāja ID"},{"UUID":"607050a5-2970-4356-98b6-5a8427d1076a","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Nevar nosūtīt vai saņemt faksu,","descFull":"Nevar nosūtīt vai saņemt faksu, izmantojot analogo faksu Problēmas novēršanai veicamās darbības Darbība Jā Nē Novērsiet kļūdu ziņojumus, kas ir redzami displejā. Vai varat nosūtīt vai saņemt faksu? Problēma ir novērsta. Pārbaudiet, vai izveidoti droši kabeļu savienojumi ar šādu aprīkojumu: Tālrunis Klausule Automātiskais atbildētājs Vai varat nosūtīt vai saņemt faksu? Problēma ir novērsta. Pārbaudiet, vai ir dzirdams centrāles gatavības signāls. Zvaniet uz faksa numuru, lai pārbaudītu, vai tas darbojas pareizi. Ja izmantojat noliktas klausules režīma funkciju, ieslēdziet skaļumu, lai pārbaudītu, vai ir dzirdams centrāles gatavības signāls. Vai ir dzirdams centrāles gatavības signāls? Pārejiet pie 5. darbības. Pārbaudiet tālruņa kontaktligzdu. Pievienojiet analogo tālruni tieši sienas kontaktligzdā. Pārbaudiet, vai ir dzirdams centrāles gatavības signāls. Ja nedzirdat centrāles gatavības signālu, izmantojiet citu tālruņa kabeli. Ja joprojām nedzirdat centrāles gatavības signālu, pievienojiet analogo tālruni citai kontaktligzdai. Ja ir dzirdams centrāles gatavības signāls, pievienojiet printeri šai kontaktligzdai. Vai varat nosūtīt vai saņemt faksu? Problēma ir novērsta. Pārbaudiet, vai printeris ir pievienots analogās tālruņa līnijas pakalpojumam vai pareizajam ciparu savienotājam. Ja izmantojat platjoslas integrēto pakalpojumu cipartīklu (Integrated Services for Digital Network — ISDN), pievienojiet printeri ISDN termināļa adaptera analogā tālruņa portā. Papildinformāciju jautājiet ISDN pakalpojumu sniedzējam. Ja izmantojat DSL, pievienojiet DSL filtru vai maršrutētāju, kas atbalsta analogās līnijas izmantošanu. Papildinformāciju jautājiet DSL pakalpojumu sniedzējam. Ja izmantojat privātā atzara centrāles (private branch exchange — PBX) tālruņa pakalpojumu, nodrošiniet analogu pieslēgumu PBX. Ja tāda nav, apsveriet iespēju izveidot faksa aparātam paredzētu analogo tālruņa līniju. Vai varat nosūtīt vai saņemt faksu? Problēma ir novērsta. Īslaicīgi atvienojiet citas ierīces un atspējojiet citus tālruņa pakalpojumus. Atvienojiet citas ierīces (piemēram, automātiskos atbildētājus, datorus, modemus vai tālruņa līnijas sadalītājus), kas atrodas starp printeri un tālruņa līniju. Atspējojiet zvanu gaidīšanu un balss pastu. Papildinformāciju jautājiet tālruņa pakalpojumu uzņēmumam. Vai varat nosūtīt vai saņemt faksu? Problēma ir novērsta. Skenējiet oriģinālo dokumentu pa vienai lapai. Ievadiet faksa numuru. Skenējiet dokumentu. Vai varat nosūtīt vai saņemt faksu? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . faksa problēmu novēršana nevar nosūtīt vai saņemt faksu, izmantojot analogo faksu problēmu novēršana, fakss nevar nosūtīt vai saņemt faksu, izmantojot analogo faksu nevar nosūtīt vai saņemt faksu, izmantojot analogo faksu"},{"UUID":"d7e32294-7cef-4a62-bd46-b3ba35212e2c","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Faksu var saņemt, bet nevar","descFull":"Faksu var saņemt, bet nevar nosūtīt, izmantojot analogo faksu Problēmas novēršanai veicamās darbības Darbība Jā Nē Pareizi ievietojiet oriģinālo dokumentu ADF paplātē vai novietojiet to uz skenera stikla. Vai varat nosūtīt faksus? Problēma ir novērsta. Pareizi iestatiet īsceļa numuru. Pārbaudiet, vai īsceļa numurs ir iestatīts tālruņa numuram, uz kuru vēlaties zvanīt. Sastādiet tālruņa numuru manuāli. Vai varat nosūtīt faksus? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Pareizi iestatiet īsceļa numuru. Pārbaudiet, vai īsceļa numurs ir iestatīts tālruņa numuram, uz kuru vēlaties zvanīt. Sastādiet tālruņa numuru manuāli. Vai varat nosūtīt faksus? Problēma ir novērsta. Sazinieties ar  tehnisko atbalstu . faksa problēmu novēršana nevar nosūtīt faksu, izmantojot analogo faksu problēmu novēršana, fakss nevar nosūtīt faksu, izmantojot analogo faksu"},{"UUID":"bcefa130-4513-4cd5-95a1-61d9a25bf4f6","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Faksu var nosūtīt, bet nevar","descFull":"Faksu var nosūtīt, bet nevar saņemt, izmantojot analogo faksu Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārliecinieties, vai papīra avota tvertne nav tukša. Vai varat saņemt faksu? Problēma ir novērsta. Pārbaudiet pirms atbildes nogaidāmo zvanu skaita iestatījumus. Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Faksa saņemšanas iestatījumi Zvana signāli pirms atbildes . Vai varat saņemt faksu? Problēma ir novērsta. Ja printeris drukā tukšas lapas, skatiet sadaļu  . Vai varat saņemt faksu? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . faksa problēmu novēršana faksu var nosūtīt, bet nevar saņemt, izmantojot analogo faksu problēmu novēršana, fakss faksu var nosūtīt, bet nevar saņemt, izmantojot analogo faksu nevar saņemt faksu, izmantojot analogo faksu"},{"UUID":"7eb68029-6530-4a31-a5aa-c263384982b5","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Nevar iestatīt etherFAX Problēmas novēršanai","descFull":"Nevar iestatīt etherFAX Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet printera savienojumu. Izdrukājiet  tīkla iestatīšanas lapu . Sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites Tīkls Tīkla iestatīšanas lapa . Pārbaudiet tīkla statusu. Vai printeris ir pievienots tīklam? Pārejiet pie 3. darbības. Pārbaudiet, vai printeris ir pievienots tīklam un tīkls ir savienots ar internetu. Vai varat iestatīt etherFAX? Problēma ir novērsta. Pārbaudiet, vai etherFAX ir iestatīts pareizi. Lai iegūtu papildinformāciju, skatiet:  . Vai varat iestatīt etherFAX? Problēma ir novērsta. Atveriet  https://www.etherfax.net/lexmark . faksa problēmu novēršana nevar iestatīt etherFAX problēmu novēršana, fakss nevar iestatīt etherFAX"},{"UUID":"4bd3d787-a2f5-48b4-a94f-acddb6032e81","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Nevar nosūtīt vai saņemt faksu,","descFull":"Nevar nosūtīt vai saņemt faksu, izmantojot etherFAX Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai printeris ir pievienots tīklam un tīkls ir savienots ar internetu. Vai varat nosūtīt vai saņemt faksu, izmantojot etherFAX? Problēma ir novērsta. Pārbaudiet, vai etherFAX ir iestatīts pareizi. Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana Vispārīgi faksa iestatījumi . Pārbaudiet, vai jums ir pareizais faksa numurs. Nodrošiniet, lai  Faksa pārraide  iestatījums ir  etherFAX . Šī izvēlne ir redzama tikai tad, ja ir pieejama vairāk nekā viena faksa pārraide. Ja printerim ir uzstādīta tikai etherFAX, tā tiek automātiski konfigurēta. Vai varat nosūtīt vai saņemt faksu, izmantojot etherFAX? Problēma ir novērsta. Sadaliet lielus dokumentus mazākos failos. Vai varat nosūtīt vai saņemt faksu, izmantojot etherFAX? Problēma ir novērsta. Atveriet  https://www.etherfax.net/lexmark . faksa problēmu novēršana nevar nosūtīt vai saņemt faksu, izmantojot etherFAX problēmu novēršana, fakss nevar nosūtīt vai saņemt faksu, izmantojot etherFAX nevar nosūtīt vai saņemt faksu, izmantojot etherFAX"},{"UUID":"9955b146-4b10-49f1-b6a0-69f2b8f46ef9","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Slikta faksa izdrukas kvalitāte Problēmas","descFull":"Slikta faksa izdrukas kvalitāte Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārliecinieties, vai nav drukas kvalitātes problēmu. Sākuma ekrānā pieskarieties pie  Iestatījumi Problēmu novēršana Drukas kvalitātes testa lapas . Novērsiet visas drukas kvalitātes problēmas. Lai iegūtu papildinformāciju, skatiet:  . Vai faksa izdrukas kvalitāte ir apmierinoša? Problēma ir novērsta. Ja izmantojat analogo faksu, samaziniet ienākošā faksa pārraides ātrumu. Sākuma ekrānā pieskarieties pie  Iestatījumi Fakss Faksa iestatīšana  Faksa saņemšanas iestatījumi Administratora vadīklas . Izvēlnē Maksimālais ātrums atlasiet lēnāku pārraides ātrumu. Vai faksa izdrukas kvalitāte ir apmierinoša? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . faksa problēmu novēršana slikta izdrukas kvalitāte slikta faksa izdrukas kvalitāte problēmu novēršana, fakss slikta izdrukas kvalitāte"},{"UUID":"a6202e4f-ddf4-4ec3-a456-440784d1706d","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"Trūkst informācijas faksa titullapā Problēmas","descFull":"Trūkst informācijas faksa titullapā Problēmas novēršanai veicamās darbības Darbība Nē Jā Izslēdziet printeri, nogaidiet aptuveni 10 sekundes un pēc tam ieslēdziet printeri. Sūtiet vai izgūstiet faksu. Vai faksa titullapā trūkst informācijas? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . faksa problēmu novēršana trūkst informācijas faksa titullapā problēmu novēršana, fakss trūkst informācijas faksa titullapā trūkst informācijas faksa titullapā"},{"UUID":"00b6fe6a-55c8-474e-9e15-5255a768bf2b","title":"Faksa sūtīšanas problēmas","link":"trb-caller-id-not-shown-topic.html","desc":"No datora nevar nosūtīt faksa","descFull":"No datora nevar nosūtīt faksa titullapu Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai printera draiveris ir atjaunināts. Lai iegūtu papildinformāciju, skatiet:  . Nosūtiet faksu. Vai varat nosūtīt faksa titullapu? Problēma ir novērsta. Dokumentā, kuru vēlaties nosūtīt pa faksu, atveriet dialoglodziņu  Drukāšana . Atlasiet printeri un pēc tam noklikšķiniet uz  Rekvizīti ,  Preferences ,  Opcijas  vai  Iestatīšana . Noklikšķiniet uz  Fakss  un pēc tam notīriet iestatījuma  Vienmēr parādīt iestatījumus pirms faksa sūtīšanas  atzīmi. Nosūtiet faksu. Vai varat nosūtīt faksa titullapu? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . faksa problēmu novēršana no datora nevar nosūtīt faksa titullapu problēmu novēršana, fakss no datora nevar nosūtīt faksa titullapu no datora nevar nosūtīt faksa titullapu"},{"UUID":"e04cd067-c713-46d3-8ede-0799bb475cb3","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nevar skenēt datorā Problēmas novēršanai","descFull":"Nevar skenēt datorā Problēmas novēršanai veicamās darbības Darbība Jā Nē Veiciet kopēšanas darbu. Vai kopēšanas darbs tika veiksmīgi izpildīts? Pārejiet pie 3. darbības. Izslēdziet printeri, nogaidiet aptuveni 10 sekundes un pēc tam atkārtoti ieslēdziet printeri. Skenējiet dokumentu. Vai varat skenēt dokumentu datorā? Problēma ir novērsta. Pārbaudiet printera savienojumu. Izdrukājiet  tīkla iestatīšanas lapu . Sākuma ekrānā pieskarieties pie  Iestatījumi Atskaites Tīkls Tīkla iestatīšanas lapa . Pārbaudiet tīkla statusu. Vai printeris ir pievienots tīklam? Pārejiet pie 5. darbības. Pievienojiet printeri tīklam. Skenējiet dokumentu. Vai varat skenēt dokumentu datorā? Problēma ir novērsta. Nodrošiniet, lai printeris un dators ir pievienoti vienam tīklam. Skenējiet dokumentu. Vai varat skenēt dokumentu datorā? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . skenēšanas problēmu novēršana nevar skenēt datorā problēmu novēršana, skenēšana nevar skenēt datorā nevar skenēt datorā"},{"UUID":"3d9901c7-c4e7-4718-8d88-a749f69867cc","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nevar skenēt tīkla mapē Problēmas","descFull":"Nevar skenēt tīkla mapē Problēmas novēršanai veicamās darbības Darbība Jā Nē Izveidojiet tīkla mapes īsceļu. Skenējiet dokumentu, izmantojot īsceļu. Lai iegūtu papildinformāciju, skatiet:  . Vai varat skenēt dokumentu un saglabāt to tīkla mapē? Problēma ir novērsta. Pārbaudiet, vai tīkla mapes ceļš un formāts ir pareizs. Piemēram,  // servera_resursdatoranosaukums /mapesnosaukums/ceļš , kur  servera_resursdatoranosaukums  ir pilnībā kvalificēts domēns (fully qualified domain — FQDN) vai IP adrese. Vai tīkla mapes ceļš un formāts ir pareizs? Pārejiet pie 4. darbības. Pārbaudiet, vai jums ir rakstīšanas piekļuves atļauja tīkla mapei. Vai varat skenēt dokumentu un saglabāt to tīkla mapē? Problēma ir novērsta. Atjauniniet tīkla mapes īsceļu. Atveriet tīmekļa pārlūkprogrammu un adreses laukā ierakstiet printera IP adresi. Printera IP adrese ir redzama sākuma ekrānā. IP adrese tiek attēlota kā četras ciparu kopas, kas atdalītas ar punktiem, piemēram, 123.123.123.123. Ja lietojat starpniekserveri, uz laiku to atspējojiet, lai tīmekļa lapa tiktu pareizi ielādēta. Noklikšķiniet uz  Īsceļi  un pēc tam atlasiet īsceļu. Ja jums ir vairāki īsceļu veidi, atlasiet  Tīkla mape . Laukā  Kopīgošanas ceļš  ierakstiet tīkla mapes ceļu. Ja jūsu kopīgošanas ceļš ir  \\\\servera_resursdatoranosaukums\\mapesnosaukums\\ceļš , ierakstiet  //servera_resursdatoranosaukums/mapesnosaukums/ceļš . Ierakstot kopīgošanas ceļu, noteikti izmantojiet uz priekšu vērstās slīpsvītras. Izvēlnē  Autentifikācija  atlasiet autentifikācijas metodi. Ja izvēlnē  Autentifikācija  ir iestatījums  Lietot piešķirto lietotājvārdu un paroli , laukā  Lietotājvārds  un  Parole  ierakstiet savus akreditācijas datus. Noklikšķiniet uz  Saglabāt . Vai varat skenēt dokumentu un saglabāt to tīkla mapē? Problēma ir novērsta. Nodrošiniet, lai printeris un tīkla mape ir pievienoti vienam tīklam. Vai varat skenēt dokumentu un saglabāt to tīkla mapē? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . nevar skenēt tīkla mapē problēmu novēršana, skenēšana nevar skenēt tīkla mapē skenēšanas problēmu novēršana nevar skenēt tīkla mapē"},{"UUID":"eb2c970a-a6c0-4bed-bacf-e4f5a9cacdce","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Daļējas dokumenta vai fotoattēla izdrukas","descFull":"Daļējas dokumenta vai fotoattēla izdrukas Problēmas novēršanai veicamās darbības Darbība Jā Nē Nodrošiniet, lai dokuments vai fotoattēls tiek novietots skenera stikla kreisās puses augšējā stūrī ar apdrukāto pusi uz leju. Kopējiet dokumentu vai fotoattēlu. Vai dokuments vai fotoattēls tiek kopēts pareizi? Problēma ir novērsta. Pārbaudiet, vai papīra izmēri atbilst paplātē ievietotajam papīram. Kopējiet dokumentu vai fotoattēlu. Vai dokuments vai fotoattēls tiek kopēts pareizi? Problēma ir novērsta. Sazinieties ar  klientu atbalsts . Pārbaudiet, vai papīra izmēri atbilst paplātē ievietotajam papīram. Kopējiet dokumentu vai fotoattēlu. Vai dokuments vai fotoattēls tiek kopēts pareizi? Problēma ir novērsta. Sazinieties ar  tehniskais atbalsts . problēmu novēršana, kopēšana daļējas dokumentu vai fotoattēlu izdrukas kopēšanas problēmu novēršana daļējas dokumentu vai fotoattēlu izdrukas problēmu novēršana, skenēšana daļējas dokumentu vai fotoattēlu izdrukas skenēšanas problēmu novēršana daļējas dokumentu vai fotoattēlu izdrukas"},{"UUID":"f2a2b847-5c6e-4e00-ac42-39e5f3fb4757","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Slikta kopijas kvalitāte Problēmas novēršanai","descFull":"Slikta kopijas kvalitāte Problēmas novēršanai veicamās darbības Darbība Jā Nē Notīriet skenera stiklu un ADF stiklu, izmantojot mīkstu, samitrinātu drānu bez plūksnām. Ja printerim ADF korpusā ir otrs ADF stikls, notīriet arī šo stiklu. Lai iegūtu papildinformāciju, skatiet:  . Nodrošiniet, lai dokuments vai fotoattēls tiek novietots skenera stikla kreisās puses augšējā stūrī ar apdrukāto pusi uz leju. Kopējiet dokumentu vai fotoattēlu. Vai kopijas kvalitāte ir apmierinoša? Problēma ir novērsta. Pārbaudiet oriģinālā dokumenta vai fotoattēla kvalitāti. Koriģējiet skenēšanas kvalitātes iestatījumus. Kopējiet dokumentu vai fotoattēlu. Vai kopijas kvalitāte ir apmierinoša? Problēma ir novērsta. Kontaktinformācija  klientu atbalstu . Pārbaudiet oriģinālā dokumenta vai fotoattēla kvalitāti. Koriģējiet skenēšanas kvalitātes iestatījumus. Kopējiet dokumentu vai fotoattēlu. Vai kopijas kvalitāte ir apmierinoša? Problēma ir novērsta. Kontaktinformācija  tehnisko atbalstu . kopēšanas problēmu novēršana slikta kopijas kvalitāte problēmu novēršana, kopēšana slikta kopijas kvalitāte skenēšanas problēmu novēršana slikta kopijas kvalitāte problēmu novēršana, skenēšana slikta kopijas kvalitāte"},{"UUID":"61b28423-0363-4e4f-8b61-57847689f961","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Izdrukās ir vertikālas tumšas svītras,","descFull":"Izdrukās ir vertikālas tumšas svītras, skenējot no ADF Problēmas novēršanai veicamās darbības Darbība Jā Nē Atveriet skenera vāku. Izmantojot mitru, mīkstu drānu bez plūksnām, noslaukiet ADF stiklu un ADF stikla pamatni. Aizveriet skenera vāku. Skenējiet dokumentu. Vai skenētajos dokumentos ir redzamas vertikālas svītras? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, skenēšana izdrukās ir vertikālas tumšas svītras, skenējot no ADF skenēšanas problēmu novēršana izdrukās ir vertikālas tumšas svītras, skenējot no ADF izdrukās ir vertikālas tumšas svītras, skenējot no ADF skenēšanas kvalitātes problēma"},{"UUID":"9293f0c1-3fe3-4d32-b733-c54fd92fc632","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Robains attēls vai teksts, skenējot","descFull":"Robains attēls vai teksts, skenējot no ADF Problēmas novēršanai veicamās darbības Darbība Jā Nē Ievietojiet ADF 50 tīras vienkārša papīra loksnes. Vienkāršs papīrs palīdz notīrīt vai noņemt putekļus un citus netīrumus no ADF padeves ruļļiem. Sākuma ekrānā pieskarieties pie  . Ievietojiet ADF oriģinālo dokumentu. Skenējiet dokumentu. Vai izdrukā ir robaini attēli vai teksts? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, skenēšana robains attēls, skenējot no ADF problēmu novēršana, skenēšana robains teksts, skenējot no ADF skenēšanas problēmu novēršana robains attēls, skenējot no ADF skenēšanas problēmu novēršana robains teksts, skenējot no ADF robains attēls skenēšana no ADF robains teksts skenēšana no ADF skenēšana no ADF robains attēls skenēšana no ADF robains teksts"},{"UUID":"178d9d21-159e-4e07-84d5-47936ff93c2d","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skenēšanas darbs bija neveiksmīgs Problēmas","descFull":"Skenēšanas darbs bija neveiksmīgs Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet kabeļu savienojumus. Nodrošiniet, lai Ethernet vai USB kabeļi ir droši pievienoti datoram un printerim. Atkārtoti nosūtiet skenēšanas darbu. Vai skenēšanas darbs tika veiksmīgi izpildīts? Problēma ir novērsta. Pārbaudiet skenējamo failu. Nodrošiniet, lai faila nosaukums jau netiek izmantots galamērķa mapē. Nodrošiniet, lai skenējamais dokuments vai fotoattēls nav atvērts citā lietojumprogrammā. Atkārtoti nosūtiet skenēšanas darbu. Vai skenēšanas darbs tika veiksmīgi izpildīts? Problēma ir novērsta. Nodrošiniet, lai galamērķa konfigurācijas iestatījumos ir atzīmēta izvēles rūtiņa  Pievienot laikspiedolu  vai  Pārrakstīt esošo failu . Atkārtoti nosūtiet skenēšanas darbu. Vai skenēšanas darbs tika veiksmīgi izpildīts? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Nodrošiniet, lai galamērķa konfigurācijas iestatījumos ir atzīmēta izvēles rūtiņa  Pievienot laikspiedolu  vai  Pārrakstīt esošo failu . Atkārtoti nosūtiet skenēšanas darbu. Vai skenēšanas darbs tika veiksmīgi izpildīts? Problēma ir novērsta. Sazinieties ar  tehnisko atbalstu . skenēšanas problēmu novēršana skenēšanas darbs bija neveiksmīgs problēmu novēršana, skenēšana skenēšanas darbs bija neveiksmīgs"},{"UUID":"59322f5f-4c90-473e-b73e-6a5fda762c8d","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skeneri nevar aizvērt Problēmas novēršanai","descFull":"Skeneri nevar aizvērt Problēmas novēršanai veicamā darbība Darbība Jā Nē Noņemiet visus priekšmetus, kas neļauj aizvērt skenera vāku. Vai skenera vāks tika pareizi aizvērts? Problēma ir novērsta. Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . problēmu novēršana, kopēšana skeneri nevar aizvērt problēmu novēršana, skenēšana skeneri nevar aizvērt skeneri nevar aizvērt"},{"UUID":"8e949756-bf25-4c93-a90d-e5b4eef380c0","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skenēšana ir pārāk ilga vai","descFull":"Skenēšana ir pārāk ilga vai liek sastingt datoram Problēmas novēršanai veicamās darbības Darbība Jā Nē Aizveriet visas lietojumprogrammas, kas traucē skenēšanai. Vai skenēšana ir pārāk ilga vai liek sastingt datoram? Sazinieties ar  klientu atbalsts . Sazinieties ar  tehniskais atbalsts . Problēma ir novērsta. skenēšanas problēmu novēršana skenēšana ir pārāk ilga skenēšanas problēmu novēršana skenēšana liek sastingt datoram"},{"UUID":"d8406ecf-87bd-4f13-908b-eb33464062f0","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skeneris nereaģē Problēmas novēršanai veicamās","descFull":"Skeneris nereaģē Problēmas novēršanai veicamās darbības Darbība Jā Nē Pārbaudiet, vai strāvas vads ir pareizi pievienots printerim un elektrotīklam. Lai izvairītos no aizdegšanās vai elektrošoka riska, pievienojiet strāvas vadu pie tāda elektrotīkla, kuram ir attiecīgā nominālā strāva, kas ir pareizi iezemēts, atrodas produkta tuvumā un kuram var ērti piekļūt. Kopējiet vai skenējiet dokumentu. Vai skeneris reaģē? Problēma ir novērsta. Pārbaudiet, vai printeris ir ieslēgts. Novērsiet kļūdu ziņojumus, kas ir redzami displejā. Kopējiet vai skenējiet dokumentu. Vai skeneris reaģē? Problēma ir novērsta. Izslēdziet printeri, nogaidiet aptuveni 10 sekundes un pēc tam ieslēdziet printeri. Kopējiet vai skenējiet dokumentu. Vai skeneris reaģē? Problēma ir novērsta. Kontaktinformācija  klientu atbalstu . Izslēdziet printeri, nogaidiet aptuveni 10 sekundes un pēc tam ieslēdziet printeri. Kopējiet vai skenējiet dokumentu. Vai skeneris reaģē? Problēma ir novērsta. Kontaktinformācija  tehnisko atbalstu . problēmu novēršana, kopēšana skeneris nereaģē kopēšanas problēmu novēršana skeneris nereaģē problēmu novēršana, skenēšana skeneris nereaģē skenēšanas problēmu novēršana skeneris nereaģē"},{"UUID":"4e1f7d8c-7927-458d-b031-c8dc98a0bc99","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skenera reģistrācijas koriģēšana Sākuma ekrānā","descFull":"Skenera reģistrācijas koriģēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Skenera konfigurēšana Skenera manuāla reģistrēšana . Izvēlnē Ātrais drukāšanas tests pieskarieties pie  Sākt . Ātrā drukāšanas testa lapu novietojiet uz skenera stikla un pēc tam pieskarieties pie  Plakanvirsmas reģistrēšana . Izvēlnē Ātrais kopēšanas tests pieskarieties pie  Sākt . Salīdziniet ātrā kopēšanas testa lapu ar oriģinālo dokumentu. Ja testa lapas piemales atšķiras no oriģinālā dokumenta, koriģējiet opcijas Kreisā piemale un Augšējā piemale. Atkārtojiet   un  , līdz ātrā kopēšanas testa lapas piemales tuvu atbilst oriģinālajam dokumentam. koriģēšana skenera reģistrēšana"},{"UUID":"33d0a21f-cf70-4ff2-8ec2-77a4dac4d2c8","title":"Skenēšanas problēmas","link":"trb-cannot-scan-to-computer-topic.html","desc":"ADF reģistrācijas koriģēšana Sākuma ekrānā","descFull":"ADF reģistrācijas koriģēšana Sākuma ekrānā pieskarieties pie  Iestatījumi Ierīce Apkope Izvēlne Konfigurēšana Skenera konfigurēšana Skenera manuāla reģistrēšana . Izvēlnē Ātrais drukāšanas tests pieskarieties pie  Sākt . Ātrā drukāšanas testa lapu novietojiet uz ADF paplātes. Pieskarieties pie  Priekšējā ADF reģistrēšana  vai  Aizmugurējā ADF reģistrēšana . Lai līdzinātu priekšējo ADF reģistrēšanu, testa lapu novietojiet ar apdrukāto pusi uz augšu, ADF vispirms ievietojot īso malu. Lai līdzinātu aizmugurējo ADF reģistrēšanu, testa lapu novietojiet ar apdrukāto pusi uz leju, ADF vispirms ievietojot īso malu. Izvēlnē Ātrais kopēšanas tests pieskarieties pie  Sākt . Salīdziniet ātrā kopēšanas testa lapu ar oriģinālo dokumentu. Ja testa lapas piemales atšķiras no oriģinālā dokumenta, koriģējiet opcijas Horizontāla koriģēšana un Augšējā piemale. Atkārtojiet   un  , līdz ātrā kopēšanas testa lapas piemales tuvu atbilst oriģinālajam dokumentam. ADF reģistrācija koriģēšana ADF reģistrācijas koriģēšana"},{"UUID":"516bafe2-9a09-41e8-bf0c-6890af5d2158","title":"Krāsas kvalitātes problēmas","link":"modifying-colors-in-printed-output-topic.html","desc":"Krāsu modificēšana izdrukās Sākuma ekrānā","descFull":"Krāsu modificēšana izdrukās Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu korekcija . Izvēlnē  Krāsu korekcija  pieskarieties pie  Manuāli Krāsu korekcijas saturs . Izvēlieties piemērotu krāsu konversijas iestatījumu. Izvēlnes Manuāla krāsa objektu veidi un to krāsu konvertēšanas tabulas Objekta veids Krāsu konvertēšanas tabulas RGB attēls RGB teksts RGB grafika Spilgts  — rada spilgtākas, piesātinātākas krāsas un var tikt lietots visiem ienākošajiem krāsu formātiem. sRGB displejs  — veido izdruku, kas tuvu atbilst datora monitorā redzamajām krāsām. Melnā tonera lietojums ir optimizēts fotoattēlu drukāšanai. Displejs-dziļi melns  — veido izdruku, kas tuvu atbilst datora monitorā redzamajām krāsām. Šis iestatījums izmanto tikai melno toneri, lai atveidotu visus neitrāli pelēkā līmeņus. sRGB spilgts  — nodrošina paaugstinātu krāsu piesātinājumu iestatījuma  sRGB displejs  krāsu korekcijai. Melnā tonera lietojums ir optimizēts uzņēmumu grafiku drukāšanai. Izslēgts CMYK attēls CMYK teksts CMYK grafika ASV CMYK  — lieto krāsu korekciju, lai izdruka tuvu atbilstu SWOP (Specifications for Web Offset Publishing) krāsu izvadei. Eiropas CMYK  — lieto krāsu korekciju, lai izdruka tuvu atbilstu Eiropas krāsu shēmas izvadei. Spilgts CMYK  — paaugstina krāsu piesātinājumu iestatījuma  ASV CMYK  krāsu korekcijai. Izslēgts krāsu izvades modificēšana manuāla krāsas korekcija krāsu korekcija"},{"UUID":"6d7f2660-b460-4469-b382-d9edde6043ea","title":"Krāsas kvalitātes problēmas","link":"modifying-colors-in-printed-output-topic.html","desc":"Bieži uzdotie jautājumi par krāsu","descFull":"Bieži uzdotie jautājumi par krāsu druku Kas ir RGB krāsu modelis? RGB krāsu modelis ir krāsu aprakstīšanas metode, kurā tiek norādīts konkrētas krāsas izveidei nepieciešamais sarkanā, zaļā vai zilā daudzums. Sarkanu, zaļu un zilu gaismu var pievienot dažādos daudzumos, lai izveidotu plašu krāsu diapazonu, kas novērojams dabā. Datoru ekrānos, skeneros un digitālajās kamerās šī metode tiek izmantota, lai parādītu krāsas. Kas ir CMYK krāsu modelis? CMYK krāsu modelis ir krāsu aprakstīšanas metode, kurā tiek norādīts konkrētas krāsas atveidei nepieciešamais ciāna, madžentas, dzeltenā un melnā daudzums. Dažādā daudzumā drukājot ciāna, madžentas, dzelteno un melno tinti vai toneri, var izveidot plašu krāsu diapazonu, kas novērojams dabā. Šādā veidā tiek radītas krāsas iespiedmašīnās, strūklprinteros un krāsu lāzerprinteros. Kā krāsa ir norādīta drukājamajā dokumentā? Programmatūras programmas tiek izmantotas, lai norādītu un modificētu dokumenta krāsu, izmantojot RGB vai CMYK krāsu kombinācijas. Papildinformāciju skatiet programmatūras programmu palīdzības tēmās. Kā printeris zina, kādu krāsu drukāt? Drukājot dokumentu, uz printeri tiek nosūtīta informācija par katra objekta veidu un krāsu; šī informācija tiek sūtīta caur krāsu konvertēšanas tabulām. Krāsa ir attiecīgs ciāna, madžentas, dzeltenā un melnā tonera daudzums, ko izmanto, lai iegūtu vajadzīgo krāsu. Objekta informācija nosaka krāsu konvertēšanas tabulu piemērošanu. Piemēram, ir iespējams tekstam piemērot viena veida krāsu konvertēšanas tabulu, bet fotoattēliem piemērot citu krāsu konvertēšanas tabulu. Kas ir manuāla krāsas korekcija? Ja ir iespējota manuāla krāsu korekcija, printeris izmanto lietotāja atlasītas krāsu konvertēšanas tabulas, lai apstrādātu objektus. Manuālas krāsu korekcijas iestatījumi ir atkarīgi no drukājamā objekta veida (teksts, grafika vai attēli). Tie ir arī atkarīgi no veida, kādā objekta krāsa ir norādīta programmatūras programmā (RGB vai CMYK kombinācijas). Lai manuāli lietotu citu krāsu konvertēšanas tabulu, skatiet  . Ja programmatūras programma nenorāda krāsas ar RGB vai CMYK kombinācijām, manuāla krāsu labošana nav noderīga. Tā nav efektīva arī gadījumos, kad programmatūras programma vai datora operētājsistēma kontrolē krāsu koriģēšanu. Vairumā gadījumu, ja opcijas Krāsu korekcija iestatījums ir Automātiski, tiek iegūtas vēlamās dokumenta krāsas. Kā es varu iegūt konkrētu krāsu (piemēram, uzņēmuma logotipam)? Printera izvēlnē Kvalitāte ir pieejami deviņi krāsu paraugu kopu veidi. Šīs kopas ir pieejamas arī servera Embedded Web Server lapā Krāsu paraugi. Atlasot jebkuru paraugu kopu, tiek ģenerēta vairāku lapu izdruka, kas sastāv no simtiem krāsainu kvadrātu. Atkarībā no atlasītās tabulas katrā kvadrātā ir CMYK vai RGB kombinācija. Katra kvadrāta attēlotā krāsa ir iegūta, kvadrātā norādīto CMYK vai RGB kombināciju pārsūtot caur atlasīto konvertēšanas tabulu. Izpētot krāsu paraugu kopas, varat noteikt kvadrātu, kura krāsa vistuvāk atbilst vajadzīgajai krāsai. Pēc tam varat izmantot kvadrātā norādīto krāsu kombināciju, lai objekta krāsu modificētu programmatūrā. Papildinformāciju skatiet programmatūras programmu palīdzības tēmās. Manuāla krāsu korekcija var būt nepieciešama, lai atlasīto krāsu konvertēšanas tabulu izmantotu konkrētam objektam. Lai atlasītu konkrētu krāsu paraugu kopu, ko lietot noteiktu krāsu atbilstības problēmu novēršanai, ir jāņem vērā šādas lietas: Izmantotās krāsu korekcijas iestatījums (Automātiski, Izslēgts vai Manuāli) Drukājamā objekta veids (teksts, grafika vai attēli) Veids, kā objekta krāsa ir norādīta programmatūras programmās (RGB vai CMYK kombinācijas) Ja programmatūras programmas nenorāda krāsas, izmantojot RGB vai CMYK kombinācijas, krāsu paraugu lapas nav noderīgas. Turklāt dažas programmatūras programmas koriģē programmā norādītās RGB vai CMYK kombinācijas, izmantojot krāsu pārvaldību. Šādā gadījumā izdrukātā krāsa var precīzi neatbilst krāsu paraugu lapām. problēmu novēršana Bieži uzdotie jautājumi par krāsu druku Bieži uzdotie jautājumi par krāsu druku"},{"UUID":"05fd3740-52a0-4683-a8ed-b30ebcf1d9be","title":"Krāsas kvalitātes problēmas","link":"modifying-colors-in-printed-output-topic.html","desc":"Izdruka izskatās iekrāsota Problēmas novēršanai","descFull":"Izdruka izskatās iekrāsota Problēmas novēršanai veicamās darbības Darbība Jā Nē Izmantojiet iestatījumu  Krāsu koriģēšana . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu koriģēšana . Izdrukājiet dokumentu. Vai izdruka izskatās iekrāsota? Problēma ir novērsta. Izmantojiet iestatījumu  Krāsu balanss . Sākuma ekrānā pieskarieties pie  Iestatījumi Drukāšana Kvalitāte Attēlveidošanas papildu iestatījumi Krāsu balanss . Koriģējiet iestatījumus. Izdrukājiet dokumentu. Vai izdruka izskatās iekrāsota? Sazinieties ar  klientu atbalstu . Sazinieties ar  tehnisko atbalstu . Problēma ir novērsta. problēmu novēršana, krāsas kvalitāte izdruka izskatās iekrāsota krāsas kvalitāte, problēmu novēršana izdruka izskatās iekrāsota izdruka izskatās iekrāsota"},{"UUID":"3ff777da-1c30-44c0-b7af-d5147b998b74","title":"Problēmas novēršana","link":"trb-contacting-customer-support-topic.html","desc":"Sazināšanās ar klientu atbalstu Pirms","descFull":"Sazināšanās ar klientu atbalstu Pirms sazināties ar klientu atbalsta nodaļu, sagatavojiet šādu informāciju: Printera problēma Kļūdas ziņojums Printera modeļa veids un sērijas numurs Apmeklējiet vietni  http://support.lexmark.com , lai saņemtu atbalstu, izmantojot e-pastu vai tērzēšanu, vai pārlūkojiet bibliotēku ar rokasgrāmatām, atbalsta dokumentāciju, draiveriem un citu lejupielādējamu informāciju. Ir pieejams arī tehniskais atbalsts pa tālruni. ASV vai Kanādā zvaniet pa tālruni 1-800-539-6275. Ja atrodaties citā valstī vai reģionā, apmeklējiet vietni  http://support.lexmark.com . Dodieties uz printera iegādes vietu. sazināšanās ar klientu atbalstu klientu atbalsts sazināšanās"},{"UUID":"97c0c1cd-6723-409b-a703-7a2108a94739","title":"Problēmas novēršana","link":"troubleshooting-chapter.html","desc":"Sazināšanās ar tehnisko atbalstu Zvanot","descFull":"Sazināšanās ar tehnisko atbalstu Zvanot tehniskā atbalsta nodaļai, pastāstiet par problēmu, printera displejā redzamo ziņojumu un darbībām, kuras esat jau veicis. Aplūkojiet etiķeti augšējā priekšējā vāka iekšpusē vai printera korpusa aizmugurē un pierakstiet šādu informāciju: printera modeli; servisa etiķetes numuru vai speciālo servisa kodu. Lai iegūtu papildinformāciju, apmeklējiet vietni  www.dell.com/support . problēmu novēršana sazināšanās ar tehnisko atbalstu sazināšanās ar tehnisko atbalstu"},{"UUID":"60c33a6b-d719-4eab-9ecf-06c4151ffbf6","title":"Otrreizējā pārstrāde un atbrīvošanās","link":"recycling-lexmark-products-topic.html","desc":"Lexmark produktu otrreizēja pārstrāde Lai","descFull":"Lexmark produktu otrreizēja pārstrāde Lai atgrieztu Lexmark produktus otrreizējai pārstrādei: Skatiet vietni  www.lexmark.com/recycle . Izvēlieties produktu, kuru vēlaties otrreiz pārstrādāt. Tos printera materiālus un aparatūru, kas nav norādīta Lexmark savākšanas un otrreizējās pārstrādes programmā (Lexmar Collection and Recycling Program), var nodot otrreizējai pārstrādei vietējā otrreizējās pārstādes iestādē. otrreizēja pārstrāde Lexmark produkti"},{"UUID":"8875fd1b-a056-4000-ac1d-8278db107865","title":"Otrreizējā pārstrāde un atbrīvošanās","link":"recycling-lexmark-packaging-topic.html","desc":"Lexmark iepakojuma otrreizēja pārstrāde Lexmark","descFull":"Lexmark iepakojuma otrreizēja pārstrāde Lexmark nepārtraukti cenšas samazināt iepakojuma materiālu apjomu. Mazāks iepakojuma materiālu apjoms palīdz nodrošināt, ka Lexmark printerus var transportēt visefektīvākajā un videi draudzīgākajā veidā, turklāt ir mazāk materiālu, no kuriem atbrīvoties. Šāda efektīva darbība sekmē arī mazāku siltumnīcefekta emisiju, taupa enerģiju un dabas resursus. Lexmark dažās valstīs vai reģionos piedāvā arī iepakojuma materiālu otrreizēju pārstrādi. Lai iegūtu papildinformāciju, skatiet vietni  www.lexmark.com/recycle  un izvēlieties savu valsti vai reģionu. Informācija par pieejamajām iepakojuma materiālu otrreizējās pārstrādes programmām ir iekļauta informācijas sadaļā par produktu otrreizējo pārstrādi. Lexmark kartons ir 100% otrreiz pārstrādājams vietās, kur ir pieejamas gofrēta papīra otrreizējās pārstrādes iekārtas. Šādu iekārtu, iespējams, jūsu reģionā nav. Lexmark iepakojuma materiālos izmantotais putuplasts ir otrreiz pārstrādājams vietās, kur ir pieejamas putuplasta otrreizējās pārstrādes iekārtas. Šādu iekārtu, iespējams, jūsu reģionā nav.  Ja uzņēmumam Lexmark atgriežat kasetni, varat izmantot kasti, kurā sākotnēji saņēmāt kasetni. Lexmark kasti otrreiz pārstrādā. otrreizēja pārstrāde Lexmark iepakojums"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"CX930, CX931, XC9325, XC9335 MFP"}},[_vm._v("\n    CX930, CX931, XC9325, XC9335 MFP\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_lv","title":"Dro&scaron;ības informācija"}},[_vm._v("\n    Drošības informācija\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Apzīmējumi"}},[_vm._v("\n     Apzīmējumi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e40","title":"Paziņojumi saistībā ar produktu"}},[_vm._v("\n     Paziņojumi saistībā ar produktu\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_lv","title":"Informācija par printeri"}},[_vm._v("\n    Informācija par printeri\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e170"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_lv","title":"Informācijas atra&scaron;ana par printeri"}},[_vm._v("\n     Informācijas atrašana par printeri\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_lv","title":"Printera sērijas numura atra&scaron;ana"}},[_vm._v("\n     Printera sērijas numura atrašana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_lv","title":"Printera konfigurācijas"}},[_vm._v("\n     Printera konfigurācijas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_lv","title":"Ja lietojat vadības paneli"}},[_vm._v("\n     Ja lietojat vadības paneli\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_lv","title":"Par indikatora gaismas statusu"}},[_vm._v("\n     Par indikatora gaismas statusu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"paper-guidelines-topic.html#d0e562","title":"Papīra izvēle"}},[_vm._v("\n     Papīra izvēle\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_lv","title":"Uzstādī&scaron;ana, instalē&scaron;ana un konfigurē&scaron;ana"}},[_vm._v("\n    Uzstādīšana, instalēšana un konfigurēšana\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e3851"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_lv","title":"Printera atra&scaron;anās vietas izvēle"}},[_vm._v("\n     Printera atrašanās vietas izvēle\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_lv","title":"Kabeļu pievieno&scaron;ana"}},[_vm._v("\n     Kabeļu pievienošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#d0e4039","title":"Sākuma ekrāna lietojumprogrammu iestatī&scaron;ana un lieto&scaron;ana"}},[_vm._v("\n     Sākuma ekrāna lietojumprogrammu iestatīšana un lietošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e4691","title":"Pieejamības funkciju iestatī&scaron;ana un lieto&scaron;ana"}},[_vm._v("\n     Pieejamības funkciju iestatīšana un lietošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e4994","title":"Faksa funkcijas iestatī&scaron;ana printerī"}},[_vm._v("\n     Faksa funkcijas iestatīšana printerī\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_lv","title":"E-pasta SMTP iestatījumu konfigurē&scaron;ana"}},[_vm._v("\n     E-pasta SMTP iestatījumu konfigurēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"loading-trays-group.html#d0e6870","title":"Papīra un speciālā apdrukājamā materiāla ievieto&scaron;ana"}},[_vm._v("\n     Papīra un speciālā apdrukājamā materiāla ievietošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e7265","title":"Programmatūras, draiveru un programmaparatūras uzstādī&scaron;ana un atjauninā&scaron;ana"}},[_vm._v("\n     Programmatūras, draiveru un programmaparatūras uzstādīšana un atjaunināšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-envelope-tray-topic.html#d0e7547","title":"Aparatūras ierīču uzstādī&scaron;ana"}},[_vm._v("\n     Aparatūras ierīču uzstādīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"networking-intro-topic.html#d0e8219","title":"Tīklo&scaron;ana"}},[_vm._v("\n     Tīklošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-serial-printing-topic.html#setting-up-serial-printing_lv","title":"Seriālās drukā&scaron;anas iestatī&scaron;ana (tikai Windows)"}},[_vm._v("\n     Seriālās drukāšanas iestatīšana (tikai Windows)\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_lv","title":"Printera dro&scaron;ība"}},[_vm._v("\n    Printera drošība\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8616"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_lv","title":"Dro&scaron;ības slota atra&scaron;ana"}},[_vm._v("\n     Drošības slota atrašana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_lv","title":"Printera atmiņas dzē&scaron;ana"}},[_vm._v("\n     Printera atmiņas dzēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_lv","title":"Printera krātuves diska dzē&scaron;ana"}},[_vm._v("\n     Printera krātuves diska dzēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_lv","title":"Rūpnīcas noklusējuma iestatījumu atjauno&scaron;ana"}},[_vm._v("\n     Rūpnīcas noklusējuma iestatījumu atjaunošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_lv","title":"Paziņojums par energoatkarību"}},[_vm._v("\n     Paziņojums par energoatkarību\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_lv","title":"Drukāt"}},[_vm._v("\n    Drukāt\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e8809"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_lv","title":"Drukā&scaron;ana no datora"}},[_vm._v("\n     Drukāšana no datora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e8835","title":"Drukā&scaron;ana no mobilās ierīces"}},[_vm._v("\n     Drukāšana no mobilās ierīces\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_lv","title":"Drukā&scaron;ana no zibatmiņas diska"}},[_vm._v("\n     Drukāšana no zibatmiņas diska\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_lv","title":"Atbalstīto zibatmiņas disku un failu veidi"}},[_vm._v("\n     Atbalstīto zibatmiņas disku un failu veidi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_lv","title":"Konfidenciālu darbu konfigurē&scaron;ana"}},[_vm._v("\n     Konfidenciālu darbu konfigurēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_lv","title":"Konfidenciālu un citu aizturētu darbu drukā&scaron;ana"}},[_vm._v("\n     Konfidenciālu un citu aizturētu darbu drukāšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_lv","title":"Fontu paraugu saraksta drukā&scaron;ana"}},[_vm._v("\n     Fontu paraugu saraksta drukāšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-h2-topic.html#printing-directory-list-h2_lv","title":"Direktoriju saraksta drukā&scaron;ana"}},[_vm._v("\n     Direktoriju saraksta drukāšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_lv","title":"Atdalo&scaron;o lapu ievieto&scaron;ana starp eksemplāriem"}},[_vm._v("\n     Atdalošo lapu ievietošana starp eksemplāriem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-printed-sheets-topic.html#stapling-printed-sheets_lv","title":"Izdrukāto lapu skavo&scaron;ana"}},[_vm._v("\n     Izdrukāto lapu skavošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_lv","title":"Caurumo&scaron;ana izdrukātās lapās"}},[_vm._v("\n     Caurumošana izdrukātās lapās\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_lv","title":"Kaudzī&scaron;u ofseta lieto&scaron;ana izdrukātajās lapās"}},[_vm._v("\n     Kaudzīšu ofseta lietošana izdrukātajās lapās\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_lv","title":"Drukas darba atcel&scaron;ana"}},[_vm._v("\n     Drukas darba atcelšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_lv","title":"Tonera intensitātes koriģē&scaron;ana"}},[_vm._v("\n     Tonera intensitātes koriģēšana\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying-chapter.html#copying-chapter_lv","title":"Kopē&scaron;ana"}},[_vm._v("\n    Kopēšana\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9600"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_lv","title":"Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana"}},[_vm._v("\n     Automātiskā dokumentu padevēja vai skenera stikla lietošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_lv","title":"Kopē&scaron;ana"}},[_vm._v("\n     Kopēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_lv","title":"Fotoattēlu kopē&scaron;ana"}},[_vm._v("\n     Fotoattēlu kopēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_lv","title":"Kopē&scaron;ana uz veidlapām"}},[_vm._v("\n     Kopēšana uz veidlapām\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_lv","title":"Kopē&scaron;ana uz abām papīra pusēm"}},[_vm._v("\n     Kopēšana uz abām papīra pusēm\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_lv","title":"Kopiju samazinā&scaron;ana vai palielinā&scaron;ana"}},[_vm._v("\n     Kopiju samazināšana vai palielināšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_lv","title":"Kopiju salik&scaron;ana"}},[_vm._v("\n     Kopiju salikšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_lv","title":"Atdalo&scaron;o lapu ievieto&scaron;ana starp eksemplāriem"}},[_vm._v("\n     Atdalošo lapu ievietošana starp eksemplāriem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_lv","title":"Vairāku lapu kopē&scaron;ana uz vienas loksnes"}},[_vm._v("\n     Vairāku lapu kopēšana uz vienas loksnes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_lv","title":"Kar&scaron;u kopē&scaron;ana"}},[_vm._v("\n     Karšu kopēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"stapling-copies-topic.html#stapling-copies_lv","title":"Kopiju skavo&scaron;ana"}},[_vm._v("\n     Kopiju skavošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"punching-holes-copies-topic.html#punching-holes-copies_lv","title":"Caurumo&scaron;ana kopijās"}},[_vm._v("\n     Caurumošana kopijās\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-offset-stacking-copies-topic.html#using-offset-stacking-copies_lv","title":"Kaudzī&scaron;u ofseta lieto&scaron;ana kopijām"}},[_vm._v("\n     Kaudzīšu ofseta lietošana kopijām\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_lv","title":"Kopē&scaron;anas īsceļa izveide"}},[_vm._v("\n     Kopēšanas īsceļa izveide\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_lv","title":"E-pasts:"}},[_vm._v("\n    E-pasts:\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e9979"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_lv","title":"Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana"}},[_vm._v("\n     Automātiskā dokumentu padevēja vai skenera stikla lietošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_lv","title":"E-pasta ziņojuma sūtī&scaron;ana"}},[_vm._v("\n     E-pasta ziņojuma sūtīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_lv","title":"E-pasta īsceļa izveide"}},[_vm._v("\n     E-pasta īsceļa izveide\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"faxing-chapter.html#faxing-chapter_lv","title":"Fakss"}},[_vm._v("\n    Fakss\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10073"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_lv","title":"Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana"}},[_vm._v("\n     Automātiskā dokumentu padevēja vai skenera stikla lietošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_lv","title":"Faksa sūtī&scaron;ana"}},[_vm._v("\n     Faksa sūtīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_lv","title":"Faksa ieplāno&scaron;ana"}},[_vm._v("\n     Faksa ieplānošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_lv","title":"Faksa galamērķa īsceļa izveide"}},[_vm._v("\n     Faksa galamērķa īsceļa izveide\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_lv","title":"Faksa iz&scaron;ķirtspējas maiņa"}},[_vm._v("\n     Faksa izšķirtspējas maiņa\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_lv","title":"Faksa intensitātes koriģē&scaron;ana"}},[_vm._v("\n     Faksa intensitātes koriģēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_lv","title":"Faksa žurnāla drukā&scaron;ana"}},[_vm._v("\n     Faksa žurnāla drukāšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_lv","title":"Nevēlamu faksu bloķē&scaron;ana"}},[_vm._v("\n     Nevēlamu faksu bloķēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_lv","title":"Faksu aizturē&scaron;ana"}},[_vm._v("\n     Faksu aizturēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_lv","title":"Faksa pāradresē&scaron;ana"}},[_vm._v("\n     Faksa pāradresēšana\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"ftp-chapter.html#ftp-chapter_lv","title":"Skenē&scaron;ana"}},[_vm._v("\n    Skenēšana\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10437"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_lv","title":"Automātiskā dokumentu padevēja vai skenera stikla lieto&scaron;ana"}},[_vm._v("\n     Automātiskā dokumentu padevēja vai skenera stikla lietošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_lv","title":"Skenē&scaron;ana uz datoru"}},[_vm._v("\n     Skenēšana uz datoru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_lv","title":"Skenē&scaron;ana uz FTP serveri"}},[_vm._v("\n     Skenēšana uz FTP serveri\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_lv","title":"FTP īsceļa izveide"}},[_vm._v("\n     FTP īsceļa izveide\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_lv","title":"Skenē&scaron;ana tīkla mapē"}},[_vm._v("\n     Skenēšana tīkla mapē\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_lv","title":"Tīkla mapes īsceļa izveide"}},[_vm._v("\n     Tīkla mapes īsceļa izveide\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_lv","title":"Skenē&scaron;ana uz zibatmiņas disku"}},[_vm._v("\n     Skenēšana uz zibatmiņas disku\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_lv","title":"Printera izvēļņu izmanto&scaron;ana"}},[_vm._v("\n    Printera izvēļņu izmantošana\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e10739"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menus-map-mfp_lv","title":"Izvēļņu karte"}},[_vm._v("\n     Izvēļņu karte\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e11102","title":"Ierīce"}},[_vm._v("\n     Ierīce\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e13477","title":"Drukāt"}},[_vm._v("\n     Drukāt\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e14883","title":"Papīrs"}},[_vm._v("\n     Papīrs\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e15252","title":"Kopē&scaron;ana"}},[_vm._v("\n     Kopēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e15914","title":"Fakss"}},[_vm._v("\n     Fakss\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e18319","title":"E-pasts:"}},[_vm._v("\n     E-pasts:\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e19369","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e19954","title":"USB disks"}},[_vm._v("\n     USB disks\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e20812","title":"Tīkls/porti"}},[_vm._v("\n     Tīkls/porti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e23002","title":"Cloud Services"}},[_vm._v("\n     Cloud Services\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e23059","title":"Dro&scaron;ība"}},[_vm._v("\n     Drošība\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e24247","title":"Atskaites"}},[_vm._v("\n     Atskaites\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_lv","title":"Problēmu novēr&scaron;ana"}},[_vm._v("\n     Problēmu novēršana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_lv","title":"Izvēļņu iestatījumu lapas drukā&scaron;ana"}},[_vm._v("\n     Izvēļņu iestatījumu lapas drukāšana\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_lv","title":"Printera uzturē&scaron;ana"}},[_vm._v("\n    Printera uzturēšana\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e24587"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_lv","title":"Detaļu un izejmateriālu statusa pārbaude"}},[_vm._v("\n     Detaļu un izejmateriālu statusa pārbaude\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_lv","title":"Izejmateriālu paziņojumu konfigurē&scaron;ana"}},[_vm._v("\n     Izejmateriālu paziņojumu konfigurēšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_lv","title":"E-pasta brīdinājumu iestatī&scaron;ana"}},[_vm._v("\n     E-pasta brīdinājumu iestatīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_lv","title":"Atskai&scaron;u skatī&scaron;ana"}},[_vm._v("\n     Atskaišu skatīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-parts-and-supplies-group.html#ordering-supplies-group_lv","title":"Detaļu un izejmateriālu pasūtī&scaron;ana"}},[_vm._v("\n     Detaļu un izejmateriālu pasūtīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e24896","title":"Detaļu un izejmateriālu nomaiņa"}},[_vm._v("\n     Detaļu un izejmateriālu nomaiņa\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e25566","title":"Printera detaļu tīrī&scaron;ana"}},[_vm._v("\n     Printera detaļu tīrīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e25834","title":"Enerģijas un papīra taupī&scaron;ana"}},[_vm._v("\n     Enerģijas un papīra taupīšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_lv","title":"Printera pārvieto&scaron;ana uz citu vietu"}},[_vm._v("\n     Printera pārvietošana uz citu vietu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_lv","title":"Printera piegāde"}},[_vm._v("\n     Printera piegāde\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_lv","title":"Problēmas novēr&scaron;ana"}},[_vm._v("\n    Problēmas novēršana\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e25988"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-topic.html#print-quality-problems_lv","title":"Drukas kvalitātes problēmas"}},[_vm._v("\n     Drukas kvalitātes problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_lv","title":"Printera kļūdu kodi"}},[_vm._v("\n     Printera kļūdu kodi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_lv","title":"Drukā&scaron;anas problēmas"}},[_vm._v("\n     Drukāšanas problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_lv","title":"Printeris nereaģē"}},[_vm._v("\n     Printeris nereaģē\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_lv","title":"Nevar lasīt zibatmiņas disku"}},[_vm._v("\n     Nevar lasīt zibatmiņas disku\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_lv","title":"USB porta iespējo&scaron;ana"}},[_vm._v("\n     USB porta iespējošana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"avoiding-jams-topic.html#d0e29524","title":"Iestrēgu&scaron;a papīra izņem&scaron;ana"}},[_vm._v("\n     Iestrēguša papīra izņemšana\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e30034","title":"Tīkla savienojuma problēmas"}},[_vm._v("\n     Tīkla savienojuma problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e30262","title":"Aparatūras ierīču problēmas"}},[_vm._v("\n     Aparatūras ierīču problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e30388","title":"Izejmateriālu problēmas"}},[_vm._v("\n     Izejmateriālu problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-envelope-seals-when-printing-topic.html#d0e30493","title":"Papīra padeves problēmas"}},[_vm._v("\n     Papīra padeves problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e30859","title":"E-pasta ziņojumu sūtī&scaron;anas problēmas"}},[_vm._v("\n     E-pasta ziņojumu sūtīšanas problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e30953","title":"Faksa sūtī&scaron;anas problēmas"}},[_vm._v("\n     Faksa sūtīšanas problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e31598","title":"Skenē&scaron;anas problēmas"}},[_vm._v("\n     Skenēšanas problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"modifying-colors-in-printed-output-topic.html#d0e32372","title":"Krāsas kvalitātes problēmas"}},[_vm._v("\n     Krāsas kvalitātes problēmas\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_lv","title":"Sazinā&scaron;anās ar klientu atbalstu"}},[_vm._v("\n     Sazināšanās ar klientu atbalstu\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_lv","title":"Otrreizējā pārstrāde un atbrīvo&scaron;anās"}},[_vm._v("\n    Otrreizējā pārstrāde un atbrīvošanās\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32622"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_lv","title":"Lexmark produktu otrreizēja pārstrāde"}},[_vm._v("\n     Lexmark produktu otrreizēja pārstrāde\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_lv","title":"Lexmark iepakojuma otrreizēja pārstrāde"}},[_vm._v("\n     Lexmark iepakojuma otrreizēja pārstrāde\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_lv","title":"Paziņojumi"}},[_vm._v("\n    Paziņojumi\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e32657"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32660","title":"Produkta informācija"}},[_vm._v("\n     Produkta informācija\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32677","title":"Izdevuma paziņojums"}},[_vm._v("\n     Izdevuma paziņojums\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_lv","title":"Preču zīmes"}},[_vm._v("\n     Preču zīmes\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_lv","title":"Paziņojumi par licencē&scaron;anu"}},[_vm._v("\n     Paziņojumi par licencēšanu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_lv","title":"Trok&scaron;ņu emisijas līmeņi"}},[_vm._v("\n     Trokšņu emisijas līmeņi\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_lv","title":"Atkritumu savāk&scaron;ana atbilsto&scaron;i Elektrisko un elektronisko iekārtu direktīvai (EEIA)"}},[_vm._v("\n     Atkritumu savākšana atbilstoši Elektrisko un elektronisko iekārtu direktīvai (EEIA)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32782","title":"Litija jonu lādējama baterija"}},[_vm._v("\n     Litija jonu lādējama baterija\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_lv","title":"Regula (EU) 2023/1542"}},[_vm._v("\n     Regula (EU) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e32820","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_lv","title":"Atbrīvo&scaron;anās no produkta"}},[_vm._v("\n     Atbrīvošanās no produkta\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_lv","title":"Lexmark kasetņu atgrie&scaron;ana atkārtotai izmanto&scaron;anai un pārstrādei"}},[_vm._v("\n     Lexmark kasetņu atgriešana atkārtotai izmantošanai un pārstrādei\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_lv","title":"Paziņojums par jutību pret statisko elektrību"}},[_vm._v("\n     Paziņojums par jutību pret statisko elektrību\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_lv","title":"Emblēma &ldquo;ENERGY STAR&rdquo;"}},[_vm._v("\n     Emblēma “ENERGY STAR”\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_lv","title":"Informācija par temperatūru"}},[_vm._v("\n     Informācija par temperatūru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_lv","title":"Jaudas patēriņ&scaron;"}},[_vm._v("\n     Jaudas patēriņš\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_lv","title":"Reglamentējo&scaron;i paziņojumi par telekomunikāciju termināla iekārtu"}},[_vm._v("\n     Reglamentējoši paziņojumi par telekomunikāciju termināla iekārtu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_lv","title":"Atbilstība Eiropas Kopienas (EK) direktīvām"}},[_vm._v("\n     Atbilstība Eiropas Kopienas (EK) direktīvām\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_lv","title":"Paziņojums par radioviļņu ietekmi"}},[_vm._v("\n     Paziņojums par radioviļņu ietekmi\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js